import { businessErrorsVi } from "./businessErrorsVi";
import { errorUiVi } from './errorUi';
import { completionVi } from "./completion";
import payroll from "./payrollVi";
export default {
  progressWorkPending: {
    label: "Đang đối soát",
    help: "Tiến độ đang chờ đối soát với chấm công. Giá trị hiển thị chưa phải kết quả hoàn tất.",
  },
  internalCosts: {
    reverse: "Đảo giá vốn hiện hành",
    reverseConfirm: "Đảo giá vốn hiện hành? Phiếu kho đã duyệt được giữ nguyên. Nhập lại nguồn sau khi đảo thành công.",
    categoryScope: "Nhóm chi phí văn phòng không gắn dự án; chi phí phát sinh dự án phải chọn dự án.",
    missingExchangeRate: "Chưa có tỷ giá quy đổi cho ngày ghi nhận.",
    missingCostDetails: "Nguồn hoặc dữ liệu giá vốn chưa được xác nhận đầy đủ.",
    operationBindSource: "Gắn nguồn giá vốn",
    tab: "Giá vốn nội bộ",
    receiptTitle: "Nguồn giá vốn phiếu nhập",
    invoiceTitle: "Giá vốn và lịch sử nguồn",
    missingQuantity: "Số lượng chưa có nguồn: {quantity}",
    approvedReceiptOnly: "Chỉ phiếu nhập đã duyệt được liên kết nguồn giá vốn.",
    mode: "Thao tác",
    bind: "Liên kết nguồn",
    transfer: "Chuyển từ phiếu xuất kho đã duyệt",
    sourceKind: "Loại nguồn",
    source: "Nguồn",
    quantity: "Số lượng",
    currency: "Tiền tệ nguồn",
    select: "Chọn",
    homogeneousPool: "Xác nhận các CCDC trong nhóm có cùng đơn giá",
    reason: "Lý do xác nhận",
    previous: "Trang trước",
    next: "Trang sau",
    sourceSupplierInvoiceLine: "Dòng hóa đơn nhà cung cấp",
    sourceStockReceipt: "Phiếu nhập kho vật tư",
    sourceTool: "CCDC phân bổ",
    sourceReturnedMaterial: "Vật tư nhận lại",
    line: "Dòng hóa đơn",
    nativeCost: "Giá vốn theo tiền tệ nguồn",
    vndCost: "Giá vốn VND",
    partialHelp: "Giá vốn còn thiếu hoặc chỉ xác định một phần. Dấu — là chưa xác định, không phải giá trị 0.",
    unresolvedReason: "Phần chưa xác định: {reason}",
    resolve: "Xác nhận lại nguồn và tính giá vốn",
    actualReturn: "Xác nhận trả hàng thật",
    returnHelp: "Kế toán xác nhận giá trị nhận lại và chọn đích chi phí chênh lệch cho phiếu này. Không tự sinh tiền hoặc doanh thu.",
    returnReceipt: "Phiếu nhập nhận lại đã duyệt",
    confirmedValue: "Giá trị nhận lại xác nhận",
    returnAboveCost: "Giá trị nhận lại không được vượt giá vốn của số lượng trả.",
    differenceCategory: "Nhóm chi phí chênh lệch",
    differenceHolder: "Chủ thể nhận chi phí chênh lệch",
    holderProject: "Dự án",
    holderCommercial: "PO thương mại",
    holderUnallocated: "Chưa phân bổ",
    newSchedule: "Lịch phân bổ mới cho CCDC nhận lại",
    newToolCode: "Mã CCDC mới",
    newToolName: "Tên CCDC mới",
    periods: "Số tháng phân bổ",
    startMonth: "Tháng bắt đầu lịch mới",
    scheduleCategory: "Nhóm chi phí lịch mới",
    projectPermission: "Cần quyền đọc dự án để chọn đích dự án; liên hệ người phụ trách quyền.",
    disposed: "Giá vốn đã bán",
    returnLineage: "Nguồn trả hàng",
    operationSale: "Bán",
    operationResolveMissing: "Xác nhận nguồn thiếu",
    operationCorrection: "Điều chỉnh",
    operationStockTransfer: "Điều chuyển kho",
    operationActualReturn: "Trả hàng thật",
    statusConfirmed: "Đã xác định",
    statusPartial: "Xác định một phần",
    statusMissingCost: "Thiếu giá vốn",
    statusConflict: "Nguồn xung đột",
  },
  outboxDiagnostics: {
    title: 'Chẩn đoán outbox', description: 'Đọc trạng thái phát sự kiện của các service bạn được phép xem. Mở màn hình không gửi lại công việc.',
    chooseOwner: 'Chọn một service để đọc outbox hiện tại.', noAccess: 'Bạn chưa có quyền đọc chẩn đoán của service nào.',
    ownerTitle: 'Outbox {owner}', refresh: 'Đọc lại trạng thái', all: 'Tất cả', apply: 'Áp dụng bộ lọc', from: 'Từ (giờ máy)', to: 'Đến (giờ máy)',
    state: 'Trạng thái phát', eventKind: 'Loại sự kiện', otherEvent: 'Loại sự kiện chưa đăng ký', occurred: 'Thời điểm phát sinh', nextAttempt: 'Lịch thử tiếp',
    processedAt: 'Ghi nhận đã phát lúc', failureCount: 'Số lần lỗi đã lưu', errorClass: 'Nhóm lỗi', records: 'Bản ghi outbox', emptyPage: 'Không có bản ghi trên trang này.',
    observed: 'Đọc lúc {at}', filtered: 'Số liệu theo bộ lọc', serviceWide: 'Số liệu toàn service', oldestAge: 'Tuổi công việc chờ lâu nhất (giây): {seconds}',
    stale: 'Số liệu đã hơn hai phút. Đọc lại để xem trạng thái hiện tại. Đây là nhắc làm mới, không phải SLO.',
    future: 'Thời điểm đọc nằm sau giờ của máy này. Kiểm tra đồng hồ trước khi đánh giá độ mới.',
    pageCaption: 'Trang {page} / {pages} · Hiển thị {shown} / {total} bản ghi phù hợp',
    unavailable: 'Chưa đọc được số liệu của service.', invalidFilters: 'Kiểm tra khoảng thời gian và giá trị bộ lọc rồi đọc lại.',
    limitationsTitle: 'Giới hạn của số liệu này',
    owners: { identity: 'Định danh', config: 'Danh mục', project: 'Dự án', workforce: 'Nhân sự', reporting: 'Báo cáo', document: 'Tài liệu', workflow: 'Phê duyệt', chat: 'Trò chuyện', procurement: 'Mua hàng' },
    states: { ready: 'Sẵn sàng phát', scheduled: 'Đã hẹn lịch', processed: 'Ghi nhận đã phát' },
    loadStates: { notLoaded: 'Chưa tải', loading: 'Đang đọc nguồn…', ready: 'Đã nhận số liệu nguồn', partial: 'Số liệu chưa đầy đủ', empty: 'Không có bản ghi phù hợp', unavailable: 'Nguồn chưa khả dụng', forbidden: 'Quyền đọc hiện tại bị từ chối' },
    errorClasses: { none: 'Không có lỗi đã lưu', unclassified: 'Có lỗi đã lưu; chưa phân loại để thử lại' },
    summary: { total: 'Bản ghi phù hợp', ready: 'Sẵn sàng phát', scheduled: 'Đã hẹn lịch', processed: 'Ghi nhận đã phát', pendingWithFailures: 'Đang chờ và từng lỗi', maximumFailureCount: 'Số lần lỗi đã lưu cao nhất' },
    limitations: {
      non_atomic_observation: 'Số đếm và danh sách được đọc qua nhiều câu truy vấn, không phải ảnh chụp nguyên tử.',
      inconsistent_observation: 'Nguồn thay đổi giữa các lần đọc; hãy tải lại trước khi diễn giải số đếm.',
      dispatch_not_consumer_ack: 'Đã phát không chứng minh consumer đã áp dụng sự kiện.',
      failure_count_not_attempt_count: 'Số lần lỗi đã lưu không phải tổng số lần thử phát.',
      unregistered_event_kind: 'Có loại sự kiện ngoài danh sách đăng ký; tên kiểu thô được ẩn.',
      future_pending_timestamp: 'Một số thời điểm công việc chờ nằm ở tương lai; cần kiểm tra đồng hồ.',
      query_timeout: 'Hết thời gian chờ đọc nguồn.', query_unavailable: 'Chưa đọc được nguồn.', other: 'Nguồn báo thêm giới hạn về độ đầy đủ.'
    },
  },
  customerFinance: {
    reasons: {
      projectScope: 'Chỉ tính các dự án người dùng được đọc.', projectSourceIncomplete: 'Nguồn dự án chưa trả về tập dữ liệu đầy đủ.',
      projectSourceLimit: 'Nguồn dự án đạt giới hạn xử lý; tổng chưa đầy đủ.', projectSourceUnavailable: 'Nguồn dự án hiện không khả dụng.',
      invoiceSourceLimit: 'Nguồn hóa đơn đạt giới hạn xử lý; tổng chưa đầy đủ.', legacyCustomerUnresolved: 'Một số hóa đơn cũ chưa xác định được khách hàng có căn cứ.',
      invoiceCurrencyMissing: 'Hóa đơn chưa có tiền tệ xác minh được.', invoiceCustomerMismatch: 'Liên kết khách hàng trên hóa đơn được phép đọc chưa nhất quán.',
      invoiceOwnerUnresolved: 'Chưa xác minh được nguồn sở hữu hóa đơn.', invoiceSourceChanged: 'Hóa đơn thay đổi trong lúc tính; cần tải lại để tính lại.',
      invoiceAmountMissing: 'Hóa đơn còn thiếu số tiền.', invoiceBalanceInvalid: 'Số dư hóa đơn cần được đối soát.',
      invoiceDueDateMissing: 'Khoản còn phải thu thiếu ngày đến hạn; số quá hạn chưa xác định.',
    },
    title: 'Doanh thu và công nợ', revenue: 'Doanh thu hợp đồng', invoices: 'Hóa đơn và công nợ',
    basis: 'Chứng từ hiện tại, tách theo nguyên tệ. Doanh thu hợp đồng chưa VAT; công nợ dùng số tiền hóa đơn có VAT. Không cộng hai nguồn với nhau hoặc tự quy đổi tiền tệ.',
    revenueBasis: 'Hợp đồng đang hiệu lực/hoàn tất đã ký, chưa VAT. Tổng gồm mọi hợp đồng đủ điều kiện trong phạm vi khách hàng được đọc, độc lập với trang chứng từ.',
    invoiceBasis: 'Hóa đơn đã phát hành và khoản thu đã ghi nhận theo hóa đơn. Quá hạn tính theo ngày nghiệp vụ hiện tại; đây không phải số dư lịch sử cuối kỳ.',
    complete: 'Tổng trong phạm vi khách hàng đã được nguồn này xác minh.', partial: 'Phạm vi chưa đầy đủ: tổng chỉ gồm các chứng từ nguồn xác minh được và người dùng được phép đọc.',
    observed: 'Thời điểm tính: {at}', incompleteData: 'Một phần dữ liệu nguồn chưa xác minh được. Số tiền chưa rõ hiển thị —.',
    invalidSource: 'Dữ liệu tài chính trả về không khớp khách hàng đang xem.',
    currency: 'Tiền tệ', contractAmount: 'Giá trị hợp đồng chưa VAT', records: 'Số hợp đồng', invoiced: 'Đã xuất hóa đơn có VAT',
    collected: 'Đã thu theo hóa đơn', outstanding: 'Còn phải thu', overdue: 'Công nợ quá hạn',
    noTotals: 'Chưa có tổng đã xác minh cho nguồn và phạm vi này. Không đồng nghĩa toàn bộ khách hàng có số dư bằng 0.',
    sourceRecords: 'Chứng từ nguồn ({total})', sourceRecordsLabel: 'Chứng từ nguồn tài chính', document: 'Chứng từ', date: 'Ngày chứng từ', page: 'Trang {page}/{total}',
  },
  customerProjectActivity: {
    coverage: "Chọn một dự án trong trang khách hàng đã tải, rồi tải riêng từng nguồn. Số lượng thuộc dự án đã chọn; không phải tổng của khách hàng. Giá trị tiền giữ nguyên loại tiền, không cộng gộp.",
    project: "Dự án đang chọn", chooseProject: "Chọn dự án đã tải",
    loaded: "Đã tải {loaded}/{total} hồ sơ của dự án", load: "Tải lại nguồn", projectLink: "Mở khu vực dự án",
    receivedAt: "Nhận lúc {at}",
  },
  customerActivity: {
  "title": "Hoạt động và hẹn chăm sóc",
  "coverage": "Lịch sử từ các trang đã tải; các mốc dự án là ngày kế hoạch, không phải ngày giao dịch. Đổi trang dự án sẽ thay phần mốc dự án đang hiển thị.",
  "forbidden": "Không có quyền xem nguồn này",
  "projectPage": "Dự án trang {page}/{pages}: {loaded}/{total} dự án",
  "interactionsLoaded": "Đã tải {loaded}/{total} tương tác",
  "partial": "Mới tải một phần",
  "currentPages": "Đã tải các trang hiện tại",
  "receivedAt": "Nhận lúc {at}",
  "needsAction": "Cần xử lý",
  "needsActionEmpty": "Không có hẹn chăm sóc đang mở trong phần đã tải.",
  "filter": "Lọc nguồn",
  "noLoadedEvents": "Chưa có hoạt động trong phần dữ liệu đã tải với bộ lọc này.",
  "sources": {
    "quotation": "Báo giá", "contract": "Hợp đồng", "document": "Chứng từ", "survey": "Khảo sát",
    "project": "Dự án",
    "interaction": "Tương tác khách hàng"
  },
  "kinds": {
    "quotationSubmitted": "Gửi báo giá", "quotationValidity": "Hạn hiệu lực báo giá", "quotationUndated": "Báo giá chưa có ngày sự kiện",
    "contractSigned": "Ký hợp đồng", "contractEffective": "Ngày hiệu lực hợp đồng", "documentUploaded": "Tải chứng từ", "surveyRecorded": "Ngày khảo sát",
    "projectStart": "Bắt đầu theo kế hoạch",
    "projectEnd": "Kết thúc theo kế hoạch",
    "interaction": "Ngày tương tác",
    "followUp": "Hẹn chăm sóc chưa hoàn tất"
  }
},
  todayWork: {
  "loadedEmpty": "Không có việc trong phần dữ liệu đã tải với bộ lọc hiện tại.",
  "title": "Hôm nay",
  "description": "Mọi việc trong ngày của bạn: việc dự án, hồ sơ chờ duyệt, hẹn chăm sóc khách hàng, việc cá nhân và lịch họp.",
  "sourceStatus": "Trạng thái từng nguồn",
  "coverage": "Chỉ sắp xếp những việc đã tải. Dữ liệu thay đổi theo từng lần đọc; tải thêm hoặc làm mới từng nguồn để cập nhật. Các lớp bảo hành và hạn nhắc trên Lịch giữ phạm vi ngày của Lịch.",
  "loadedOverdueCount": "{n} việc đã tải quá hạn",
  "loadedCount": "Đã tải {n} việc",
  "loadMore": "Tải thêm",
  "groupFilter": "Lọc theo hạn",
  "delegated": "Được giao duyệt thay",
  "reminded": "Đã nhắc hạn",
  "escalated": "Đã chuyển cấp",
  "summary": "Bạn có {overdue} việc quá hạn, {today} việc đến hạn hôm nay và {events} lịch trong ngày.",
  "openCalendar": "Mở lịch",
  "tasksTitle": "Việc cần làm",
  "search": "Tìm việc",
  "allDue": "Mọi hạn",
  "allSources": "Tất cả",
  "quickAdd": "Thêm việc cá nhân cho hôm nay (Enter)",
  "add": "Thêm",
  "allClear": "Không còn việc nào cần làm — bạn đã xử lý xong!",
  "clearFilters": "Bỏ lọc",
  "daysLate": "Trễ {count} ngày",
  "todayAt": "Hôm nay {time}",
  "open": "Mở {name}",
  "openShort": "Mở",
  "agendaTitle": "Lịch hôm nay",
  "agendaError": "Không tải được lịch.",
  "agendaEmpty": "Không có lịch nào hôm nay.",
  "allDay": "Cả ngày",
  "happeningNow": "Đang diễn ra",
  "upNext": "Sắp tới",
  "needsResponse": "Chưa phản hồi",
  "join": "Tham gia",
  "greeting": {
    "morning": "Chào buổi sáng, {name}",
    "noon": "Chào buổi trưa, {name}",
    "afternoon": "Chào buổi chiều, {name}",
    "evening": "Chào buổi tối, {name}",
  },
  "stats": {
    "overdue": "Quá hạn",
    "today": "Đến hạn hôm nay",
    "approval": "Chờ bạn duyệt",
    "followUp": "Hẹn chăm sóc đến hạn",
    "events": "Lịch hôm nay",
  },
  "batches": {
    "TimesheetApprovals": "{count} bảng chấm công chờ duyệt",
    "ReportReviews": "{count} báo cáo chờ duyệt",
  },
  "batchSources": {
    "timesheets": "Chấm công chờ duyệt",
    "reports": "Báo cáo chờ duyệt",
  },
  "groups": {
    "overdue": "Quá hạn",
    "today": "Hôm nay",
    "upcoming": "Sắp tới",
    "undated": "Không hạn"
  },
  "states": {
    "notLoaded": "Chưa tải",
    "loading": "Đang tải",
    "ok": "Đã tải đủ các trang hiện tại",
    "empty": "Không có việc",
    "forbidden": "Không có quyền truy cập nguồn này",
    "error": "Không tải được nguồn này",
    "partial": "Mới tải một phần — chưa phải toàn bộ"
  }
},
  customerInteractions: {
    title: "Nhật ký chăm sóc khách hàng",
    customer: "Khách hàng",
    contact: "Người liên hệ",
    channel: "Kênh liên hệ",
    occurredOn: "Ngày trao đổi",
    notes: "Nội dung trao đổi",
    owner: "Người phụ trách",
    followUpOn: "Ngày hẹn tiếp theo",
    completed: "Đã hoàn tất hẹn",
    followUpState: "Trạng thái hẹn",
    channels: {
      Call: "Gọi điện",
      Email: "Email",
      Meeting: "Gặp mặt",
      Other: "Khác",
    },
    states: {
      open: "Chưa hoàn tất",
      due: "Đến hạn hôm nay",
      overdue: "Quá hạn",
      completed: "Đã hoàn tất",
    },
  },
  contextCreate: {
    quotation: "Tạo báo giá",
    purchaseRequest: "Tạo đề nghị mua",
    paymentRequest: "Tạo đề nghị thanh toán",
  },
  sourceStates: {
    notLoaded: "Chưa tải", loading: "Đang tải", ok: "Đã tải đủ các trang hiện tại", empty: "Không có bản ghi",
    partial: "Mới tải một phần — chưa phải toàn bộ", forbidden: "Không có quyền truy cập nguồn này", error: "Không tải được nguồn này",
  },
  globalSearch: {
    recent: "Hồ sơ vừa mở",
    documentsMetadataHint: "Tìm trong sổ tài liệu; quyền tải tệp được kiểm tra riêng.",
    seeMore: "Xem thêm kết quả",
    forbidden: "Bạn không còn quyền đọc nguồn này.",
    sourceError: "Không tải được nguồn này.",
    placeholder: "Tìm khách hàng, dự án, vật tư, sản phẩm, sổ tài liệu, hồ sơ chờ duyệt…",
    partialError: "Một số nhóm không tải được. Hãy thử lại.",
    empty: "Không có kết quả phù hợp.",
  },
  annualLeave: {
    monthlySummary: "Sổ phép tháng {month} (đến ngày đã chọn)",
    monthOpening: "Số dư đầu tháng",
    monthCredits: "Phép cộng trong tháng",
    monthUsed: "Phép đã dùng trong tháng",
    monthClosing: "Số dư cuối kỳ",
    exhausted: "Đã hết số dư phép năm. Vui lòng kiểm tra trước khi duyệt nghỉ phép.",
    probation: "Đang thử việc: chưa cộng phép. Khi chính thức sẽ tính bù thời gian đủ điều kiện.",
    accrualSummary: "Định mức: {annual} ngày/năm · Phép tích lũy: {accrued} ngày.",
    accrualHelp: "Từ năm 2027: tháng đầu tiên trong năm nhận phần còn lại của định mức, các tháng sau cộng 1 ngày (định mức 14: tháng 1 cộng 3); vào làm hoặc nghỉ việc trong năm tính theo tỷ lệ tháng làm việc, làm tròn lên nửa ngày. Năm 2026 và trước đó cộng định mức năm / 12 × số tháng đủ điều kiện. Thời gian thử việc được tính bù khi chính thức.",
    payrollSource: "Bảng lương sử dụng số dư từ sổ phép này tại ngày cuối kỳ lương.",
    title: "Sổ phép năm",
    subtitle:
      "Cấp phép theo quy định và dữ liệu do nhân sự xác nhận; giữ lịch sử điều chỉnh.",
    asOf: "Tính đến ngày",
    balance: "Số dư phép",
    calculated: "Phép được cấp",
    category: "Nhóm điều kiện lao động",
    certification:
      "Tôi xác nhận nguồn số dư, thâm niên, điều kiện và thời gian được tính phép là chính xác.",
    days: "Số ngày",
    effectiveDate: "Ngày hiệu lực",
    employee: "Nhân viên",
    entry: "Ghi sổ phép",
    history: "Lịch sử cấp và điều chỉnh",
    kind: "Loại bút toán",
    months: "Số tháng đủ điều kiện",
    noOpening: "Chưa xác nhận số dư đầu kỳ; chưa có số dư khả dụng.",
    ownOnly: "Bạn đang xem số dư phép năm của chính mình. Sổ chi tiết của mọi người do nhân sự quản lý.",
    openingHelp:
      "Nhập số dư có căn cứ tại ngày mở sổ. Khoảng làm việc dùng số phút từ 00:00, không tính giờ nghỉ giữa ca.",
    policy: "Cấu hình mức phép",
    retry: "Thử lại bút toán đang chờ",
    retryHelp:
      "Kết quả chưa xác định. Thử lại cùng bút toán để tránh ghi trùng.",
    serviceYears: "Số năm làm việc đã đủ",
    source: "Nguồn và căn cứ",
    used: "Đã sử dụng",
    usage: "Chi tiết nghỉ được duyệt",
    year: "Năm cấp phép",
    workingInterval: "Khoảng làm việc {number}: từ phút / đến phút",
    Opening: "Số dư đầu kỳ",
    Grant: "Cấp phép",
    Adjustment: "Điều chỉnh",
    Normal: "Điều kiện bình thường",
    ProtectedOrHazardous: "Nhóm được hưởng 14 ngày theo luật",
    EspeciallyHazardous: "Công việc đặc biệt nặng nhọc, độc hại, nguy hiểm",
    normalDays: "Ngày phép cơ bản",
    protectedOrHazardousDays: "Ngày phép nhóm 14 ngày",
    especiallyHazardousDays: "Ngày phép nhóm 16 ngày",
    seniorityYearsPerDay: "Số năm thâm niên cho mỗi lần tăng",
    seniorityDays: "Ngày tăng mỗi mốc thâm niên",
  },
  exchangeRates: {
    title: "Tỷ giá quy đổi",
    description:
      "Quản lý tỷ giá theo cặp tiền và ngày hiệu lực. Tỷ giá tự động được tổng hợp lúc 09:00 khi có đủ báo giá ngân hàng; chứng từ đã chốt không bị thay đổi.",
    newTitle: "Thiết lập tỷ giá",
    editTitle: "Chỉnh sửa tỷ giá",
    listTitle: "Danh sách tỷ giá",
    cancelEdit: "Thoát chỉnh sửa",
    automaticSource: "Tự động · trung bình ngân hàng",
    automaticLocked: "Tỷ giá tự động chỉ xem; hệ thống cập nhật khi đủ dữ liệu ngân hàng.",
    sourceCurrency: "Tiền nguồn",
    targetCurrency: "Tiền quy đổi",
    rate: "Số tiền đích / 1 đơn vị tiền nguồn",
    effectiveDate: "Ngày hiệu lực",
    sourceName: "Nguồn tỷ giá",
    active: "Đang sử dụng",
    effectiveOn: "Hiệu lực đến ngày",
    sourceHint: "Tên ngân hàng hoặc nguồn nhập tay",
  },
  payroll,
  ownFollowUp: {
    title: "Hẹn chăm sóc của tôi",
    readOnly: "Chi tiết chỉ đọc của hẹn do bạn phụ trách. Mở sổ chăm sóc nếu cần xử lý theo quyền hiện có.",
    missing: "Hẹn không còn tồn tại hoặc không thuộc phạm vi phụ trách của bạn.",
    openDirectory: "Mở sổ chăm sóc",
  },
  notificationAdmin: {
    retryAdmissionQueued: "Đã xếp hàng xử lý lại. Kết quả này chưa xác nhận thông báo đã đến người nhận.",
    retryAdmissionUnknown: "Chưa xác định được kết quả yêu cầu xử lý lại. Hãy tra cứu thao tác này trước khi thực hiện tiếp.",
    retryAdmissionInvalid: "Biên nhận xử lý lại không khớp yêu cầu này. Cần đối soát kết quả.",
    retryAdmissionMissing: "Chưa tìm thấy biên nhận đã lưu. Hãy tiếp tục tra cứu thao tác này; chưa đủ căn cứ để gửi yêu cầu xử lý lại mới.",
    retryStorageLimited: "Chưa thể gửi yêu cầu xử lý lại mới vì trình duyệt không lưu được mã tra cứu. Hãy đối soát những thao tác đang chờ hoặc cho phép trình duyệt lưu dữ liệu phiên.",
    lookupRetryOperation: "Tra cứu kết quả xử lý lại",
    diagnosticsScope: "Chẩn đoán vận hành thông báo",
    deliveryScope: "Bước giao thông báo — toàn bộ thông báo, không áp dụng bộ lọc danh sách",
    deliveryUnavailable: "Chưa có số liệu bước giao thông báo; chưa thể kết luận hoạt động bình thường.",
    deliveryIncomplete: "Số liệu giao thông báo chưa đầy đủ; cần kiểm tra trạng thái xử lý.",
    deliveryFailed: "Giao thất bại",
    deliveryDue: "Đến hạn chưa giao",
    deliverySending: "Đang giao",
    deliveryExpired: "Lượt xử lý hết hạn, cần đối soát",
    deliveryOldestDue: "Quá hạn lâu nhất (giây)",
    backlog: "Số tác vụ đang chờ",
    oldestPendingAge: "Tuổi tác vụ chờ lâu nhất (giây)",
    errorClass: "Nhóm lỗi",
    maximumAttempts: "Số lần thử lớn nhất",
    pendingAge: "Thời gian chờ (giây)",
    diagnosticHelp: "Số liệu mô tả xử lý và gửi thông báo, chưa chứng minh người nhận đã nhận thư. Đối soát kết quả chưa rõ trước khi thử lại.",
    title: "Cấu hình thông báo",
    subtitle: "Cấu hình người nhận và tần suất theo loại sự kiện.",
    enabled: "Bật",
    disabled: "Tắt",
    recipients: "Người nhận",
    users: "Người dùng",
    roles: "Vai trò toàn hệ thống",
    related: "Người liên quan đến nội dung này",
    audienceMode: "Chế độ người nhận",
    conditions: "Điều kiện kích hoạt",
    replace: "Thay người nhận mặc định",
    extend: "Gộp thêm người nhận mặc định",
    fields: "Chỉ báo khi đổi một trong các trường",
    sampleFields: "Các trường thay đổi trong mẫu thử",
    origin: "Nguồn thay đổi",
    beforeStatus: "Trạng thái trước",
    afterStatus: "Trạng thái sau",
    includeActor: "Gửi cả cho người thực hiện",
    frequency: "Tần suất",
    immediate: "Gửi ngay",
    grouped: "Gom 5 phút",
    saveDraft: "Lưu nháp",
    publish: "Áp dụng",
    restore: "Khôi phục mặc định",
    preview: "Xem thử",
    evaluate: "Kiểm tra mẫu",
    history: "Lịch sử",
    reload: "Tải lại",
    close: "Đóng",
    version: "Phiên bản",
    failed: "Không thể thực hiện. Vui lòng thử lại.",
    conflict: "Cấu hình đã thay đổi. Tải lại trước khi sửa tiếp.",
    draftSaved: "Đã lưu bản nháp.",
    published: "Đã áp dụng cấu hình.",
    restored: "Đã tạo phiên bản dùng mặc định.",
    workflowOwned: "Do quy trình duyệt quản lý",
    openWorkflow: "Mở cấu hình quy trình duyệt",
    configure: "Xem cấu hình",
    defaults: "Mặc định",
    proposed: "Cấu hình đang thử",
    module: "Module",
    moduleKey: "Module",
    eventKey: "Sự kiện",
    allModules: "Tất cả module",
    searchEvents: "Tìm sự kiện…",
    loading: "Đang tải…",
    empty: "Không có dữ liệu phù hợp.",
    searchRecipients: "Tìm theo tên…",
    inactive: "Không hoạt động",
    lookupFailed: "Không tải được danh sách người nhận.",
    refineSearch: "Còn kết quả khác. Nhập thêm để thu hẹp tìm kiếm.",
    previewHelp:
      "Dùng dữ liệu mẫu để xem kết quả của cấu hình đang sửa. Không gửi thông báo thật.",
    targetType: "Loại nội dung",
    targetId: "ID nội dung",
    parentId: "ID dự án cha (khi cần)",
    actor: "Người thực hiện trong mẫu",
    matched: "Khớp cấu hình",
    notMatched: "Không gửi",
    directory: "Kết quả tra cứu người nhận",
    unavailableSelectors: "Người nhận lịch sử không thể suy ra",
    fanout: "Số người nhận / giới hạn",
    excluded: "Người bị loại và lý do",
    target: "Đích mở",
    occurrences: "Lịch sử xử lý thông báo",
    status: "Trạng thái",
    from: "Từ thời điểm",
    to: "Đến thời điểm",
    filter: "Lọc",
    pages: "Phân trang",
    previous: "Trước",
    next: "Tiếp",
    attempts: "Số lần thử",
    retryReason: "Lý do xử lý lại",
    retry: "Thử xử lý lại",
    noPermission:
      "Bạn không có quyền xem lịch sử xử lý thông báo (yêu cầu quyền NotificationRules.Read).",
    viewFull: "Xem toàn màn hình",
    viewDetails: "Xem chi tiết",
    delivery: "Kết quả gửi",
    policySnapshot: "Cấu hình tại thời điểm tiếp nhận",
    factSnapshot: "Thay đổi đã ghi nhận",
    selectors: {
      project_creator: "Người tạo dự án",
      project_sales: "Kinh doanh của dự án",
      project_leader: "Trưởng dự án hiện tại",
      project_previousLeader: "Trưởng dự án trước thay đổi",
      project_newLeader: "Trưởng dự án mới",
      project_members: "Thành viên dự án",
      project_relatedUsers: "Người liên quan đến thay đổi dự án",
      wbs_pic: "PIC của WBS liên quan",
      wbs_addedPic: "PIC được thêm",
      wbs_removedPic: "PIC bị gỡ",
      issue_owner: "Người tạo yêu cầu",
      issue_actionPic: "PIC xử lý hành động",
      project_requester: "Người gửi đề nghị",
      owner_relatedUsers: "Người liên quan đến tài liệu",
      closure_reviewers: "Người tham gia rà soát đóng dự án",
    },
    noOccurrenceSelected: "Chưa chọn bản ghi nào",
    noOccurrenceSelectedHint: "Nhấp chọn một sự kiện trong danh sách phía trên để xem chi tiết người nhận và kết quả gửi thông báo.",
    noRuleSelected: "Chưa chọn cấu hình thông báo",
    noRuleSelectedHint: "Nhấp vào nút \"Xem cấu hình\" hoặc chọn một dòng trong danh sách phía trên để chỉnh sửa người nhận và điều kiện gửi thông báo.",
  },
  ...completionVi,
  materialTemporaryDetails: {
    totalAmount: "Thành tiền",
    submittedDate: "Ngày gửi",
    createdBy: "Người tạo",
    createdDate: "Ngày tạo",
  },
  productTemporaryDetails: {
    submittedDate: "Ngày gửi",
    createdBy: "Người tạo",
    createdDate: "Ngày tạo",
  },
  organizationTemporaryDetails: {
    phone: "Số điện thoại",
    fax: "Số fax",
    submittedDate: "Ngày gửi",
    createdBy: "Người tạo",
    createdDate: "Ngày tạo",
  },
  partnerColumns: {
    name: "Tên đối tác",
    shortName: "Tên viết tắt",
    ownershipCountry: "Quốc gia sở hữu",
    legalRepresentative: "Người đại diện pháp luật",
    address: "Địa chỉ",
    industry: "Ngành nghề kinh doanh",
    fax: "Số fax:",
    contact1: "Người liên lạc 1",
    contact2: "Người liên lạc 2",
    contact3: "Người liên lạc 3",
    contact4: "Người liên lạc 4",
    placeholders: {
      name: "Công ty ABC",
      shortName: "ABC",
      ownershipCountry: "VN",
      legalRepresentative: "Nguyễn Văn A",
      industry: "Xuất nhập khẩu",
      address: "123 Nguyễn Huệ, Quận 1, TP. Hồ Chí Minh",
    },
  },
  supplierColumns: {
    name: "Tên nhà cung cấp",
    shortName: "Tên viết tắt",
    materialCount: "Số lượng linh kiện",
    placeholders: {
      name: "Công ty TNHH Cung ứng XYZ",
      shortName: "Cung ứng XYZ",
    },
  },
  customerTemporaryDetails: {
    title: "Thông tin khách hàng",
    help: "Các trường này chỉ hiển thị trên giao diện và không được gửi xuống backend.",
    fields: {
      endUser: "Tên khách hàng",
      customerShortName: "Tên viết tắt",
      companyCategory: "Loại công ty",
      ownershipCountry: "Quốc gia sở hữu",
      factoryCount: "Số lượng nhà máy",
      projectCount: "Số lượng dự án",
      region: "Khu vực",
      taxOrBusinessCode: "Mã số thuế",
      legalRepresentative: "Người đại diện pháp luật",
      address: "Địa chỉ",
      businessIndustry: "Ngành nghề kinh doanh",
      bankName: "Ngân hàng",
      bankAccountNumber: "Số tài khoản",
      transactionCurrency: "Tiền tệ",
      vatRate: "VAT (%)",
      creditDays: "Số ngày công nợ",
      recurringPaymentDay: "Ngày thanh toán định kỳ",
      companyPhone: "Số điện thoại",
      faxNumber: "Số fax:",
      contact1Name: "Người liên lạc 1",
      contact1Department: "Phòng ban",
      contact1Position: "Chức vụ",
      contact1Phone: "Số điện thoại",
      contact1Email: "Email",
      contact2Name: "Người liên lạc 2",
      contact2Department: "Phòng ban",
      contact2Position: "Chức vụ",
      contact2Phone: "Số điện thoại",
      contact2Email: "Email",
      contact3Name: "Người liên lạc 3",
      contact3Department: "Phòng ban",
      contact3Position: "Chức vụ",
      contact3Phone: "Số điện thoại",
      contact3Email: "Email",
      salesOwner: "Đảm trách kinh doanh",
      submittedDate: "Ngày gửi",
      createdBy: "Người tạo",
      createdDate: "Ngày tạo",
    },
    placeholders: {
      endUser: "Công ty TNHH Thương mại ABC",
      customerShortName: "MMT",
      companyCategory: "Công ty TNHH",
      taxOrBusinessCode: "0123456789",
      legalRepresentative: "Nguyễn Văn A",
      businessIndustry: "Xuất nhập khẩu",
      ownershipCountry: "VN",
      region: "TP. Hồ Chí Minh",
      salesOwner: "Chọn nhân viên phụ trách",
      companyPhone: "0987654321",
      faxNumber: "028-3822-1234",
      transactionCurrency: "USD",
      vatRate: "10",
      createdBy: "Nguyễn Văn A",
      address: "123 Nguyễn Huệ, Quận 1, TP. Hồ Chí Minh",
    },
  },
  menu: {
    overview: "Tổng quan",
    crmMaster: "Dữ liệu CRM",
    projectManagement: "Dự án",
    workforceOperations: "Nhân sự và vận hành",
    governance: "Kiểm soát & danh mục",
    finance: "Tài chính kế toán",
    externalProgress: "Quản lý tiến độ ngoại bộ",
    administration: "Hành chính",
    operatingCost: "Chi phí vận hành",
    attendanceGroup: "Chấm công & lịch",
    crm: "CRM",
    purchasing: "Mua hàng",
    accounting: "Kế toán",
    hrAdministration: "Hành chính & Nhân sự",
    system: "Hệ thống",
    paymentVouchers: "Chứng từ thanh toán",
    cashAndBank: "Quỹ & ngân hàng",
    invoices: "Hóa đơn",
    financeReports: "Báo cáo & khóa sổ",
    accountingCatalogs: "Danh mục kế toán",
    requestsGroup: "Đơn từ & Tiếp nhận",
    projectMyWork: "Của tôi",
    projectRegister: "Dự án",
    projectExecution: "Thực thi",
    projectReports: "Báo cáo dự án",
    projectExternal: "Chia sẻ ngoài",
    trackingWarnings: "Cảnh báo",
    externalCustomer: "Khách hàng",
    externalSubcontractor: "Nhà thầu phụ",
    execution: "Theo dõi dự án",
    organizations: "Đối tác & NCC",
    salesDocuments: "Báo giá & hợp đồng",
    documentTemplates: "Mẫu chứng từ",
    procurementDocuments: "Đề nghị & đơn mua",
    warehouse: "Kho",
    notificationSettings: "Thông báo",
    audit: "Audit & sử dụng",
    diagnostics: "Chẩn đoán hệ thống",
    favorites: "Yêu thích",
    recent: "Gần đây",
    addFavorite: "Ghim {name} vào Yêu thích",
    removeFavorite: "Bỏ {name} khỏi Yêu thích",
    pendingApprovals: "{count} việc chờ duyệt",
    payrollGroup: "Lương",
    usersAndAccess: "Người dùng & phân quyền",
    search: "Tìm trong menu…",
    toggle: "Đóng mở điều hướng",
    breadcrumb: "Đường dẫn trang",
    theme: "Đổi giao diện sáng tối",
    detail: "Chi tiết",
    copyright: "Bản quyền © 2014–{year} NMI. Đã đăng ký.",
  },
  table: {
    records: "bản ghi",
    filter: "Lọc",
    sort: "Sắp xếp",
    selectAll: "Chọn tất cả",
    searchValues: "Tìm trong giá trị",
    pageSize: "Số dòng mỗi trang",
    firstPage: "Trang đầu",
    previousPage: "Trang trước",
    nextPage: "Trang sau",
    lastPage: "Trang cuối",
    goToPage: "Đến trang {page}",
    resizeColumnHint: "Kéo để thay đổi độ rộng, nhấp đúp để đặt lại",
    columns: "Cột",
    chooseColumns: "Chọn cột hiển thị",
    resetColumns: "Mặc định",
    columnLocked: "Luôn hiển thị",
    rowNumber: "STT",
  },
  setup: {
    expand: "Mở rộng khu vực",
    collapse: "Thu gọn khu vực",
    update: "Cập nhật",
    fieldOrder: "Sắp xếp trường",
    resetOrder: "Đặt lại thứ tự",
    expandSide: "Hiện lịch sử revision",
    collapseSide: "Ẩn lịch sử revision",
  },
  workflow: {
    saveDraft: "Lưu nháp",
    submitApproval: "Gửi phê duyệt",
    saveAndSubmit: "Lưu và gửi duyệt",
    savedNotSubmitted:
      "Đã lưu bản nháp, chưa gửi duyệt. Bạn có thể thử gửi lại.",
  },
  referenceData: {
    unavailable:
      "Một số dữ liệu tra cứu không khả dụng với quyền hiện tại. Dữ liệu chính vẫn được hiển thị; các thao tác phụ thuộc tra cứu đã được tắt.",
  },
  permissionCatalog: {
    features: {
      EmployeeProfiles: "Hồ sơ nhân viên",
      SkillAssessments: "Bản đồ kỹ năng – đánh giá năng lực",
      SkillCatalogs: "Danh mục kỹ năng và thang đánh giá",
      OperationalRequests: "Đơn từ: nghỉ phép, OT, công tác, onsite, xe, suất ăn, điều chỉnh công",
      AdministrativeReceipts: "Hồ sơ tiếp nhận – Hành chính nhân sự",
      AccountingReceipts: "Hồ sơ tiếp nhận – Kế toán",
      AnnualLeave: "Sổ phép năm",
      Timesheets: "Chấm công dự án (ghi giờ ở Dự án › Thực thi › Của tôi)",
      TimesheetApprovals: "Chấm công chờ duyệt",
      TimesheetPeriods: "Khóa kỳ chấm công",
      Capacity: "Năng lực và tải công việc",
      CompanyCalendars: "Lịch làm việc công ty – soạn lịch",
      CompanyCalendarApprovals: "Lịch làm việc công ty – duyệt lịch",
      Attendance: "Quản trị chấm công (máy chấm công)",
      Payroll: "Bảng lương và phiếu lương",
      MandayCosts: "Chi phí 1 Manday",
      CompanyVehicles: "Quản lý xe công ty",
      ControlledDocuments: "Sổ tài liệu kiểm soát",
      ApprovalTasks: "Hộp duyệt (việc chờ duyệt theo quy trình)",
      WorkflowActivities: "Việc thực hiện theo quy trình (không phải duyệt)",
      ProjectDashboards: "Trung tâm điều hành: danh mục dự án, nguồn lực",
      ExecutionWarnings: "Cảnh báo tiến độ và sức khỏe dự án",
      Notifications: "Thông báo của tôi",
      Chat: "Trò chuyện nội bộ (chat dự án)",
      Projects: "Dự án và đăng ký dự án",
      ProjectRegistrationInbox: "Hộp đăng ký dự án chờ xử lý",
      ProjectLeaders: "Phân công trưởng dự án",
      WbsNodes: "Cấu trúc WBS và việc của tôi",
      Execution: "Theo dõi dự án: phân bổ nguồn lực, giao việc, cập nhật tiến độ",
      ProjectMilestones: "Mốc dự án (kế hoạch, thực tế)",
      ExternalProgress: "Tiến độ ngoại bộ",
      WbsTemplates: "Mẫu WBS theo loại sản phẩm",
      Reports: "Báo cáo dự án",
      ReportSchedules: "Lịch gửi báo cáo",
      Issues: "Issue: khắc phục, giao hàng, theo dõi",
      Lessons: "Thư viện bài học kinh nghiệm",
      CustomerSurveys: "Khảo sát hài lòng khách hàng",
      ProjectClosureReviews: "Đánh giá đóng dự án theo vai trò",
      ProjectClosureConclusions: "Kết luận đóng dự án",
      ProjectClosures: "Ký biên bản đóng dự án",
      Customers: "Khách hàng",
      CustomerInteractions: "Chăm sóc khách hàng",
      ProjectCommunications: "Nhật ký trao đổi với khách hàng theo dự án",
      CustomerHistory: "Lịch sử tài chính dự án của khách hàng",
      FinancialProfiles: "Hồ sơ tài chính khách hàng, đối tác, nhà cung cấp",
      Partners: "Đối tác",
      Suppliers: "Nhà cung cấp",
      Products: "Sản phẩm",
      ProductCategories: "Nhóm sản phẩm",
      ProductRevisions: "Phiên bản sản phẩm",
      CustomerProducts: "Sản phẩm của khách hàng",
      Quotations: "Báo giá",
      QuotationLines: "Giá vốn trong báo giá",
      ProjectContracts: "Hợp đồng và biên bản nghiệm thu",
      WarrantyTickets: "Phiếu bảo hành, hậu mãi",
      DocumentTemplates: "Mẫu chứng từ: báo giá, hợp đồng, RFQ, P/O",
      PurchaseRequests: "Đề nghị mua hàng (PR)",
      PurchaseOrders: "Đơn mua hàng (P/O)",
      MaterialStock: "Kho: nhập, xuất, tồn kho",
      Materials: "Danh mục vật tư, linh kiện",
      PaymentRequests: "Đề nghị tạm ứng, thanh toán, hoàn ứng",
      ProjectInvoices: "Hóa đơn bán ra (theo dự án)",
      SupplierInvoices: "Hóa đơn nhà cung cấp và công nợ phải trả",
      CashBook: "Sổ quỹ tiền mặt, ngân hàng",
      BankStatements: "Sao kê ngân hàng (TK 112)",
      Finance: "Báo cáo tài chính và khóa sổ",
      Amortizations: "Chi phí trả trước, CCDC phân bổ",
      ExpenseCategories: "Danh mục mã chi phí",
      ExchangeRates: "Tỷ giá",
      Users: "Tài khoản người dùng",
      Roles: "Vai trò, nhóm tài khoản",
      Departments: "Phòng ban",
      WorkflowDefinitions: "Quy trình duyệt (định nghĩa)",
      WorkflowInstances: "Phiên chạy quy trình",
      NotificationRules: "Cài đặt thông báo",
      SystemSettings: "Cài đặt hệ thống",
      AuditTrail: "Nhật ký hệ thống, audit phân quyền",
      SystemDiagnostics: "Chẩn đoán kỹ thuật (Outbox)",
      Documents: "Tệp đính kèm dùng chung",
    },
    featureHelp: {
      EmployeeProfiles: "Menu Hồ sơ nhân viên. Mỗi người luôn tự xem, khai và gửi duyệt hồ sơ của mình mà không cần cấp quyền.",
      SkillAssessments: "Màn Bản đồ kỹ năng: đánh giá năng lực theo kỳ.",
      SkillCatalogs: "Danh mục kỹ năng và thang điểm dùng khi đánh giá năng lực.",
      OperationalRequests: "Menu Đơn từ & Tiếp nhận. Mọi tài khoản luôn tạo, sửa, gửi và xem đơn của mình; các quyền dưới đây dành cho người kiểm tra, xác nhận, duyệt đơn của người khác.",
      AdministrativeReceipts: "Tab «Hồ sơ tiếp nhận» phía Hành chính nhân sự: đơn đã duyệt chuyển tới HCNS xử lý.",
      AccountingReceipts: "Tab «Hồ sơ tiếp nhận» phía Kế toán: đơn đã duyệt có phát sinh chi phí chuyển tới Kế toán.",
      AnnualLeave: "Tab Sổ phép năm. Mỗi người luôn xem số dư phép của mình.",
      Timesheets: "Dự án › Thực thi › Của tôi: mỗi người ghi giờ ngay trên dòng việc rồi gửi công trong ngày.",
      TimesheetApprovals: "Hộp phê duyệt › Chấm công: giám sát phần công và góc nhìn «Theo tổ».",
      TimesheetPeriods: "Khóa kỳ để không ai sửa chấm công của kỳ đã chốt.",
      Capacity: "Giờ chuẩn, thiếu giờ, quá tải của nhân viên trên màn Chấm công và Tổng quan.",
      CompanyCalendars: "Tab Lịch làm việc: ngày làm việc, ngày nghỉ, ngày lễ của công ty theo năm.",
      CompanyCalendarApprovals: "Bước xác nhận và phê duyệt lịch làm việc công ty trước khi áp dụng.",
      Attendance: "Tab Quản trị chấm công: dữ liệu máy chấm công, bảng công tháng.",
      Payroll: "Menu Lương: tab Bảng lương và Phiếu lương của tôi.",
      MandayCosts: "Tab Chi phí 1 Manday trong menu Lương: đơn giá ngày công dùng để tính chi phí dự án.",
      CompanyVehicles: "Menu Hành chính › tab Quản lý xe công ty.",
      ControlledDocuments: "Menu Hành chính › tab Sổ tài liệu kiểm soát (mở tab cần thêm quyền Documents.Read – tệp đính kèm dùng chung, nhóm Hệ thống).",
      ApprovalTasks: "Hộp công việc › tab Hộp phê duyệt: các bước duyệt quy trình giao cho bạn hoặc nhóm của bạn.",
      WorkflowActivities: "Bước thực hiện (không phải duyệt) của quy trình, ví dụ tiếp nhận, xử lý hồ sơ.",
      ProjectDashboards: "Menu Tổng quan › Trung tâm điều hành: danh mục dự án, nguồn lực.",
      ExecutionWarnings: "Cảnh báo chậm tiến độ, rủi ro trên Trung tâm điều hành.",
      Notifications: "Chuông thông báo trên thanh trên cùng.",
      Chat: "Khung trò chuyện trên thanh trên cùng và tab Trao đổi trong hồ sơ dự án.",
      Projects: "Menu Quản lý dự án và hồ sơ dự án: đăng ký → xác nhận → phê duyệt → thực hiện → đóng.",
      ProjectRegistrationInbox: "Danh sách đăng ký dự án đang chờ người xử lý.",
      ProjectLeaders: "Chỉ định, thay trưởng dự án cho dự án đã duyệt.",
      WbsNodes: "Dự án › Thực thi › Của tôi và cây WBS trong hồ sơ dự án.",
      Execution: "Dự án › Thực thi › Cảnh báo và phần nguồn lực, giao việc, cập nhật tiến độ trong WBS & Gantt của hồ sơ dự án.",
      ProjectMilestones: "Mốc kế hoạch và mốc thực tế trong hồ sơ dự án.",
      ExternalProgress: "Dự án › Chia sẻ ngoài: góc nhìn Khách hàng, Nhà thầu phụ.",
      WbsTemplates: "Mẫu WBS dùng khi lập WBS cho dự án mới.",
      Reports: "Dự án › Thực thi › Báo cáo dự án (kèm tab Danh mục báo cáo tài chính ở Kế toán › Báo cáo & khóa sổ).",
      ReportSchedules: "Báo cáo dự án › menu ⋯ › Gửi báo cáo định kỳ.",
      Issues: "Tab Theo dõi yêu cầu (vấn đề, đối sách) trong hồ sơ dự án.",
      Lessons: "Báo cáo dự án › khối Bài học kinh nghiệm.",
      CustomerSurveys: "Khảo sát hài lòng khách hàng khi bàn giao, đóng dự án.",
      ProjectClosureReviews: "Hồ sơ dự án › Đóng dự án: mỗi vai trò nhập đánh giá của mình.",
      ProjectClosureConclusions: "Hồ sơ dự án › Đóng dự án: kết luận chung và phê duyệt đóng.",
      ProjectClosures: "Ký biên bản đóng dự án thay mặt công ty.",
      Customers: "Menu Khách hàng. Menu Đối tác & NCC (tab Đối tác, Nhà cung cấp) cũng mở bằng quyền Xem khách hàng.",
      CustomerInteractions: "Menu Khách hàng › tab Chăm sóc khách hàng (cần kèm Xem khách hàng).",
      ProjectCommunications: "Nhật ký trao đổi với khách hàng trong hồ sơ khách hàng, đối tác.",
      CustomerHistory: "Doanh thu, công nợ các dự án của một khách hàng.",
      FinancialProfiles: "Mã số thuế, tài khoản ngân hàng, điều khoản thanh toán của khách hàng, đối tác, nhà cung cấp.",
      Partners: "Menu Đối tác & NCC › tab Đối tác.",
      Suppliers: "Menu Đối tác & NCC › tab Nhà cung cấp.",
      Products: "Menu Sản phẩm.",
      ProductCategories: "Nhóm, phân loại sản phẩm.",
      ProductRevisions: "Các phiên bản (revision) của sản phẩm.",
      CustomerProducts: "Liên kết sản phẩm với khách hàng sử dụng.",
      Quotations: "Menu Báo giá & hợp đồng › tab Báo giá.",
      QuotationLines: "Cột giá vốn, chi phí trong bảng báo giá.",
      ProjectContracts: "Menu Báo giá & hợp đồng › tab PO khách hàng, Hợp đồng & bảo hành.",
      WarrantyTickets: "Menu Báo giá & hợp đồng › tab Hợp đồng & bảo hành.",
      DocumentTemplates: "Menu Mẫu chứng từ.",
      PurchaseRequests: "Menu Đề nghị & đơn mua › tab Đề nghị mua hàng.",
      PurchaseOrders: "Menu Đề nghị & đơn mua › tab Đơn mua hàng.",
      MaterialStock: "Menu Kho: tồn kho, kiểm kê, phiếu nhập xuất.",
      Materials: "Menu Vật tư, linh kiện.",
      PaymentRequests: "Menu Chứng từ thanh toán: tạm ứng, thanh toán, hoàn ứng.",
      ProjectInvoices: "Menu Hóa đơn › tab Tình hình xuất hoá đơn.",
      SupplierInvoices: "Menu Hóa đơn › tab Hoá đơn nhà cung cấp.",
      CashBook: "Menu Quỹ & ngân hàng › tab Sổ quỹ.",
      BankStatements: "Menu Quỹ & ngân hàng › tab Sao kê ngân hàng.",
      Finance: "Menu Báo cáo & khóa sổ › tab Báo cáo tài chính công ty, Chốt tháng.",
      Amortizations: "Menu Báo cáo & khóa sổ › tab Trả trước và CCDC.",
      ExpenseCategories: "Menu Danh mục kế toán › tab Mã chi phí.",
      ExchangeRates: "Menu Danh mục kế toán › tab Tỷ giá.",
      Users: "Menu Người dùng & phân quyền › tab Tài khoản.",
      Roles: "Menu Người dùng & phân quyền › tab Vai trò, Nhóm tài khoản, Danh mục quyền.",
      Departments: "Menu Người dùng & phân quyền › tab Phòng ban.",
      WorkflowDefinitions: "Menu Cấu hình quy trình duyệt: các bước và cách chuyển duyệt.",
      WorkflowInstances: "Phiên quy trình đang chạy của từng chứng từ.",
      NotificationRules: "Menu Thông báo (Hệ thống): cấu hình gửi và lịch sử gửi.",
      SystemSettings: "Menu Cài đặt hệ thống: tổ chức, bảo mật, email, lịch, tích hợp.",
      AuditTrail: "Menu Audit & sử dụng.",
      SystemDiagnostics: "Menu Audit & sử dụng › chẩn đoán Outbox (dành cho quản trị kỹ thuật).",
      Documents: "Tệp đính kèm ở mọi màn (dự án, mua hàng, kế toán…) và mở tab Sổ tài liệu kiểm soát.",
    },
    codes: {
      EmployeeProfiles: {
        Read: "Xem sổ hồ sơ",
        ReadSensitive: "Xem thông tin nhạy cảm",
        Manage: "Tạo, sửa hồ sơ",
        UpdateAny: "Sửa mọi hồ sơ",
        Approve: "Duyệt hồ sơ",
      },
      SkillAssessments: {
        Read: "Xem đánh giá",
        ReadTeam: "Xem năng lực của tổ",
        Manage: "Lập, sửa đánh giá",
        Approve: "Duyệt đánh giá",
      },
      SkillCatalogs: {
        Read: "Xem danh mục",
      },
      OperationalRequests: {
        Read: "Xem đơn",
        ReadReview: "Rà soát đơn",
        Confirm: "Xác nhận đơn",
        Approve: "Duyệt đơn",
      },
      AdministrativeReceipts: {
        Read: "Xem hồ sơ tiếp nhận",
        Manage: "Tiếp nhận, xử lý",
      },
      AccountingReceipts: {
        Read: "Xem hồ sơ tiếp nhận",
        Manage: "Tiếp nhận, xử lý",
      },
      AnnualLeave: {
        Read: "Xem sổ phép mọi người",
        Manage: "Điều chỉnh sổ phép",
      },
      Timesheets: {
        Read: "Xem chấm công của mình",
        Manage: "Khai, gửi chấm công",
      },
      TimesheetApprovals: {
        Read: "Xem chấm công chờ duyệt",
        ReadAll: "Xem chấm công toàn công ty",
        Approve: "Duyệt chấm công",
      },
      TimesheetPeriods: {
        Read: "Xem kỳ chấm công",
        Manage: "Khóa, mở khóa kỳ",
      },
      Capacity: {
        Read: "Xem tải công việc",
        Manage: "Nhập dữ liệu năng lực",
      },
      CompanyCalendars: {
        Read: "Xem lịch công ty",
        Manage: "Soạn lịch, gửi duyệt",
      },
      CompanyCalendarApprovals: {
        Read: "Xem lịch chờ duyệt",
        Confirm: "Xác nhận lịch",
        Approve: "Phê duyệt lịch",
      },
      Attendance: {
        Read: "Xem bảng công mọi người",
        ReadOwn: "Xem bảng công của mình",
        Manage: "Nhập dữ liệu máy chấm công",
      },
      Payroll: {
        Read: "Xem bảng lương",
        ReadOwn: "Xem phiếu lương của mình",
        Manage: "Lập, sửa bảng lương",
        Approve: "Duyệt bảng lương",
        Publish: "Phát hành phiếu lương",
        Send: "Gửi phiếu lương",
        Export: "Xuất Excel",
      },
      MandayCosts: {
        Read: "Xem",
        ReadSensitive: "Xem đơn giá chi tiết",
        Manage: "Tạo, kích hoạt đơn giá",
      },
      CompanyVehicles: {
        Read: "Xem danh sách xe",
        Manage: "Quản lý xe, bảo dưỡng",
      },
      ControlledDocuments: {
        Read: "Xem sổ tài liệu",
        Manage: "Soạn, sửa, gửi, hủy",
        Confirm: "Xác nhận tài liệu",
        Approve: "Phê duyệt tài liệu",
      },
      ApprovalTasks: {
        Read: "Xem việc chờ duyệt của mình",
        ReadAll: "Xem mọi việc duyệt",
        Approve: "Duyệt, từ chối",
      },
      WorkflowActivities: {
        Manage: "Hoàn thành việc được giao",
      },
      ProjectDashboards: {
        Read: "Xem Trung tâm điều hành",
      },
      ExecutionWarnings: {
        Read: "Xem cảnh báo",
      },
      Notifications: {
        Read: "Nhận, xem thông báo",
      },
      Chat: {
        Read: "Xem trò chuyện",
        Manage: "Gửi, sửa, xóa tin nhắn",
        Moderate: "Kiểm duyệt trò chuyện",
        Export: "Xuất nội dung",
      },
      Projects: {
        Read: "Xem dự án liên quan",
        ReadAll: "Xem mọi dự án",
        Manage: "Lập, sửa, gửi đăng ký",
        UpdateAll: "Sửa đăng ký mọi dự án",
        AssignLeader: "Chỉ định trưởng dự án",
        Confirm: "Xác nhận đăng ký",
        Approve: "Phê duyệt đăng ký",
        Close: "Đóng dự án",
        Cancel: "Hủy dự án",
        ImportHistorical: "Nhập dự án cũ",
      },
      ProjectRegistrationInbox: {
        Read: "Xem hộp đăng ký",
        ReadRelated: "Xem đăng ký liên quan",
        ReadUnassigned: "Xem đăng ký chưa phân công",
      },
      ProjectLeaders: {
        Read: "Xem phân công",
        Manage: "Phân công, thay trưởng dự án",
      },
      WbsNodes: {
        Read: "Xem WBS, việc của tôi",
        Manage: "Lập, sửa WBS",
      },
      Execution: {
        Read: "Xem thực thi",
        Manage: "Cập nhật tiến độ, giao việc",
      },
      ProjectMilestones: {
        Read: "Xem mốc",
        Manage: "Sửa mốc, ghi mốc thực tế",
      },
      ExternalProgress: {
        ReadCustomer: "Xem tiến độ cho khách hàng",
        ReadSubcontractor: "Xem tiến độ cho thầu phụ",
      },
      WbsTemplates: {
        Read: "Xem mẫu WBS",
        Manage: "Lập, phát hành mẫu WBS",
      },
      Reports: {
        Read: "Xem báo cáo",
        Manage: "Lập, sửa, gửi báo cáo",
        Approve: "Xem xét, duyệt báo cáo",
        Export: "Xuất báo cáo",
      },
      ReportSchedules: {
        Read: "Xem lịch gửi",
        Manage: "Cài lịch gửi",
      },
      Issues: {
        Read: "Xem issue",
        Manage: "Tạo, xử lý issue",
        Approve: "Duyệt, quyết định issue",
      },
      Lessons: {
        Read: "Xem bài học",
        Manage: "Thêm, sửa, xóa bài học",
      },
      CustomerSurveys: {
        Read: "Xem khảo sát",
        Manage: "Lập, cập nhật khảo sát",
      },
      ProjectClosureReviews: {
        Read: "Xem đánh giá",
        Manage: "Nhập đánh giá",
      },
      ProjectClosureConclusions: {
        Read: "Xem kết luận",
        Approve: "Phê duyệt đóng dự án",
      },
      ProjectClosures: {
        SignProduction: "Ký thay Sản xuất",
        SignDirector: "Ký thay Giám đốc",
      },
      Customers: {
        Read: "Xem khách hàng",
        Manage: "Thêm, sửa, nhập, xóa",
        Export: "Xuất Excel",
      },
      CustomerInteractions: {
        Read: "Xem chăm sóc",
        Manage: "Ghi nhận chăm sóc",
      },
      ProjectCommunications: {
        Read: "Xem nhật ký",
        Manage: "Ghi nhật ký trao đổi",
      },
      CustomerHistory: {
        ReadFinancial: "Xem lịch sử tài chính",
      },
      FinancialProfiles: {
        Read: "Xem hồ sơ tài chính",
        ReadSensitive: "Xem tài khoản ngân hàng",
        Manage: "Sửa hồ sơ tài chính",
      },
      Partners: {
        Read: "Xem đối tác",
        Manage: "Thêm, sửa, xóa đối tác",
      },
      Suppliers: {
        Read: "Xem nhà cung cấp",
        Manage: "Thêm, sửa, xóa nhà cung cấp",
      },
      Products: {
        Read: "Xem sản phẩm",
        Manage: "Thêm, sửa, nhập, xóa",
        Export: "Xuất Excel",
      },
      ProductCategories: {
        Read: "Xem nhóm",
        Manage: "Quản lý nhóm",
      },
      ProductRevisions: {
        Read: "Xem phiên bản",
        Manage: "Tạo, kích hoạt phiên bản",
      },
      CustomerProducts: {
        Read: "Xem liên kết",
        Manage: "Gắn, gỡ sản phẩm",
      },
      Quotations: {
        Read: "Xem báo giá",
        Manage: "Lập, sửa, gửi báo giá",
        Export: "Xuất báo giá",
      },
      QuotationLines: {
        ReadSensitive: "Xem giá vốn",
      },
      ProjectContracts: {
        Read: "Xem hợp đồng",
        Manage: "Lập, sửa hợp đồng",
      },
      WarrantyTickets: {
        Read: "Xem phiếu bảo hành",
        Manage: "Lập, xử lý phiếu",
      },
      DocumentTemplates: {
        Read: "Xem mẫu",
        Manage: "Soạn, sửa mẫu",
      },
      PurchaseRequests: {
        Read: "Xem đề nghị",
        Manage: "Lập, sửa, gửi, hủy",
        Quote: "Nhập báo giá NCC",
        Confirm: "Xác nhận đề nghị",
        Approve: "Duyệt đề nghị",
        AdminReceive: "HCNS tiếp nhận",
        AccountingReceive: "Kế toán tiếp nhận",
      },
      PurchaseOrders: {
        Read: "Xem đơn mua",
        Manage: "Lập, sửa, gửi, hủy",
        Deliver: "Ghi nhận giao hàng",
      },
      MaterialStock: {
        Read: "Xem kho",
        Manage: "Lập phiếu nhập, xuất",
        Approve: "Duyệt phiếu kho",
        BypassApproval: "Ghi kho không qua duyệt",
        Reverse: "Đảo phiếu kho",
      },
      Materials: {
        Read: "Xem vật tư",
        Manage: "Thêm, sửa, xóa vật tư",
      },
      PaymentRequests: {
        Read: "Xem phiếu liên quan",
        ReadAll: "Xem mọi phiếu",
        Manage: "Lập, sửa, gửi, hủy",
        Approve: "Duyệt phiếu",
        Disburse: "Chi tiền",
        ConfirmPaid: "Xác nhận đã chi",
      },
      ProjectInvoices: {
        Read: "Xem hóa đơn",
        Manage: "Xuất, sửa, hủy hóa đơn",
        RecordPayment: "Ghi nhận thu tiền",
      },
      SupplierInvoices: {
        Read: "Xem hóa đơn",
        Manage: "Nhập, sửa hóa đơn",
        RecordPayment: "Ghi nhận trả tiền",
        ReleasePaymentHold: "Gỡ tạm giữ thanh toán",
      },
      CashBook: {
        Read: "Xem sổ quỹ",
        Manage: "Ghi sổ, số dư đầu kỳ",
        Reverse: "Đảo bút toán",
      },
      BankStatements: {
        Read: "Xem sao kê",
        Manage: "Nhập, đối chiếu sao kê",
      },
      Finance: {
        Read: "Xem BCTC, chốt tháng",
        PeriodClose: "Khóa sổ tháng",
        PeriodReopen: "Mở lại sổ",
      },
      Amortizations: {
        Read: "Xem phân bổ",
        Manage: "Lập, sửa phân bổ",
      },
      ExpenseCategories: {
        Read: "Xem mã chi phí",
        Manage: "Quản lý mã chi phí",
      },
      ExchangeRates: {
        Read: "Xem tỷ giá",
        Manage: "Nhập, sửa tỷ giá",
      },
      Users: {
        Read: "Xem tài khoản",
        Manage: "Tạo, sửa, khóa tài khoản",
        AssignPermissions: "Gán vai trò, quyền",
        Export: "Xuất danh sách",
      },
      Roles: {
        Read: "Xem vai trò, nhóm",
        Manage: "Tạo, sửa vai trò, nhóm",
        AssignMembers: "Gán thành viên",
        AssignPermissions: "Gán quyền",
      },
      Departments: {
        Read: "Xem phòng ban",
        Manage: "Quản lý phòng ban",
      },
      WorkflowDefinitions: {
        Read: "Xem quy trình",
        Manage: "Tạo, sửa, kích hoạt quy trình",
      },
      WorkflowInstances: {
        ReadAll: "Xem mọi phiên",
        Manage: "Chạy lại, đồng bộ lại",
        Start: "Khởi động quy trình",
      },
      NotificationRules: {
        Read: "Xem cấu hình",
        Manage: "Sửa cấu hình",
      },
      SystemSettings: {
        Read: "Xem cài đặt",
        Manage: "Sửa cài đặt",
      },
      AuditTrail: {
        Read: "Xem nhật ký",
        ReadSensitive: "Xem chi tiết nhạy cảm",
        Export: "Xuất nhật ký",
      },
      SystemDiagnostics: {
        Read: "Xem chẩn đoán",
      },
      Documents: {
        Read: "Xem, tải tệp",
        Manage: "Tải lên, xóa tệp",
      },
    },
    codeHelp: {
      EmployeeProfiles: {
        Read: "Mở menu Hồ sơ nhân viên, xem danh sách và hồ sơ của mọi nhân viên (không gồm thông tin nhạy cảm).",
        ReadSensitive: "Xem CCCD, địa chỉ, tài khoản ngân hàng và các trường mã hóa khác trong hồ sơ.",
        Manage: "Tạo hồ sơ cho nhân viên mới, sửa và gửi duyệt hồ sơ.",
        UpdateAny: "Sửa trực tiếp hồ sơ của bất kỳ nhân viên nào, kể cả hồ sơ đã duyệt.",
        Approve: "Phê duyệt hoặc từ chối hồ sơ nhân viên đã gửi duyệt.",
      },
      SkillAssessments: {
        Read: "Mở Bản đồ kỹ năng, xem kết quả đánh giá năng lực.",
        ReadTeam: "Xem đánh giá năng lực của các thành viên trong tổ mình phụ trách.",
        Manage: "Lập, sửa và gửi duyệt phiếu đánh giá năng lực.",
        Approve: "Phê duyệt hoặc từ chối phiếu đánh giá năng lực.",
      },
      SkillCatalogs: {
        Read: "Xem danh mục kỹ năng và thang đánh giá.",
      },
      OperationalRequests: {
        Read: "Quyền nền để xem đơn của người khác; cấp kèm «Rà soát đơn».",
        ReadReview: "Xem sổ đơn của mọi người để kiểm tra (cần kèm «Xem đơn»).",
        Confirm: "Xác nhận đơn ở bước kiểm tra trước khi duyệt; được từ chối đơn (cần kèm «Xem đơn» và «Rà soát đơn»).",
        Approve: "Duyệt hoặc từ chối đơn ở bước duyệt (cần kèm «Xem đơn» và «Rà soát đơn»).",
      },
      AdministrativeReceipts: {
        Read: "Mở tab Hồ sơ tiếp nhận, xem đơn đã duyệt chuyển tới Hành chính nhân sự.",
        Manage: "Tiếp nhận và cập nhật xử lý đơn phía Hành chính nhân sự.",
      },
      AccountingReceipts: {
        Read: "Mở tab Hồ sơ tiếp nhận, xem đơn đã duyệt chuyển tới Kế toán.",
        Manage: "Tiếp nhận và cập nhật xử lý đơn phía Kế toán.",
      },
      AnnualLeave: {
        Read: "Xem sổ phép năm của mọi nhân viên.",
        Manage: "Ghi bút toán điều chỉnh sổ phép (cộng, trừ ngày phép).",
      },
      Timesheets: {
        Read: "Xem lịch sử chấm công và lời nhắc chấm công của mình.",
        Manage: "Mở tab Chấm công: khai, sửa, gửi duyệt chấm công; đặt nhắc chấm công.",
      },
      TimesheetApprovals: {
        Read: "Mở tab Chấm công chờ duyệt, xem chấm công cần mình duyệt.",
        ReadAll: "Xem chấm công của mọi nhân viên, mọi dự án.",
        Approve: "Duyệt hoặc trả lại chấm công.",
      },
      TimesheetPeriods: {
        Read: "Xem trạng thái khóa của các kỳ chấm công.",
        Manage: "Khóa hoặc mở khóa kỳ chấm công.",
      },
      Capacity: {
        Read: "Xem giờ chuẩn, thiếu giờ, quá tải của nhân viên.",
        Manage: "Nhập dữ liệu năng lực (giờ chuẩn) của nhân viên.",
      },
      CompanyCalendars: {
        Read: "Xem lịch làm việc công ty theo năm.",
        Manage: "Soạn, sửa lịch làm việc công ty và gửi duyệt.",
      },
      CompanyCalendarApprovals: {
        Read: "Xem lịch làm việc đang chờ xác nhận, phê duyệt.",
        Confirm: "Xác nhận lịch làm việc (bước trước phê duyệt).",
        Approve: "Phê duyệt hoặc từ chối lịch làm việc công ty.",
      },
      Attendance: {
        Read: "Mở tab Quản trị chấm công, xem dữ liệu máy chấm công và bảng công tháng của mọi người.",
        ReadOwn: "Xem bảng công tháng của chính mình.",
        Manage: "Nhập dữ liệu từ máy chấm công.",
      },
      Payroll: {
        Read: "Mở tab Bảng lương, xem bảng lương các kỳ.",
        ReadOwn: "Mở tab Phiếu lương của tôi.",
        Manage: "Lập kỳ lương, sửa các dòng lương.",
        Approve: "Duyệt bảng lương.",
        Publish: "Phát hành phiếu lương cho nhân viên xem.",
        Send: "Gửi phiếu lương qua email.",
        Export: "Xuất bảng lương ra Excel.",
      },
      MandayCosts: {
        Read: "Xem bảng chi phí 1 Manday (mở tab cần kèm «Xem đơn giá chi tiết»).",
        ReadSensitive: "Xem đơn giá chi tiết của từng bảng chi phí 1 Manday.",
        Manage: "Tạo và kích hoạt bảng chi phí 1 Manday.",
      },
      CompanyVehicles: {
        Read: "Mở tab Quản lý xe công ty, xem danh sách xe và lịch sử bảo dưỡng.",
        Manage: "Thêm, sửa xe; ghi nhận bảo trì, bảo dưỡng.",
      },
      ControlledDocuments: {
        Read: "Xem sổ tài liệu kiểm soát và các phiên bản.",
        Manage: "Soạn, sửa, gửi duyệt và hủy tài liệu kiểm soát.",
        Confirm: "Xác nhận tài liệu ở bước kiểm tra trước khi phê duyệt.",
        Approve: "Phê duyệt hoặc từ chối tài liệu kiểm soát.",
      },
      ApprovalTasks: {
        Read: "Mở tab Hộp phê duyệt, xem các bước duyệt giao cho mình hoặc nhóm của mình.",
        ReadAll: "Xem mọi việc duyệt của mọi người (giám sát quy trình).",
        Approve: "Duyệt hoặc từ chối bước duyệt được giao.",
      },
      WorkflowActivities: {
        Manage: "Hoàn thành bước thực hiện (không phải duyệt) được giao trong quy trình.",
      },
      ProjectDashboards: {
        Read: "Mở Trung tâm điều hành: danh mục dự án, nguồn lực.",
      },
      ExecutionWarnings: {
        Read: "Xem cảnh báo chậm tiến độ, rủi ro của dự án.",
      },
      Notifications: {
        Read: "Nhận và xem thông báo của mình trên chuông thông báo.",
      },
      Chat: {
        Read: "Xem các cuộc trò chuyện mình tham gia, tab Trao đổi của dự án.",
        Manage: "Gửi, sửa, xóa tin nhắn của mình.",
        Moderate: "Kiểm duyệt trò chuyện: xử lý tin nhắn của người khác.",
        Export: "Xuất nội dung trò chuyện ra file.",
      },
      Projects: {
        Read: "Mở menu Quản lý dự án, xem dự án mình là thành viên hoặc liên quan.",
        ReadAll: "Xem mọi dự án của công ty.",
        Manage: "Lập, sửa, gửi đăng ký dự án; khôi phục, xóa bản nháp lỗi.",
        UpdateAll: "Sửa đăng ký của mọi dự án mà không cần là thành viên.",
        AssignLeader: "Chỉ định trưởng dự án khi phê duyệt đăng ký.",
        Confirm: "Xác nhận đăng ký dự án (bước trước phê duyệt).",
        Approve: "Phê duyệt hoặc trả lại đăng ký dự án; quản lý loại tài liệu dự án.",
        Close: "Đóng dự án khi đã hoàn thành.",
        Cancel: "Hủy dự án hoặc xóa đăng ký chưa duyệt.",
        ImportHistorical: "Nhập dữ liệu dự án cũ (trước khi dùng phần mềm).",
      },
      ProjectRegistrationInbox: {
        Read: "Xem hộp đăng ký dự án chờ mình xử lý.",
        ReadRelated: "Xem đăng ký dự án mình liên quan (Sales, người lập…).",
        ReadUnassigned: "Xem đăng ký dự án chưa có người xử lý.",
      },
      ProjectLeaders: {
        Read: "Xem trưởng dự án được phân công.",
        Manage: "Phân công, thay trưởng dự án.",
      },
      WbsNodes: {
        Read: "Mở tab Việc của tôi, xem cây WBS của dự án.",
        Manage: "Thêm, sửa, xóa hạng mục WBS.",
      },
      Execution: {
        Read: "Mở Dự án › Thực thi › Cảnh báo, xem phân bổ nguồn lực, giao việc, tiến độ, phụ thuộc WBS.",
        Manage: "Cập nhật tiến độ, phân bổ nguồn lực, giao việc, đổi kế hoạch có lý do.",
      },
      ProjectMilestones: {
        Read: "Xem mốc kế hoạch, mốc thực tế của dự án.",
        Manage: "Sửa mốc kế hoạch, ghi ngày đạt mốc thực tế.",
      },
      ExternalProgress: {
        ReadCustomer: "Mở tab Dùng cho khách hàng: tiến độ trình bày cho khách hàng.",
        ReadSubcontractor: "Mở tab Dùng cho nhà thầu phụ: tiến độ phần việc của thầu phụ.",
      },
      WbsTemplates: {
        Read: "Xem mẫu WBS theo loại sản phẩm.",
        Manage: "Lập, sửa, phát hành mẫu WBS và đặt mẫu mặc định.",
      },
      Reports: {
        Read: "Mở tab Báo cáo dự án (và tab Danh mục báo cáo tài chính ở Kế toán).",
        Manage: "Lập, sửa, gửi báo cáo dự án.",
        Approve: "Xem xét, duyệt, trả lại, từ chối báo cáo; mở tab Gửi báo cáo định kỳ.",
        Export: "Xuất báo cáo ra file.",
      },
      ReportSchedules: {
        Read: "Mở tab Gửi báo cáo định kỳ, xem lịch gửi.",
        Manage: "Tạo, sửa, bật, tắt lịch gửi báo cáo.",
      },
      Issues: {
        Read: "Mở tab Theo dõi yêu cầu, xem issue của dự án.",
        Manage: "Tạo issue, cập nhật khắc phục, giao hàng, theo dõi, đính kèm bằng chứng.",
        Approve: "Duyệt theo dõi issue, ra quyết định của PIC và xác nhận.",
      },
      Lessons: {
        Read: "Mở tab Bài học kinh nghiệm.",
        Manage: "Thêm, sửa, xóa bài học kinh nghiệm.",
      },
      CustomerSurveys: {
        Read: "Xem phiếu khảo sát hài lòng khách hàng.",
        Manage: "Lập, cập nhật phiếu khảo sát.",
      },
      ProjectClosureReviews: {
        Read: "Xem đánh giá đóng dự án của các vai trò.",
        Manage: "Nhập, sửa đánh giá đóng dự án của vai trò mình.",
      },
      ProjectClosureConclusions: {
        Read: "Xem kết luận đóng dự án.",
        Approve: "Phê duyệt kết luận đóng dự án.",
      },
      ProjectClosures: {
        SignProduction: "Ký biên bản đóng dự án với vai trò Sản xuất.",
        SignDirector: "Ký biên bản đóng dự án với vai trò Giám đốc.",
      },
      Customers: {
        Read: "Mở menu Khách hàng và Đối tác & NCC, xem thông tin chung.",
        Manage: "Thêm, sửa, nhập từ Excel, kích hoạt, ngừng, xóa, khôi phục khách hàng; kiểm tra trùng.",
        Export: "Xuất danh sách khách hàng ra Excel.",
      },
      CustomerInteractions: {
        Read: "Mở tab Chăm sóc khách hàng.",
        Manage: "Ghi nhận, sửa hoạt động chăm sóc khách hàng.",
      },
      ProjectCommunications: {
        Read: "Xem nhật ký trao đổi với khách hàng theo dự án.",
        Manage: "Ghi nhật ký trao đổi với khách hàng.",
      },
      CustomerHistory: {
        ReadFinancial: "Xem doanh thu, công nợ các dự án của khách hàng.",
      },
      FinancialProfiles: {
        Read: "Xem hồ sơ tài chính (mã số thuế, điều khoản thanh toán…).",
        ReadSensitive: "Xem số tài khoản ngân hàng và thông tin tài chính nhạy cảm.",
        Manage: "Tạo, sửa hồ sơ tài chính khách hàng, đối tác, nhà cung cấp.",
      },
      Partners: {
        Read: "Xem thông tin đối tác.",
        Manage: "Thêm, sửa, ngừng, xóa, khôi phục đối tác.",
      },
      Suppliers: {
        Read: "Xem thông tin nhà cung cấp.",
        Manage: "Thêm, sửa, ngừng, xóa, khôi phục nhà cung cấp.",
      },
      Products: {
        Read: "Mở menu Sản phẩm.",
        Manage: "Thêm, sửa, nhập từ Excel, ngừng, xóa, khôi phục sản phẩm.",
        Export: "Xuất danh sách sản phẩm ra Excel.",
      },
      ProductCategories: {
        Read: "Xem nhóm sản phẩm.",
        Manage: "Thêm, sửa, bật, tắt nhóm sản phẩm.",
      },
      ProductRevisions: {
        Read: "Xem các phiên bản sản phẩm.",
        Manage: "Tạo, sửa, nhập, kích hoạt phiên bản sản phẩm.",
      },
      CustomerProducts: {
        Read: "Xem sản phẩm khách hàng đang dùng.",
        Manage: "Gắn, sửa, gỡ sản phẩm của khách hàng.",
      },
      Quotations: {
        Read: "Mở tab Báo giá.",
        Manage: "Lập, sửa, gửi, nhân bản báo giá (chỉ thành viên Sales/PiPic/trưởng dự án của dự án).",
        Export: "Xuất báo giá ra file.",
      },
      QuotationLines: {
        ReadSensitive: "Xem giá vốn, chi phí từng dòng báo giá.",
      },
      ProjectContracts: {
        Read: "Mở tab PO khách hàng, Hợp đồng & bảo hành; xem hợp đồng, biên bản nghiệm thu.",
        Manage: "Lập, sửa hợp đồng và biên bản nghiệm thu.",
      },
      WarrantyTickets: {
        Read: "Xem phiếu bảo hành, hậu mãi.",
        Manage: "Lập, cập nhật xử lý phiếu bảo hành.",
      },
      DocumentTemplates: {
        Read: "Mở menu Mẫu chứng từ.",
        Manage: "Soạn, sửa mẫu báo giá, hợp đồng, RFQ, P/O.",
      },
      PurchaseRequests: {
        Read: "Mở tab Đề nghị mua hàng.",
        Manage: "Lập, sửa, gửi, hủy, xóa nháp đề nghị mua hàng.",
        Quote: "Nhập, so sánh báo giá nhà cung cấp cho đề nghị.",
        Confirm: "Xác nhận đề nghị mua hàng (bước trước duyệt).",
        Approve: "Duyệt hoặc từ chối đề nghị mua hàng.",
        AdminReceive: "Hành chính nhân sự tiếp nhận đề nghị đã duyệt.",
        AccountingReceive: "Kế toán tiếp nhận đề nghị đã duyệt.",
      },
      PurchaseOrders: {
        Read: "Mở tab Đơn mua hàng.",
        Manage: "Lập, sửa, gửi, hủy, xóa nháp đơn mua hàng.",
        Deliver: "Ghi nhận nhà cung cấp đã giao hàng.",
      },
      MaterialStock: {
        Read: "Mở menu Kho: tồn kho, kiểm kê, lịch sử nhập xuất.",
        Manage: "Lập phiếu nhập, xuất kho; xóa phiếu nháp.",
        Approve: "Duyệt phiếu nhập, xuất kho.",
        BypassApproval: "Ghi phiếu kho có hiệu lực ngay, không qua duyệt.",
        Reverse: "Đảo (hủy bằng bút toán ngược) phiếu kho đã ghi.",
      },
      Materials: {
        Read: "Mở menu Vật tư, linh kiện.",
        Manage: "Thêm, sửa, gửi duyệt, ngừng, xóa, khôi phục vật tư.",
      },
      PaymentRequests: {
        Read: "Mở menu Chứng từ thanh toán, xem phiếu mình lập hoặc được giao chi.",
        ReadAll: "Xem mọi phiếu tạm ứng, thanh toán, hoàn ứng và tổng hợp theo dự án.",
        Manage: "Lập, sửa, gửi, hủy, xóa nháp phiếu.",
        Approve: "Duyệt hoặc từ chối phiếu.",
        Disburse: "Chi tiền cho phiếu đã duyệt.",
        ConfirmPaid: "Xác nhận phiếu đã được chi.",
      },
      ProjectInvoices: {
        Read: "Mở tab Tình hình xuất hoá đơn.",
        Manage: "Xuất, sửa, hủy hóa đơn bán ra.",
        RecordPayment: "Ghi nhận khách hàng đã thanh toán hóa đơn.",
      },
      SupplierInvoices: {
        Read: "Mở tab Hoá đơn nhà cung cấp, xem công nợ phải trả.",
        Manage: "Nhập, sửa hóa đơn nhà cung cấp.",
        RecordPayment: "Ghi nhận đã trả tiền nhà cung cấp.",
        ReleasePaymentHold: "Gỡ tạm giữ để hóa đơn được thanh toán.",
      },
      CashBook: {
        Read: "Mở tab Sổ quỹ.",
        Manage: "Ghi thu, chi; đặt số dư đầu kỳ.",
        Reverse: "Đảo bút toán sổ quỹ đã ghi.",
      },
      BankStatements: {
        Read: "Mở tab Sao kê ngân hàng.",
        Manage: "Nhập sao kê, đối chiếu với sổ sách.",
      },
      Finance: {
        Read: "Mở tab Báo cáo tài chính công ty, Chốt tháng.",
        PeriodClose: "Khóa sổ tháng (chốt số liệu).",
        PeriodReopen: "Mở lại tháng đã khóa sổ.",
      },
      Amortizations: {
        Read: "Mở tab Trả trước và CCDC.",
        Manage: "Lập, sửa lịch phân bổ chi phí trả trước, CCDC.",
      },
      ExpenseCategories: {
        Read: "Mở tab Mã chi phí.",
        Manage: "Thêm, sửa, ngừng mã chi phí.",
      },
      ExchangeRates: {
        Read: "Mở tab Tỷ giá.",
        Manage: "Nhập, sửa tỷ giá.",
      },
      Users: {
        Read: "Mở menu Người dùng & phân quyền, xem tài khoản.",
        Manage: "Tạo, sửa, khóa, mở khóa tài khoản.",
        AssignPermissions: "Gán vai trò, nhóm và quyền riêng cho tài khoản.",
        Export: "Xuất danh sách tài khoản.",
      },
      Roles: {
        Read: "Xem vai trò, nhóm tài khoản và danh mục quyền.",
        Manage: "Tạo, sửa, bật, tắt vai trò và nhóm tài khoản.",
        AssignMembers: "Thêm, bớt thành viên của nhóm tài khoản.",
        AssignPermissions: "Gán quyền cho vai trò, nhóm tài khoản.",
      },
      Departments: {
        Read: "Mở tab Phòng ban, xem cây phòng ban, tổ.",
        Manage: "Thêm, sửa, sắp xếp phòng ban, tổ.",
      },
      WorkflowDefinitions: {
        Read: "Mở menu Cấu hình quy trình duyệt.",
        Manage: "Tạo, sửa, nhân bản, bật, tắt, xóa quy trình.",
      },
      WorkflowInstances: {
        ReadAll: "Xem mọi phiên quy trình và chi tiết từng bước.",
        Manage: "Chạy lại quy trình, đồng bộ lại trạng thái chứng từ.",
        Start: "Khởi động quy trình cho chứng từ.",
      },
      NotificationRules: {
        Read: "Mở menu Thông báo (Hệ thống), xem cấu hình và lịch sử gửi.",
        Manage: "Sửa cấu hình gửi thông báo.",
      },
      SystemSettings: {
        Read: "Mở menu Cài đặt hệ thống.",
        Manage: "Sửa cài đặt hệ thống.",
      },
      AuditTrail: {
        Read: "Mở menu Audit & sử dụng, xem nhật ký hệ thống, audit phân quyền.",
        ReadSensitive: "Xem giá trị trước/sau nhạy cảm trong nhật ký.",
        Export: "Xuất nhật ký ra file.",
      },
      SystemDiagnostics: {
        Read: "Xem chẩn đoán Outbox của mọi module (quản trị kỹ thuật).",
      },
      Documents: {
        Read: "Xem, tải xuống tệp đính kèm; mở tab Sổ tài liệu kiểm soát.",
        Manage: "Tải lên, xóa tệp đính kèm.",
      },
    },
    sections: {
      topbar: "Thanh trên cùng: thông báo, trò chuyện",
      projectClosure: "Đóng dự án (trong hồ sơ dự án)",
      shared: "Dùng chung ở nhiều màn",
    },
  },
  identityAdmin: {
    moduleOther: "Khác",
    menuPreview: "Xem trước menu",
    menuPreviewNote: "Với bộ quyền đang chọn (kể cả thay đổi chưa lưu), tài khoản sẽ thấy {count} mục menu.",
    menuPreviewEmpty: "Không thấy mục nào",
    modules: {
      Web: "Điểm vào ứng dụng",
      Identity: "Tài khoản & phân quyền",
      Config: "Danh mục & khách hàng",
      Project: "Dự án",
      Workforce: "Nhân sự & chấm công",
      Reporting: "Báo cáo",
      Document: "Tài liệu",
      Notification: "Thông báo",
      Chat: "Trao đổi",
      Workflow: "Quy trình duyệt",
      Procurement: "Mua hàng & tài chính",
    },
    ruleLabels: {
      Read: "Xem",
      Manage: "Quản lý",
      Export: "Xuất",
      Import: "Nhập",
      Approved: "Duyệt",
      Action: "Thao tác",
      Other: "Đặc biệt",
    },
    change: {
      create: "Tạo mới: {name}",
      info: "Thông tin chung",
      role: "Vai trò",
      group: "Nhóm",
      member: "Thành viên",
      code: "Quyền",
      codes: "{count} quyền",
    },
    gridNote: {
      user: "Bấm vào ô để cấp/thu quyền riêng cho người này. Ô xanh nhạt là quyền nhận từ vai trò hoặc nhóm — muốn thu thì gỡ vai trò/nhóm ở trên. Bấm tên chức năng để chọn cả dòng.",
      group: "Bấm vào ô để cấp/thu quyền riêng của nhóm; mọi thành viên nhận theo. Ô xanh nhạt là quyền từ vai trò của nhóm. Bấm tên chức năng để chọn cả dòng.",
      role: "Bấm vào ô để thêm/bớt quyền trong vai trò; mọi người và nhóm có vai trò này nhận theo. Bấm tên chức năng để chọn cả dòng.",
    },
    legendOwn: {
      user: "Quyền riêng",
      group: "Quyền của nhóm",
      role: "Có trong vai trò",
    },
    grantedBy: "Đang có nhờ: {sources}",
    grantReadAll: "Cho xem hết",
    grantAll: "Cấp hết",
    revokeAll: "Bỏ hết",
    whoCanHint: "Xem ai làm được chức năng này",
    rowToggleHint: "Bấm để chọn/bỏ cả dòng",
    copySuffix: "bản sao",
    askPlaceholder: "Hỏi nhanh: gõ tên người, nhóm, vai trò hoặc chức năng (vd: bảng lương, Tuấn…)",
    askFeatures: "Ai làm được…",
    askPeople: "Người này làm được gì",
    whoCan: "Ai làm được: {feature}",
    whatCan: "{name} làm được gì?",
    answerNote: "Danh sách tính theo vai trò và nhóm; quyền cấp riêng từng người xem ở trang của người đó. Bấm tên để mở và chỉnh.",
    action: "Thao tác",
    people: "Người",
    via: "Qua vai trò / nhóm",
    nobody: "Chưa có ai",
    addRole: "Thêm vai trò",
    addGroup: "Thêm vào nhóm",
    addMember: "Thêm thành viên",
    remove: "Gỡ",
    usedBy: "Đang dùng bởi",
    canDo: "Làm được gì",
    canDoSummary: "Làm được {count} việc trong {modules} phân hệ",
    heldOnly: "Chỉ hiện quyền đang có",
    expandAll: "Mở hết",
    collapseAll: "Thu gọn",
    catalogNote: "Toàn bộ chức năng của hệ thống theo phân hệ. Bấm vào một quyền hoặc tên chức năng để xem ai đang làm được.",
    gridReadOnly: "Chỉ xem — bạn không có quyền chỉnh mục này.",
    legendInherited: "Từ vai trò/nhóm",
    legendAdd: "Sẽ cấp",
    legendRemove: "Sẽ thu",
    technicalDetails: "Chi tiết kỹ thuật ({count} dòng quyền hiệu lực)",
    history: "Lịch sử thay đổi",
    pendingChanges: "{count} thay đổi chờ lưu:",
    reasonRequired: "Lý do thay đổi (bắt buộc)",
    grantOptions: "Thời hạn",
    discard: "Hoàn tác",
    saveChanges: "Lưu thay đổi",
    impactRole: "Ảnh hưởng {users} người · {groups} nhóm",
    impactGroup: "Ảnh hưởng {users} thành viên",
    copied: "Đã chép vai trò, nhóm và quyền riêng của {name} — kiểm tra rồi bấm Lưu thay đổi.",
    copyFrom: "Chép quyền từ người khác…",
    cloneRole: "Nhân bản",
    editInfo: "Sửa thông tin",
    lockAccount: "Khóa tài khoản",
    unlockAccount: "Mở khóa",
    railFilter: "Lọc tài khoản",
    railFilterAll: "Tất cả tài khoản",
    railFilterLocked: "Đang khóa",
    grantMore: "Cấp cho…",
    grantStaged: "Đã đưa quyền {code} cho {name} vào khay — nhập lý do rồi bấm Lưu thay đổi.",
    grantNotAllowed: "Bạn không có quyền cấp quyền riêng cho người này.",
    newUser: "Tạo tài khoản",
    openResponsibilities: "Trách nhiệm đang mở",
    openResponsibilitiesHelp:
      "Chuyển giao hết các mục dưới đây rồi mới vô hiệu hóa; hoặc buộc vô hiệu hóa — việc duyệt đích danh sẽ trả về vai trò của bước, các mục còn lại cần xử lý tay.",
    responsibilitySourceUnavailable:
      "Chưa kiểm được nguồn: {sources}. Không thể vô hiệu hóa thường cho tới khi nguồn hoạt động lại.",
    transferTo: "Chuyển giao cho",
    transfer: "Chuyển giao nhóm này",
    forceDeactivate: "Vô hiệu hóa (buộc)",
    deactivated:
      "Đã vô hiệu hóa tài khoản ({released} việc duyệt trả về vai trò).",
    transferred: "Đã chuyển giao {count} mục.",
    responsibilityKinds: {
      WorkflowTask: "Việc duyệt đích danh",
      ProjectLeader: "Trưởng dự án",
      ProjectPic: "PIC công việc",
      ProjectSales: "Kinh doanh dự án",
      Customer: "Khách hàng phụ trách",
      ControlledDocument: "Tài liệu kiểm soát đang soạn",
    },
    editAccount: "Sửa tài khoản / mật khẩu",
    accountSaved: "Đã lưu tài khoản.",
    password: "Mật khẩu ban đầu",
    resetPassword: "Mật khẩu mới (để trống để giữ nguyên)",
    confirmPassword: "Nhập lại mật khẩu",
    passwordHelp:
      "Mật khẩu tối thiểu 12 ký tự; hai ô mật khẩu phải trùng nhau.",
    passwordResetHelp:
      "Chỉ nhập khi cần đặt lại mật khẩu. Tối thiểu 12 ký tự; người dùng sẽ cần đăng nhập lại.",
    selectRoles: "Chọn vai trò",
    selectGroups: "Chọn nhóm tài khoản",
    selectMembers: "Chọn thành viên",
    linkedProfile: "Liên kết hồ sơ HR",
    linked: "Đã liên kết",
    notLinked: "Chưa liên kết",
    effectivePermissionCount: "Quyền hiệu lực ({count} mã quyền)",
    auditHistory: "Lịch sử phân quyền",
    occurredAt: "Thời điểm",
    auditAction: "Thao tác",
    actor: "Người thực hiện",
    auditLimit:
      "Hiển thị thay đổi trực tiếp của đối tượng trong 500 sự kiện gần nhất toàn hệ thống. Thay đổi vai trò/nhóm được xem tại chính vai trò/nhóm đó.",
    beforeChange: "Trước thay đổi",
    afterChange: "Sau thay đổi",
    setGrantMetadata: "Thay phạm vi / thời hạn của các quyền đang chọn",
    setMembershipDates: "Thay thời hạn của các thành viên / nhóm đang chọn",
    replaceMetadataHelp:
      "Khi lưu, cấu hình dưới đây áp dụng cho toàn bộ lựa chọn đang giữ lại và thêm mới. Thời gian theo múi giờ trên máy của bạn.",
    preserveMetadataHelp:
      "Giữ nguyên phạm vi và thời hạn hiện có. Lựa chọn thêm mới dùng cấu hình mặc định.",
    invalidGrant:
      "Nhập mã phạm vi và khoảng thời gian hợp lệ; thời điểm kết thúc phải sau bắt đầu.",
    directPermissionExpiry:
      "Quyền trực tiếp thêm mới mặc định hết hạn sau 90 ngày nếu không đặt ngày kết thúc.",
    ruleBasedMembers:
      "Thành viên do quy tắc nhân sự quản lý; không chỉnh thủ công tại đây.",
    roleImpact:
      "Vai trò này đang được gán trực tiếp cho {users} tài khoản và {groups} nhóm. Thay quyền sẽ ảnh hưởng cả người nhận qua nhóm; “—” nghĩa là chưa có quyền xem số liệu.",
    groupPreview: "Xem trước {count} mã quyền cấu hình · {members} thành viên",
    groupPreviewHelp:
      "Tổng hợp quyền trực tiếp và vai trò đang chọn. Quyền thực tế còn phụ thuộc trạng thái, phạm vi, thời hạn và điều kiện HR của từng tài khoản.",
    searchPermissions: "Tìm mã quyền / chức năng",
    selectedOnly: "Chỉ quyền đang chọn",
    selectionCount: "{count} mã quyền",
    scopes: {
      Global: "Toàn hệ thống",
      Organization: "Đơn vị tổ chức",
      Project: "Dự án",
      Resource: "Đối tượng",
      Own: "Cá nhân",
      Customer: "Khách hàng",
      Catalog: "Danh mục",
    },

    title: "Nhân sự & phân quyền",
    lockHint: "Khóa tài khoản {name}: nhập lý do rồi bấm \"Xác nhận\". Nếu người này còn việc đang phụ trách, hệ thống sẽ yêu cầu bàn giao trước.",
    unlockHint: "Mở lại tài khoản {name}: nhập lý do rồi bấm \"Xác nhận\".",
    accessViews: {
      subjects: "Ai được quyền",
      catalog: "Vai trò & quyền",
      organization: "Phòng ban",
    },
    railSearch: "Tìm người, nhóm, vai trò… (không cần dấu)",
    rolesShort: "{count} vai trò",
    membersShort: "{count} người",
    permissionsShort: "{count} quyền",
    lockedShort: "đã khóa",
    catalogHint: "Mọi quyền trong hệ thống",
    pickHint: "Chọn một người hoặc nhóm ở cột trái để xem và sửa quyền.",
    holders: "Đang có quyền này — Vai trò: {roles} · Nhóm: {groups} · {users} người (chưa tính quyền cấp riêng)",
    explain: {
      subjects: "Chọn người hoặc nhóm ở cột trái (hoặc gõ vào ô Hỏi nhanh): thấy ngay họ làm được gì theo từng phân hệ, nhờ vai trò/nhóm nào; thêm/gỡ vai trò, nhóm, bấm ô để cấp/thu quyền riêng — mọi thay đổi gom vào khay dưới cùng, nhập một lý do và lưu một lần.",
      catalog: "Vai trò là gói quyền đặt tên (vd Kế toán). Chọn vai trò để bấm ô thêm/bớt quyền, xem ai đang dùng, nhân bản vai trò; mở Danh mục quyền và bấm vào chức năng để biết ai làm được.",
      users: "Chọn một người để xem họ được làm gì và vì sao: vai trò gán trực tiếp, nhóm tài khoản tham gia, quyền cấp riêng, và danh sách quyền hiệu lực có ghi nguồn. Sửa phân quyền của người đó tại đây.",
      roles: "Vai trò là một gói quyền đặt tên (ví dụ Kế toán). Gán vai trò cho người hoặc nhóm thì họ có cả gói quyền đó.",
      permissions: "Danh mục mọi việc có thể làm trong hệ thống. Quyền được gom vào vai trò, hoặc cấp thẳng cho nhóm/người.",
      groups: "Nhóm tài khoản là một nhóm người cùng nhận vai trò và/hoặc quyền (ví dụ nhóm xem bảng lương). Thêm người vào nhóm là họ có quyền của nhóm.",
      organization: "Cây phòng ban và tổ dùng chung toàn hệ thống. Hồ sơ nhân viên chọn đơn vị từ cây này; Phòng ban và Tổ trên hồ sơ được điền theo cây. Mã đơn vị không đổi sau khi tạo; đơn vị không dùng nữa thì ngừng dùng thay vì xóa.",
    },
    tabGroups: {
      people: "Nhân sự",
      access: "Phân quyền",
    },
    tabs: {
      profiles: "Hồ sơ nhân viên",
      users: "Theo người dùng",
      roles: "Vai trò",
      permissions: "Danh mục quyền",
      groups: "Nhóm tài khoản",
      departments: "Phòng ban",
    },
    departments: {
      title: "Phòng ban",
      new: "Thêm đơn vị",
      code: "Mã đơn vị",
      codeHint: "Viết hoa, chỉ chữ, số, - hoặc _. Không đổi được sau khi tạo.",
      name: "Tên đơn vị",
      parent: "Thuộc đơn vị",
      topLevel: "— Cấp gốc —",
      description: "Mô tả",
      sortOrder: "Thứ tự",
      members: "Nhân viên",
      children: "Đơn vị con",
      path: "Đường dẫn",
      active: "Đang dùng",
      inactive: "Ngừng dùng",
      activate: "Dùng lại",
      deactivate: "Ngừng dùng",
      search: "Tìm mã, tên đơn vị",
      empty: "Chưa có đơn vị nào.",
      saved: "Đã lưu đơn vị.",
      membersHint: "Số nhân viên theo hồ sơ nhân viên đã duyệt.",
    },
    users: "Tài khoản",
    roles: "Vai trò",
    permissions: "Quyền",
    accountGroups: "Nhóm tài khoản",
    permissionCatalog: "Danh mục quyền",
    userName: "Tên đăng nhập",
    employeeCode: "Mã nhân viên",
    loginEligible: "Đủ điều kiện đăng nhập",
    fullName: "Họ tên",
    email: "Email",
    directRoles: "Vai trò trực tiếp",
    effectivePermissions: "Quyền hiệu lực",
    permissionCode: "Mã quyền",
    source: "Nguồn cấp",
    sourceName: "Tên nguồn",
    scope: "Phạm vi",
    scopeNotSupported: "không hiệu lực (Q23)",
    scopeId: "Mã phạm vi",
    validFrom: "Hiệu lực từ",
    validTo: "Hiệu lực đến",
    grantSource: "Nguồn cấp quyền",
    system: "Hệ thống",
    membershipMode: "Cách xác định thành viên",
    members: "Thành viên",
    newRole: "Tạo vai trò",
    newGroup: "Tạo nhóm tài khoản",
    reason: "Lý do thay đổi",
    yes: "Có",
    no: "Không",
    activate: "Kích hoạt",
    deactivate: "Ngưng sử dụng",
    saveRoles: "Lưu vai trò",
    saveGroups: "Lưu nhóm",
    saveMembers: "Lưu thành viên",
    savePermissions: "Lưu quyền",
    service: "Dịch vụ",
    feature: "Chức năng",
    readOnlyNoPermission: "Bạn không có quyền đọc khu vực này.",
    authorizationReadRequired:
      "Cần đồng thời Users.Read và Roles.Read để xem phân quyền tài khoản.",
    matrixStatusHelp:
      "Quyền đã triển khai có thể được phân công; quyền dự kiến được hiển thị nhưng bị khóa; N/A là không áp dụng. Các quyền nhạy cảm được đánh dấu nổi bật.",
    planned: "Dự kiến",
    plannedHelp:
      "Chức năng này nằm trong kế hoạch nhưng backend chưa sẵn sàng nên chưa thể phân quyền.",
    notApplicable: "N/A",
    notApplicableHelp:
      "Quyền này không có ý nghĩa nghiệp vụ đối với chức năng này.",
    writeComposite:
      "“Ghi” chỉ là cách hiển thị tổng hợp của “Thêm” và “Cập nhật”, không được gửi như một mã quyền.",
    legacyCompatibility: "Quyền tương thích cũ",
    legacyCompatibilityHelp:
      "Tên thay thế theo từng endpoint được giữ trong thời gian chuyển đổi; đây không phải quy tắc chuẩn của ma trận.",
    legacyCanonicalTarget: "Quyền chuẩn tương ứng: {code}",
    legacyBadge: "Có tên quyền tương thích cũ",
    legacyOnly: "Chỉ là tên quyền cũ",
    matrixScrollLabel: "Ma trận phân quyền; cuộn ngang để xem tất cả các cột",
    directPermissionsFor: "Quyền trực tiếp · {name}",
    permissionsFor: "Quyền · {name}",
    saved: "Đã lưu thay đổi phân quyền.",
    concurrency:
      "Dữ liệu phân quyền đã được thay đổi ở nơi khác. Hãy tải lại và thử lại.",
  },
  workflowAdmin: {
    title: "Cấu hình quy trình duyệt",
    subtitle: "Cấu hình các luồng phê duyệt và hoạt động có thể tái sử dụng.",
    createTitle: "Tạo cấu hình quy trình duyệt",
    description: "Mô tả",
    targetType: "Loại đối tượng",
    targetTypes: "Các loại đối tượng",
    targetGroups: "Nhóm đối tượng",
    initiators: "Quyền khởi tạo",
    allUsers: "Tất cả",
    initiatorPermissions: "Phân quyền người khởi tạo",
    allowRequesterApproval: "Cho phép người yêu cầu phê duyệt bước của mình",
    initiatorUsers: "Người được khởi tạo",
    initiatorRoles: "Vai trò được phép khởi tạo",
    department: "Phân công theo phòng ban",
    departmentUnsupported: "Q ONE chưa hỗ trợ phòng ban",
    steps: "Các bước",
    addStep: "Thêm bước",
    removeStep: "Xóa bước",
    assignmentMode: "Cách phân công",
    singleUser: "Một người",
    multipleUsers: "Nhiều người song song",
    role: "Theo vai trò",
    assignee: "Người xử lý",
    assignees: "Những người xử lý",
    notificationRecipients: "Người nhận thông báo khi bước được kích hoạt",
    notificationRecipientsHelp:
      "Để trống để gửi theo mặc định. Khi chọn, chỉ gửi cho vai trò và người dùng đã chọn; bật ô bên dưới để gửi thêm người nhận mặc định.",
    notificationRoles: "Vai trò nhận thông báo",
    notificationUsers: "Người dùng nhận thông báo",
    notificationRolesPlaceholder: "— Chọn vai trò nhận thông báo —",
    notificationUsersPlaceholder: "— Chọn người nhận thông báo —",
    alsoNotifyDefault: "Gửi thêm cho người nhận mặc định của bước này",
    notificationPreviewDefault: "Thông báo theo người nhận mặc định",
    notificationPreviewCustom: "Thông báo cho vai trò/người dùng đã chọn",
    notificationPreviewIncludeDefault: "Có gửi thêm người nhận mặc định",
    activityHelp: "Bước hoạt động được hoàn tất qua quyền/API chuyên biệt.",
    terminalStep: "Hệ thống hoàn tất",
    terminalStepHelp:
      "Hệ thống tự áp dụng sau khi hoàn thành toàn bộ bước đã cấu hình; đây không phải bước quy trình có thể chỉnh sửa.",
    dependencies: "Tình trạng sử dụng",
    locked: "Đã khóa",
    editable: "Có thể sửa",
    active: "Đang dùng",
    inactive: "Tạm ngưng",
    activate: "Bật",
    deactivate: "Tắt",
    optional: "Không bắt buộc",
    retry: "Thử lại",
    version: "Phiên bản",
    clone: "Nhân thành phiên bản mới",
    cloneNamePrompt: "Tên của phiên bản quy trình được nhân:",
    cloned: "Đã nhân phiên bản quy trình.",
    rejectionMode: "Cách xử lý từ chối",
    rejectTerminate: "Kết thúc quy trình",
    rejectPrevious: "Quay về bước trước",
    rejectTarget: "Quay về bước được chọn",
    rejectTargetStep: "Thứ tự bước đích",
    candidateMode: "Cách xác định người xử lý",
    candidateStatic: "Danh sách cố định",
    candidateSharedRole: "Chung vai trò; người xử lý đầu tiên quyết định",
    candidateDynamic: "Một người động",
    candidateDynamicActor: "Ủy quyền động theo nghiệp vụ",
    dynamicSource: "Nguồn người xử lý động",
    operationalReviewer: "Người duyệt đăng ký nhân sự",
    operationalDirectManager: "Quản lý trực tiếp của người tạo",
    operationalNextManager: "Quản lý cấp tiếp theo của người tạo",
    operationalProjectLeader: "Trưởng dự án của phiếu/phần dự án",
    operationalRequestTarget: "OperationalRequest (Nhân sự & vận hành)",
    operationalRequestPartTarget:
      "OperationalRequestPart (Nhân sự & vận hành theo dự án)",
    targetTypesHelp: "Chọn loại đối tượng mà quy trình áp dụng.",
    unnamedStep: "Chưa đặt tên bước",
    initiator: "Người khởi tạo",
    commaHelp: "Phân tách giá trị tùy chỉnh bằng dấu phẩy.",
    saved: "Đã lưu cấu hình quy trình duyệt.",
    validation: "Vui lòng kiểm tra: {fields}",
    validationNameRequired: "Tên là bắt buộc.",
    validationTargetTypeRequired: "Chọn loại đối tượng áp dụng.",
    validationStepsRequired: "Quy trình phải có ít nhất một bước.",
    validationSlaRequired:
      "Cần đặt hạn xử lý khi đã chọn vai trò nhận chuyển cấp.",
    validationSlaRange:
      "Hạn xử lý phải là số nguyên từ 1 đến 8760 giờ làm việc.",
    validationDynamicSource:
      "Nguồn người xử lý động không phù hợp với cách xác định đã chọn.",
    validationAssignee: "Chọn đúng một nguồn người duyệt cho bước này.",
    validationCandidateMode:
      "Bước hoạt động do người yêu cầu thực hiện, không được cấu hình người duyệt động.",
    validationUnknown: "Giá trị cấu hình chưa hợp lệ.",
    validationGroupUnsupported: "Nhóm không hợp lệ với loại đối tượng đã chọn.",
    validationFirstStepType: "Bước 1 của loại đối tượng này phải là bước {type}.",
    validationRejectUnsupported: "Loại đối tượng này không hỗ trợ trả về bước trước; chọn «Kết thúc quy trình».",
    validationDynamicSourceUnsupported: "Nguồn người xử lý động không được loại đối tượng này hỗ trợ.",
    validationStepKeyUnsupported: "Mốc không thuộc danh sách mốc của loại đối tượng này.",
    condition: "Điều kiện áp dụng bước",
    conditionText: {
      rolesNotIn: "người lập KHÔNG có vai trò nào trong: {roles}",
      rolesIn: "người lập có một trong các vai trò: {roles}",
      roleIs: "người lập có vai trò {role}",
      roleIsNot: "người lập không có vai trò {role}",
      and: "và",
      or: "hoặc",
      not: "không phải",
    },
    conditionPlaceholder: "vd approvalCurrency != \"VND\" or approvalAmount > 5000000",
    conditionHint: "Để trống = luôn áp dụng; điều kiện sai thì bỏ qua bước. Toán tử: == != > >= < <=, in [..], not in, and, or, not; chữ đặt trong nháy kép.",
    conditionVariables: "Biến loại hồ sơ gửi:",
    validationConditionLength: "Điều kiện tối đa 1000 ký tự.",
    validationConditionVariableUnsupported: "Điều kiện dùng biến mà loại hồ sơ này không gửi.",
    overrideRoles: "Vai trò duyệt vượt cấp",
    overrideRolesHint: "Người có vai trò này ở bất kỳ bước duyệt nào đang chờ: Phê duyệt = hoàn tất cả quy trình (bỏ qua các bước còn lại), Từ chối = kết thúc quy trình. Vd CEO, CTO, CHO, CMO, Giám đốc. Để trống = không ai được vượt cấp.",
    overrideCondition: "Điều kiện duyệt vượt cấp",
    overrideConditionHint: "Để trống = luôn được vượt cấp; cùng cú pháp với điều kiện bước, vd approvalAmount < 50000000.",
    overrideConditionPlaceholder: "vd approvalAmount < 50000000",
    overrideNone: "Không cho vượt cấp",
    overrideInherit: "Theo cấp định nghĩa",
    overrideUseDefinition: "Dùng giá trị cấp định nghĩa",
    skipCovered: "Bỏ qua các bước mà người lập có quyền duyệt",
    skipCoveredHint: "Khi gửi/gửi lại hoặc khi quy trình tới các bước Phê duyệt liên tiếp: tìm bước cao nhất mà người lập thuộc diện được giao (vai trò được giao, người được giao đích danh, hoặc phân hệ xác nhận người duyệt động); bước đó và các bước trước nó tự bỏ qua. Bước người lập giữ nguyên.",
    requireIndependent: "Luôn cần ít nhất một người duyệt khác người lập",
    requireIndependentHint: "Nếu mọi bước Phê duyệt còn lại đều bị bỏ qua thì giữ lại bước Phê duyệt cuối. Tắt = phiếu được duyệt luôn, không có người duyệt cuối.",
    requireIndependentOn: "luôn cần một người duyệt khác người lập",
    requireIndependentOff: "được tự hoàn tất khi mọi bước bị bỏ qua",
    stepSkip: "Bỏ qua khi người lập có quyền duyệt",
    stepSkipHint: "Ghi đè tùy chọn cấp định nghĩa cho bước này. Bước tắt bỏ qua chặn vùng bỏ qua: bước sau nó chỉ được xét khi quy trình đi qua nó.",
    stepSkipInheritOn: "Theo định nghĩa (đang bật)",
    stepSkipInheritOff: "Theo định nghĩa (đang tắt)",
    stepSkipOn: "Được bỏ qua",
    stepSkipOff: "Không bỏ qua",
    stepOverrideRoles: "Vai trò duyệt vượt cấp riêng của bước",
    stepOverrideHint: "Để trống = theo «Vai trò duyệt vượt cấp» cấp định nghĩa; chọn vai trò = chỉ các vai trò này được vượt cấp ở bước (kèm điều kiện riêng nếu có); bỏ chọn hết = bước không cho vượt cấp.",
    validationOverrideConditionRoles: "Điều kiện vượt cấp cần ít nhất một vai trò duyệt vượt cấp.",
    substituteRoles: "Vai trò được làm thay",
    substituteHint: "Vai trò được xem, duyệt, trả về thay người được giao ở bước này (vd Kế toán thay Kế toán trưởng).",
    allowAdminException: "Cho phép quản trị duyệt ngoại lệ",
    allowAdminExceptionHint: "Quản trị toàn quyền được duyệt ngoại lệ (ghi lý do) khi bước không còn người duyệt hợp lệ.",
    validationStepKeyDuplicate: "Mỗi mốc chỉ gắn cho một bước.",
    stepKey: "Mốc nghiệp vụ",
    stepKeyNone: "— Không gắn mốc —",
    stepKeyHint: "Phân hệ sở hữu ghi chữ ký trung gian theo mốc của bước vừa duyệt; trạng thái hồ sơ không phụ thuộc thứ tự bước.",
    stepKeyNames: {
      DepartmentHead: "Trưởng bộ phận",
      ChiefAccountant: "Kế toán trưởng",
      Director: "Giám đốc",
      Pic: "Người phụ trách",
      Confirm: "Xác nhận",
      Approval: "Phê duyệt",
      Quote: "Báo giá",
    },
    ownerUnavailable: "phân hệ sở hữu chưa phản hồi",
    ownerUnavailableNotice: "Phân hệ sở hữu loại đối tượng này chưa phản hồi danh mục năng lực: chỉ lưu được ở trạng thái Tạm ngưng, bật khi phân hệ hoạt động lại.",
    capabilitiesUnavailable: "Không tải được danh mục năng lực quy trình; cấu hình vẫn được kiểm khi lưu.",
    structureLocked: "Cấu trúc 3 bước của loại đối tượng này cố định: chỉ đổi tên bước, hạn xử lý và người nhận thông báo.",
    groupNone: "Loại đối tượng này không phân nhóm.",
    groupProjectHelp: "Nhóm là mã định danh (GUID) dự án, phân tách bằng dấu phẩy; để trống để áp dụng cho mọi dự án.",
    groupMaterialHelp: "Nhóm là mã định danh (GUID) vật tư, phân tách bằng dấu phẩy; để trống để áp dụng cho mọi vật tư.",
    pickGroups: "— Tất cả nhóm —",
    definitionInUse:
      "Cấu hình này đã được sử dụng trong {count} lượt chạy; chỉ được thay đổi trạng thái bật/tắt.",
    deleteConfirm: "Xóa cấu hình quy trình duyệt “{name}”?",
    concurrency:
      "Cấu hình đã được người khác thay đổi. Hãy tải lại và thử lại.",
    terminalFeatures: {
      wbs: "Kích hoạt WBS",
      timesheet: "Mở chấm công",
      leader: "Phân quyền trưởng dự án",
      owner: "Phân hệ sở hữu ghi nhận chứng từ đã duyệt",
    },
    allowAllUsers: "— Cho phép tất cả người dùng —",
    allowAllRoles: "— Cho phép tất cả vai trò —",
    stepKinds: {
      Approval: "Phê duyệt",
      Activity: "Thực hiện",
    },
    pickApprovers: "— Chọn những người duyệt —",
    pickApproverRoles: "— Chọn vai trò được duyệt —",
    initiatorsHelp: "Cấu hình người dùng hoặc vai trò được phép khởi chạy quy trình này. Nếu để trống cả 2 ô, tất cả các tài khoản có quyền tạo đối tượng đều có thể khởi tạo.",
  },
  approvalHistory: {
    tab: "Phê duyệt",
    loading: "Đang tải lịch sử phê duyệt…",
    empty: "Hồ sơ chưa có quy trình phê duyệt nào.",
    forbidden: "Bạn không có quyền xem lịch sử phê duyệt của hồ sơ này.",
    error: "Không tải được lịch sử phê duyệt.",
    retry: "Tải lại",
    round: "Vòng {number}",
    version: "phiên bản {version}",
    unknownDefinition: "Quy trình",
    assignee: "Giao cho",
    actor: "Người xử lý",
    onBehalfOf: "làm thay {name}",
    reassignedFrom: "Chuyển từ",
    assignedAt: "Giao lúc",
    actedAt: "Xử lý lúc",
    due: "Hạn",
    overdue: "quá hạn",
    decisions: { Pending: "Đang chờ", Approved: "Đã duyệt", Completed: "Đã hoàn thành", Returned: "Trả về bổ sung", Rejected: "Từ chối", Cancelled: "Đã hủy", SkippedByOverride: "Bỏ qua do duyệt vượt cấp", SkippedByInitiator: "Tự bỏ qua theo người lập" },
    skippedByOverride: "Bỏ qua — hoàn tất vượt cấp bởi {name}",
    skippedByInitiator: "Tự bỏ qua — người lập là {name}",
    skippedByInitiatorRole: "Tự bỏ qua — người lập là {name} ({roles})",
    override: "Vượt cấp",
    part: "Phần {number} của đơn",
    roundStatuses: { Pending: "Chờ bắt đầu", InProgress: "Đang chạy", Completed: "Hoàn tất", Rejected: "Bị từ chối", Cancelled: "Đã hủy" },
  },
  approvalInbox: {
    summaryLoading: "Đang tải thông tin nguồn…",
    summaryBorrowerUnavailable: "Không có thông tin người mượn",
    summaryCurrentSource: "Dữ liệu hiện tại từ hệ thống nguồn; không phải ảnh chụp tại thời điểm trình duyệt.",
    summaryPartial: "Đã tải phần được phép xem; chi tiết bổ sung chưa khả dụng.",
    summaryRetry: "Tải lại thông tin nguồn",
    summaryOpenSource: "Mở hồ sơ nguồn",
    summaryAllocations: "Phân bổ của phần này",
    syncRetryReasonContext: "Nhập lý do gửi lại revision {revision}; không nhập mật khẩu hoặc dữ liệu hồ sơ.",
    syncRetryUnknown: "Chưa xác định kết quả. Tra cứu thao tác trước khi xử lý tiếp.",
    syncRetryOutcome: "Đồng bộ revision {revision}: {state}",
    syncRetryLookup: "Tra cứu kết quả",
    syncApplicationEvidence: "Bằng chứng áp dụng tại nguồn: {state}",
    syncApplicationStates: { Verified: "Đã xác minh áp dụng", Unverified: "Đã nhận, chưa xác minh áp dụng", Unknown: "Chưa rõ kết quả", Pending: "Đang chờ", NotRequired: "Không cần đồng bộ" },
    syncRetryStates: { Requested: "Đã tiếp nhận", Dispatching: "Đang gửi", Succeeded: "Đã xác minh áp dụng", RetryableFailure: "Lỗi cho phép thử lại", Unknown: "Chưa rõ kết quả", Superseded: "Đã có revision mới hơn", Blocked: "Không được gửi lại" },
    summaryLines: "Các dòng chứng từ",
    summaryStates: {
      sync_pending: "Hồ sơ nguồn đang chờ đồng bộ phiên bản của luồng duyệt. Hãy tải lại sau.",
      unverified_binding: "Chưa xác minh được liên kết giữa hồ sơ nguồn và luồng duyệt này.",
      restricted: "Bạn không có quyền đọc hồ sơ nguồn.",
      missing: "Hồ sơ nguồn không tồn tại hoặc không còn trong phạm vi đọc.",
      error: "Không tải được thông tin nguồn. Bạn có thể thử tải lại.",
      stale: "Hồ sơ nguồn đã đổi phiên hoặc phiên bản; hãy mở hồ sơ nguồn và tải lại hộp duyệt.",
      unsupported: "Loại hồ sơ này chưa có tóm tắt nguồn đã xác minh. Hãy kiểm tra tại màn nguồn.",
    },
    summaryFields: {
      borrower: "Người mượn",
      borrowDate: "Ngày mượn",
      expectedReturnDate: "Ngày dự kiến trả",
      returnedDate: "Ngày đã trả",
      noteTruncated: "Nội dung đã rút gọn",
      quotationDueDate: "Hạn báo giá",
      deliveryDueDate: "Hạn giao hàng",
      materialCode: "Mã vật tư",
      materialName: "Tên vật tư",
      model: "Model",
      category: "Phân loại",
      maker: "Nhà sản xuất",
      unit: "Đơn vị",
      supplier: "Nhà cung cấp",
      quantity: "Số lượng",
      documentNumber: "Số chứng từ",
      approvalStatus: "Trạng thái phê duyệt nguồn",
      type: "Loại",
      status: "Trạng thái nguồn",
      requester: "Người yêu cầu",
      project: "Dự án",
      periodStart: "Từ ngày",
      periodEnd: "Đến ngày",
      minutes: "Thời lượng yêu cầu (phút)",
      reason: "Nội dung",
      workplace: "Nơi làm việc",
      attachmentCount: "Số tài liệu đính kèm",
      appliedRevision: "Phiên bản đã áp dụng tại nguồn",
      revision: "Phiên bản hồ sơ",
      date: "Ngày",
      startTime: "Giờ bắt đầu",
      endTime: "Giờ kết thúc",
      customer: "Khách hàng",
      objective: "Mục tiêu",
      scope: "Phạm vi",
      requirements: "Yêu cầu",
      total: "Tổng tiền",
      amountToPay: "Số tiền cần thanh toán",
    },
    retryOriginalDecision: "Thử lại quyết định gốc",
    retryOriginalDecisionConfirm: "Gửi lại đúng quyết định và ghi chú trước đó với phiên bản gốc? Máy chủ sẽ kiểm tra lại quyền và chỉ áp dụng một lần.",
    decisionResults: "Kết quả từng tác vụ",
    decisionUnknown: "Chưa xác định kết quả. Tra lại trước khi thử quyết định.",
    decisionProcessed: "Tác vụ đã được xử lý bằng quyết định khác hoặc bởi người khác.",
    checkDecision: "Tra lại kết quả",
    delegatedFrom: "Duyệt thay cho {name}",
    overrideApproval: "Duyệt vượt cấp",
    overrideApprovalHint: "Bạn thấy việc này nhờ vai trò duyệt vượt cấp của quy trình.",
    overrideApproveHint: "Duyệt vượt cấp: phê duyệt sẽ hoàn tất cả quy trình, các bước còn lại được bỏ qua.",
    overrideRejectHint: "Duyệt vượt cấp: từ chối sẽ kết thúc quy trình (từ chối luôn, không trả về bước trước).",
    callbackRevision: "Đồng bộ quy trình duyệt: {state} · phiên bản {revision}",
    summaryReminded: "Đã nhắc",
    summaryEscalated: "Đã chuyển cấp",
    reviewSelection: "Xác nhận {action} cho {count} hồ sơ/phần sau:\n{items}",
    reopenPart: "Mở lại phần",
    reopenPartReason: "Nhập lý do mở lại phần đã duyệt",
    timesheetPartReopened: "Đã mở lại phần để nhân viên sửa và nộp lại.",
    bulkPartResults: "Kết quả duyệt từng phần",
    retryFailedParts: "Thử lại các phần thất bại",
    bulkOutcomeUnknown: "Chưa xác nhận kết quả. Tải lại trước khi thử lại.",
    selectActionableParts: "Chọn các phần có thể duyệt",
    selectPart: "Chọn phần duyệt",
    title: "Hộp phê duyệt",
    subtitle:
      "Xử lý các việc duyệt được giao trực tiếp hoặc qua vai trò của bạn.",
    target: "Đối tượng",
    targetType: "Loại đối tượng",
    outcomeTitle: "Kết quả xử lý hồ sơ",
    outcomeNotYours: "Hồ sơ vẫn đang được xử lý nhưng bước hiện tại không còn chờ bạn (có thể đã có người khác trong cùng nhóm duyệt xử lý).",
    outcomeClosed: "Hồ sơ đã kết thúc: {status}. Không còn việc nào chờ bạn.",
    outcomeUnavailable: "Việc này đã được xử lý hoặc bạn không còn quyền xem chi tiết. Không còn việc nào chờ bạn.",
    outcomeStatus: {
      Pending: "Chờ xử lý",
      InProgress: "Đang xử lý",
      Approved: "Đã duyệt",
      Completed: "Đã duyệt xong",
      Rejected: "Đã từ chối",
      Cancelled: "Đã hủy",
    },
    requestType: "Loại đơn",
    requestTime: "Thời gian",
    issue: {
      content: "Nội dung vấn đề",
      plan: "Kế hoạch xử lý",
      noActions: "Chưa có nội dung xử lý nào.",
      title: "Vấn đề",
      description: "Mô tả",
      cause: "Nguyên nhân",
      handling: "Phương án xử lý",
      severity: "Mức độ",
      impact: "Ảnh hưởng",
      requester: "Người yêu cầu",
      receivedDate: "Ngày tiếp nhận",
      owner: "PIC",
      internalDeadline: "Hạn nội bộ",
      customerDeadline: "Hạn khách hàng",
      deliveryState: "Tình trạng giao",
      plannedMandays: "Manday kế hoạch",
      action: "Nội dung xử lý",
      pic: "PIC",
      delivery: {
        Planned: "Theo kế hoạch",
        AtRisk: "Rủi ro",
        Due: "Đến hạn",
        Overdue: "Quá hạn",
        Delivered: "Đã giao",
      },
    },
    stepNames: {
      SubmitterActivity: "Người lập hoàn thiện",
      LeaderApproval: "Trưởng dự án duyệt",
      ManagerApproval: "Quản lý duyệt",
      ReviewerConfirm: "Người duyệt xác nhận",
      FinalApproval: "Phê duyệt cuối",
      ProcurementApproval: "Quản lý duyệt phiếu",
      ProcurementReturnApproval: "Quản lý duyệt trả hàng",
      DepartmentHeadApproval: "Trưởng bộ phận duyệt",
      ChiefAccountantApproval: "Kế toán trưởng duyệt",
      DirectorApproval: "Giám đốc duyệt",
    },
    person: "Họ và tên",
    kind: "Loại",
    project: "Dự án",
    content: "Nội dung cần xử lý",
    targetTypes: {
      OperationalRequestPart: "Đơn theo dự án",
      ProcurementPaymentRequest: "Phiếu đề nghị chi",
      ProcurementPurchaseRequest: "Yêu cầu mua hàng",
      ProcurementPurchaseOrder: "Đơn đặt hàng nhà cung cấp (P/O)",
      ProcurementStockReceipt: "Phiếu nhập kho hàng kinh doanh",
      ProcurementStockIssue: "Phiếu xuất kho hàng kinh doanh",
      ProjectIssue: "Vấn đề dự án",
      ProjectRegistration: "Đăng ký dự án",
      OperationalRequest: "Đơn hành chính",
      MaterialEnrollment: "Phiếu đăng ký vật tư",
      AssetMaterialEnrollment: "Phiếu đăng ký tài sản",
      AssetMaterialReturnedEnrollment: "Phiếu trả tài sản",
      MaterialMaster: "Mã vật tư mới",
      AssetMaterialReceipt: "Phiếu nhập kho tài sản",
    },
    workflow: "Quy trình duyệt",
    step: "Bước",
    requestedAt: "Thời điểm yêu cầu",
    waitingDays: "Số ngày chờ",
    groupSize: "Số phiếu",
    selectTask: "Chọn việc {target}",
    bulkApprove: "Duyệt các việc đã chọn",
    bulkReject: "Từ chối các việc đã chọn",
    bulkSuccess: "Đã xử lý các việc đang hiển thị.",
    bulkPartial:
      "Đã xử lý {success} việc; {failed} việc thất bại hoặc đã thay đổi.",
    assignment: "Kiểu phân công",
    visibility: "Chế độ hiển thị",
    specificUser: "Giao trực tiếp",
    sharedRole: "Vai trò dùng chung: {roles}",
    operationalReviewer: "Quản lý trực tiếp / Trưởng dự án / Nhân sự",
    operationalRequests: "Đăng ký nhân sự",
    unassigned: "Chưa phân công",
    history: "Lịch sử",
    historyTitle: "Lịch sử quy trình duyệt",
    actor: "Người xử lý",
    comment: "Ý kiến",
    approveTitle: "Phê duyệt việc",
    rejectTitle: "Từ chối việc",
    rejectCommentRequired: "Bắt buộc nhập ý kiến khi từ chối.",
    approved: "Đã phê duyệt.",
    rejected: "Đã từ chối.",
    targetSync: "Đồng bộ đối tượng",
    retrySync: "Thử đồng bộ lại",
    syncRetried: "Đã thử đồng bộ lại đối tượng.",
    syncBlocksDecision:
      "Phải đồng bộ xong trạng thái quy trình duyệt với đối tượng rồi mới được xử lý việc này.",
    concurrency: "Việc này đã được người khác xử lý.",
    loadFailed: "Không tải được danh sách chờ duyệt.",
    openProjectIssue: "Mở theo dõi yêu cầu của dự án",
    timesheetTitle: "Bảng chấm công chờ duyệt",
    timesheetSubtitle:
      "Theo dõi các bảng chấm công đang chờ; quyền quyết định vẫn theo người được giao.",
    employee: "Nhân viên",
    workDate: "Ngày làm việc",
    totalHours: "Tổng giờ",
    approver: "Người duyệt",
    submittedAt: "Thời điểm gửi",
    actionable: "Cần tôi duyệt",
    observer: "Quan sát",
    unknownPerson: "Chưa xác định người dùng",
    timesheetLoadFailed: "Không tải được bảng chấm công chờ duyệt.",
    timesheetApproved: "Đã duyệt bảng chấm công.",
    timesheetRejected: "Đã từ chối bảng chấm công.",
    partTitle: "Phần bảng công",
    partHours: "Giờ phần duyệt",
    bulkApproveParts: "Duyệt phần đã chọn",
    noPartsSelected: "Chưa chọn phần nào để duyệt.",
    timesheetPartApproved: "Đã duyệt phần chấm công.",
    timesheetPartRejected: "Đã từ chối phần chấm công.",
    pauseAutoRefresh: "Tạm dừng làm mới",
    resumeAutoRefresh: "Tiếp tục làm mới",
  },
  app: { name: "Q ONE CRM PM", environment: "Điều hành dự án" },
  nav: {
    dashboard: "Trung tâm điều hành",
    analytics: "Phân tích",
    customers: "Khách hàng",
    partners: "Đối tác",
    suppliers: "Nhà cung cấp",
    products: "Sản phẩm",
    materials: "Vật tư, linh kiện",
    projectRegistration: "Quản lý dự án",
    projects: "Dự án",
    quotations: "Báo giá",
    approvalInbox: "Hộp phê duyệt",
    workInbox: "Hộp công việc",
    reports: "Báo cáo",
    accountSettings: "Thông tin tài khoản",
    changePassword: "Đổi mật khẩu",
    workCalendar: "Lịch làm việc",
    workCalendarLegacy: "Lịch làm việc (phiên bản cũ)",
    mandayCost: "Chi phí 1 Manday",
    attendanceAdministration: "Quản trị chấm công",
    attendanceCorrections: "Xác nhận giờ công",
    leaveRequests: "Đăng ký nghỉ",
    overtimeRequests: "Đăng ký tăng ca",
    onsiteRequests: "Đăng ký onsite",
    businessTrips: "Đăng ký công tác",
    vehicleRequests: "Đăng ký xe & di chuyển",
    companyVehicles: "Quản lý xe công ty",
    mealRegistrations: "Đăng ký suất ăn",
    materialRegistrations: "Theo dõi & phê duyệt vật tư",
    assetRegistrations: "Theo dõi & phê duyệt tài sản",
    adminReceipts: "HCNS tiếp nhận",
    accountingReceipts: "Kế toán tiếp nhận",
    employeeProfiles: "Hồ sơ nhân viên",
    skillMap: "Bản đồ kỹ năng",
    controlledDocuments: "Sổ tài liệu kiểm soát",
    financeReportCatalog: "Danh mục báo cáo tài chính",
    workflowDefinitions: "Cấu hình quy trình duyệt",
    monitoring: "Tiến độ dự án",
    purchaseRequests: "Yêu cầu lấy báo giá và mua hàng",
    purchaseOrders: "Đơn đặt hàng nhà cung cấp",
    events: "Sự kiện",
    projectInvoices: "Tình hình xuất hoá đơn",
    materialStock: "Kho vật tư",
    assetStock: "Kho tài sản",
    crmTrash: "Thùng rác dữ liệu",
    externalCustomerProgress: "Dùng cho khách hàng",
    externalSubcontractorProgress: "Dùng cho nhà thầu phụ",
    notifications: "Thông báo",
    notificationRules: "Cấu hình thông báo",
    notificationOccurrences: "Lịch sử xử lý thông báo",
    advanceRequests: "Đề nghị tạm ứng",
    paymentRequests: "Đề nghị thanh toán",
    advanceSettlements: "Thanh toán tạm ứng",
    expenseCategories: "Mã chi phí",
    cashBook: "Sổ quỹ",
    projectContracts: "Hợp đồng & bảo hành",
    customerOrders: "PO khách hàng",
    financePeriodClose: "Chốt tháng",
    financeStatement: "Báo cáo tài chính công ty",
    bankStatements: "Sao kê ngân hàng",
    amortizations: "Trả trước và CCDC",
    supplierInvoices: "Hoá đơn nhà cung cấp",
    projectFinance: "Bảng tài chính dự án",
  },
  workspace: {
    noAccess: "Bạn chưa có quyền xem mục nào trong màn này.",
  },
  common: {
    invalidDateRange: "Ngày kết thúc không được trước ngày bắt đầu.",
    moreActions: "Thao tác khác",
    none: "Không có",
    reason: "Lý do",
    attachments: "Tệp đính kèm",
    files: "Tệp",
    noAttachments: "Chưa có tệp đính kèm.",
    confirmDelete: "Bấm lần nữa để xoá",
    select: "Chọn",
    selectAll: "Chọn tất cả",
    clearSelection: "Bỏ chọn",
    year: "Năm",
    month: "Tháng",
    update: "Cập nhật",
    search: "Tìm kiếm",
    create: "Tạo mới",
    save: "Lưu",
    cancel: "Hủy",
    back: "Quay lại",
    help: "Hướng dẫn",
    clear: "Xóa lọc",
    apply: "Áp dụng",
    status: "Trạng thái",
    actions: "Thao tác",
    loading: "Đang tải…",
    noData: "Không có dữ liệu",
    loadMore: "Tải thêm",
    all: "Tất cả",
    language: "Ngôn ngữ",
    logout: "Đăng xuất",
    error: "Có lỗi xảy ra",
    success: "Thành công",
    refresh: "Làm mới",
    retry: "Thử lại",
    close: "Đóng",
    code: "Mã",
    name: "Tên",
    description: "Mô tả",
    date: "Ngày",
    submit: "Gửi duyệt",
    confirm: "Xác nhận",
    approve: "Phê duyệt",
    reject: "Từ chối",
    view: "Xem",
    type: "Loại",
    version: "Phiên bản",
    sizeKb: "Dung lượng (KB)",
    cause: "Nguyên nhân",
    pic: "PIC",
    deadline: "Hạn xử lý",
    actionCount: "Số hành động",
    upload: "Tải lên",
    download: "Tải xuống",
    import: "Nhập dữ liệu",
    export: "Xuất dữ liệu",
    exportExcel: "Xuất Excel",
    exportCsv: "Xuất CSV",
    exportPdf: "Xuất PDF",
    edit: "Sửa",
    delete: "Xóa",
    createdBy: "Người tạo",
    createdAt: "Ngày tạo",
    forbidden: "Bạn không có quyền truy cập chức năng này.",
    moveUp: "Di chuyển lên",
    moveDown: "Di chuyển xuống",
    details: "Thông tin chi tiết",
    optional: "Tùy chọn",
    skipToContent: "Bỏ qua đến nội dung chính",
    exportExcelNoTable: "Không tìm thấy bảng để xuất Excel.",
    warning: "Cảnh báo",
    previous: "Trang trước",
    next: "Trang sau",
    project: "Dự án",
    rejectReason: "Lý do từ chối",
  },
  workforceAdmin: {
    tripSourceRange: "Chọn khoảng ngày hợp lệ, tối đa 366 ngày.",
    tabsLabel: "Chế độ xem đơn",
    tabs: {
      overview: "Tổng quan",
      mine: "Của tôi",
      registrationForm: "Mẫu đăng ký",
      manage: "Quản lý",
    },
    subtitle:
      "Sổ nghiệp vụ nhân sự theo dữ liệu đã gửi, xác nhận và phê duyệt.",
    sheetCode: "Biểu mẫu {code}",
    saved: "Đã lưu bản nháp.",
    linkedRequest: "Đơn được liên kết từ Hộp phê duyệt",
    linkedRequestHint:
      "Thông tin dưới đây chỉ dùng để đối chiếu và không mở biểu mẫu chỉnh sửa.",
    linkedRequestUnavailable:
      "Không thể mở đơn được liên kết hoặc bạn không có quyền truy cập.",
    readOnly: "Chỉ đọc",
    linkedFilesPreserved:
      "Tệp đã liên kết được giữ nguyên; màn này không yêu cầu nhập mã kỹ thuật.",
    newRequest: "Phiếu nghiệp vụ",
    createRequest: "Tạo đơn",
    requestNo: "Số đơn",
    panelTabs: { info: "Thông tin", history: "Lịch sử duyệt" },
    noFiles: "Đơn chưa có tệp đính kèm.",
    advanceFile: "Đề nghị tạm ứng",
    editRequest: "Cập nhật phiếu nghiệp vụ",
    myRequests: "Phiếu của tôi",
    reviewQueue: "Hàng chờ xử lý",
    requestLedger: "Đơn của mọi người",
    groupRequest: "Đơn nhóm",
    groupRequestHint:
      "Một đơn có thể đăng ký nhiều người và phân bổ theo từng dự án, ngày, khoảng giờ.",
    groupEditImpactHint:
      "Sửa nội dung chung sẽ yêu cầu duyệt lại các phần liên quan; sửa phân bổ chỉ gửi lại phần đang sửa.",
    addParticipant: "Thêm người tham gia",
    selectParticipant: "Chọn người",
    addAllocation: "Thêm phân bổ",
    copyAllocation: "Sao chép phân bổ",
    removeAllocation: "Xóa phân bổ",
    removeParticipant: "Xóa người tham gia",
    allocationHint:
      "Mỗi dòng là một khoảng thời gian của một người trên một dự án.",
    approvedPartLocked: "Phần đã duyệt được khóa",
    unassignedApprover: "Chưa phân công người duyệt",
    unassignedReasons: {
      no_eligible_reviewer: "Không có người duyệt hợp lệ cho bước này (thiếu «Báo cáo cho»/trưởng dự án, hoặc người duyệt là người lập, người tham gia hay đã xác nhận ở bước trước). Liên hệ HR cập nhật «Báo cáo cho» hoặc quản trị hệ thống duyệt ngoại lệ.",
      reviewer_directory_unavailable: "Chưa tra được danh bạ người duyệt (Identity tạm không phản hồi). Thử lại sau; nếu vẫn lỗi, liên hệ quản trị hệ thống.",
    },
    unknownProject: "Chưa xác định dự án",
    partHistory: "Lịch sử theo phần",
    resubmitPart: "Gửi lại phần này",
    legacyValue: "dữ liệu cũ",
    leaveClassificationHint: "Bắt buộc chọn. Nghỉ hưởng lương trừ vào sổ phép năm; sổ không còn đủ ngày thì không tạo được đơn.",
    submissionStageAuto: "Tự xác định khi trình: trình trước ngày bắt đầu là tiền sự, còn lại là hậu sự.",
    leavePeriods: {
      morning: "Nghỉ sáng (08:00–12:15)",
      afternoon: "Nghỉ chiều (13:15–17:00)",
      fullDay: "Nghỉ cả ngày",
    },
    leaveBalanceRemaining: "Sổ phép đến {date} còn {days} ngày (chưa trừ đơn có lương đang chờ duyệt).",
    leaveBalanceNotOpened: "Chưa mở sổ phép năm: có thể không tạo được đơn nghỉ hưởng lương. Liên hệ nhân sự hoặc chọn nghỉ không hưởng lương.",
    leavePlan: {
      toggle: "Nghỉ định kỳ (theo lịch học)",
      hint: "Chọn từng ngày kèm buổi; cả kế hoạch được duyệt một lần. Nghỉ hưởng lương thì sổ phép phải đủ cho tất cả các buổi.",
      from: "Từ ngày",
      to: "Đến ngày",
      weekdays: "Các thứ",
      period: "Buổi",
      add: "Thêm các buổi",
      addOne: "Thêm một ngày",
      or: "hoặc",
      chooseFile: "Chọn tệp",
      noFile: "Chưa chọn tệp",
      remove: "Bỏ buổi",
      clear: "Xóa hết",
      date: "Ngày",
      empty: "Chưa có buổi nào.",
      summary: "{count} buổi · {from} → {to} · khoảng {days} ngày",
      sessionCount: "{count} buổi",
      schedule: "Lịch học (bắt buộc)",
      scheduleAttached: "Đã đính kèm lịch học",
      attachmentRequired: "Kế hoạch nghỉ định kỳ phải đính kèm lịch học trước khi gửi duyệt.",
      tooMany: "Tối đa 120 buổi.",
      sessions: "Các buổi nghỉ",
    },
    weekdayShort: {
      d0: "CN",
      d1: "T2",
      d2: "T3",
      d3: "T4",
      d4: "T5",
      d5: "T6",
      d6: "T7",
    },
    receiptDone: "Đã nhận",
    overtimeAfterCutoff:
      "Đơn tăng ca gửi sau 14:00 ngày tăng ca (NMI-AC-0001/03)",
    pendingLedger: "Đơn chưa duyệt",
    settledLedger: "Đơn đã duyệt",
    syncing: "Đang đồng bộ",
    syncingHint:
      "Đã duyệt xong, hệ thống đang ghi trạng thái về phiếu. Tải lại sau ít phút.",
    history: "Lịch sử",
    historyFailed: "Không tải được lịch sử phiếu.",
    requestInformation: "Thông tin phiếu",
    requestDetails: "Chi tiết {type}",
    requestedPeriod: "Thời gian đăng ký",
    processingHistory: "Lịch sử xử lý",
    submittedAt: "Thời điểm gửi phiếu",
    decisionReason: "Lý do xử lý",
    unknownValue: "Chưa xác định",
    department: "Phòng ban",
    position: "Chức vụ",
    reviewQueueWorkflowHint:
      "Đơn đến lượt bạn duyệt có nút duyệt ngay tại bảng trên. Xem toàn bộ việc chờ duyệt tại",
    selectProject: "Chọn dự án đã duyệt",
    fromBusinessTrip: "Lập từ đơn công tác",
    selectBusinessTrip: "Chọn đơn công tác đã đăng ký",
    prospectCustomerPlaceholder: "Tên công ty sắp đến khảo sát",
    prospectCustomerHint:
      "Điền khi chưa có dự án, ví dụ đi khảo sát khách hàng mới.",
    selectVehicle: "Chọn xe còn rảnh",
    noVehicleAvailable: "Không còn xe rảnh trong khoảng ngày này.",
    vehicleBusy: {
      booked: "Đã có phiếu duyệt",
      maintenance: "Đang bảo dưỡng",
    },
    selectCompanions: "Tìm và chọn người đi cùng",
    companionsHint: "Người đi cùng được tính như người đăng ký.",
    rejectReasonFor: "Lý do từ chối của {name}",
    receiveAdmin: "HCNS nhận",
    receiveAccounting: "Kế toán nhận",
    retryWorkflow: "Thử tạo quy trình duyệt lại",
    partPending: "Phần đang chờ duyệt",
    partActionUnavailable: "Không thể xử lý phần đơn này.",
    rejectReasonForPart: "Lý do từ chối phần {name}",
    nextApprover: "Người duyệt tiếp theo",
    submittedBy: "Đã gửi bởi",
    confirmedBy: "Đã xác nhận bởi",
    approvedBy: "Đã phê duyệt bởi",
    rejectedBy: "Đã từ chối bởi",
    processedBy: "Đã xử lý bởi",
    approvalRoute: "Luồng phê duyệt dự kiến",
    step: "Bước {number}",
    confirmation: "Xác nhận",
    finalApproval: "Phê duyệt",
    withdraw: "Rút đơn",
    withdrawConfirm: "Bạn có chắc chắn muốn rút đơn này không?",
    withdrawn: "Đã rút đơn thành công.",
    deleteDraft: "Xóa bản nháp",
    deleteDraftConfirm: "Bạn có chắc chắn muốn xóa bản nháp này không?",
    draftDeleted: "Đã xóa bản nháp.",
    cancelApproved: "Hủy đơn đã duyệt",
    adminCancel: "Quản trị viên hủy đơn trùng",
    adminApprove: "Quản trị viên duyệt ngoại lệ",
    adminCancelledBy: "Quản trị viên hủy đơn trùng",
    adminApprovalSyncFailed: "Đã ghi nhận duyệt ngoại lệ nhưng đồng bộ trạng thái đơn thất bại. Hãy kiểm tra luồng duyệt; không duyệt lại.",
    adminApprovalUnavailable: "Bước duyệt đã thay đổi. Hãy tải lại danh sách trước khi duyệt ngoại lệ.",
    adminApprovalSyncPending: "Đã ghi nhận duyệt ngoại lệ; đang chờ đồng bộ trạng thái đơn. Hãy làm mới để kiểm tra.",
    submissionPending: "Đơn đang được xử lý, trang sẽ tự cập nhật sau vài giây. Nếu đơn vẫn chưa gửi, hãy bấm Gửi lại.",
    adminApprovalComplete: "Đã duyệt ngoại lệ và đồng bộ trạng thái đơn.",
    cancelApprovedConfirm: "Bạn có chắc chắn muốn hủy đơn đã duyệt này không?",
    cancelReason: "Lý do hủy đơn",
    cancelReasonRequired: "Vui lòng nhập lý do hủy đơn.",
    cancelled: "Đã hủy đơn thành công.",
    types: {
      TimeCorrection: "Xác nhận giờ công",
      Leave: "Đăng ký nghỉ",
      Overtime: "Đăng ký tăng ca",
      Onsite: "Đăng ký onsite",
      BusinessTrip: "Đăng ký công tác",
      Vehicle: "Đăng ký xe & di chuyển",
      Meal: "Đăng ký suất ăn",
    },
    leaveTypes: {
      ANNUAL: "Nghỉ phép năm",
      BEREAVEMENT: "Nghỉ khánh điếu",
      BUSINESS: "Nghỉ công tác",
      SOCIAL_INSURANCE: "Nghỉ BHXH",
      MATERNITY: "Nghỉ thai sản",
      PERSONAL: "Nghỉ việc riêng",
      OTHER: "Khác",
    },
    leaveClassifications: {
      PaidLeave: "Nghỉ hưởng lương",
      UnpaidLeave: "Nghỉ không hưởng lương",
    },
    submissionStages: {
      PRE_EVENT: "Tiền sự",
      DURING_EVENT: "Trung sự",
      POST_EVENT: "Hậu sự",
    },
    onsiteForms: {
      IN_DAY: "Trong ngày",
      OVERNIGHT: "Qua đêm",
    },
    tripForms: {
      ONSITE: "Onsite",
      IN_DAY: "Trong ngày",
      OVERNIGHT: "Qua đêm",
    },
    correctionReasons: {
      BUSINESS_TRIP: "Đi công tác",
      DEVICE_FAILURE: "Máy chấm công hỏng",
      FORGOT: "Quên chấm công",
      POWER_OUTAGE: "Mất điện",
      LATE: "Đi muộn",
      OTHER: "Khác",
    },
    transportMethods: {
      COMPANY_CAR: "Xe công ty",
      PERSONAL_VEHICLE: "Xe cá nhân",
      TAXI: "Xe taxi",
      PARTNER_VEHICLE: "Xe đối tác",
      OTHER: "Phương tiện khác",
    },
    requestContent: "Nội dung đơn",
    requester: {
      title: "Người đăng ký",
      employeeCode: "Mã nhân viên",
      department: "Phòng ban",
      position: "Chức danh",
      manager: "Quản lý trực tiếp",
    },
    fields: {
      from: "Từ ngày",
      to: "Đến ngày",
      schedule: "Thời gian",
      employee: "Họ và tên",
      participants: "Người tham gia",
      allocations: "Phân bổ",
      nextApprover: "Người duyệt tiếp theo",
      status: "Trạng thái",
      search: "Tìm kiếm",
      searchPlaceholder: "Mã đơn, người, dự án",
      project: "Dự án",
      tripDestination: "Dự án / điểm đến",
      tripArrangement: "Hình thức / phương tiện",
      duration: "Thời lượng",
      startTime: "Từ giờ",
      endTime: "Đến giờ",
      minutes: "phút",
      checkInTime: "Giờ vào",
      checkOutTime: "Giờ ra",
      departureTime: "Giờ xuất phát",
      returnTime: "Giờ về",
      actualStartDate: "Ngày đi thực tế",
      actualEndDate: "Ngày về thực tế",
      actualNights: "Số đêm thực tế",
      requestedHours: "Số giờ đề nghị",
      reasonCode: "Mã lý do",
      leaveType: "Loại đơn nghỉ",
      selectLeaveType: "Chọn loại đơn",
      selectLeaveClassification: "Chọn phân loại phép",
      reason: "Lý do / nội dung",
      workplace: "Nơi làm việc / công tác",
      tripDistanceKm: "Quãng đường công tác (km)",
      tripDistanceRequired: "Cần nhập quãng đường từ 0 đến 10.000 km, tối đa 2 số thập phân trước khi gửi duyệt. Phiếu nháp có thể để trống.",
      tripForm: "Hình thức công tác",
      onsiteForm: "Hình thức onsite",
      selectOnsiteForm: "Chọn hình thức",
      selectTripForm: "Chọn hình thức công tác",
      selectReasonCode: "Chọn mã lý do",
      autoFromSchedule: "tự tính từ mốc đi/về",
      submissionMethod: "Trình đơn",
      selectSubmissionMethod: "Chọn trình đơn",
      transportMethod: "Phương tiện",
      selectTransportMethod: "Chọn phương tiện",
      vehicleCode: "Mã xe",
      prospectCustomer: "Khách hàng khảo sát",
      companions: "Người đi cùng",
      attachmentId: "Tệp đính kèm hệ thống",
      advanceAttachmentId: "Tệp đề nghị tạm ứng hệ thống",
      mealRequired: "Dùng suất ăn (bỏ chọn = hủy suất)",
      unexpectedMeal: "Phát sinh trong ngày",
      guestCount: "Số khách",
      mealQuantity: "Số suất ăn",
      leaveClassification: "Loại nghỉ phép",
      submittedDate: "Ngày trình đơn",
      leavePeriod: "Thời gian nghỉ",
      selectLeavePeriod: "Chọn thời gian nghỉ",
      confirmationDate: "Ngày cần xác nhận",
      overtimeDate: "Ngày đăng ký tăng ca",
    },
    attendance: {
      tripDistanceMissing: "Đơn công tác cũ thiếu quãng đường: tạm tính 1 ngày công tác khi đủ 4 giờ trong ngày. Cần đối soát trước khi phát hành lương.",
      title: "Quản trị chấm công",
      subtitle:
        "Đối chiếu dữ liệu vào/ra, công thực tế và các phiếu đã duyệt theo tháng.",
      tabs: "Các thẻ chấm công",
      summaryTab: "Tổng hợp chấm công",
      inputTab: "Nhập dữ liệu và cảnh báo",
      legacyUnknownLeaveWarning:
        "Có {minutes} phút nghỉ chưa phân loại từ dữ liệu cũ; chưa cộng vào phép hưởng công.",
      viewDetails: "Xem chi tiết",
      viewOverview: "Xem tổng quan",
      employeeCount: "{count} nhân viên",
      effectiveMinutes: "Phút hiệu lực",
      summaryCalendarStandardDays: "Ngày công chuẩn theo lịch",
      summaryCreditedDays: "Ngày công được hưởng",
      summaryPendingEffort: "Công chờ duyệt",
      summaryLateEarlyMinutes: "Muộn + về sớm",
      summaryWorkdayOvertime: "OT ngày làm việc",
      summaryRestDayOvertime: "OT ngày nghỉ",
      summaryHolidayOvertime: "OT ngày lễ",
      summaryPaidLeave: "Phép được hưởng công",
      summaryBusinessTrip: "Công tác",
      summaryActualNights: "Qua đêm thực tế",
      summaryCalendarStandardDaysShort: "Ngày chuẩn",
      summaryCreditedDaysShort: "Ngày hưởng",
      summaryPendingEffortShort: "Chờ duyệt",
      summaryLateEarlyMinutesShort: "Muộn+sớm",
      summaryWorkdayOvertimeShort: "OT ngày LV",
      summaryRestDayOvertimeShort: "OT ngày nghỉ",
      summaryHolidayOvertimeShort: "OT ngày lễ",
      summaryPaidLeaveShort: "Phép",
      summaryBusinessTripShort: "Công tác",
      summaryActualNightsShort: "Qua đêm",
      unitDays: "ngày",
      unitMinutes: "phút",
      unitNights: "đêm",
      month: "Tháng",
      present: "Hiện diện",
      effort: "Công đã duyệt",
      overtime: "Tăng ca",
      corrected: "Điều chỉnh",
      lateDeduction: "Khấu trừ đi trễ",
      leave: "Nghỉ",
      onsite: "Onsite",
      businessTrip: "Công tác",
      businessTripNight: "Công tác qua đêm",
      meals: "Suất ăn",
      monthlyTotals: "Tổng hợp chấm công tháng",
      ledger: "Sổ chấm công tổng hợp",
      matrix: "Bảng tổng hợp chấm công",
      matrixHint:
        "Mỗi nhân viên một dòng: ô ngày hiển thị phút làm việc; V là nghỉ có phép. Màu ô thể hiện trạng thái theo chú giải.",
      presence_indirect: "Gián tiếp",
      presence_indirectHint: "Nhân viên có công tác hoặc onsite đã duyệt, không có điểm danh trực tiếp trong ngày.",
      presence_direct: "Trực tiếp",
      presence_directHint: "Nhân viên có giờ điểm danh hoặc giờ đã được điều chỉnh trong ngày.",
      presence_total: "Tổng",
      presence_totalHint: "Tổng số nhân viên chấm công trong ngày; mỗi nhân viên chỉ được tính một lần.",
      presenceMonthlyTotal: "Tổng lượt nhân sự trong tháng",
      presenceEmployeeDays: "lượt",
      matrixCaption: "Bảng chấm công {month}",
      legend: "Chú giải bảng chấm công",
      completeClock: "Đủ giờ vào / ra",
      incompleteClock: "Thiếu giờ vào hoặc ra",
      approvedLeave: "Nghỉ có phép",
      calendarRestDay: "Ngày nghỉ theo lịch",
      approvedRequest: "Có phiếu đã duyệt",
      weekend: "Cuối tuần",
      sequence: "STT",
      department: "Bộ phận",
      metricColumn: "Phân loại",
      absenceMinutes: "Tổng số phút vắng",
      onsiteHoursSummary: "Phút onsite công tác",
      expandMetrics: "Bung đủ chỉ tiêu",
      collapseMetrics: "Thu gọn một dòng",
      weekdayShort: {
        "0": "CN",
        "1": "T2",
        "2": "T3",
        "3": "T4",
        "4": "T5",
        "5": "T6",
        "6": "T7",
      },
      metric_checkIn: "Giờ vào",
      metric_lateIn: "Phút vào trễ",
      metric_checkOut: "Giờ ra",
      metric_earlyOut: "Phút về sớm",
      metric_workedHours: "Phút làm việc",
      metric_onsiteHours: "Phút onsite công tác",
      metric_absenceHours: "Phút vắng",
      metric_overtimeWorkday: "Phút tăng ca",
      metric_overtimeRestDay: "Phút tăng ca ngày nghỉ",
      metric_overtimeHoliday: "Phút tăng ca ngày lễ",
      workDays: "Ngày công",
      overtimeShort: "TC (giờ)",
      lateMinutes: "Muộn (phút)",
      sourceLateMinutes: "Phút muộn theo máy",
      calculatedLateMinutes: "Phút muộn tính theo giờ vào / ra",
      calendarDayType: "Loại ngày theo lịch",
      overtimeCategory: "Loại tăng ca",
      overtimeCategory_WORKDAY: "Ngày làm việc",
      overtimeCategory_REST_DAY: "Ngày nghỉ",
      overtimeCategory_HOLIDAY: "Ngày lễ",
      leaveShort: "Phép",
      onsiteShort: "Onsite",
      businessTripShort: "Công tác",
      symbol: "Ký hiệu",
      sourceWorkday: "Công nguồn",
      sourceWorkedHours: "Tổng giờ nguồn",
      workLocation: "Nơi làm việc",
      totalWorkDays: "TỔNG NGÀY CÔNG",
      standardWorkDays: "Ngày công chuẩn",
      overtimeHours: "SỐ PHÚT TĂNG CA",
      totalLateMinutes: "Tổng số phút đi muộn",
      officePresence: "Có mặt ở VP",
      halfDay: "Làm 1/2 ngày",
      customerOnsite: "Onsite khách hàng",
      overnightOnsite: "Onsite khách hàng qua đêm",
      onlineWork: "Làm việc online",
      workdayOvertime: "Tăng ca ngày làm việc",
      restDayOvertime: "Tăng ca ngày nghỉ",
      holidayOvertime: "Tăng ca ngày lễ",
      excusedAbsence: "Vắng mặt có lý do",
      unexcusedAbsence: "Vắng mặt không lý do",
      leaveSummary: "Phép",
      noMonthlyAttendance:
        "Chưa có hồ sơ nhân viên hoặc dữ liệu chấm công trong tháng này.",
      checkIn: "Giờ vào",
      checkOut: "Giờ ra",
      source: "Nguồn dữ liệu",
      sourceReference: "Mã tham chiếu nguồn",
      note: "Ghi chú",
      rawEntry: "Bản ghi chấm công nguồn",
      rawLedger: "Dữ liệu vào / ra",
      selectEmployee: "Chọn nhân viên",
      importXml: "Nhập dữ liệu máy chấm công",
      importHint:
        "Chọn file Excel 2003 XML. Hệ thống sẽ xem trước, đối chiếu mã máy chấm công với hồ sơ nhân viên và chỉ ghi dữ liệu sau khi quản trị viên xác nhận.",
      chooseXml: "Chọn file chấm công .xml (tối đa 10 MB)",
      previewFile: "Kiểm tra trước",
      importFile: "Xác nhận nhập",
      previewReady: "Đã kiểm tra — chưa thay đổi dữ liệu",
      importCompleted: "Nhập dữ liệu hoàn tất",
      matchedEmployees: "Nhân viên khớp",
      employeeMapping: "Ánh xạ mã chấm công",
      mappingHint:
        "Tên trong file được dùng để gợi ý; quản trị viên kiểm tra và lưu ánh xạ dùng cho các lần nhập sau.",
      attendanceCode: "Mã chấm công",
      nameInFile: "Tên trong file",
      systemEmployee: "Nhân viên trên hệ thống",
      mappingStatus: "Kết quả",
      mapAttendanceCode: "Chọn nhân viên cho mã chấm công {code}",
      saveMappings: "Lưu {count} ánh xạ",
      suggestedByName: "Hệ thống gợi ý theo tên — cần quản trị viên xác nhận",
      mappingMapped: "Đã ánh xạ",
      mappingReady: "Sẵn sàng lưu",
      mappingMissing: "Chưa ánh xạ",
      created: "Tạo mới",
      updated: "Cập nhật",
      skipped: "Đã khớp, bỏ qua",
      ignoredEmpty: "Ngày không có giờ",
      issues: "Cần lưu ý",
      xmlOnly: "Chỉ chấp nhận file có phần mở rộng .xml.",
      xmlTooLarge: "File XML không được vượt quá 10 MB.",
      coverage: "Theo dõi chấm công trong ngày",
      attentionOnly: "Chỉ hiện người cần xử lý",
      selectAllAttention: "Chọn tất cả cần nhắc",
      selected: "Đã chọn {count}",
      remindSelected: "Gửi nhắc nhở",
      selectToRemind: "Chọn để nhắc",
      selectEmployeeReminder: "Chọn nhắc {name}",
      employeeCode: "Mã NV",
      status: "Trạng thái",
      lastReminder: "Nhắc gần nhất",
      statusComplete: "Đủ vào / ra",
      statusIncomplete: "Thiếu một đầu giờ",
      statusExcused: "Có phiếu đã duyệt",
      statusMissing: "Chưa có dữ liệu",
      statusNonWorkday: "Ngày không làm việc",
      noAttention: "Không có nhân viên nào cần xử lý trong phạm vi đang xem.",
      reminderFeedback:
        "Đã gửi {queued}; trùng {duplicate}; tắt nhận nhắc {optedOut}; không còn phù hợp {ineligible}.",
      manualEntry: "Nhập hoặc hiệu chỉnh thủ công",
      issue_employee_not_found:
        "Mã chấm công chưa được ánh xạ với hồ sơ nhân viên nên dữ liệu được bỏ qua.",
      issue_incomplete_punch_pair: "Dòng nguồn thiếu giờ vào hoặc giờ ra.",
      issue_multiple_punch_pairs:
        "Nhiều lượt vào/ra được quy về giờ vào đầu tiên và giờ ra cuối cùng.",
      issue_duplicate_source_row: "Dòng trùng trong file nguồn đã được bỏ qua.",
      issue_invalid_clock_value: "Giá trị giờ không hợp lệ đã được bỏ qua.",
      issue_invalid_clock_order:
        "Giờ ra phải sau giờ vào nên dòng này không được nhập.",
    },
    receipts: {
      batchSelect: "Chọn để xử lý lô",
      batchReceive: "Tiếp nhận {count} hồ sơ",
      batchConfirm: "Xác nhận tiếp nhận {count} hồ sơ đã chọn:\n{items}",
      combinedTitle: "Hồ sơ tiếp nhận",
      kind: "Bộ phận tiếp nhận",
      kinds: { admin: "Nhân sự", accounting: "Kế toán" },
      pending: "Chờ tiếp nhận",
      received: "Đã tiếp nhận",
      waitingSince: "Chờ từ",
      receivedBy: "Người nhận",
      receivedAt: "Nhận lúc",
      startFrom: "Ngày đi từ",
      startTo: "đến",
      admin: {
        title: "HCNS tiếp nhận công tác & phương tiện",
        subtitle:
          "Hàng chờ riêng sau khi phiếu đã duyệt; không phụ thuộc quyền duyệt nghiệp vụ.",
        queue: "Phiếu chờ HCNS tiếp nhận",
        received: "Phiếu HCNS đã tiếp nhận",
        waitingSince: "Duyệt lúc",
      },
      accounting: {
        title: "Kế toán tiếp nhận công tác & phương tiện",
        subtitle:
          "Hàng chờ riêng sau khi HCNS đã tiếp nhận; không hiển thị phiếu HR khác.",
        queue: "Phiếu chờ Kế toán tiếp nhận",
        received: "Phiếu Kế toán đã tiếp nhận",
        waitingSince: "HCNS nhận lúc",
      },
    },
    profile: {
      completeness: "Độ đầy đủ",
      missingFields: "Còn thiếu",
      copyPermanentAddress: "Giống địa chỉ thường trú",
      suggestProbationEnd: "Gợi ý: {date} (60 ngày)",
      alertsColumn: "Cần lưu ý",
      person: "Nhân viên",
      unit: "Phòng ban · Chức vụ",
      accountSection: "Tài khoản đăng nhập",
      profileSection: "Hồ sơ nhân viên",
      openAccess: "Xem & sửa phân quyền",
      noAccountHint: "Người này chưa có tài khoản đăng nhập. Tạo tài khoản bằng nút \"Tạo tài khoản\" trên bảng.",
      editProfileShort: "Sửa hồ sơ",
      lockAccount: "Khóa tài khoản",
      unlockAccount: "Mở khóa tài khoản",
      peopleLedger: "Nhân viên & tài khoản",
      accountStatus: "Tài khoản",
      accountActive: "Hoạt động",
      accountLocked: "Đã khóa",
      noAccount: "Chưa có",
      profileStatus: "Hồ sơ",
      noProfile: "Chưa có hồ sơ",
      searchPlaceholder: "Tìm tên, mã, tài khoản, SĐT, email, phòng ban… (không cần dấu)",
      allProfiles: "Tất cả",
      alerts: {
        contractExpired: "Hợp đồng đã hết hạn",
        contractExpiring: "Hợp đồng sắp hết hạn",
        probationEnding: "Sắp hết thử việc",
        birthdayThisMonth: "Sinh nhật tháng này",
        pendingApproval: "Chờ duyệt",
        incomplete: "Thiếu thông tin lương/BHXH",
        accountStillActive: "Đã nghỉ nhưng tài khoản còn hoạt động",
        noAccount: "Chưa có tài khoản",
        noProfile: "Có tài khoản nhưng chưa có hồ sơ",
        accountMismatch: "Hồ sơ và tài khoản lệch tên/mã",
        managerInactive: "Quản lý trực tiếp đã nghỉ/bị khóa",
      },
      warnings: {
        dateOrder: "Ngày này đang sớm hơn ngày trước đó trong quá trình làm việc.",
        nationalIdFormat: "CCCD gồm 12 chữ số (CMND cũ 9 số).",
        phoneFormat: "Số điện thoại gồm 10 số, bắt đầu bằng 0 hoặc +84.",
        emailFormat: "Email chưa đúng định dạng.",
        bankAccountFormat: "Số tài khoản chỉ gồm 6–20 chữ số.",
        tooYoung: "Ngày sinh cho thấy chưa đủ 15 tuổi.",
        duplicateCode: "Mã nhân viên đã có ở hồ sơ khác.",
        duplicateNationalId: "Số CCCD đã có ở hồ sơ khác.",
      },
      probationEndDate: "Ngày kết thúc thử việc",
      contractEndDate: "Ngày hết hạn hợp đồng",
      pageTitle: "Hồ sơ nhân viên",
      subtitle:
        "Thông tin vòng đời, cá nhân, liên hệ, tài chính và vị trí tổ chức.",
      viewDetails: "Xem chi tiết",
      viewAccount: "Xem tài khoản & quyền",
      approvalDetails: "Thông tin tạo và xét duyệt",
      reviewedBy: "Người xét duyệt",
      reviewedAt: "Ngày xét duyệt",
      decisionReason: "Lý do xét duyệt",
      myProfile: "Hồ sơ của tôi",
      adminLedger: "Sổ hồ sơ nhân viên",
      adminViews: "Các bảng thông tin nhân viên",
      contactAddress: "Địa chỉ liên lạc",
      organizationChart: "Sơ đồ tổ chức",
      editProfile: "Sửa hồ sơ · {name}",
      administrationSaved: "Đã cập nhật hồ sơ nhân viên.",
      correctionReason: "Lý do điều chỉnh hồ sơ đã duyệt",
      correctionReasonPlaceholder: "Nêu rõ nội dung và căn cứ điều chỉnh",
      sensitiveValuesPreserved:
        "CCCD và số tài khoản đang được che sẽ được giữ nguyên nếu không nhập giá trị mới.",
      employment: "Hợp đồng & vòng đời",
      personal: "Cá nhân & năng lực",
      contactFinance: "Địa chỉ & tài chính",
      organization: "Vị trí tổ chức",
      employeeCode: "Mã nhân viên",
      fullName: "Họ và tên",
      hireDate: "Ngày vào làm",
      probationStartDate: "Ngày bắt đầu thử việc",
      officialContractDate: "Ngày hợp đồng chính thức",
      contractNumber: "Số hợp đồng",
      contractType: "Loại hợp đồng",
      classification: "Phân loại",
      employeeType: "Hình thức nhân viên",
      employmentStatus: "Trạng thái làm việc",
      employmentStatuses: {
        active: "Đang làm việc",
        probation: "Thử việc",
        onboarding: "Đang tiếp nhận",
        inactive: "Tạm ngưng",
        terminated: "Đã nghỉ việc",
      },
      terminationDate: "Ngày nghỉ việc",
      returnDate: "Ngày quay lại",
      birthDate: "Ngày sinh",
      gender: "Giới tính",
      nationalId: "CCCD / Mã định danh",
      phone: "Điện thoại",
      email: "Email",
      commuteDistanceKm: "Khoảng cách đi làm (km)",
      education: "Trình độ học vấn",
      languages: "Ngoại ngữ",
      language1: "Ngoại ngữ 1",
      language2: "Ngoại ngữ 2",
      submittedAt: "Ngày gửi",
      cvAttachmentId: "CV đã liên kết",
      photoAttachmentId: "Ảnh đã liên kết",
      permanentHouseNumber: "Số nhà thường trú",
      permanentStreet: "Đường thường trú",
      permanentWard: "Phường/xã thường trú",
      permanentProvince: "Tỉnh/thành thường trú",
      currentHouseNumber: "Số nhà hiện tại",
      currentStreet: "Đường hiện tại",
      currentWard: "Phường/xã hiện tại",
      currentProvince: "Tỉnh/thành hiện tại",
      bankName: "Ngân hàng",
      bankAccountNumber: "Số tài khoản",
      department: "Phòng ban",
      departmentUnit: "Đơn vị (phòng ban › tổ)",
      departmentUnitPlaceholder: "Chọn đơn vị trong cây phòng ban",
      division: "Khối",
      team: "Nhóm",
      position: "Vị trí",
      title: "Chức danh",
      reportsTo: "Báo cáo cho",
      contactColumns: {
        hometownHouseNumber: "Quê quán · Số nhà",
        hometownStreet: "Quê quán · Đường/Phố",
        hometownWard: "Quê quán · Xã/Phường",
        hometownProvince: "Quê quán · Tỉnh/Thành phố",
        currentHouseNumber: "Chỗ ở hiện tại · Số nhà",
        currentStreet: "Chỗ ở hiện tại · Đường/Phố",
        currentWard: "Chỗ ở hiện tại · Xã/Phường",
        currentProvince: "Chỗ ở hiện tại · Tỉnh/Thành phố",
      },
    },
    skills: {
      title: "Bản đồ kỹ năng",
      subtitle:
        "Ma trận năng lực hiện tại, mức mục tiêu và kỳ đánh giá tiếp theo.",
      assessmentDate: "Ngày đánh giá",
      nextAssessmentDate: "Ngày đánh giá tiếp theo",
      track: "Nhóm kỹ năng",
      profile: "Chuẩn đánh giá",
      score: "Điểm",
      resultLevel: "Kết quả cấp độ",
      staff: "Nhân viên",
      leaderStaff: "Trưởng nhóm / Nhân viên",
      thresholds: "Ngưỡng kết quả theo API",
      category: "Nhóm năng lực",
      competency: "Năng lực",
      currentLevel: "Cấp độ hiện tại",
      targetLevel: "Cấp độ mục tiêu",
      note: "Ghi chú",
      newAssessment: "Tạo kỳ đánh giá",
      editAssessment: "Cập nhật kỳ đánh giá",
      matrixCaption: "Ma trận kỹ năng {track}",
      levelFor: "{field} của {skill}",
      noteFor: "Ghi chú cho {skill}",
      myAssessments: "Các kỳ đánh giá của tôi",
      reviewQueue: "Kỳ đánh giá chờ duyệt",
    },
  },
  mealMatrix: {
    suggestCancellation:
      "Có đơn nghỉ/công tác đã duyệt. Cân nhắc bỏ suất ăn trước hạn chốt.",
    pastDate: "Không thể thay đổi suất ăn của ngày đã qua.",
    historyQuantity: "Số suất",
    historyGuests: "Số khách",
    historyNote: "Ghi chú",
    historyUnknown: "Chưa có dữ liệu lịch sử",
    title: "Đăng ký suất ăn",
    subtitle:
      "Lưới nhân viên theo ngày. Mặc định đăng ký hết; bỏ đánh dấu ngày không ăn.",
    selectAll: "Đánh dấu hết",
    clearAll: "Bỏ hết",
    clearRow: "Bỏ cả hàng",
    pending: "{count} ô chờ lưu",
    saved: "Đã lưu đăng ký suất ăn.",
    saveProgress: "Đã lưu {saved} ô; còn {remaining} ô chờ lưu.",
    invalidPeriod: "Năm phải là số nguyên từ 2020 đến 2100, tháng từ 1 đến 12.",
    unsavedChanges:
      "Có thay đổi suất ăn chưa lưu. Bạn có muốn bỏ các thay đổi này không?",
    noMealDays: "Tháng này không có ngày ăn nào.",
    rowTotal: "Số ngày",
    dayTotal: "Tổng suất",
    cutoffRule:
      "Qua mốc chốt của bếp, ô sẽ khóa; chỉ người quản trị kỳ chấm công còn sửa được và mọi thay đổi đều được ghi vết.",
    cutoffPassed:
      "Đã qua mốc chốt suất ăn của ngày này; liên hệ người quản trị để điều chỉnh.",
    history: "Lịch sử thay đổi",
    historyEmpty: "Tháng này chưa có thay đổi đăng ký nào.",
    historyWhen: "Lúc",
    historyChange: "Thay đổi",
    historyBy: "Người sửa",
    historyDefault: "Mặc định (có ăn)",
    registered: "Có ăn",
    notRegistered: "Không ăn",
    afterCutoff: "Sau mốc chốt",
  },
  companyVehicles: {
    title: "Quản lý xe công ty",
    subtitle: "Hồ sơ xe, hạn đăng kiểm/bảo hiểm và nhật ký bảo trì bảo dưỡng.",
    fleet: "Đội xe",
    showRetired: "Hiện cả xe đã ngừng khai thác",
    platePlaceholder: "29A-12345",
    newVehicle: "Thêm xe",
    editVehicle: "Sửa hồ sơ xe",
    saved: "Đã lưu hồ sơ xe.",
    removed: "Đã xóa xe.",
    maintenanceLog: "Nhật ký bảo dưỡng",
    history: "Thông tin và nhật ký xe",
    vehicleInformation: "Thông tin xe",
    maintenanceFor: "Bảo dưỡng · {code} — {name}",
    newMaintenance: "Ghi đợt bảo dưỡng",
    editMaintenance: "Sửa đợt bảo dưỡng",
    maintenanceSaved: "Đã lưu đợt bảo dưỡng.",
    maintenanceRemoved: "Đã xóa đợt bảo dưỡng.",
    removeMaintenanceConfirm:
      "Xóa đợt bảo dưỡng này? Dòng nhật ký hệ thống thì không xóa được.",
    logEntry: "Nhật ký hệ thống",
    correctOdometer: "Sửa số km",
    odometerPrompt: "Số km đúng của xe {code}",
    odometerInvalid: "Số km phải là số không âm.",
    odometerCorrected: "Đã hiệu chỉnh số km và ghi nhật ký.",
    reasonPrompt: "Lý do (bắt buộc)",
    retire: "Ngừng khai thác",
    retirePrompt: "Lý do ngừng khai thác xe {code}",
    retired: "Đã chuyển xe sang ngừng khai thác.",
    reactivate: "Kích hoạt lại",
    reactivatePrompt: "Lý do kích hoạt lại xe {code}",
    reactivated: "Đã kích hoạt lại xe.",
    status: {
      Active: "Đang khai thác",
      UnderMaintenance: "Đang bảo dưỡng",
      Retired: "Ngừng khai thác",
    },
    kind: {
      Service: "Bảo dưỡng định kỳ",
      Repair: "Sửa chữa",
      Inspection: "Đăng kiểm",
      Insurance: "Bảo hiểm",
      Registration: "Đăng ký xe",
      OdometerCorrection: "Hiệu chỉnh số km",
      Retirement: "Ngừng khai thác",
      Reactivation: "Kích hoạt lại",
    },
    maintenanceStatus: {
      Planned: "Đã lên lịch",
      InProgress: "Đang làm",
      Completed: "Đã xong",
      Cancelled: "Đã hủy",
    },
    alerts: {
      registration: "Sắp hết hạn đăng kiểm",
      insurance: "Sắp hết hạn bảo hiểm",
      service: "Đến hạn bảo dưỡng",
      openMaintenance: "{count} đợt bảo dưỡng chưa đóng",
    },
    fields: {
      vehicleType: "Loại xe",
      seatCount: "Số chỗ",
      odometer: "Số km",
      registrationExpiry: "Hạn đăng kiểm",
      insuranceExpiry: "Hạn bảo hiểm",
      nextServiceDue: "Bảo dưỡng kỳ tới",
      nextServiceOdometer: "Km bảo dưỡng kỳ tới",
      note: "Ghi chú",
      kind: "Hạng mục",
      scheduledDate: "Ngày hẹn",
      completedDate: "Ngày hoàn thành",
      cost: "Chi phí",
      vendor: "Đơn vị thực hiện",
      description: "Nội dung",
    },
  },
  documentRegister: {
    departmentCode: "Ký hiệu bộ phận",
    documentNumberAuto: "Tự cấp khi lưu",
    title: "Sổ tài liệu kiểm soát",
    subtitle:
      "Quản lý tài liệu và hồ sơ từ soạn thảo đến xác nhận, phê duyệt hoặc hủy.",
    department: "Bộ phận",
    documentNumber: "Số tài liệu",
    recordNumber: "Số hồ sơ",
    revision: "Số Rev",
    effectiveDate: "Ngày hiệu lực",
    newTitle: "Tạo tài liệu kiểm soát",
    editTitle: "Cập nhật tài liệu kiểm soát",
    saved: "Đã lưu tài liệu kiểm soát.",
    attachmentPreserved:
      "Tệp đã liên kết được giữ nguyên; màn này không yêu cầu nhập mã kỹ thuật.",
    decisionNote: "Ý kiến / lý do quyết định",
    noteRequiredForReject: "Bắt buộc khi từ chối hoặc hủy",
    cancelDocument: "Hủy tài liệu",
    effective: "Hiệu lực",
    effectiveYes: "Đang hiệu lực",
    effectiveAt: "Hiệu lực tại ngày",
    supersede: "Thay thế",
    supersedeBy: "Thay thế bằng tài liệu đã duyệt",
    superseded: "Đã ghi nhận thay thế.",
    supersededBy: "Đã bị thay thế bởi {number}",
    noReplacement: "Chưa có tài liệu đã duyệt cùng loại để thay thế.",
    auditTrail: "Dấu vết kiểm soát tài liệu",
    ledger: "Danh mục tài liệu & hồ sơ",
    searchPlaceholder: "Tên, bộ phận hoặc số tài liệu",
    kinds: { Document: "Tài liệu", Record: "Hồ sơ" },
    audit: {
      created: "Khởi tạo",
      submitted: "Gửi xác nhận",
      confirmed: "Đã xác nhận",
      approved: "Đã phê duyệt",
      rejected: "Bị từ chối",
      cancelled: "Đã hủy",
    },
  },
  financeCatalog: {
    title: "Danh mục báo cáo tài chính",
    subtitle: "Phạm vi menu tài chính hợp nhất từ Update.xlsx và Version.xlsx.",
    menuOnly: "{count} mục đang hoạt động",
    entries: "mục menu",
    noContractTitle: "Mọi báo cáo tài chính đã có màn hình",
    noContractBody:
      "Mỗi mục mở đúng màn hình hoặc thẻ báo cáo. Mục bị khóa là mục bạn chưa được cấp quyền đọc; liên hệ quản trị nếu cần.",
    unavailable: "Chưa có nguồn dữ liệu được phê duyệt.",
    openReport: "Mở báo cáo",
    noDataContract: "Không có hợp đồng dữ liệu",
    availableContract: "Đang hoạt động",
    inherited: "Kế thừa từ Update.xlsx",
    footnote:
      "Hai báo cáo kế thừa được giữ lại từ Update.xlsx theo nguyên tắc không loại bỏ nội dung cũ.",
    reports: {
      invoiceStatus: "Tình hình xuất hoá đơn",
      financial: "Báo cáo tài chính",
      revenue: "Báo cáo doanh thu",
      projectCost: "Giá vốn dự án",
      inventory: "Tồn kho",
      costOfGoods: "Giá vốn",
      receivables: "Công nợ phải thu",
      payables: "Công nợ phải trả",
      cashExpenses: "CP tiền mặt",
      officeExpenses: "Chi phí quản lý văn phòng",
      cashFlow: "Báo cáo dòng tiền",
      payroll: "Bảng lương",
    },
  },
  projectContracts: {
    exportWord: "Xuất Word",
    panel: {
      info: "Thông tin",
      new: {
        contracts: "Thêm hợp đồng",
        acceptances: "Thêm biên bản nghiệm thu",
        tickets: "Thêm phiếu bảo hành",
      },
    },
    saveForAttachments: "Lưu hoặc chọn hợp đồng / biên bản nghiệm thu để tải tệp đính kèm.",
    title: "Hợp đồng, nghiệm thu và bảo hành",
    projectGroup: "Dự án",
    contractGroup: "Hợp đồng",
    termsGroup: "Giá trị & bảo hành",
    acceptanceGroup: "Biên bản nghiệm thu",
    ticketGroup: "Phiếu bảo hành mới",
    pickProject:
      "Chọn dự án để xem hợp đồng, biên bản nghiệm thu và phiếu bảo hành.",
    openTickets: "Phiếu đang mở",
    allProjects: "Tất cả dự án",
    directorySearch: "Số, tên hợp đồng, mã dự án…",
    openInProject: "Mở ở dự án",
    directoryHint: "Danh mục chỉ đọc. Bấm «Mở ở dự án» để sửa, xuất Word/PDF, lập biên bản nghiệm thu hoặc phiếu bảo hành.",
    latestContract: "Hợp đồng mới nhất",
    activate: "Kích hoạt",
    complete: "Hoàn tất",
    terminate: "Chấm dứt",
    terminateTitle: "Chấm dứt hợp đồng {number}",
    void: "Huỷ",
    voided: "Đã huỷ",
    voidTitle: "Huỷ biên bản {number}",
    createTicket: "Tạo phiếu",
    takeTicket: "Nhận xử lý",
    reopenTicket: "Mở lại",
    resolveTicket: "Ghi đã xử lý",
    closeTicket: "Đóng phiếu",
    rejectTitle: "Từ chối phiếu {number}",
    inWarranty: "Trong bảo hành",
    outOfWarranty: "Ngoài bảo hành",
    tabs: {
      contracts: "Hợp đồng",
      acceptances: "Biên bản nghiệm thu",
      tickets: "Phiếu bảo hành",
    },
    status: {
      Draft: "Nháp",
      Active: "Đang hiệu lực",
      Completed: "Đã hoàn tất",
      Terminated: "Đã chấm dứt",
    },
    ticketStatus: {
      Open: "Mới",
      InProgress: "Đang xử lý",
      Resolved: "Đã xử lý",
      Closed: "Đã đóng",
      Rejected: "Từ chối",
    },
    results: {
      Accepted: "Đạt",
      AcceptedWithRemarks: "Đạt có ghi chú",
      Rejected: "Không đạt",
    },
    severities: {
      Low: "Thấp",
      Medium: "Trung bình",
      High: "Cao",
      Critical: "Nghiêm trọng",
    },
    fields: {
      project: "Dự án",
      customer: "Khách hàng",
      contractNumber: "Số hợp đồng",
      title: "Tên hợp đồng",
      customerSigner: "Người ký phía khách",
      signedDate: "Ngày PO",
      effectiveFrom: "Hiệu lực từ",
      effectiveTo: "Hiệu lực đến",
      value: "Giá trị",
      currency: "Tiền tệ",
      warrantyMonths: "Bảo hành (tháng)",
      warrantyStart: "Bắt đầu bảo hành",
      warrantyEnd: "Hết bảo hành",
      inWarranty: "Bảo hành",
      paymentTerms: "Điều khoản thanh toán",
      note: "Ghi chú",
      recordNumber: "Số biên bản",
      acceptanceDate: "Ngày nghiệm thu",
      scope: "Phạm vi nghiệm thu",
      result: "Kết quả",
      remarks: "Ghi chú / tồn tại",
      ticketNumber: "Số phiếu",
      reportedDate: "Ngày báo",
      reportedBy: "Người báo",
      ticketTitle: "Tiêu đề",
      description: "Mô tả",
      severity: "Mức độ",
      resolution: "Cách xử lý",
    },
  },
  customerOrders: {
    title: "Đơn đặt hàng của khách hàng",
    newManual: "Tạo PO khách",
    newFromQuotation: "Tạo từ báo giá",
    source: "Nguồn lập",
    sourceManual: "Nhập tay",
    sourceQuotation: "Từ báo giá",
    pickProject: "Chọn dự án để lập PO khách hàng.",
    noQuotation: "Dự án chưa có báo giá đã phát hành còn hiệu lực.",
    notInList: "Không thấy PO trong danh sách đang xem; hãy chọn dự án ở bộ lọc.",
    linesFromQuotation: "Dòng hàng chép từ báo giá (bỏ dòng nhóm); tiền tệ theo báo giá, điều khoản thanh toán để trống thì lấy theo báo giá.",
    confirm: "Xác nhận PO",
    confirmHint: "Xác nhận PO lập từ báo giá sẽ ghi kết quả thương mại của báo giá là «Khách chấp nhận».",
    cancel: "Hủy PO",
    cancelTitle: "Hủy PO khách {number}",
    linkContract: "Gắn hợp đồng",
    saveLink: "Lưu liên kết",
    noLinkedContract: "— Không gắn hợp đồng —",
    noContract: "Dự án chưa có hợp đồng còn hiệu lực để gắn.",
    headerGroup: "Thông tin PO",
    linesGroup: "Dòng hàng",
    addLine: "Thêm dòng",
    removeLine: "Xóa dòng",
    noLines: "Chưa có dòng hàng.",
    fields: {
      project: "Dự án",
      customer: "Khách hàng",
      orderNumber: "Số PO khách",
      orderDate: "Ngày PO",
      requestedDeliveryDate: "Ngày giao yêu cầu",
      currency: "Tiền tệ",
      paymentTerms: "Điều khoản thanh toán",
      customerSigner: "Người ký phía khách",
      note: "Ghi chú",
      quotation: "Báo giá",
      contract: "Hợp đồng",
      subtotal: "Tiền trước thuế",
      vatAmount: "Tiền VAT",
      total: "Tổng tiền",
      cancelReason: "Lý do hủy",
      code: "Mã hàng",
      description: "Diễn giải",
      unit: "ĐVT",
      quantity: "Số lượng",
      unitPrice: "Đơn giá",
      vatPercent: "VAT %",
      amount: "Thành tiền",
    },
    status: {
      Draft: "Nháp",
      Confirmed: "Đã xác nhận",
      Cancelled: "Đã hủy",
    },
  },
  financeClose: {
    title: "Chốt tháng",
    periodGroup: "Kỳ kế toán",
    period: "Kỳ",
    currency: "Đồng tiền báo cáo",
    range: "Khoảng ngày",
    version: "Phiên bản số liệu",
    notClosed: "Chưa chốt",
    statusOpen: "Đang mở",
    statusClosed: "Đã chốt v{version}",
    close: "Chốt kỳ",
    reopen: "Mở lại kỳ",
    reopenTitle: "Mở lại kỳ {period}",
    reopenContext:
      "Ảnh chụp số liệu của lần chốt vẫn được giữ. Nêu rõ lý do mở lại (ít nhất 10 ký tự).",
    reason: "Lý do",
    blocked:
      "Chưa thể chốt: còn {count} hạng mục ở mức “Chặn chốt”. Hạng mục “Cảnh báo” không chặn nhưng được ghi vào biên bản.",
    notEnded: "Kỳ chưa kết thúc: chỉ chốt được sau ngày cuối tháng.",
    checklist: "Danh sách kiểm tra",
    history: "Lịch sử chốt / mở lại",
    noHistory: "Kỳ này chưa từng được chốt.",
    closedEvent: "chốt",
    reopenedEvent: "mở lại",
    warningsRecorded: "{count} cảnh báo ghi biên bản",
    snapshotNote:
      "Mỗi lần chốt lưu ảnh chụp số liệu theo phiên bản; mở lại cần lý do và quyền riêng.",
    passed: "Đạt",
    open: "Chưa xong",
    review: "Cần xem",
    resolve: "Xử lý",
    columns: {
      item: "Hạng mục kiểm tra",
      level: "Mức",
      count: "Còn lại",
      amount: "Giá trị",
      action: "Xử lý",
    },
    levels: {
      Blocking: "Chặn chốt",
      Warning: "Cảnh báo",
    },
    checks: {
      bank_unclassified: "Dòng sao kê chưa phân loại",
      payment_disbursing: "Phiếu chi đang chi, chưa xác nhận thực chi",
      bank_default_classified: "Dòng sao kê còn phân loại mặc định",
      bank_unmatched_trade: "Thu bán hàng / chi NCC chưa đối soát",
      payment_approved_unpaid: "Phiếu chi đã duyệt chưa chi",
      advance_overdue: "Tạm ứng quá hạn hoàn ứng",
      cash_opening_missing: "Chưa có số dư quỹ đầu kỳ được xác nhận",
      amortization_changed: "Khoản phân bổ vừa sửa trong kỳ",
      payroll_unpublished: "Bảng lương của kỳ chưa phát hành",
    },
  },
  financeStatement: {
    turnoverBasis: "Cách tính số dư bình quân",
    turnoverBases: { "openingClosing": "Bình quân đầu kỳ và cuối kỳ", "monthlyClosing": "Bình quân số dư cuối tháng" },
    turnoverPeriodNote: "Hệ số tính cho kỳ báo cáo, không quy đổi cả năm.",
    plan: {
      title: "Kế hoạch (báo giá được chấp nhận) và thực tế",
      hint: "Kế hoạch lấy từ báo giá được khách chấp nhận của từng dự án, ghi vào tháng dự án (ADR-050/051) và lọc theo trực thuộc của báo giá. Thực tế là số BCTC ở trên; lãi ròng thực tế không tách theo dự án nên chỉ hiện kế hoạch.",
      variance: "Chênh lệch TT − KH",
      projectMonth: "Tháng dự án",
      quotation: "Báo giá",
      actualRevenue: "Doanh thu thực tế trong kỳ",
      rows: {
        revenue: "Doanh thu",
        cogs: "Giá vốn",
        grossProfit: "Lãi gộp",
        netProfit: "Lãi ròng (sau thuế TNDN)",
      },
    },
    matrix: {"party": "Đối tác", "project": "Dự án / PO thương mại", "document": "Chứng từ", "source": "Nguồn", "status": "Trạng thái", "contract": "Hợp đồng", "invoiced": "Theo hóa đơn", "paid": "Đã thanh toán", "outstanding": "Còn lại", "references": "Số HĐ/ngày thanh toán", "invoiceBasis": "Giá vốn theo hóa đơn; khoản chi trực tiếp chưa gắn hóa đơn được tính riêng.", "cashBasis": "Chi tiền", "empty": "Chưa có dữ liệu trong kỳ."},
    scopeIncomplete: "Phạm vi trực thuộc chưa phân bổ lương, vốn đầu kỳ và số dư quỹ; các số liệu này chưa đầy đủ.",
    affiliation: "Trực thuộc (mã)",
    incompleteBalance: "Thiếu số dư gốc",
    title: "Báo cáo tài chính công ty",
    subtitle:
      "Báo cáo kết quả hoạt động kinh doanh theo tháng, quý, năm tài chính (BCTCCRM.xlsx) ghép từ hoá đơn đầu ra, sổ quỹ, phiếu chi, tồn kho và bảng lương đã công bố.",
    invalidRange:
      "Chọn đầy đủ ngày bắt đầu và kết thúc, ngày kết thúc không được trước ngày bắt đầu.",
    exportCsv: "Tải CSV",
    tabs: { revenue: "Doanh thu theo dự án", costs: "Giá vốn theo dự án", flows: "Dòng tiền", statement: "BCTC", analysis: "Phân tích", detail: "Chi tiết" },
    modes: { month: "Tháng", quarter: "Quý", year: "Năm" },
    filters: { mode: "Cột" },
    kinds: { balance: "số dư cuối kỳ", cumulative: "luỹ kế" },
    columns: {
      variance: "Chênh lệch",
      indicator: "Chỉ tiêu",
      formula: "Công thức",
      total: "Cả kỳ",
      kpi: "Chỉ số",
      plan: "Kế hoạch",
      actual: "Thực tế",
      range: "Ngưỡng",
      verdict: "Kết quả",
      line: "Khoản mục",
    },
    sections: {
      statement: "I. Chỉ tiêu tổng hợp",
      analysis: "II. Phân tích",
      personnel: "III. Chi phí nhân sự",
      office: "III. Chi phí quản lý văn phòng",
      provisions: "Khoản chi dự tính",
      flows: "Báo cáo dòng tiền",
      extras: "Công nợ và giá vốn dồn tích",
    },
    extras: {
      cogsCash: "Giá vốn đã chi tiền",
      projectPending: "Chi phí dự án chờ chi (chỉ xem, chưa vào giá vốn)",
      collected: "Thu tiền hoá đơn đầu ra",
      receivablesClosing: "Phải thu khách hàng cuối kỳ",
      cogsAccrual: "Giá vốn theo hoá đơn NCC (phần gắn dự án theo tháng dự án)",
      revenueInvoiced: "Doanh thu đã xuất hoá đơn",
      cogsLabor: "Trong giá vốn: OT/công tác gắn dự án",
      payablesClosing: "Phải trả nhà cung cấp cuối kỳ",
    },
    estimatedExpenses: {
      officeVat: "Thuế GTGT",
      projectEntertainment: "Tiếp khách dự án",
      displayOnly: "Chỉ hiển thị, không cộng vào tổng; gồm cả phần chờ chi như BCTC dự án.",
    },
    indicators: {
      capital: "Vốn góp",
      revenue: "Doanh thu hợp đồng",
      receivables: "Phải thu khách hàng",
      cogs: "Giá vốn",
      payables: "Phải trả nhà cung cấp",
      personnel: "Chi phí nhân sự",
      office: "Chi phí quản lý văn phòng",
      officeWithInvoice: "Trong đó chi phí có hoá đơn",
      officeNoInvoice: "Chi phí không hoá đơn",
      provisions: "Khoản chi dự tính (thuế GTGT)",
      grossProfit: "Lãi gộp",
      profitBeforeTax: "Lợi nhuận trước thuế",
      cumulativeProfit: "Lợi nhuận luỹ kế",
      profitAfterTax: "Lợi nhuận sau thuế",
      inventory: "Hàng tồn kho",
      cashPosition: "Tồn tiền",
      cashRemaining: "Tiền mặt còn lại",
    },
    personnel: {
      headcount: "Số nhân sự",
      insurance: "BHXH, KPCĐ (phần công ty)",
      salary: "Tiền lương",
      overtime: "Lương tăng ca",
      trip: "Công tác phí",
      meal: "Ăn giữa ca",
      otherAllowance: "Phụ cấp khác",
      holidayBonus: "Thưởng lễ tết",
      attitudeBonus: "Thưởng thái độ",
    },
    flows: {
      flowSales: "I. Tiền thu từ bán hàng",
      flowFinancialIn: "II. Thu hoạt động tài chính",
      flowSuppliers: "III. Chi trả nhà cung cấp",
      flowPersonnel: "IV. Chi trả người lao động, BHXH",
      flowTax: "V. Thuế đã nộp",
      flowFinancialOut: "VI. Chi hoạt động tài chính",
      cashClosing: "Tồn quỹ tiền mặt",
      bankClosing: "Tồn quỹ ngân hàng",
    },
    kpis: {
      revenue: "Doanh thu",
      salary: "Tiền lương",
      headcount: "Số nhân sự",
      personnelCost: "Chi phí nhân sự",
      officeCost: "Chi phí văn phòng",
      costPerHead: "Chi phí / người",
      revenuePerHead: "Doanh thu / người",
      receivableTurnover: "Vòng quay phải thu",
      inventoryTurnover: "Vòng quay tồn kho",
      ros: "ROS (LNTT / doanh thu)",
    },
    verdicts: { Fail: "Không đạt", Pass: "Đạt", Good: "Tốt", None: "Chưa có" },
    notes: {
      cashBasis:
        "Giá vốn ghi nhận theo hóa đơn; khoản chi trực tiếp chưa gắn hóa đơn được tính riêng, không cộng lại thanh toán hóa đơn. LNST = lợi nhuận luỹ kế × (1 − {rate}%). Số dư là số cuối kỳ.",
      targets:
        "Kế hoạch và ngưỡng lấy từ cấu hình Procurement:FinanceTargets (Trung tâm cấu hình); 0 = chưa đặt kế hoạch.",
      unpublished:
        "Tháng chưa chốt bảng lương (chi phí nhân sự chỉ có ăn giữa ca): {months}",
      noPayrollAccess:
        "Bạn không có quyền xem bảng lương nên chi phí nhân sự chỉ gồm ăn giữa ca từ sổ quỹ.",
      payrollUnavailable:
        "Không tải được chi phí nhân sự từ bảng lương; các dòng nhân sự tạm tính bằng ăn giữa ca.",
      bankFromStatement:
        "Số dư ngân hàng ưu tiên sao kê theo từng tháng. Giao dịch do hệ thống tự tạo dùng phân loại của phiếu gốc và không được cộng trùng; tháng chưa có sao kê thực dùng dòng tiền trong sổ quỹ.",
      amortized: "gồm phân bổ",
      otherAllocation: "Phân bổ trả trước/CCDC chưa gắn dòng",
    },
    recognition: {
      basis: "Doanh thu từng hợp đồng ghi theo tháng PO. Giá vốn gắn dự án ghi theo tháng PO sớm nhất, chưa có hợp đồng thì theo tháng tạo dự án. Phải thu, thu tiền và dòng tiền theo hoá đơn.",
      partial: "Dữ liệu một phần: {sources}.",
      laborMismatch: "OT/công tác gắn dự án tính từ phiếu lớn hơn số trên bảng lương đã công bố ở tháng: {months}. Phần vượt không trừ khỏi chi phí nhân sự.",
      shiftsTitle: "{count} khoản bị dời sang tháng mở vì kỳ ghi nhận đã chốt sổ",
      series: "Chỉ tiêu",
      projectPeriod: "Tháng dự án",
      recognizedPeriod: "Ghi vào tháng",
      amount: "Số tiền",
      seriesNames: {
        revenue: "Doanh thu hợp đồng",
        cogs: "Giá vốn",
      },
      sources: {
        project: "không tải được hợp đồng dự án; doanh thu hợp đồng chưa đầy đủ, không thay bằng doanh thu hóa đơn",
        contractAffiliationUnavailable: "hợp đồng chưa có trực thuộc xác định nên chưa được phân bổ doanh thu vào đơn vị đang lọc; xem Tất cả để xem tổng doanh thu hợp đồng",
        projectScope: "bạn chỉ xem được một phần dự án (thiếu quyền xem mọi dự án)",
        projectUnresolved: "có dự án không tra được hợp đồng nên chưa ghi nhận doanh thu hợp đồng của dự án đó",
        projectPlan: "không đọc được báo giá (thiếu quyền xem báo giá) nên không có số kế hoạch",
        projectPlanCost: "không có quyền xem giá vốn báo giá nên giá vốn và lãi kế hoạch bị bỏ trống",
        labor: "không tải được OT/công tác theo dự án (cần quyền xem bảng lương)",
        laborRates: "một số khoản OT thiếu đơn giá giờ (chưa có hồ sơ lương) nên chưa tính",
        stockCost: "có phiếu xuất kho cho dự án chưa có giá vốn FIFO (lớp nhập thiếu đơn giá) nên giá vốn theo dự án chưa đầy đủ",
      },
    },
    projectRevenue: {
      title: "Doanh thu hợp đồng theo dự án",
      hint: "Giá trị từ hợp đồng đã ký so với số đã xuất hóa đơn lũy kế đến cuối kỳ. Hóa đơn chỉ theo dõi tiến độ xuất, không thay thế giá trị hợp đồng.",
      basis: "Căn cứ",
      recognitionDate: "Ngày ghi nhận",
      contractValue: "Giá trị hợp đồng",
      invoiced: "Đã xuất hoá đơn",
      remaining: "Còn phải xuất",
      recognized: "Doanh thu trong kỳ",
      unallocated: "Hoá đơn chưa gắn dự án/PO",
      bases: {
        NoContract: "Chưa có hợp đồng đủ điều kiện",
        Contract: "Hợp đồng đã ký",
        InvoiceFallback: "Chưa có hợp đồng — tạm theo hoá đơn",
        CommercialPo: "Đơn thương mại — theo hoá đơn",
        Unallocated: "Theo tháng hoá đơn",
        Unresolved: "Không tra được hợp đồng dự án",
      },
    },
  },
  bankStatements: {
    allocation: {
      fromMatch: "Theo chứng từ đã khớp",
      matchedLocked: "Dòng đã khớp chứng từ nên dự án và mã chi phí lấy theo chứng từ đó. Muốn gắn riêng thì bỏ khớp trước.",
      duplicateHint: "Sổ quỹ ngân hàng đã có một bút toán ghi tay cùng ngày, cùng số tiền. Nếu đây là khoản khác thì xác nhận để lưu.",
      confirmDuplicate: "Đây là khoản khác, vẫn lưu",
    },
    record: {
      hint: "Ghi một giao dịch ngân hàng; chọn hóa đơn để đồng thời cập nhật công nợ. Giao dịch đã có trên sao kê không ghi lại tại đây.",
      direction: "Loại bút toán",
      currency: "Tiền tệ",
      invoice: "Khách hàng / nhà cung cấp · hóa đơn",
      other: "Giao dịch khác (không thanh toán hóa đơn)",
      amount: "Số tiền",
      supplierPayment: "Thanh toán hóa đơn NCC",
    },
    title: "Sao kê ngân hàng",
    subtitle:
      "Sổ tiền gửi TK 112 nhập từ CSV Internet Banking; phân loại dòng tiền BH/NCC/LBH/TTC/CTC và đối soát với phiếu chi, thu hoá đơn. Có sao kê thì BCTC lấy quỹ ngân hàng từ đây (ADR-028).",
    invalidRange:
      "Chọn đầy đủ ngày bắt đầu và kết thúc, ngày kết thúc không được trước ngày bắt đầu.",
    tabs: { lines: "Dòng sao kê", summary: "Tổng hợp dòng tiền" },
    filters: {
      account: "Số tài khoản",
      flowCode: "Mã dòng tiền",
      all: "Tất cả",
      unmatched: "Chỉ dòng chưa khớp",
      defaultOnly: "Chỉ dòng phân loại mặc định",
    },
    columns: {
      date: "Ngày CT",
      month: "Tháng",
      document: "Số CT",
      description: "Diễn giải",
      credit: "Thu",
      debit: "Chi",
      balance: "Số dư",
      flowCode: "Mã dòng tiền",
      source: "Nguồn",
      matched: "Đối soát",
      allocation: "Dự án · mã chi phí",
    },
    flowCodes: {
      Unclassified: "Chưa phân loại",
      Sales: "BH · Thu bán hàng",
      Supplier: "NCC · Chi trả nhà cung cấp",
      Payroll: "LBH · Lương, bảo hiểm",
      FinancialIncome: "TTC · Thu tài chính",
      FinancialExpense: "CTC · Chi tài chính",
      Tax: "Thuế đã nộp",
      Capital: "Vốn góp",
      InternalTransfer: "Chuyển quỹ nội bộ",
      Other: "Khác",
    },
    sources: { Default: "Mặc định", Rule: "Từ khoá", Manual: "Kế toán" },
    import: {
      encoding: "Mã hóa tệp CSV",
      tooLarge: "Tệp nhập không được vượt 10 MB.",
      button: "Nhập CSV / XLSX",
      title: "Nhập sao kê từ CSV",
      hint: "Xuất sao kê từ Internet Banking dạng CSV (có cột ngày, diễn giải, ghi nợ/ghi có, số dư). Dòng trùng được bỏ qua nên có thể nhập lại cùng tệp.",
      account: "Số tài khoản",
      currency: "Tiền tệ",
      file: "Tệp CSV",
      missing: "Nhập số tài khoản và chọn tệp CSV.",
      submit: "Nhập",
      result:
        "{imported} dòng mới, {skipped} dòng trùng bỏ qua, {matchedRequests} khớp phiếu chi, {matchedPayments} khớp thu hoá đơn, {defaults} dòng phân loại mặc định cần xem lại.",
    },
    batch: {
      selected: "Đã chọn {count} dòng",
      selectPage: "Chọn cả trang",
      clear: "Bỏ chọn",
      flowCode: "Phân loại thành…",
      classify: "Phân loại {count} dòng",
      match: "Khớp dòng có đúng một gợi ý",
      result: "Xong {succeeded} dòng · bỏ qua {skipped} · lỗi {failed}.",
      selectRow: "Chọn dòng sao kê",
    },
    match: {
      button: "Đối soát",
      unmatch: "Gỡ khớp",
      title: "Chọn chứng từ khớp với dòng sao kê",
      none: "Chưa khớp",
      noCandidates:
        "Không có phiếu chi hay thu hoá đơn nào cùng số tiền trong ±15 ngày.",
      kind: "Loại",
      reference: "Chứng từ",
      amount: "Số tiền",
      pick: "Chọn",
      kindPaymentRequest: "Phiếu chi",
      kindInvoicePayment: "Thu hoá đơn",
    },
    summary: {
      title: "Dòng tiền ngân hàng theo tháng",
      counts:
        "{lines} dòng trong kỳ · {defaults} dòng phân loại mặc định · {unmatched} dòng chưa khớp",
      credit: "Thu",
      debit: "Chi",
      balances: "Số dư theo tài khoản",
      account: "Tài khoản",
      lastDate: "Ngày CT cuối",
      credits: "Tổng thu trong kỳ",
      debits: "Tổng chi trong kỳ",
      balance: "Số dư cuối",
    },
  },
  amortizations: {
    title: "Chi phí trả trước và công cụ dụng cụ",
    subtitle:
      "Phân bổ đều theo tháng (sheet Khấu hao): số tiền ÷ số kỳ, kỳ cuối nhận phần lẻ. Phân bổ cộng vào dòng văn phòng đích của BCTC; tiền chi mua ghi sổ quỹ bằng mã CPTT / CCDCPB.",
    invalidRange:
      "Chọn đầy đủ ngày bắt đầu và kết thúc, ngày kết thúc không được trước ngày bắt đầu.",
    kinds: {
      Prepaid: "Chi phí trả trước (CPTT)",
      Tool: "Công cụ dụng cụ (CCDC)",
    },
    filters: { includeInactive: "Hiện khoản đã ngừng" },
    createPrepaid: "Thêm trả trước",
    createTool: "Thêm CCDC",
    create: "Thêm khoản phân bổ",
    edit: "Sửa khoản phân bổ",
    inactive: "Đã ngừng",
    activate: "Kích hoạt",
    deactivate: "Ngừng",
    total: "Tổng phân bổ",
    columns: {
      code: "Mã",
      name: "Tên",
      quantity: "SL",
      recognizedOn: "Ngày ghi nhận",
      amount: "Số tiền",
      periods: "Số kỳ",
      start: "Bắt đầu",
      monthly: "PB hàng kỳ",
      category: "Dòng chi phí",
      allocated: "Luỹ kế đến cuối kỳ",
      remaining: "Còn lại",
    },
    form: {
      openingAllocatedAmount: "Đã phân bổ trước khi nhập",
      openingAllocatedPeriods: "Số kỳ đã phân bổ",
      openingHint: "Giữ tháng bắt đầu và tổng số kỳ gốc. Phần đã phân bổ không ghi lại vào chi phí tháng.",
      debitAccount: "Tài khoản Nợ",
      creditAccount: "Tài khoản Có",

      purchaseSource: "Nguồn mua hàng",
      purchaseSourceHint:
        "Chọn khoản chi mua CCDC hoặc trả trước để lấy nguyên giá; mỗi khoản chỉ lập một lịch phân bổ cho từng mã chi phí.",
      sourceLocked:
        "Nguyên giá, loại, tiền tệ và ngày ghi nhận lấy từ nguồn mua, không thể thay đổi.",
      effectiveMonth: "Kỳ hiệu lực",
      effectiveHint:
        "Số tiền là tổng toàn bộ khoản phân bổ. Ngày bắt đầu và số kỳ xác định kỳ kết thúc; chỉ phần còn lại được phân bổ lại từ kỳ hiệu lực.",
      kind: "Loại",
      code: "Mã",
      name: "Tên",
      recognizedOn: "Ngày ghi nhận",
      amount: "Số tiền",
      currency: "Tiền tệ",
      periods: "Số kỳ (tháng)",
      startYear: "Năm bắt đầu",
      startMonth: "Tháng bắt đầu",
      category: "Mã chi phí nhận phân bổ",
      line: "dòng {line}",
      quantity: "Số lượng",
      unit: "ĐVT",
      note: "Ghi chú",
    },
  },
  supplierInvoices: {
    paidEditHelp: "Lịch sử thanh toán được giữ nguyên. Tổng tiền sau sửa không được nhỏ hơn số đã thanh toán; giữ nguyên loại tiền.",
    landedCost: {
      open: "Phân bổ vào giá vật tư",
      title: "Phân bổ thuế, phí nhập khẩu vào giá nhập kho",
      summary: "Hoá đơn {invoice}, dòng {line}: {description} · mã {category} · {amount} (trước thuế GTGT)",
      basis: "Tiêu thức",
      bases: { Value: "Theo giá trị hàng", Quantity: "Theo số lượng" },
      goodsInvoice: "Lô hàng nhận phí",
      goodsSupplier: "Tìm hoá đơn hàng theo nhà cung cấp",
      byCustoms: "Theo số tờ khai {customs}",
      noReceipts: "Không tìm thấy phiếu nhập kho đã duyệt của lô hàng này. Kiểm tra số tờ khai, hoặc chọn hoá đơn hàng.",
      columns: { material: "Vật tư", date: "Ngày nhập", quantity: "SL nhập", issued: "Đã xuất", purchaseValue: "Giá trị mua", landedSoFar: "Phí đã phân bổ", amount: "Phân bổ lần này", stocked: "Vào giá tồn kho", expensed: "Phần hàng đã xuất" },
      total: "Tổng phân bổ",
      difference: "Tổng phân bổ phải bằng {amount}; đang lệch {difference}.",
      issuedHint: "Lô hàng đã xuất một phần. Phần phí của số đã xuất không vào giá tồn kho; khoản phí này đã là giá vốn theo hoá đơn.",
      propose: "Lấy số đề xuất",
      save: "Lưu phân bổ",
      replace: "Thay phân bổ hiện tại",
      replaceReason: "Lý do thay phân bổ",
      current: "Phân bổ đang hiệu lực",
      cancel: "Huỷ phân bổ",
      cancelReason: "Lý do huỷ",
      history: "Phân bổ đã huỷ ({count})",
      ineligible: { category: "Dòng này không phải thuế, phí nhập khẩu nên không phân bổ vào giá vật tư. Thuế GTGT không được phân bổ.", void: "Hoá đơn đã huỷ." },
    },
    descriptiveOnly: "Hoá đơn đã có thanh toán: chỉ sửa được hạn thanh toán, người đảm trách, end-user và ghi chú. Muốn sửa tiền hoặc dòng hàng thì gỡ thanh toán trước.",
    stockReceipt: {"approved": "Đã nhập kho (đã duyệt).", "open": "Mở danh sách phiếu nhập", "material": "Vật tư kho", "create": "Tạo / mở phiếu nhập", "created": "Phiếu nhập nháp; cần trình duyệt trước khi ghi nhận tồn kho."},
    autoStock: {"received": "Đã tự nhập kho {count} dòng gắn vật tư.", "skippedLine": "Dòng {line} chưa nhập kho: {reason}", "deferred": "Hóa đơn {id} đã lưu. {count} dòng đã nhập kho; các dòng còn lại tạm hoãn vì {reason}. Có thể thử lại sau khi dự án mở khóa.", "retry": "Thử nhập kho các dòng còn lại"},
    matching: {
      held: "Tạm chặn thanh toán do chưa khớp chứng từ",
      released: "Đã giải trình và gỡ chặn thanh toán",
      releaseReason: "Lý do cho phép thanh toán",
      release: "Giải trình và gỡ chặn",
      purchase_order_missing: "Chưa liên kết P/O",
      purchase_order_not_supplier: "P/O không phải đơn mua từ nhà cung cấp",
      purchase_order_not_approved: "P/O chưa được duyệt",
      supplier_mismatch: "Nhà cung cấp không khớp",
      project_mismatch: "Dự án không khớp",
      currency_mismatch: "Loại tiền không khớp",
      purchase_order_line_missing: "Chưa liên kết dòng P/O",
      item_or_unit_mismatch: "Hàng hóa hoặc đơn vị không khớp",
      price_mismatch: "Đơn giá không khớp",
      billed_quantity_exceeds_order: "Số lượng hóa đơn vượt số lượng đặt",
      billed_quantity_exceeds_approved_receipts:
        "Số lượng hóa đơn vượt số lượng đã nhận được duyệt",
    },
    title: "Hoá đơn nhà cung cấp",
    subtitle:
      "Phiếu mua hàng có dòng hàng (mã, model, serial, tên, nhóm, SL, ĐVT, đơn giá, thuế); thanh toán nhiều lần, gắn phiếu chi đã chi; công nợ phải trả theo NCC và tuổi nợ (sheet Công nợ phải trả).",
    invalidRange:
      "Chọn đầy đủ ngày bắt đầu và kết thúc, ngày kết thúc không được trước ngày bắt đầu.",
    tabs: { invoices: "Hoá đơn NCC", payables: "Công nợ phải trả" },
    filters: { all: "Tất cả", outstandingOnly: "Chỉ hoá đơn còn nợ" },
    create: "Lập hoá đơn NCC",
    edit: "Sửa hoá đơn NCC",
    overdueDays: "quá hạn {days} ngày",
    statuses: {
      Open: "Chưa thanh toán",
      PartiallyPaid: "Thanh toán một phần",
      Paid: "Đã thanh toán",
      Void: "Đã huỷ",
    },
    columns: {
      number: "Số hoá đơn",
      date: "Ngày HĐ",
      supplier: "Nhà cung cấp",
      project: "Dự án",
      total: "Tổng tiền",
      paid: "Đã thanh toán",
      outstanding: "Còn phải trả",
      due: "Hạn thanh toán",
    },
    form: {
      invoiceOrCustomsNumber: "Số hóa đơn / tờ khai",
      commercialPo: "PO thương mại",
      commercialPoHint: "Đơn thương mại không có mã dự án: chọn PO ở đây, áp cho mọi dòng chưa chọn dự án.",
      legacyCustomsNumber: "Tờ khai đã lưu",
      responsibleName: "Người đảm trách",

      purchaseOrder: "Đơn đặt hàng NCC",
      addOrderLines: "Lấy dòng hàng từ P/O",
      exchangeRateSource: "Nguồn tỷ giá",
      exchangeRateEffectiveDate: "Ngày tỷ giá",
      lookupRate: "Tra tỷ giá",

      endUser: "End-user",
      category: "Loại chi phí",
      currency: "Tiền tệ",
      exchangeRate: "Tỉ giá",
      customs: "Số tờ khai",
      note: "Ghi chú",
    },
    lines: {
      add: "Thêm dòng",
      allocation: "Dự án / PO thương mại",
      project: "Dự án của dòng",
      commercialPo: "Mã PO thương mại ngoài",
      commercialPoNew: "Mã chưa từng dùng. Kiểm tra lại trước khi lưu.",
      categoryFromHeader: "Theo đầu phiếu ({code})",
      lineMode: "Đang phân bổ theo từng dòng; chọn dự án hoặc PO thương mại cho mỗi dòng.",
      allocationRequired: "Mỗi dòng phải chọn đúng một dự án hoặc nhập một mã PO thương mại ngoài.",
      itemCode: "Mã hàng",
      model: "Model",
      serial: "Serial",
      description: "Tên hàng / dịch vụ",
      itemGroup: "Nhóm",
      classification: "Phân loại",
      quantity: "SL",
      unit: "ĐVT",
      unitPrice: "Đơn giá",
      tax: "Thuế %",
      total: "Thành tiền",
      subTotal: "Trước thuế",
      taxAmount: "Thuế",
      groups: { goods: "Hàng hoá", services: "Dịch vụ" },
      removeLine: "Xoá dòng",
    },
    payment: {
      button: "Ghi thanh toán",
      title: "Ghi thanh toán hoá đơn NCC",
      createRequest: "Lập phiếu chi",
      noOutstanding: "Hoá đơn không còn số tiền phải thanh toán.",
      history: "Lịch sử thanh toán",
      none: "Chưa có lần thanh toán nào.",
      date: "Ngày thanh toán",
      amount: "Số tiền",
      reference: "Chứng từ / UNC",
      paymentRequest: "Phiếu chi",
      purpose: "Nội dung",
      candidates:
        "Phiếu chi đã chi cho NCC cùng tiền tệ, chưa gắn hoá đơn (chọn để điền số tiền và ngày):",
      submit: "Ghi",
    },
    void: {
      button: "Huỷ hoá đơn",
      title: "Huỷ hoá đơn NCC",
      reason: "Lý do huỷ",
    },
    payables: {
      title: "Công nợ phải trả",
      line: "Khoản mục",
      invoiced: "Phát sinh trong tháng",
      paid: "Đã thanh toán trong tháng",
      closing: "Còn phải trả cuối tháng",
      aging: "Tuổi nợ tại ngày kết thúc",
      current: "Trong hạn",
      bySupplier: "Theo nhà cung cấp",
      outstanding: "Còn phải trả",
      openInvoices: "Hoá đơn còn nợ",
      overdue: "Quá hạn",
    },
  },
  procurement: {
    salesInvoices: {
      contractTotal: "Tổng tiền hợp đồng",
      contractTotalHint: "Giá trị từ hợp đồng của dự án; có thể lặp lại ở các lần xuất hóa đơn, không cộng vào doanh thu hóa đơn.",
      contractTotalUnavailable: "Không tải được giá trị hợp đồng; cột tổng tiền hợp đồng tạm để trống.",
      title: "Tình hình xuất hoá đơn",
      subtitle: "Hoá đơn bán cho khách hàng: đơn dự án, đơn thương mại hoặc chưa xác định; lần xuất do hệ thống tự cấp.",
      create: "Lập hoá đơn",
      tabInvoices: "Hoá đơn",
      tabReceivables: "Công nợ và thu tiền",
      orderKind: "Loại đơn",
      kindProject: "Đơn dự án",
      kindCommercial: "Đơn thương mại",
      kindUndetermined: "Chưa xác định",
      internalPo: "P/O nội bộ (tuỳ chọn)",
      commercialPoCode: "Mã PO thương mại",
      commercialHelp: "Mã PO này áp cho mọi dòng chưa chọn đích riêng.",
      lineOverrideHelp: "Từng dòng vẫn chọn được dự án hoặc mã PO thương mại riêng; dòng để trống theo đầu hoá đơn.",
      sequenceAuto: "Tự cấp khi lưu",
      customerFromProject: "Khách hàng lấy theo dự án hoặc P/O.",
      numberRequired: "Nhập số hoá đơn và ngày xuất.",
      customerRequired: "Chọn khách hàng.",
      projectRequired: "Chọn dự án hoặc P/O nội bộ cho đơn dự án.",
      commercialRequired: "Nhập mã PO thương mại.",
      linesRequired: "Nhập ít nhất một dòng hàng hợp lệ hoặc số tiền hoá đơn.",
      destination: "Dự án / PO",
      customerName: "Tên khách hàng",
      search: "Tìm số hoá đơn, khách hàng, dự án/PO",
      allStatuses: "Tất cả trạng thái",
      paymentTitle: "Thu tiền hoá đơn",
      amountTitle: "Cập nhật số tiền hoá đơn",
      detailLines: "Dòng hàng",
      stockIssued: "Đã tự xuất kho {count} dòng gắn vật tư.",
      stockSkippedLine: "Dòng {line} chưa xuất kho: {reason}",
    },
    supplierDocument: {
      rfq: "RFQ theo mẫu",
      order: "Đơn đặt hàng NCC",
      supplier: "Nhà cung cấp nhận RFQ",
      contact: "Người nhận",
      template: "Mẫu chứng từ",
      defaultTemplate: "Mẫu mặc định",
      excel: "Tải Excel theo mẫu chứng từ",
      pdf: "Tải PDF theo mẫu chứng từ",
      failed: "Không xuất được chứng từ theo mẫu.",
    },
    poForm: {
      title: "Biểu mẫu PO (sheet PO)",
      quotation: "Báo giá dự án (QT No)",
      noQuotation: "— Không gắn báo giá —",
      quotationsUnavailable: "Không tải được báo giá của dự án (cần quyền xem báo giá).",
      endUser: "Khách cuối (EU)",
      nmiPercent: "NMI %",
      endUserCommissionPercent: "HH End User %",
      endUserTaxPercent: "Thuế %",
      dealerCommissionPercent: "HH đại lý %",
      paymentTerm: "Điều khoản thanh toán",
      warrantyTerm: "Bảo hành",
      help: "Đơn giá PO = ROUND(Giá vào ÷ (1 − NMI%) × (1 + HH End User% × (1 + Thuế%)), −3); HH đại lý chỉ để đối chiếu, không cộng vào đơn giá.",
      export: "Xuất PO (biểu mẫu)",
      template: "Mẫu biểu PO",
      templateAuto: "Theo báo giá",
      exportFailed: "Không xuất được file PO.",
    },
    monthlyStock: {"title": "Tồn kho theo tháng", "load": "Xem tồn kho", "month": "Tháng", "value": "Giá trị tồn kho", "unvalued": "Chưa có giá nhập phù hợp", "invalidFilters": "Chọn khoảng ngày hợp lệ và mã tiền tệ gồm 3 chữ cái.", "valuationHelp": "Chỉ tính giao dịch đã duyệt; giá trị theo giá nhập gần nhất cùng tiền tệ và đơn vị trực thuộc.", "loadFailed": "Không tải được tồn kho. Vui lòng thử lại."},
    sales: {"lines": "Dòng hàng bán", "optionalLines": "Thêm dòng hàng để hệ thống tính tổng tiền và thuế; hóa đơn cũ có thể chỉ nhập tổng tiền.", "previewTotal": "Tổng tiền dự tính", "responsibleName": "Người đảm trách", "affiliation": "Trực thuộc", "poHelp": "Chọn P/O hoặc dự án ở đầu hóa đơn nếu áp dụng chung cho tất cả các dòng.", "openOrders": "Mở danh sách P/O", "linesImmutable": "Dòng hàng đã phát hành không sửa trực tiếp; hãy lập hóa đơn thay thế.", "lineMode": "Đang phân bổ theo từng dòng; mỗi dòng chọn dự án hoặc mã PO thương mại ngoài. Các dự án phải cùng một khách hàng.", "allocationRequired": "Mỗi dòng phải chọn đúng một dự án hoặc nhập một mã PO thương mại ngoài.", "customer": "Khách hàng", "customerRequired": "Chọn khách hàng cho hóa đơn chỉ gồm các mã PO thương mại ngoài.", "customerPermissionRequired": "Cần quyền xem khách hàng để chọn.", "stockMaterial": "Vật tư kho", "internalAsset": "Tài sản", "source": "Nguồn", "stockAvailable": "Tồn khả dụng: {quantity} {unit}"},
    stockSubmitted: "Đã gửi phiếu kho để duyệt.",
    stockType: "Loại phiếu",
    quantity: "Số lượng",
    unit: "Đơn vị",
    inventory: {
      title: "Kiểm kê và xuất kho hàng kinh doanh",
      subtitle:
        "Kho hàng kinh doanh; phiếu kiểm kê và xuất hàng chỉ ghi tồn sau khi được duyệt.",
      operation: "Nghiệp vụ",
      count: "Kiểm kê",
      projectIssue: "Xuất cho dự án",
      material: "Vật tư",
      project: "Dự án",
      counted: "Số lượng thực kiểm",
      date: "Ngày chứng từ",
      unitCost: "Đơn giá vốn",
      fifoCost: "Giá vốn FIFO",
      landed: "Giá mua {purchase} · phí phân bổ {fees} · giá nhập thực tế {actual}",
      fifoCostMissing: "Chưa có giá vốn",
      createDraft: "Lập phiếu kiểm kê/xuất kho nháp",
      reason: "Nội dung / lý do",
    },
    receipts: {
      title: "Nhận hàng theo P/O",
      part: "Dòng hàng",
      ordered: "Đã đặt",
      approved: "Đã nhận được duyệt",
      remaining: "Còn lại",
      reason: "Nội dung nhận hàng",
      materialRequired:
        "Chọn hàng hóa, vật tư linh kiện để lập phiếu nhập kho kinh doanh.",
      createDraft: "Lập phiếu nhập kho kinh doanh nháp",
      draftCreated:
        "Đã lập phiếu nhập kho kinh doanh nháp; gửi duyệt để ghi nhận tồn kho.",
    },
    requests: {
      title: "Yêu cầu lấy báo giá và mua hàng",
      subtitle: "Lập yêu cầu, ghi nhận báo giá và theo dõi phê duyệt theo quy trình",
    },
    orders: {
      title: "Quản lý đơn đặt hàng nhà cung cấp",
      subtitle: "Lập đơn đặt hàng gửi nhà cung cấp từ đề nghị mua đã duyệt, theo dõi duyệt và giao hàng",
    },
    invoices: {
      title: "Tình hình xuất hoá đơn",
      subtitle: "Hoá đơn bán; lần xuất do hệ thống tự cấp theo dự án hoặc PO",
    },
    stock: {
      title: "Nhập, xuất và tồn kho hàng kinh doanh",
      subtitle: "Sổ phát sinh bất biến với số dư do hệ thống tính",
    },
    newRecord: "Bản ghi mới",
    deleteConfirm: "Xoá bản nháp này?",
    reasonPrompt: "Nhập lý do bắt buộc",
    quoteRequired:
      "Cần chọn nhà cung cấp, nhập tổng báo giá lớn hơn 0 và tiền tệ.",
    quotes: {
      title: "Báo giá nhà cung cấp đã ghi",
      selected: "Đang chọn",
      select: "Chọn báo giá này",
    },
    amountRequired: "Cần nhập số tiền, tiền tệ và hạn thanh toán.",
    paymentRequired: "Số tiền thu phải lớn hơn 0.",
    overdue: "Quá hạn thanh toán",
    payment: {
      date: "Ngày thu",
      amount: "Số tiền thu",
      reference: "Tham chiếu (tuỳ chọn)",
    },
    slot: "Lần",
    lines: "Chi tiết",
    freeText: "Nhập tự do",
    receipt: "Nhập kho",
    issue: "Xuất kho",
    stockQuantityRequired: "Số lượng phải lớn hơn 0.",
    stockDateRequired: "Hãy chọn ngày giao dịch.",
    stockReasonRequired: "Hãy nhập lý do nhập hoặc xuất kho.",
    stockSerialAlreadyExists: "Đã tồn tại serial này rồi",
    stockSerialQuantityMustBeOne: "Vật tư có Serial phải có số lượng bằng 1.",
    stockSerialNotAvailable: "Serial này không còn tồn kho.",
    stockSerialNone: "Không theo dõi Serial",
    borrow: "Mượn vật tư",
    currentBalance: "Tồn hiện tại",
    internalMaterials: "Kho tài sản",
    materialEntry: "Nhập hàng vào kho kinh doanh",
    assetEntry: "Nhập hàng vào kho tài sản",

    borrowingList: "Danh sách mượn vật tư",
    borrowSlip: "Phiếu mượn vật tư",
    borrowAsset: "Phiếu mượn tài sản",
    backendPending: "Chức năng này chưa được hỗ trợ.",
    submitForApproval: "Gửi duyệt",
    startBorrowing: "Bắt đầu mượn",
    returnMaterial: "Trả hàng/vật tư về kho kinh doanh",
    receiptRequired:
      "Hãy nhập đủ nhóm hàng, model/mã vật tư, mô tả, đơn vị và số lượng nhập kho kinh doanh.",
    belowSafety: "Dưới mức tồn an toàn",
    safetyStock: "Tồn an toàn",
    stockStatus: "Tình trạng tồn",
    stockAvailable: "Đủ tồn",
    empty: "Chưa có dữ liệu",
    actions: {
      submit: "Gửi",
      quote: "Ghi nhận báo giá",
      adminReceive: "HCNS tiếp nhận",
      accountingReceive: "Kế toán tiếp nhận",
      revise: "Tạo revision",
      deliver: "Xác nhận giao",
      void: "Huỷ hoá đơn",
      reverse: "Đảo giao dịch",
      updateAmount: "Cập nhật số tiền",
      recordPayment: "Ghi nhận thanh toán",
      withdraw: "Rút lại",
      cancelRequest: "Hủy đề nghị",
      cancelOrder: "Hủy đơn đặt hàng",
    },
    decisionReason: "Lý do",
    quoteComparison: {
      title: "So sánh báo giá nhà cung cấp",
      hint: "Chỉ các báo giá của phiên bản đề nghị hiện tại; chênh lệch so với giá thấp nhất cùng tiền tệ.",
      quotedOn: "Ngày ghi",
      file: "Tệp báo giá",
      difference: "Chênh lệch",
      selection: "Đang chọn",
      lowest: "Thấp nhất",
      hasFile: "Có tệp",
      attach: "Đính kèm tệp báo giá",
      mixedCurrency: "Có nhiều tiền tệ: chênh lệch chỉ so trong cùng tiền tệ, không quy đổi.",
      olderRevisions: "{count} báo giá của phiên bản cũ không hiển thị.",
    },
    stockPanel: {
      title: "Phiếu nhập/xuất kho",
      types: {
        receipt: "Phiếu nhập",
        issue: "Phiếu xuất",
        reversal: "Phiếu đảo",
      },
      customs: "Số tờ khai",
      book: "sổ sách",
      workflowStep: "Bước quy trình",
      lines: "Dòng vật tư",
      unit: "Đơn vị",
      amount: "Thành tiền",
    },
    fields: {
      project: "Dự án",
      department: "Bộ phận",
      requestedDate: "Ngày yêu cầu",
      quotationDueDate: "Hạn báo giá",
      deliveryDueDate: "Hạn giao",
      endUser: "Người sử dụng cuối",
      partCode: "Mã vật tư",
      modelCode: "Model",
      description: "Mô tả",
      supplier: "Nhà cung cấp",
      quoteTotal: "Tổng báo giá",
      currency: "Tiền tệ",
      purchaseRequest: "Yêu cầu mua hàng",
      receivedDate: "Ngày tiếp nhận",
      revision: "Revision",
      deliveryDate: "Ngày giao",
      deliveredDate: "Ngày giao thực tế",
      deliveryTerm: "Điều kiện giao",
      moduleCode: "Module",
      issueDate: "Ngày xuất",
      invoiceNumber: "Số hoá đơn",
      amount: "Số tiền hoá đơn",
      dueDate: "Hạn thanh toán",
      paid: "Đã thu",
      outstanding: "Còn phải thu",
      transactionType: "Loại giao dịch",
      material: "Vật tư",
      quantity: "Số lượng",
      unit: "Đơn vị",
      transactionDate: "Ngày giao dịch",
      serial: "Serial",
      reason: "Lý do",
      customs: "Tờ khai hải quan",
      unitCost: "Đơn giá",
      slipCode: "Mã phiếu",
      borrower: "Người mượn",
      borrowDate: "Ngày mượn",
      expectedReturnDate: "Ngày trả dự kiến",
      materialName: "Tên vật tư",
      documentNumber: "Số chứng từ",
      category: "Nhóm vật tư",
      detailDescription: "Mô tả chi tiết",
      receiptQuantity: "Số lượng nhập",
      condition: "Tình trạng",
      note: "Ghi chú",
      location: "Vị trí",
      remark: "Chú thích",
      selectMaterial: "Chọn vật tư",
      newMaterialOption: "— Tạo vật tư mới —",
      modelOrCode: "Model / mã vật tư",
      materialCode: "Mã vật tư",
      internalModelOrCode: "Model / mã vật tư nội bộ",
      availableShort: "Tồn",
    },
    borrowStatuses: { draft: "Nháp", borrowing: "Đang mượn" },
    internalStatuses: { available: "Đang sử dụng", maintenance: "Bảo trì" },
    conditions: { good: "Tốt", used: "Đã sử dụng", damaged: "Hỏng" },
    placeholders: {
      reason: "Đơn hàng PO-2024-001",
      customs: "12345678900",
    },
  },
  payments: {
    payerSettings: { "title": "Cài đặt người chi tiền", "help": "Kế toán chọn những tài khoản được phép chi / thu tiền. Chỉ tài khoản đã cài đặt và còn hoạt động xuất hiện khi chỉ định người xử lý.", "accounts": "Tài khoản được chỉ định", "inactive": "Tài khoản không còn hoạt động — bỏ chọn để lưu", "empty": "Chưa có người chi tiền được cấu hình. Mở Cài đặt người chi tiền để bổ sung trước khi chỉ định." },
    advanceSettings: { title: "Cài đặt tạm ứng", cashLimit: "Hạn mức tạm ứng tiền mặt", bankAccount: "STK công ty", bankAccounts: "Danh mục STK công ty", bankAccountsHint: "Mỗi dòng một số tài khoản, tối đa 50 tài khoản. Giữ nguyên các số 0 đầu tài khoản.", invalid: "Nhập hạn mức không âm và tối đa 50 tài khoản, mỗi tài khoản không quá 50 ký tự." },
    allocations: {
      title: "Phân bổ cho hoá đơn nhà cung cấp",
      allocated: "Đã phân bổ",
      remaining: "Còn lại",
      invoice: "Hoá đơn",
      invoiceDate: "Ngày hoá đơn",
      dueDate: "Hạn trả",
      outstanding: "Còn phải trả",
      amount: "Số phân bổ",
      fill: "Điền tối đa",
      held: "đang giữ thanh toán",
      noCandidates:
        "Không còn hoá đơn mở nào của nhà cung cấp này cùng tiền tệ và dự án.",
      over: "Tổng phân bổ vượt số còn lại của phiếu chi.",
      submit: "Phân bổ {amount}",
    },
    payrollLink: {
      title: "Liên kết bảng lương",
      hint: "Liên kết vào kỳ lương nháp; phát hành lương không tự xác nhận phiếu đã chi.",
      linked: "Đã liên kết",
      year: "Năm",
      period: "Kỳ lương",
      attach: "Thêm vào kỳ lương",
    },
    kinds: {
      Advance: "Giấy đề nghị tạm ứng",
      Payment: "Giấy đề nghị thanh toán",
      AdvanceSettlement: "Giấy thanh toán tạm ứng",
    },
    subtitle: {
      Advance:
        "Biểu mẫu NMI-AC-0001/01 — tạm ứng tiền mặt tối đa 10 triệu/lần, hoàn ứng trong 10 ngày",
      Payment:
        "Biểu mẫu NMI-AC-0001/02 — đính kèm hoá đơn, báo giá từ 3 triệu, hợp đồng từ 5 triệu",
      AdvanceSettlement:
        "Biểu mẫu NMI-AC-0001/04 — đối chiếu số đã tạm ứng với số đã chi",
    },
    sections: { pending: "Đang xử lý", done: "Đã chi / đã đóng" },
    columns: {
      nextApprover: "Chờ duyệt",
      number: "Số phiếu",
      requestDate: "Ngày trình",
      requester: "Người lập",
      project: "Dự án",
      category: "Mã chi phí",
      amount: "Số tiền",
      method: "Hình thức",
      paidDate: "Ngày chi",
      warnings: "Cảnh báo",
    },
    filters: {
      scope: "Phạm vi",
      mine: "Phiếu của tôi",
      all: "Tất cả",
      from: "Từ ngày",
      to: "Đến ngày",
    },
    actions: {
      new: "Lập phiếu",
      retry: "Gửi lại quy trình duyệt",
      disburse: "Chọn hình thức chi",
      editDisbursement: "Sửa hình thức chi",
      confirmPaid: "Xác nhận đã chi",
      closeSettlement: "Đã nhận nộp lại",
      print: "In phiếu",
    },
    dialogs: {
      approve: "Xác nhận duyệt phiếu",
      disburse: "Chọn hình thức chi",
      editDisbursement: "Sửa hình thức chi",
      confirm: "Xác nhận đã chi",
      refund: "Xác nhận nhận tiền nộp lại",
      cancel: "Huỷ phiếu",
      plannedPayDate: "Ngày dự kiến chi",
      lineCategories: "Mã chi phí theo dòng",
      lineCategoriesHint: "Kế toán có thể gắn mã chi phí ở mọi trạng thái duyệt. Kỳ tài chính đã chốt phải được mở lại trước khi sửa.",
      saveCategories: "Lưu mã chi phí",
      categoryMissing: "Chưa gắn mã",
      paidDate: "Ngày chi",
      reference: "Số UNC / tham chiếu",
      receivedDate: "Ngày nhận tiền",
      cancelReason: "Lý do huỷ",
      deleteConfirm: "Xoá bản nháp này?",
    },
    approval: {
      loadFailed: "Không tải được quyền duyệt phiếu. Hãy thử làm mới danh sách.",
      unavailable: "Phiếu không còn ở bước bạn được duyệt. Hãy làm mới danh sách.",
      waitingLabel: "Duyệt tiếp theo",
      waitingFor: "Chờ: {step} — {names}",
      waitingStep: "Chờ: {step}",
      noRecipient: "Chưa có người nhận bước này",
      directManager: "cấp trên trực tiếp",
      lineManager: "cấp trên cấp {level}",
      steps: {
        DepartmentHeadApproval: "Quản lý duyệt",
        ChiefAccountantApproval: "Kế toán duyệt",
        DirectorApproval: "Giám đốc duyệt",
        CeoApproval: "CEO duyệt",
      },
    },
    detail: {
      requester: "Người trình đơn",
      departmentHead: "Trưởng phòng",
      chiefAccountant: "Kế toán trưởng",
      director: "Giám đốc",
      rejected: "Bị trả về",
      requested: "đề nghị",
      workflowFailed: "Chưa gửi được quy trình duyệt",
    },
    form: {
      affiliation: "Trực thuộc",
      keepAffiliation: "Giữ trực thuộc hiện tại",
      noOpenAdvances:
        "Không có tạm ứng đã nhận tiền và chưa hoàn ứng của bạn. Phiếu chưa chi hoặc do người khác đề nghị không thể chọn.",
      advanceLoadFailed:
        "Không tải được tạm ứng đủ điều kiện. Hãy thử lại trước khi lưu.",
      information: "Thông tin đề nghị",
      project: "Mã dự án",
      officeExpense: "Chi phí văn phòng (không gắn dự án)",
      purpose: "Nội dung",
      category: "Mã chi phí",
      payeeType: "Đối tượng nhận",
      payeeName: "Tên người/đơn vị nhận",
      requestDate: "Ngày trình đơn",
      requestedMethod: "Hình thức đề nghị",
      taskEndDate: "Ngày kết thúc nhiệm vụ",
      contractValue: "Giá trị hợp đồng",
      settlesAdvance: "Tạm ứng cần thanh toán",
      selectAdvance: "Chọn phiếu tạm ứng đã nhận tiền",
      directorOverrideNote: "Ghi chú Giám đốc (trường hợp đặc biệt)",
      assignedPayer: "Người chi / thu tiền được chỉ định",
      evidence: "Ảnh / tệp chứng từ",
      saveBeforeEvidence: "Chọn loại và tệp chứng từ trước khi tạo phiếu. Hệ thống sẽ lưu phiếu và tải tệp trong cùng thao tác.",
      evidenceType: "Loại hồ sơ đính kèm",
      evidenceFile: "Tệp đính kèm",
      evidenceRequired: "Chọn ít nhất một báo giá, hợp đồng, chứng từ hoặc hóa đơn để tạo phiếu.",
      evidenceDraftSaved: "Phiếu nháp đã lưu. Hãy tải lại tệp để hoàn tất tạo phiếu.",
      evidenceUploadFailed: "Không tải được chứng từ. Phiếu nháp đã được giữ để thử lại.",
      evidenceFileInvalid: "Chọn tệp PDF, Office, ảnh, TXT, CSV hoặc ZIP không rỗng, tối đa 25 MB.",
      evidenceFiles: "Tệp đã chọn (chọn loại cho từng tệp)",
      evidenceRemove: "Bỏ tệp",
      evidenceFailed: "Tệp chưa tải lên được",
      evidenceRetry: "Thử lại",
      categoryOptionalHint: "Có thể để trống mã chi phí; kế toán sẽ gắn mã theo từng dòng khi chi.",
      advanceCategoryHint: "Mã chi phí trên tạm ứng là tùy chọn và chưa ghi nhận chi phí. Chi phí được ghi nhận khi hoàn tất thanh toán tạm ứng.",
      bankAccount: "Số tài khoản ngân hàng của công ty",
      bankAccountHint: "Nhập hoặc chọn tài khoản chuyển/nhận tiền. Giao dịch được ghi vào Sao kê ngân hàng sau khi xác nhận thực chi/thu.",
      evidencePermissionRequired: "Tài khoản cần quyền tải chứng từ để tạo phiếu.",
      attachmentsDeclared: "Hồ sơ kèm theo",
      quoteProvided: "Đã kèm báo giá",
      contractProvided: "Đã kèm hợp đồng",
      lines: "Nội dung chi",
      lineDescription: "Nội dung",
      documentKind: "Chứng từ kèm theo",
      documentNumber: "Số hoá đơn / tờ khai",
      documentDate: "Ngày chứng từ",
      amount: "Số tiền",
      addLine: "Thêm dòng",
      removeLine: "Xoá dòng",
      total: "Tổng",
      advanceAmount: "I. Số tiền tạm ứng",
      spentAmount: "II. Số tiền đã chi",
      difference: "III. Chênh lệch",
      refundDue: "(nộp lại tiền tạm ứng)",
      extraDue: "(công ty chi thêm)",
      amountToPay: "Số tiền quỹ chi",
      requester: "Họ và tên",
      employeeCode: "MSNV",
      department: "Phòng ban",
      requesterHint:
        "MSNV, họ tên và phòng ban được lấy từ hồ sơ nhân viên của bạn khi lưu.",
    },
    methods: {
      Cash: "Tiền mặt",
      Transfer: "Chuyển khoản",
      Payroll: "Chi qua lương",
    },
    payees: { Employee: "Nhân viên", Supplier: "Nhà cung cấp" },
    documentKinds: {
      NoInvoice: "Không hoá đơn",
      Invoice: "Hoá đơn",
      Declaration: "Tờ khai",
      Other: "Chứng từ khác",
    },
    evidenceCategories: {
      Quotation: "Báo giá",
      Contract: "Hợp đồng",
      PaymentProof: "Chứng từ",
      Invoice: "Hóa đơn",
    },
    compliance: {
      advance_unsettled:
        "Tạm ứng đã chi chưa được hoàn ứng. Hãy lập giấy thanh toán tạm ứng.",
      title: "Kiểm tra theo NMI-AC-0001",
      clean: "Không có cảnh báo.",
      cash_advance_limit_exceeded:
        "Tạm ứng tiền mặt vượt 10.000.000 đ/lần — cần ghi chú của Giám đốc (§IV.1a).",
      cash_advance_limit_overridden:
        "Tạm ứng tiền mặt vượt 10.000.000 đ, đã có ghi chú Giám đốc.",
      open_advance_exists:
        "Còn tạm ứng chưa hoàn ứng — phải thanh toán hết mới được ứng tiếp.",
      open_advance_overridden:
        "Còn tạm ứng chưa hoàn ứng, đã có ghi chú Giám đốc.",
      transfer_advance_exceeds_contract_share:
        "Tạm ứng chuyển khoản vượt 30% giá trị hợp đồng.",
      invoice_required:
        "Có dòng từ 200.000 đ không kèm hoá đơn tài chính (§III.3).",
      quote_required: "Từ 3.000.000 đ phải có báo giá của nhà cung cấp.",
      contract_required: "Từ 5.000.000 đ phải có hợp đồng cung cấp.",
      settlement_overdue:
        "Hoàn ứng sau hơn 10 ngày kể từ khi kết thúc nhiệm vụ.",
      cash_limit_exceeded:
        "Chi tiền mặt vượt ngưỡng của nhóm chi (mua sắm < 3 triệu, tiếp khách < 5 triệu).",
    },
    print: {
      print: "In",
      requester: "Người trình đơn",
      departmentHead: "Trưởng phòng PD",
      chiefAccountant: "Kế toán trưởng",
      director: "Giám đốc",
      project: "Mã dự án:",
      employeeCode: "MSNV:",
      fullName: "Họ và tên:",
      department: "Phòng ban trực thuộc:",
      requestDate: "Ngày trình đơn:",
      content: {
        Advance: "Nội dung tạm ứng",
        Payment: "Nội dung thanh toán",
        AdvanceSettlement: "Nội dung thanh toán tạm ứng",
      },
      documents: "Chứng từ kèm theo",
      amount: "Số tiền",
      total: "Tổng:",
      noInvoice: "Không hóa đơn",
      advanceSection: "Số tiền tạm ứng",
      spentSection: "Số tiền đã chi",
      differenceSection: "Chênh lệch",
      attachments: "(Kèm theo: hóa đơn, chứng từ thanh toán)",
      issuedOn: "Ngày ban hành",
    },
    cashBook: {
      unverified: "Chưa xác nhận số dư đầu kỳ",
      negativeReason: "Lý do tiếp tục khi âm quỹ",
      openingCertificate: {
        title: "Xác nhận số dư đầu kỳ",
        hint: "Số dư áp dụng trước mọi giao dịch trong ngày đã chọn. Mỗi lần xác nhận được lưu thêm cùng căn cứ, không ghi đè lịch sử.",
        evidence: "Căn cứ xác nhận số dư",
      },
      invalidRange:
        "Chọn đầy đủ ngày bắt đầu và kết thúc, ngày kết thúc không được trước ngày bắt đầu.",
      title: "Sổ quỹ",
      subtitle: "Theo dõi thu, chi theo quỹ; điều chỉnh bằng bút toán đảo.",
      tabs: {
        ledger: "Sổ quỹ",
        office: "Chi phí quản lý văn phòng",
        cash: "CP tiền mặt",
        flow: "Dòng tiền",
      },
      fund: { CashBox: "Quỹ tiền mặt", Bank: "Ngân hàng" },
      filters: { fund: "Quỹ" },
      columns: {
        month: "Tháng",
        description: "Nội dung",
        receipt: "Thu",
        disbursement: "Chi",
        date: "Ngày",
        project: "Dự án",
        document: "Chứng từ",
        category: "Mã chi phí",
        payee: "Người nhận",
        unit: "Trực thuộc",
        balance: "Số dư",
      },
      opening: "Số dư đầu kỳ",
      closing: "Số dư cuối kỳ",
      record: "Ghi thu / chi",
      side: "Loại bút toán",
      reverse: "Đảo bút toán",
      reverseReason: "Lý do đảo",
      reversed: "Đã đảo",
      reversal: "Bút toán đảo",
      total: "Tổng",
      office: {
        title: "Chi phí quản lý văn phòng",
        subtitle:
          "Chi phí theo nhóm và tháng tài chính, chỉ khoản chi không gắn dự án",
        line: "Nội dung chi tiết",
      },
      cash: {
        title: "CP tiền mặt",
        subtitle: "Chi từ quỹ tiền mặt theo mã chi phí (gồm cả khoản dự án)",
      },
      flow: {
        title: "Báo cáo dòng tiền",
        subtitle: "Thu, chi và số dư luỹ kế theo tháng của một quỹ",
        net: "Ròng",
      },
    },
    categories: {
      title: "Danh mục mã chi phí",
      subtitle:
        "Mã chi phí của sổ quỹ ánh xạ tới báo cáo văn phòng (dòng 1–20) và bảng tài chính dự án",
      new: "Thêm mã",
      group: "Nhóm báo cáo",
      groups: {
        OfficeExpense: "Chi phí văn phòng",
        ProjectCogs: "Giá vốn dự án",
        ProjectIncidental: "Chi phí phát sinh dự án",
        Personnel: "Chi cho con người",
        Financial: "Thu chi tài chính, thuế",
        Equity: "Vốn góp",
        Deferred: "Chờ phân bổ (trả trước, CCDC)",
      },
      officeLine: "Dòng báo cáo VP",
      sheetLine: "Dòng bảng tài chính dự án",
      sheetLines: {
        NhaCungCap: "Nhà cung cấp",
        PhiMoToKhai: "Phí mở tờ khai",
        PhiThongQuan: "Phí thông quan",
        LePhiToKhai: "Lệ phí tờ khai",
        PhiLamHang: "Phí làm hàng",
        ThueNK: "Thuế NK",
        ThueGTGT: "Thuế GTGT",
        CuocCPN: "Cước CPN",
        PhiBaoHiem: "Phí bảo hiểm",
        PhiVanChuyen: "Phí vận chuyển",
        PhiNganHang: "Phí ngân hàng",
        LuongNhanSu: "Lương nhân sự",
        TangCa: "Tăng ca",
        PhuCapXang: "Phụ cấp tiền xăng",
        PhuCapXe: "Phụ cấp tiền xe",
        PhuCapKhachSan: "Phụ cấp khách sạn",
        PhuCapAn: "Phụ cấp tiền ăn",
        PhuCapCongTac: "Phụ cấp công tác",
        Ship: "Chi phí vận chuyển, gửi thư",
        TiepKhach: "Chi phí tiếp khách",
          TiepKhachDuAn: "Tiếp khách dự án",
        MuaHang: "Mua hàng",
      },
      sortOrder: "Thứ tự",
      active: "Đang dùng",
      inactive: "Đã tắt",
      deactivate: "Tắt",
      activate: "Bật lại",
    },
  },
  projectFinance: {
    profitWarningsTitle: "Dự án giảm lợi nhuận",
    profitWarningsUnavailable: "Chưa đủ dữ liệu hoặc quyền nguồn để so sánh lợi nhuận của tất cả dự án.",
    profitWarningsEmpty: "Không có dự án cần cảnh báo giảm lợi nhuận.",
    profitDecline: "Mức giảm",
    warningYellow: "Vàng",
    warningRed: "Đỏ",

    profitChartUnavailable: {
      limitedAccess: "Không hiển thị biểu đồ vì bạn chưa có đủ quyền xem các nguồn tài chính.",
      noPlan: "Không hiển thị biểu đồ vì chưa có lợi nhuận kế hoạch.",
      incomplete: "Chưa đủ dữ liệu có ngày để vẽ biểu đồ khớp với BCTC.",
    },
    entertainment: "Tiếp khách",
    profitWarningYellow: "Cảnh báo vàng: lợi nhuận thực tế giảm {decline} so với kế hoạch.",
    profitWarningRed: "Cảnh báo đỏ: lợi nhuận thực tế giảm {decline} so với kế hoạch.",
    profitChartTitle: "Lợi nhuận và chi phí lũy kế theo tháng",
    profitChartPlanned: "Lợi nhuận kế hoạch",
    profitChartCosts: "Chi phí",
    profitChartActual: "Lợi nhuận thực tế",
    profitChartMonth: "Tháng",

    projectEntertainment: "Tiếp khách dự án",
    contractRevenueUnavailable: "Chưa có giá trị hợp đồng phù hợp hoặc chưa có quyền xem. Doanh thu kế hoạch chưa xác định.",
    contractPlanSource: "Doanh thu kế hoạch lấy từ hợp đồng đang hiệu lực hoặc đã hoàn thành, cùng loại tiền. Kế hoạch chi phí giữ theo báo giá được chấp nhận.",
    stock: {
      row: "Hàng xuất kho (giá FIFO)",
      issue: "{material} × {quantity}: xuất cho dự án",
      transferOut: "{material} × {quantity}: hàng của dự án đã xuất cho {project}",
      outsideStatement: "ngoài BCTC (tồn đầu hoặc nhập tay không có hoá đơn NCC)",
      missing: "{count} phần xuất kho cho dự án chưa có giá vốn (lớp nhập thiếu đơn giá hoặc phiếu xuất trước khi có FIFO) nên chưa tính tiền.",
      outsideHint: "{count} phần xuất kho lấy từ tồn đầu hoặc nhập tay không có hoá đơn NCC: có trong bảng này nhưng không có trên BCTC.",
      unavailable: "Không tải được giá vốn hàng xuất kho của dự án; dòng Hàng xuất kho chưa có số.",
    },
    labor: {
      unavailable: "Không tải được OT/công tác theo dự án từ bảng lương; dòng Tăng ca và Phụ cấp công tác chỉ gồm phiếu chi.",
      noAccess: "Cần quyền xem bảng lương để hiện OT/công tác theo dự án và bảng quy tắc tính.",
      missing: "{count} khoản OT chưa có đơn giá giờ (nhân viên chưa có hồ sơ lương) nên chưa tính tiền.",
      missingRate: "thiếu đơn giá giờ",
      rulesTitle: "Quy tắc tính tiền OT và công tác (theo chính sách lương hiệu lực)",
      formulaOvertime: "Tiền OT = số giờ × hệ số (ngày thường/nghỉ/lễ, ngày/đêm; đêm là trước 06:00 hoặc từ 22:00) × đơn giá giờ; đơn giá giờ = (lương cơ bản + phụ cấp chức vụ + phụ cấp kỹ năng) / (ngày công chuẩn × giờ mỗi ngày).",
      formulaTrip: "Công tác/ONS trong ngày: từ 100 km cần ít nhất 4 giờ, dưới 100 km cần ít nhất 6 giờ để tính một ngày phụ cấp. Phiếu cũ chưa có khoảng cách tính theo số phút và có cảnh báo. Qua đêm = số đêm × đơn giá đêm. Chỉ tính phiếu đã duyệt gắn dự án này.",
      sourceTypes: {
        Overtime: "Tăng ca",
        BusinessTrip: "Công tác",
        Onsite: "ONS",
      },
      detail: {
        Overtime: "{employee} · {type}: {quantity} giờ × {multiplier} × {rate}/giờ",
        TripDay: "{employee} · {type} trong ngày: {quantity} ngày × {rate}",
        TripNight: "{employee} · {type} qua đêm: {quantity} đêm × {rate}",
      },
      rules: {
        month: "Tháng",
        source: "Nguồn chính sách",
        period: "Kỳ lương lần {revision} ({status})",
        default: "Mặc định (chưa lập kỳ lương)",
        weekday: "Hệ số ngày thường (ngày/đêm)",
        restDay: "Hệ số ngày nghỉ (ngày/đêm)",
        holiday: "Hệ số ngày lễ (ngày/đêm)",
        tripDay: "Công tác trong ngày",
        tripNight: "Công tác qua đêm",
        hoursPerDay: "Giờ mỗi ngày",
        minimumOvertime: "OT tối thiểu (phút)",
        onsite: "Tính ONS",
        onsiteIncluded: "Có",
        onsiteExcluded: "Không",
      },
    },
    supplierCommitments:
      "Giá trị P/O chưa có hóa đơn: {amount}. Chưa tính vào giá vốn thực tế.",
    profitComparisonUnavailable:
      "Chưa thể so sánh tỷ lệ lợi nhuận vì kế hoạch không dương hoặc thiếu dữ liệu.",
    loadFailed:
      "Không tải đủ dữ liệu tài chính. Vui lòng thử tải lại trước khi đối chiếu hoặc xuất báo cáo.",
    limitedAccess: "Báo cáo chỉ gồm các nguồn dữ liệu bạn được phép xem.",
    title: "Bảng quản lý tài chính dự án",
    subtitle:
      "Đối chiếu kế hoạch từ báo giá, công dự kiến với chi phí và doanh thu thực tế.",
    pickProject: "Chọn dự án",
    head: {
      code: "Mã số dự án",
      customer: "Khách hàng",
      content: "Nội dung dự án",
      leader: "Trưởng dự án",
      totalDays: "Tổng số ngày thực hiện",
      remainingDays: "Tổng số ngày còn lại",
      staff: "Nhân sự (manday)",
      costHidden: " · không có quyền xem đơn giá",
    },
    milestones: {
      Receipt: "Ngày tiếp nhận",
      Survey: "Ngày khảo sát",
      SolutionProposal: "Ngày đề xuất giải pháp",
      Demo: "Ngày Demo",
      Quotation: "Ngày báo giá",
      PurchaseOrder: "Ngày nhận P/O",
      GoLive: "Ngày đưa vào sử dụng",
    },
    collection: { title: "Tiến độ thu tiền" },
    columns: {
      percent: "%",
      item: "Tên công đoạn",
      planned: "Kế hoạch",
      actual: "Thực tế",
      paid: "Đã thanh toán",
      unpaid: "Chưa thanh toán",
      variance: "Chênh lệch KH − TT",
      verdict: "Đánh giá",
    },
    revenue: "Doanh thu",
    cogs: "Giá vốn",
    incidental: "Chi phí phát sinh",
    profit: "Lợi nhuận",
    verdict: { Saving: "Tiết kiệm", Over: "Vượt", Neutral: "—" },
    tabs: {
      sheet: "Bảng tài chính",
      plan: "Kế hoạch (báo giá)",
    },
    plan: {
      title: "Kế hoạch từ báo giá được chấp nhận",
      none: "Dự án chưa có báo giá được khách chấp nhận nên chưa có số kế hoạch.",
      noAccess: "Cần quyền xem báo giá để hiện số kế hoạch.",
      costHidden: "Bạn không có quyền xem giá vốn báo giá: giá vốn, hoa hồng, phí và lãi kế hoạch bị ẩn, không so sánh được lợi nhuận.",
      source: "Báo giá {number} lần {revision} · cách tính {model} · biểu mẫu {template} · trực thuộc {affiliation} · ngày chấp nhận {date}",
      projectMonth: "Tháng dự án: {month} ({basis})",
      bases: {
        Contract: "theo ngày PO sớm nhất",
        ProjectCreated: "theo ngày tạo dự án",
      },
      lines: {
        revenue: "Doanh thu kế hoạch (trước VAT, sau chiết khấu)",
        cost: "Giá vốn kế hoạch (chi phí mua × SL)",
        endUserCommission: "Hoa hồng End User",
        endUserTax: "Thuế End User",
        inPriceVat: "VAT trong giá",
        contingency: "Phí phát sinh",
        grossProfit: "Lãi gộp kế hoạch",
        corporateTax: "Thuế TNDN",
        netProfit: "Lãi ròng kế hoạch",
      },
      summary: {
        title: "SUMMARY — tổng theo nhóm của báo giá",
        group: "Nhóm",
        subtotal: "Thành tiền",
        share: "Tỷ trọng",
      },
    },
    profitVerdict: { Profit: "Lãi", Loss: "Lỗ", Neutral: "—" },
    otherCurrencies:
      "Có khoản bằng tiền tệ khác ({currencies}) không được quy đổi và không hiện trên bảng này.",
    sources:
      "Kế hoạch: báo giá revision mới nhất (giá bán, giá vốn) và chi phí manday; Thực tế: P/O, hoá đơn đầu ra đã thu (ADR-025), phiếu chi đã duyệt theo mã chi phí (ADR-027). Dấu * = ngày kế hoạch, chưa có ngày thực tế.",
  },
  accounting: {
    overview: "Tổng quan Kế toán",
    paymentVouchers: "Phiếu thanh toán",
    paymentSteps: {
      Submitted: "Chờ duyệt",
      Approved: "Chờ chi",
      Disbursing: "Đang chi",
    },
    receivables: "Công nợ phải thu",
    payables: "Công nợ phải trả",
    outstanding: "Còn phải thu/trả",
    overdue: "Quá hạn",
    current: "Trong hạn",
    noData: "Chưa có dữ liệu.",
  },
  hr: {
    overview: "Tổng quan Nhân sự",
    myRequests: "Đơn của tôi (năm nay)",
    ledgerPending: "Sổ nghỉ & tăng ca",
    pendingRequests: "Đơn chờ xử lý",
    shortcuts: "Lối tắt",
  },
  crm: {
    overview: "Tổng quan CRM",
    activeCustomers: "Đang giao dịch",
    inactiveCustomers: "Ngừng giao dịch",
    allCustomers: "Tất cả",
    myFollowUps: "Việc chăm sóc của tôi",
    openFollowUps: "Đang mở",
  },
  purchasing: {
    overview: "Tổng quan Mua hàng",
    openList: "Mở danh sách",
    openStock: "Mở tồn kho vật tư",
    pending: "Chứng từ đang chờ xử lý",
    nothingPending: "Không có chứng từ đang chờ.",
    queues: {
      label: "Hàng chờ theo trạng thái",
      all: "Tất cả",
      draft: "Nháp",
      inProgress: "Đang xử lý",
      awaitingApproval: "Chờ duyệt",
      approved: "Đã duyệt",
      received: "Đã tiếp nhận",
      delivered: "Đã giao",
      closed: "Đã đóng",
      rejected: "Bị từ chối",
      cancelled: "Đã hủy",
    },
  },
  help: {
    title: "Trung tâm hướng dẫn",
    search: "Tìm hướng dẫn…",
    empty: "Không có chủ đề phù hợp.",
    noTopic: "Màn bạn vừa mở chưa có chủ đề riêng; chọn chủ đề gần nhất bên dưới.",
    steps: "Các bước",
    tips: "Lưu ý",
    openScreen: "Mở màn hình",
    groupStart: "Bắt đầu",
    shortcut: "Hướng dẫn (F1)",
    groupProcesses: "Quy trình xuyên phân hệ",
    groupRoles: "Theo vai trò",
    filterRole: "Lọc theo vai trò",
    allRoles: "Mọi vai trò",
    print: "In / Xuất PDF",
    onThisPage: "Trong trang này",
    quickStart: "Bắt đầu nhanh",
    detailPending: "Hướng dẫn chi tiết (quy trình, sơ đồ, use case) của nhóm này đang được biên soạn; tạm thời dùng phần Bắt đầu nhanh ở trên.",
    sections: { purpose: "Mục đích và ai dùng", prerequisites: "Điều kiện trước", anatomy: "Các vùng trên màn hình", tasks: "Hướng dẫn từng việc", statuses: "Trạng thái", flows: "Sơ đồ quy trình", useCases: "Use case", troubleshooting: "Lỗi thường gặp và mẹo" },
    when: "Khi nào dùng",
    roles: "Vai trò",
    permissions: "Quyền cần có",
    permission: "Mã quyền",
    meaning: "Ý nghĩa",
    result: "Kết quả",
    check: "Kiểm tra",
    status: "Trạng thái",
    by: "Ai chuyển",
    next: "Chuyển sang",
    notApplicable: "Không áp dụng",
    legend: { normal: "bước tiếp theo", reject: "từ chối / không hợp lệ", return: "trả lại / làm lại" },
    actor: "Tác nhân",
    goal: "Mục tiêu",
    preconditions: "Tiền điều kiện",
    mainFlow: "Luồng chính",
    alternatives: "Luồng thay thế / lỗi",
    outcome: "Kết quả",
    problem: "Vấn đề",
    message: "Thông báo hệ thống",
    fix: "Cách xử lý",
    related: "Chủ đề liên quan",
  },
  legal: {
    privacy: "Chính sách quyền riêng tư",
    terms: "Điều khoản sử dụng",
    links: "Chính sách và điều khoản",
    language: "Ngôn ngữ",
    contents: "Nội dung",
    effectiveDate: "Có hiệu lực từ {date}",
    backToLogin: "Về trang đăng nhập",
  },
  login: {
    title: "Đăng nhập hệ thống",
    subtitle: "Một luồng dữ liệu xuyên suốt từ cơ hội đến bàn giao.",
    email: "Email",
    password: "Mật khẩu",
    action: "Đăng nhập",
    invalid: "Thông tin đăng nhập không hợp lệ",
    unavailable:
      "Không thể kết nối tới máy chủ. Vui lòng kiểm tra dịch vụ và thử lại.",
    failed: "Không thể hoàn tất đăng nhập. Vui lòng thử lại.",
    mustChangePassword:
      "Bạn đang dùng mật khẩu tạm do quản trị cấp. Hãy đặt mật khẩu mới trước khi dùng hệ thống.",
    devQuickLogin: "Đăng nhập nhanh theo vai trò (DEV)",
    devQuickLoginPlaceholder: "Chọn tài khoản theo vai trò…",
    devQuickLoginHint: "Chỉ có ở môi trường phát triển: tài khoản tạo sẵn (deploy/dev/config.js), không bao giờ có ở môi trường chính thức.",
    platformAction: "Đăng nhập bằng Q One",
    platformDivider: "hoặc",
    platformContinuing: "Đang đăng nhập bằng Q One…",
    platformNotLinked: "Tài khoản Q One này chưa có tài khoản CRM cùng email (hoặc tài khoản CRM đã ngừng hoạt động). Liên hệ quản trị CRM.",
    platformFailed: "Không đăng nhập được bằng Q One. Thử lại hoặc đăng nhập bằng mật khẩu.",
    backToLogin: "Quay lại trang đăng nhập",
  },
  sso: {
    title: "Đăng nhập một lần",
    continuing: "Đang chuyển bạn sang hệ thống dùng chung đăng nhập…",
    failed: "Không thiết lập được phiên đăng nhập dùng chung. Thử lại hoặc liên hệ quản trị hệ thống.",
    invalidReturn: "Đường dẫn quay lại không hợp lệ.",
    retry: "Thử lại",
    home: "Về trang chủ CRM",
  },
  dashboardPeriod: {
    reports: "SUMMARY 4 · Báo cáo",
    requests: "Đơn từ vận hành",
    teamHub: "Chấm công chờ duyệt",
    users: "Danh bạ người dùng",
    stock: "Kho vật tư",
    invoices: "Hoá đơn",
    customers: "Khách hàng",
    from: "Từ ngày",
    to: "Đến ngày",
    generated: "Cập nhật {at}",
    loadingRows: "Đang tải {loaded}/{total} dự án",
    registration: "Tổng hợp đăng ký",
    charts: "SUMMARY 1 · Chỉ số dự án",
    delivery: "SUMMARY 1 · Tiến độ",
    resources: "SUMMARY 2 · Nguồn lực",
    issues: "SUMMARY 3 · Vấn đề",
    approvals: "Phê duyệt",
    capacity: "Năng lực",
    approvalHistory: "Chu kỳ duyệt (lịch sử)",
    purchaseRequests: "Yêu cầu mua",
    purchaseOrders: "Đơn mua",
    costs: "Chi phí & biên",
    curve: "S-curve",
    milestones: "Cột mốc",
    stale: "Mất tín hiệu",
    workload: "Tải việc theo người",
    documents: "Tài liệu dự án",
    quality: "Chất lượng bàn giao",
    qualityIssues: "Sự cố sau go-live",
    receivables: "Công nợ",
    surveys: "Khảo sát hài lòng",
    followUps: "Hẹn chăm sóc của tôi",
    paymentQueues: "Phiếu chi theo bước",
    payables: "Công nợ phải trả",
    myRequests: "Đơn từ của tôi",
  },
  dashboard: {
    viewMode: "Cách hiển thị",
    viewChart: "Biểu đồ",
    viewTable: "Bảng",
    tableLabel: "Hạng mục",
    presetLabel: "Kỳ nhanh",
    viewsLabel: "Góc nhìn Dashboard",
    views: {
      crm: "CRM",
      overview: "Tổng quan",
      projects: "Dự án",
      finance: "Tài chính",
      resources: "Nguồn lực",
      procurement: "Mua sắm",
      quality: "Chất lượng & vấn đề",
      people: "Nhân sự & phê duyệt",
      untitled: "Góc nhìn mới",
    },
    widgetGroups: {
      overview: "Tổng quan",
      projects: "Dự án",
      finance: "Tài chính",
      resources: "Nguồn lực",
      procurement: "Mua sắm & kho",
      quality: "Chất lượng",
      people: "Nhân sự & phê duyệt",
    },
    widget: {
      noTiles: "Chưa chọn thẻ nào — bấm Tùy chỉnh rồi biểu tượng bánh răng để chọn.",
      retry: "Thử lại",
      partial: "{count} nguồn dữ liệu chưa tải được.",
    },
    edit: {
      customize: "Tùy chỉnh",
      done: "Xong",
      addWidget: "Thêm widget",
      searchWidgets: "Tìm widget",
      viewFull: "Góc nhìn đã đủ 40 widget.",
      added: "Đã có",
      add: "Thêm",
      settingsTitle: "Thiết lập: {name}",
      limitDefault: "Theo Dashboard ({count})",
      detail: "Mức chi tiết",
      detailCompact: "Gọn — biểu đồ chính",
      detailFull: "Đầy đủ — mọi biểu đồ phân tích",
      comparePrevious: "So sánh với kỳ trước (mũi tên tăng/giảm trên thẻ)",
      tiles: "Thẻ hiển thị ({count}/{max})",
      keys: "mũi tên để đổi chỗ, Shift + mũi tên trái/phải để đổi độ rộng, Delete để bỏ",
      move: "Kéo để đổi chỗ",
      moveBefore: "Đưa lên trước",
      moveAfter: "Đưa ra sau",
      narrower: "Hẹp hơn",
      wider: "Rộng hơn",
      width: "Rộng {width}/12 cột",
      configure: "Thiết lập",
      remove: "Bỏ widget",
      hint: "Kéo tay nắm để đổi chỗ, −/+ để đổi độ rộng; thay đổi tự lưu theo tài khoản.",
      emptyView: "Góc nhìn này chưa có widget.",
      saving: "Đang lưu bố cục…",
      saveFailed: "Chưa lưu được bố cục — thử lại sau.",
    },
    manage: {
      open: "Góc nhìn",
      title: "Quản lý góc nhìn",
      hint: "Đổi tên, sắp xếp, ẩn hoặc thêm góc nhìn riêng; mỗi góc nhìn là một bộ widget.",
      rename: "Đổi tên {name}",
      widgetCount: "{count} widget",
      up: "Lên",
      down: "Xuống",
      show: "Hiện",
      hide: "Ẩn",
      delete: "Xóa {name}",
      newName: "Tên góc nhìn mới",
      copyCurrent: "Chép widget của góc nhìn đang mở",
      add: "Thêm góc nhìn",
      template: "Mẫu bố cục",
      roleDefault: "theo vai trò",
      reset: "Khôi phục mẫu",
      resetConfirm: "Bỏ mọi tùy chỉnh và dùng mẫu đã chọn?",
    },
    templates: {
      executive: "Điều hành",
      project: "Quản lý dự án",
      sales: "Kinh doanh",
      accounting: "Kế toán",
      purchasing: "Mua hàng & kho",
      hr: "Nhân sự",
    },
    widgets: {
      kpi: {
        title: "Chỉ số chính",
        description: "Các thẻ KPI tự chọn; bấm thẻ để mở danh sách liên quan.",
      },
      attention: {
        title: "Cần chú ý",
        description: "Cảnh báo, dự án cần xử lý, Go-live 30 ngày tới và dự án mất tín hiệu.",
      },
      portfolio: {
        title: "Danh mục dự án",
        description: "Trạng thái, sức khỏe tiến độ, vòng đời và thời gian còn lại của dự án.",
      },
      pipeline: {
        title: "Phễu dự án",
        description: "Phễu giai đoạn, loại, mức ưu tiên và Leader phụ trách.",
      },
      progress: {
        title: "Tiến độ & cột mốc",
        description: "S-curve so với kế hoạch và cột mốc trễ.",
      },
      attachments: {
        title: "Tài liệu dự án",
        description: "Tệp theo loại, tệp chờ quét và dự án thiếu tài liệu bắt buộc.",
      },
      finance: {
        title: "Chi phí & biên lợi nhuận",
        description: "Chi phí kế hoạch/thực tế và biên lợi nhuận dự kiến theo dự án.",
      },
      receivables: {
        title: "Công nợ phải thu",
        description: "Đã thu, còn phải thu và quá hạn theo tiền tệ và khách hàng.",
      },
      resources: {
        title: "Nguồn lực & năng lực",
        description: "Manday kế hoạch/thực tế theo dự án và năng lực chấm công.",
      },
      workload: {
        title: "Tải việc theo người",
        description: "Bản đồ nhiệt quá tải, rảnh việc và trùng lịch giữa dự án.",
      },
      procurement: {
        title: "Mua sắm & kho",
        description: "Yêu cầu mua, đơn mua, giao dịch kho và hóa đơn trong kỳ.",
      },
      issues: {
        title: "Vấn đề & sự cố",
        description: "Vấn đề còn hiệu lực theo trạng thái, mức độ và dự án.",
      },
      quality: {
        title: "Chất lượng bàn giao",
        description: "Bàn giao đúng hạn, nghiệm thu và sự cố khách hàng sau Go-live.",
      },
      satisfaction: {
        title: "Hài lòng khách hàng",
        description: "Điểm khảo sát, NPS và độ phủ khảo sát.",
      },
      approvals: {
        title: "Phê duyệt",
        description: "Việc chờ duyệt theo tuổi, loại chứng từ và chu kỳ duyệt.",
      },
      progressOverview: {
        title: "Tổng quan tiến độ",
        description: "Gantt 3 năm của các dự án đang vận hành: kế hoạch từ ngày nhận PO đến ngày kết thúc, thực tế, PO, yêu cầu mở/trễ, việc trễ.",
      },
      governance: {
        title: "Báo cáo & đơn từ",
        description: "Báo cáo chờ duyệt và đơn từ theo loại, trạng thái.",
      },
      payables: {
        title: "Công nợ phải trả",
        description: "Phải trả nhà cung cấp từ đầu năm: tổng, tuổi nợ và nhà cung cấp nợ nhiều nhất.",
      },
    },
    presets: {
      thisMonth: "Tháng này",
      thisQuarter: "Quý này",
      thisYear: "Năm nay",
      last30: "30 ngày qua",
      custom: "Tuỳ chọn",
    },
    lastUpdated: "Cập nhật {at}",
    sourcesOk: "{count} nguồn sẵn sàng",
    sourcesError: "{count} nguồn lỗi",
    kpiTitle: "Chỉ số điều hành",
    kpiGroups: {
      crm: "Khách hàng & chăm sóc",
      projects: "Dự án",
      mandays: "Manday",
      finance: "Tài chính",
      issues: "Vấn đề",
      approvals: "Phê duyệt & báo cáo",
      procurement: "Mua sắm",
      documents: "Tài liệu",
      quality: "Chất lượng & hài lòng",
      people: "Nhân lực & khách hàng",
    },
    kpi: {
      total: "Tổng dự án",
      active: "Đang chạy",
      late: "Trễ tiến độ",
      pastGoLive: "Quá go-live",
      completed: "Hoàn thành",
      planned: "MD kế hoạch",
      actual: "MD thực tế",
      mandayRatio: "Thực tế / kế hoạch",
      plannedCost: "Chi phí kế hoạch",
      actualCost: "Chi phí thực tế",
      expectedMargin: "Biên dự kiến TB",
      negativeMargins: "Dự án biên âm",
      attachmentFiles: "Tệp đã quét sạch",
      attachmentPendingScan: "Tệp chờ quét",
      attachmentMissing: "Dự án thiếu tài liệu",
      receivableCollected: "Đã thu trong kỳ",
      receivableOutstanding: "Công nợ",
      receivableOverdue: "Nợ quá hạn",
      satisfactionAverage: "Hài lòng trung bình",
      satisfactionNps: "NPS",
      surveyCoverage: "Dự án đóng có khảo sát",
      workloadOverload: "Người-ngày quá tải",
      workloadIdle: "Người-ngày rảnh",
      workloadConflicts: "Xung đột đa dự án",
      openIssues: "Đang mở",
      overdueIssues: "Quá hạn",
      criticalIssues: "Nghiêm trọng",
      pendingApprovals: "Việc chờ duyệt",
      overdueApprovals: "Duyệt quá SLA",
      slaRate: "Tỷ lệ đúng SLA",
      pendingReports: "Báo cáo chờ duyệt",
      pendingRequests: "Đơn từ chờ duyệt",
      pendingTimesheets: "Chấm công chờ duyệt",
      openPurchaseRequests: "PR đang xử lý",
      undeliveredOrders: "PO chưa giao",
      overdueOrders: "PO quá hạn giao",
      invoicesIssued: "Hoá đơn trong kỳ",
      utilization: "Sử dụng năng lực",
      overloadedDays: "Ngày công quá tải",
      customersActive: "Khách hàng hoạt động",
      customersInactive: "Khách hàng ngừng hoạt động",
      openFollowUps: "Hẹn chăm sóc chưa xong",
      paymentQueues: "Phiếu chi",
      payablesOutstanding: "Công nợ phải trả",
      openInvoices: "{count} hoá đơn còn nợ",
      vsPrevious: "so với kỳ trước",
      previousValue: "Kỳ trước ({from} – {to}): {value}",
      myRequests: "Đơn của tôi",
    },
    tone: {
      good: "Ổn định",
      warning: "Cần theo dõi",
      critical: "Cần xử lý",
    },
    alertsTitle: "Cảnh báo điều hành",
    alertsHint: "Số lượng hạng mục cần xử lý ngay; bấm để tới mục tương ứng.",
    alerts: {
      lateProjects: "dự án trễ tiến độ",
      pastGoLive: "dự án quá go-live",
      overdueIssues: "vấn đề quá hạn",
      overdueApprovals: "việc duyệt quá SLA",
      overdueOrders: "PO quá hạn giao",
      overloadedDays: "ngày công quá tải",
      pendingReports: "báo cáo chờ duyệt",
      pendingRequests: "đơn từ chờ duyệt",
      silentProjects: "dự án mất tín hiệu",
      overdueMilestones: "cột mốc quá hạn",
      overdueInvoices: "hoá đơn quá hạn thanh toán",
      workloadOverload: "người-ngày quá tải",
      workloadIdle: "người-ngày rảnh",
      workloadConflicts: "người-ngày xung đột dự án",
    },
    attentionTitle: "Dự án cần chú ý",
    attentionHint:
      "Xếp theo mức rủi ro: trễ tiến độ, quá go-live, vấn đề quá hạn / nghiêm trọng, vượt manday.",
    attentionEmpty: "Không có dự án nào cần chú ý trong kỳ.",
    colProject: "Dự án",
    colCustomer: "Khách hàng",
    colReasons: "Lý do",
    colProgress: "Tiến độ",
    colRemaining: "Còn lại",
    colIssues: "Vấn đề mở",
    colVariance: "Lệch MD",
    colGoLive: "Go-live",
    overdueShort: "{count} quá hạn",
    reasons: {
      late: "Trễ tiến độ",
      pastGoLive: "Quá go-live",
      overdueIssues: "Vấn đề quá hạn",
      criticalIssues: "Vấn đề nghiêm trọng",
      mandayOver: "Vượt manday",
      silent: "Mất tín hiệu",
      milestoneOverdue: "Cột mốc quá hạn",
    },
    daysLeft: "{count} ngày",
    daysOver: "Quá {count} ngày",
    sectionFinance: "Tài chính dự án",
    financeHint:
      "Chi phí manday theo đơn giá đang hiệu lực, biên so với báo giá đã gửi.",
    sectionProgress: "Diễn biến & cột mốc",
    progressHint:
      "S-curve kế hoạch/thực tế, cột mốc trượt và dự án mất tín hiệu.",
    sectionWorkload: "Tải việc theo người",
    workloadHint:
      "Hạng mục đang chạy theo người và ngày; bấm ô để xem chi tiết.",
    sectionAttachments: "Tài liệu dự án",
    attachmentsHint:
      "Số tệp theo dự án và loại; tổng hợp từ dịch vụ Tài liệu theo phạm vi bạn được đọc.",
    sectionQuality: "Chất lượng bàn giao",
    qualityHint:
      "Go-live đúng hạn, nghiệm thu trượt ngày, manday phát sinh và sự cố khách hàng sau bàn giao.",
    sectionPayables: "Công nợ phải trả",
    payablesHint:
      "Hoá đơn nhà cung cấp lũy kế từ đầu năm đến hôm nay: còn phải trả, tuổi nợ và nhà cung cấp nợ nhiều nhất.",
    payables: {
      totals: "Phải trả ({currency})",
      totalsHint: "Lũy kế từ đầu năm đến hôm nay.",
      outstanding: "Còn phải trả",
      openInvoices: "Hoá đơn còn nợ",
      overdue: "Quá hạn",
      agingTitle: "Tuổi nợ phải trả ({currency})",
      agingHint: "Số tiền còn phải trả theo số ngày quá hạn.",
      bySupplier: "Nhà cung cấp còn nợ nhiều nhất",
      aging: {
        current: "Chưa đến hạn",
        days1To30: "1–30 ngày",
        days31To60: "31–60 ngày",
        days61To90: "61–90 ngày",
        daysOver90: "Trên 90 ngày",
      },
    },
    sectionReceivables: "Công nợ và thu tiền",
    receivablesHint:
      "Số tiền hoá đơn đã phát hành, đã thu, còn phải thu và tuổi nợ quá hạn theo tiền tệ.",
    sectionSatisfaction: "Hài lòng khách hàng",
    satisfactionHint:
      "Điểm khảo sát theo tiêu chí, phân bố điểm, NPS theo quý/khách hàng và độ phủ khảo sát dự án đã đóng.",
    finance: {
      title: "Tài chính dự án",
      hidden: "Bạn không có quyền xem chi phí manday.",
      hiddenDetail:
        "Liên hệ quản trị nếu bạn cần xem chi phí và biên lợi nhuận.",
      totalsTitle: "Tổng chi phí trong kỳ",
      totalsHint: "Theo đơn giá manday đang hiệu lực",
      noProfile: "Chưa có đơn giá manday đang hiệu lực.",
      planned: "Kế hoạch",
      actual: "Thực tế",
      averageMargin: "Biên dự kiến TB",
      negativeMargins: "Dự án biên âm",
      byProject: "Chi phí theo dự án",
      margin: "Biên lợi nhuận dự kiến",
      marginHint: "Xếp tăng dần; chỉ dự án so sánh được cùng tiền tệ (VND)",
      expectedMargin: "Biên %",
      mandays: "Manday theo dự án",
      mandaysHint: "Kế hoạch và thực tế của cùng tập dự án",
    },
    progressCurve: {
      planFromWbs: "Đường kế hoạch lấy từ WBS hiện tại.",
      plannedEnd: "Kế hoạch kết thúc {end}; đường kế hoạch lấy từ WBS hiện tại.",
      curve: "S-curve danh mục",
      milestones: "Cột mốc trong kỳ",
      milestonesHint: "Tỷ lệ đúng hạn và các mốc đang quá hạn",
      onTimeRate: "Tỷ lệ đúng hạn",
      overdueCount: "Mốc quá hạn",
      currentPlannedEnd: "Kế hoạch kết thúc",
      noOverdue: "Không có cột mốc quá hạn.",
      colMilestone: "Cột mốc",
      colSlip: "Trễ (ngày)",
      slipChart: "Lệch ngày cột mốc",
      slipHint: "Dương là trượt, âm là sớm; chỉ mốc đã tới hạn",
      slipDays: "Lệch ngày",
    },
    stale: {
      title: "Dự án mất tín hiệu",
      hint: "Không cập nhật tiến độ trong 7 ngày làm việc",
      colSilentDays: "Số ngày im",
      colWarnings: "Cảnh báo",
      warningTypes: {
        Late: "Trễ hạn",
        AtRisk: "Chưa khởi động",
        OverMandays: "Vượt MD",
        MissingUpdate: "Thiếu cập nhật",
      },
    },
    workload: {
      hint: "Tải việc theo người theo ngày cho dự án đang vận hành.",
      heatmap: "Bản đồ nhiệt tải việc",
      heatmapHint:
        "Ô đậm hơn là nhiều việc hơn; viền đỏ khi ≥ 3 việc hoặc > 1 MD/ngày.",
      heatmapCaption: "Lưới tải việc theo người và ngày",
      metricLabel: "Chế độ đo",
      metricTasks: "Số việc",
      metricMandays: "Manday",
      empty: "Không có hạng mục nào được gán trong kỳ.",
      unitTasks: "việc",
      colPerson: "Người",
      colTotal: "Tổng",
      rowUnassigned: "Chưa gán",
      rowTotal: "Tổng ngày",
      loadTitle: "Điểm nóng tải việc",
      loadHint: "Trên ngày làm việc, so với 1 MD/ngày",
      overloaded: "Người-ngày quá tải",
      idle: "Người-ngày rảnh",
      conflicts: "Xung đột đa dự án",
      stack: "Việc theo ngày và người",
      stackHint: 'Tối đa 8 người, còn lại gộp "Khác"',
      planVsActual: "Kế hoạch so với chấm công",
      planVsActualHint: "MD kế hoạch so với phút đã duyệt / 480",
      planned: "Kế hoạch",
      actual: "Đã duyệt",
      dialogNoPermission: "Bạn không có quyền xem chi tiết WBS.",
      dialogEmpty:
        "Không tìm thấy hạng mục được gán cho người này trong dự án.",
    },
    goLiveTitle: "Sắp go-live (30 ngày)",
    goLiveHint: "Dự án chưa kết thúc, gần hạn nhất trước",
    sectionPipeline: "Kinh doanh & pipeline",
    pipelineHint:
      "Phễu giai đoạn SUMMARY 1, phân bố theo loại, ưu tiên và trưởng nhóm.",
    sectionGovernance: "Báo cáo & đơn từ",
    governanceHint:
      "Báo cáo dự án trong kỳ và hàng đợi đơn từ vận hành (hiện trạng).",
    total: "Tổng dự án",
    completed: "Đã hoàn thành",
    mandayRatio: "MD thực tế / kế hoạch",
    openIssues: "Vấn đề đang mở",
    overdueIssues: "Vấn đề quá hạn",
    pendingApprovals: "Việc chờ duyệt",
    overdueApprovals: "Duyệt quá hạn",
    utilization: "Sử dụng năng lực",
    topN: "Top {count}",
    topNLabel: "Số dự án mỗi biểu đồ",
    asOf: "Tính đến {date}",
    sectionNav: "Đi tới mục",
    sectionPortfolio: "Danh mục dự án",
    sectionResources: "Nguồn lực & năng lực",
    sectionIssues: "Vấn đề & sự cố",
    sectionApprovals: "Phê duyệt",
    sectionProcurement: "Mua sắm",
    portfolioHint: "Theo kỳ kế hoạch đã chọn; bấm cột để mở dự án.",
    resourcesHint: "Manday đã duyệt theo dự án và năng lực chấm công trong kỳ.",
    issuesHint:
      "Vấn đề còn hiệu lực trong kỳ trên dự án vận hành được phép xem.",
    approvalsHint:
      "Hiện trạng toàn hệ thống, không theo kỳ; bấm cột để mở hộp duyệt.",
    procurementHint: "Hiện trạng PR/PO đang xem được, không theo kỳ.",
    title: "Trung tâm điều hành",
    subtitle: "Tổng quan và phân tích theo dữ liệu đã duyệt; tự chọn góc nhìn và widget",
    active: "Dự án đang chạy",
    late: "Dự án trễ",
    planned: "MD kế hoạch",
    actual: "MD thực tế",
    summary1: "SUMMARY 1 · Tiến độ",
    summary2: "SUMMARY 2 · Nguồn lực",
    progress: "Tiến độ",
    variance: "Chênh lệch",
  },
  analytics: {
    title: "Phân tích điều hành",
    subtitle: "Biểu đồ phân tích sâu tách khỏi Tổng quan, theo lĩnh vực",
    tabsLabel: "Lĩnh vực phân tích",
    tabs: {
      projects: "Dự án",
      finance: "Tài chính",
      resources: "Nguồn lực",
      issues: "Vấn đề",
      approvals: "Phê duyệt",
      procurement: "Mua sắm",
      quality: "Chất lượng",
      people: "Nhân sự",
    },
    empty: "Không có dữ liệu cho lĩnh vực này trong kỳ.",
  },
  charts: {
    acceptanceMappingMissing:
      "{count} dự án chưa có hoặc có nhiều ánh xạ giai đoạn nghiệm thu.",
    acceptanceMappingLegacy:
      "{count} dự án dùng ánh xạ nghiệm thu cũ đã được cấu hình.",

    stageCompletion: "Hoàn thành theo 16 giai đoạn",
    stageN: "GĐ {n}",
    salesFunnel: "Phễu giai đoạn dự án",
    salesFunnelHint: "Số dự án đã đạt mốc từng giai đoạn",
    stages: {
      Receipt: "Tiếp nhận",
      Survey: "Khảo sát",
      SolutionProposal: "Đề xuất giải pháp",
      Demo: "Demo",
      Quotation: "Báo giá",
      PurchaseOrder: "Nhận P/O",
      GoLive: "Go-live",
    },
    byLeader: "Dự án theo trưởng nhóm",
    unassigned: "Chưa gán",
    byType: "Dự án theo loại",
    byPriority: "Dự án theo ưu tiên",
    priorities: {
      Low: "Thấp",
      Normal: "Bình thường",
      High: "Cao",
      Critical: "Khẩn",
    },
    reportStatus: "Báo cáo theo trạng thái",
    reportStatusHint: "Báo cáo có kỳ giao với kỳ lọc",
    reportStatuses: {
      Draft: "Nháp",
      Submitted: "Đã nộp",
      Reviewed: "Đã xem xét",
      Approved: "Đã duyệt",
      Returned: "Trả lại",
      Rejected: "Từ chối",
    },
    reportType: "Báo cáo theo loại",
    reportTypes: {
      Daily: "Hằng ngày",
      Weekly: "Hằng tuần",
    },
    axisReports: "Số báo cáo",
    inPeriodHint: "Phát sinh trong kỳ",
    currentStateHint: "Hiện trạng, không theo kỳ",
    requestsPendingByType: "Đơn từ chờ duyệt theo loại",
    requestsPendingHint: "Đã nộp / đã xác nhận, chưa quyết định",
    requestTypes: {
      TimeCorrection: "Xác nhận giờ công",
      Leave: "Nghỉ phép",
      Overtime: "Tăng ca",
      Onsite: "Onsite",
      BusinessTrip: "Công tác",
      Vehicle: "Xe",
      Meal: "Cơm",
    },
    requestsByStatus: "Đơn từ theo trạng thái",
    requestStatuses: {
      Draft: "Nháp",
      Submitted: "Đã nộp",
      Confirmed: "Đã xác nhận",
      Approved: "Đã duyệt",
      Rejected: "Từ chối",
      Returned: "Trả lại",
      AdminReceived: "HC đã nhận",
      AccountingReceived: "KT đã nhận",
      Withdrawn: "Đã rút",
      Cancelled: "Đã hủy",
    },
    stockByType: "Giao dịch kho theo loại",
    stockTypes: {
      Receipt: "Nhập kho",
      Issue: "Xuất kho",
      Reversal: "Hoàn",
    },
    stockByStatus: "Giao dịch kho theo trạng thái",
    stockStatuses: {
      Draft: "Nháp",
      Submitted: "Đã gửi",
      Confirmed: "Đã xác nhận",
      Approved: "Đã duyệt",
      Rejected: "Từ chối",
      Reversed: "Đã hoàn",
    },
    stockMovement: "Nhập / xuất đã duyệt theo vật tư",
    stockReceipt: "Nhập",
    stockIssue: "Xuất",
    axisTransactions: "Số giao dịch",
    axisQuantity: "Số lượng",
    invoiceStatus: "Hoá đơn theo trạng thái",
    invoiceStatuses: {
      Issued: "Đã phát hành",
      Voided: "Đã huỷ",
    },
    axisInvoices: "Số hoá đơn",
    capacityHealthUnit: "Người × ngày",
    axisProjects: "Số dự án",
    axisPercent: "Tỷ lệ (%)",
    axisProgress: "% hoàn thành",
    axisStage: "Giai đoạn",
    axisDays: "Số ngày",
    axisMandays: "Manday (MD)",
    axisHours: "Giờ",
    axisDate: "Ngày",
    axisIssues: "Số vấn đề",
    axisTasks: "Số việc chờ duyệt",
    axisRequests: "Số yêu cầu",
    axisOrders: "Số đơn",
    axisAmount: "Giá trị",
    axisCurrency: "Tiền tệ",
    unitMd: "MD",
    unitDays: "ngày",
    unitHours: "giờ",
    scheduleHealthShare: "Tiến độ toàn danh mục",
    lifecycle: "Vòng đời dự án",
    lifecycleRegistration: "Đăng ký",
    lifecycleExecuting: "Đang triển khai",
    lifecycleFinished: "Kết thúc",
    progressBuckets: "Phân bố % hoàn thành",
    progressBucket0: "0%",
    progressBucket1To25: "1–25%",
    progressBucket26To50: "26–50%",
    progressBucket51To75: "51–75%",
    progressBucket76To99: "76–99%",
    progressBucket100: "100%",
    scheduleShareByProject: "Tỷ lệ nhanh / đúng hạn / trễ theo dự án",
    stageHint: "16 giai đoạn SUMMARY 1, % dự án đã xong",
    remainingDayBuckets: "Số ngày còn lại đến go-live",
    remainingOverdue: "Đã quá go-live",
    remainingWithin7: "≤ 7 ngày",
    remainingWithin30: "8–30 ngày",
    remainingWithin90: "31–90 ngày",
    remainingOver90: "> 90 ngày",
    byCustomer: "Dự án theo khách hàng",
    mandayVariance: "Chênh lệch MD (thực tế trừ kế hoạch)",
    mandayEfficiency: "Hiệu quả manday theo dự án",
    efficiencyHint: "{count} dự án thấp nhất",
    capacityDaily: "Năng lực theo ngày",
    capacityAvailable: "Sẵn có",
    capacityApproved: "Đã duyệt",
    capacityDraft: "Nháp",
    capacityHealth: "Tình trạng ngày công",
    capacityHealthHint: "Theo người và ngày trong kỳ",
    capacityNormal: "Bình thường",
    capacityOverloaded: "Quá tải",
    capacityMissing: "Thiếu chấm công",
    issueStatus: "Vấn đề theo trạng thái",
    issueSeverity: "Vấn đề theo mức độ",
    issueDelivery: "Vấn đề theo tình trạng giao",
    issueSource: "Nguồn vấn đề",
    issuesByProject: "Vấn đề đang mở theo dự án",
    issueOpen: "Mở",
    issueInProgress: "Đang xử lý",
    issueResolved: "Đã giải quyết",
    issueClosed: "Đã đóng",
    issueOpenOnTime: "Mở, còn hạn",
    severityLow: "Thấp",
    severityMedium: "Trung bình",
    severityHigh: "Cao",
    severityCritical: "Nghiêm trọng",
    deliveryPlanned: "Theo kế hoạch",
    deliveryAtRisk: "Rủi ro",
    deliveryDue: "Đến hạn",
    deliveryOverdue: "Quá hạn",
    deliveryDelivered: "Đã giao",
    sourceCustomer: "Khách hàng",
    sourceInternal: "Nội bộ",
    approvalsByType: "Việc chờ duyệt theo loại",
    approvalsByTypeHint: "Quá hạn theo SLA của bước",
    approvalPending: "Còn hạn",
    approvalOverdue: "Quá hạn",
    approvalAge: "Tuổi chờ duyệt",
    approvalAgeHint: "Tính từ lúc giao việc",
    approvalCycleByType: "Chu kỳ duyệt theo loại",
    approvalCycleByTypeHint: "Giờ từ lúc giao đến lúc quyết định",
    approvalCycleByStep: "Chu kỳ duyệt theo bước",
    approvalCycleByStepHint: "Bước chậm nhất trước, tối đa 10",
    approvalThroughput: "Quyết định theo ngày",
    approvalThroughputHint: "Số việc đã chốt mỗi ngày trong kỳ",
    approvalAvgCycle: "TB (giờ)",
    approvalMedianCycle: "Trung vị (giờ)",
    approvalApproved: "Đã duyệt",
    approvalRejected: "Từ chối",
    approvalCancelled: "Đã huỷ",
    attachmentStack: "Tệp theo dự án",
    attachmentStackHint: "{count} dự án nhiều tệp nhất, xếp chồng theo loại",
    attachmentMatrix: "Mật độ tài liệu theo dự án",
    attachmentMatrixHint: "Ô đậm hơn là nhiều tệp hơn trong cùng loại",
    attachmentMatrixCaption: "Bảng tệp theo dự án và loại tài liệu",
    attachmentTotals: "Tài liệu & trạng thái quét",
    attachmentTotalsHint:
      "Chỉ tính tệp đã quét sạch; tệp chờ quét và bị từ chối tách riêng",
    attachmentFiles: "Tệp đã quét sạch",
    attachmentPendingScan: "Tệp chờ quét",
    attachmentRejected: "Tệp bị từ chối",
    attachmentMissingProjects: "Dự án thiếu tài liệu bắt buộc",
    attachmentMissingExample: "Ví dụ dự án thiếu",
    attachmentOwners: "Dự án có quyền đọc",
    attachmentProject: "Dự án",
    attachmentRowTotal: "Tổng dự án",
    attachmentColumnTotal: "Tổng loại",
    attachmentCategoryTotals: "Tệp theo loại tài liệu",
    attachmentCategoryTotalsHint: "Toàn bộ dự án trong phạm vi đọc",
    attachmentCategories: {
      Survey: "Khảo sát",
      Drawing: "Bản vẽ",
      Contract: "Hợp đồng",
      Report: "Báo cáo",
      Other: "Khác",
    },
    qualityTotals: "Chất lượng bàn giao",
    qualityTotalsHint: "Dự án đã go-live trong và trước kỳ 90 ngày",
    qualityOnTimeRate: "Go-live đúng hạn",
    qualityAverageSlip: "Lệch go-live TB (ngày)",
    qualityRework: "Manday phát sinh sau go-live",
    qualityProjects: "Dự án đã go-live",
    goLiveOnTimeByQuarter: "Go-live đúng hạn theo quý",
    goLiveOnTimeByQuarterHint: "Đúng hạn / trễ theo quý ghi nhận go-live",
    goLiveOnTime: "Đúng hạn",
    goLiveLate: "Trễ",
    goLiveSlip: "Lệch go-live",
    goLiveSlipHint: "Ngày thực tế trừ kế hoạch; dương là trễ",
    acceptanceSlip: "Nghiệm thu trượt ngày",
    acceptanceSlipHint: "Chỉ dự án đã có ngày nghiệm thu thực tế",
    customerIssuesAfterGoLive: "Sự cố khách hàng sau go-live (90 ngày)",
    customerIssuesAfterGoLiveHint:
      "Vấn đề khách hàng tiếp nhận trong 90 ngày kể từ go-live",
    qualityCustomerIssues: "Sự cố khách hàng",
    reworkMandays: "Manday phát sinh sau go-live",
    reworkMandaysHint: "Hạng mục có ngày bắt đầu thực tế sau ngày go-live",
    receivableTotals: "Công nợ {currency}",
    receivableTotalsHint:
      "Đã thu và số dư theo kỳ lọc; nợ quá hạn theo hạn thanh toán",
    receivableInvoiced: "Đã xuất hoá đơn",
    receivableCollected: "Đã thu",
    receivableOutstanding: "Còn phải thu",
    receivableOverdue: "Quá hạn",
    receivableOverdueInvoices: "Hoá đơn quá hạn",
    receivableAging: "Tuổi nợ quá hạn {currency}",
    receivableAgingHint: "Số ngày quá hạn so với hôm nay (giờ Việt Nam)",
    "receivableAging0-30": "0–30 ngày",
    "receivableAging31-60": "31–60 ngày",
    "receivableAging61-90": "61–90 ngày",
    receivableAgingOver90: "> 90 ngày",
    receivableMonth: "Hoá đơn và đã thu {currency}",
    receivableMonthHint:
      "Theo tháng phát hành hoá đơn và tháng thu tiền trong kỳ",
    receivableByProject: "Công nợ theo dự án {currency}",
    receivableByProjectHint: "Top {count} dự án còn phải thu, kèm phần quá hạn",
    satisfactionTotals: "Khảo sát trong kỳ",
    satisfactionTotalsHint: "Điểm 1–5; NPS = %(9–10) − %(0–6)",
    satisfactionSurveys: "Số khảo sát",
    satisfactionProjects: "dự án",
    satisfactionAverage: "Điểm tổng TB",
    satisfactionNps: "NPS",
    satisfactionCoverage: "Độ phủ dự án đóng",
    satisfactionBreakdown: "Ủng hộ / trung lập / chê",
    satisfactionCriteriaTitle: "Điểm theo tiêu chí",
    satisfactionCriteriaHint: "Thang 1–5, điểm tổng là điểm chung",
    satisfactionDistributionTitle: "Phân bố điểm tổng",
    satisfactionDistributionHint: "Số khảo sát theo mức 1–5",
    satisfactionNpsQuarter: "NPS theo quý",
    satisfactionNpsQuarterHint: "Âm là nhiều người chê hơn ủng hộ",
    satisfactionNpsCustomer: "NPS theo khách hàng",
    satisfactionNpsCustomerHint: "Top {count} khách hàng nhiều khảo sát",
    axisPoints: "Điểm (1–5)",
    axisSurveys: "Số khảo sát",
    satisfactionCriteria: {
      schedule: "Tiến độ",
      quality: "Chất lượng",
      communication: "Trao đổi",
      support: "Hỗ trợ",
      overall: "Tổng thể",
    },
    ageUnder1Day: "< 1 ngày",
    ageOneToThreeDays: "1–3 ngày",
    ageThreeToSevenDays: "3–7 ngày",
    ageOverSevenDays: "> 7 ngày",
    targetTypes: {
      ProjectRegistration: "Đăng ký dự án",
      ProjectIssue: "Vấn đề dự án",
      Timesheet: "Chấm công",
      MealDayRegistration: "Đăng ký cơm",
      PurchaseRequest: "Yêu cầu mua",
      PurchaseOrder: "Đơn mua",
    },
    prStatus: "Yêu cầu mua theo trạng thái",
    poStatus: "Đơn mua theo trạng thái",
    poOutlook: "Đơn mua chưa giao theo hạn",
    poOutlookHint: "Đơn đã gửi/đã duyệt, theo ngày giao",
    poValue: "Giá trị đơn mua đang mở",
    poValueHint: "Đơn đã gửi/đã duyệt, theo tiền tệ",
    outlookOverdue: "Quá hạn giao",
    outlookWithin7: "≤ 7 ngày",
    outlookWithin30: "8–30 ngày",
    outlookOver30: "> 30 ngày",
    prStatuses: {
      Draft: "Nháp",
      Submitted: "Đã gửi",
      Quoted: "Đã báo giá",
      Confirmed: "Đã xác nhận",
      Approved: "Đã duyệt",
      AdminReceived: "HC đã nhận",
      AccountingReceived: "KT đã nhận",
      Rejected: "Từ chối",
      Cancelled: "Đã hủy",
    },
    poStatuses: {
      Draft: "Nháp",
      Submitted: "Đã gửi",
      Approved: "Đã duyệt",
      Rejected: "Từ chối",
      Delivered: "Đã giao",
      Cancelled: "Đã hủy",
    },
    projectStatus: "Trạng thái dự án",
    completionProgress: "Tiến độ hoàn thành",
    scheduleStatus: "Trạng thái tiến độ",
    executionDays: "Theo dõi số ngày thực hiện",
    mandays: "Theo dõi Manday",
    resourceStatus: "Trạng thái nguồn lực",
    running: "Đang chạy",
    pause: "Tạm dừng",
    cancelled: "Đã hủy",
    completed: "Đã hoàn thành",
    inProgress: "Đang thực hiện",
    notStarted: "Chưa bắt đầu",
    notCompleted: "Chưa hoàn thành",
    ahead: "Nhanh",
    onTrack: "Đúng hạn",
    late: "Trễ",
    elapsed: "Đã thực hiện",
    remaining: "Còn lại",
    planned: "Kế hoạch",
    actual: "Thực tế",
    enough: "Đủ",
    shortage: "Thiếu",
    over: "Vượt",
    filtered: "Đang lọc theo biểu đồ",
    clearFilter: "Bỏ lọc",
    other: "Khác",
  },
  summary1: {
    totalExecutionDays: "Tổng số ngày thực hiện",
    remainingDays: "Tổng số ngày còn lại",
    done: "Đã",
    pending: "Chưa",
    manday: "Man day",
    efficiency: "Hiệu quả",
    projectStatus: "Trạng thái dự án",
    stageStatus: "Trạng thái",
    link: "Liên kết",
    openProject: "Mở dự án {code}",
  },
  summary1Stages: {
    survey: "Khảo sát",
    solutionProposal: "Đề xuất giải pháp",
    demo: "Demo",
    quotation: "Báo giá",
    purchaseOrder: "Tiếp nhận P/O",
    implementation: "Triển khai dự án",
    supplierPurchaseOrder: "P/O nhà cung cấp",
    subcontractorPurchaseOrder: "P/O nhà thầu phụ",
    commissioningTest: "Chạy thử nghiệm thu",
    delivery: "Giao hàng",
    installation: "Lắp đặt",
    operationTest: "Chạy thử vận hành",
    massProduction: "Chạy hàng loạt",
    training: "Đào tạo",
    acceptance: "Nghiệm thu",
    payment: "Thanh toán",
  },
  inlineGrid: {
    addRow: "Thêm dòng",
    removed: "Đã xóa một dòng.",
    undo: "Hoàn tác",
  },
  saveStatus: {
    pending: "Có thay đổi",
    saving: "Đang lưu…",
    saved: "Đã lưu",
    invalid: "Chưa lưu",
    error: "Lưu thất bại",
  },
  recordPanel: {
    fullscreen: "Xem toàn màn hình",
    exitFullscreen: "Thu nhỏ về panel",
    previous: "Bản ghi trước",
    next: "Bản ghi sau",
    discardChanges: "Có thay đổi chưa lưu. Bỏ các thay đổi này?",
  },
  customers: {
    panel: {
      tabs: {
        info: "Thông tin",
        contacts: "Liên hệ & địa điểm",
        projects: "Dự án",
        activities: "Hoạt động",
        followUps: "Hẹn chăm sóc",
        finance: "Tài chính",
        commercial: "Báo giá & PO",
      },
      financialTerms: "Điều khoản thanh toán",
      commercialQuotations: "Báo giá của khách hàng",
      commercialOrders: "PO khách hàng",
      newQuotation: "Tạo báo giá",
      commercialHint: "Báo giá và PO thuộc các dự án của khách hàng mà bạn được xem. Bấm một dòng để mở ở Báo giá & hợp đồng.",
      audit: "Theo dõi thay đổi",
      noContacts: "Chưa có người liên hệ. Bấm Sửa để thêm.",
      noSites: "Chưa có địa điểm.",
      defaultSite: "Mặc định",
      activitiesHint: "Cuộc gọi, email, gặp mặt đã ghi nhận với khách hàng.",
      logActivity: "Ghi hoạt động",
      scheduleFollowUp: "Hẹn chăm sóc",
      noActivities: "Chưa có hoạt động nào.",
      noFollowUps: "Không có lịch hẹn chăm sóc.",
      markDone: "Hoàn thành",
    },
    projectsPageSummary: "Thống kê trạng thái trong trang đã tải",
    projectsForbidden: "Bạn không có quyền xem dự án của khách hàng này.",
    title: "Danh mục khách hàng",
    codeFromShortName: "Mã sinh từ tên viết tắt",
    deleteConfirm: "Chuyển khách hàng {code} vào thùng rác?",
    subtitle: "Hồ sơ pháp lý, địa điểm, người liên hệ và điều khoản thương mại",
    legalName: "Tên pháp lý",
    shortName: "Tên viết tắt",
    abbreviation: "Tên viết tắt",
    province: "Tỉnh/Thành phố",
    country: "Quốc gia",
    tax: "Mã số thuế",
    owner: "Phụ trách kinh doanh",
    new: "Tạo khách hàng",
    duplicate: "Kiểm tra trùng",
    industry: "Lĩnh vực",
    sector: "Ngành",
    legalRep: "Đại diện pháp luật",
    sites: "Địa điểm / Nhà máy",
    contacts: "Danh bạ",
    financial: "Tài chính",
    bank: "Ngân hàng",
    account: "Số tài khoản",
    paymentTerm: "Điều khoản thanh toán",
    creditDays: "Số ngày công nợ",
    paymentDay: "Ngày thanh toán định kỳ",
    history: "Lịch sử dự án",
    addSite: "Thêm địa điểm",
    addContact: "Thêm người liên hệ",
    siteName: "Tên địa điểm",
    siteType: "Loại",
    address: "Địa chỉ",
    isDefault: "Mặc định",
    fullName: "Họ tên",
    department: "Phòng ban",
    position: "Chức vụ",
    phone: "Điện thoại",
    email: "Email",
    corporateEmail: "Email công ty",
    fax: "Fax",
    factoryCount: "Số nhà máy",
    dupExact: "Trùng mã số thuế với khách hàng đã có — không thể tạo.",
    dupName: "Tên pháp lý tương tự khách hàng đã có — kiểm tra trước khi lưu.",
    profile: "Hồ sơ",
    activate: "Kích hoạt",
    deactivate: "Ngưng hoạt động",
    backToProjectHistory: "Quay lại lịch sử dự án",
    historyChat: "Chat",
    historyTable: "PO",
    readOnlyLog: "Chế độ xem nhật ký (Chỉ đọc)",
    customerSpeaker: "Khách hàng",
    youProjectManager: "Bạn (Quản lý dự án)",
    internalSpeaker: "Nhân sự nội bộ",
    communicationLog: "Nhật ký trao đổi",
    searchCommunicationLog: "Tìm trong nhật ký...",
    selectSpeaker: "Bên phát ngôn",
    meSpeaker: "Nội bộ (Tôi)",
    externalSpeaker: "Đại diện khách hàng / đối tác",
    communicationPlaceholder: "Nhập nội dung biên bản cuộc họp, thỏa thuận kỹ thuật hoặc trao đổi dự án...",
    addCommunicationEntry: "Ghi chép trao đổi mới",
    saveCommunicationEntry: "Lưu vào nhật ký",
    communicationEntryTitle: "Ghi chép nhật ký trao đổi dự án",
    communicationEntrySubtitle: "Lưu trữ biên bản làm việc, trao đổi kỹ thuật hoặc thỏa thuận với khách hàng/đối tác",
    recordedBy: "Ghi nhận bởi",
    ctrlEnterHint: "Nhấn Ctrl + Enter để lưu nhanh",
    attachedDocuments: "Tài liệu & Biên bản đính kèm",
    speakerLabel: "Người phát ngôn / Đại diện",
    allTimelineEntries: "Dòng thời gian nhật ký",
    attachFile: "Đính kèm file",
    documentFallback: "Tài liệu",
    communicationEmpty: "Chưa có nội dung trao đổi",
    communicationEmptyHint:
      "Nội dung được lưu sẽ hiển thị theo trình tự thời gian tại đây.",
    projectHistoryUnavailable: "Không thể tải nhật ký của dự án.",
    historyEntries: "bản ghi",
    loadingOlderMessages: "Đang tải trao đổi cũ hơn...",
    loadOlderMessages: "Xem trao đổi cũ hơn",
    startOfHistory: "Đầu nhật ký trao đổi",
    placeholders: {
      sector: "Sản xuất",
      corporateEmail: "lienhe{'@'}congty.com",
      bank: "Vietcombank",
      account: "0123456789012",
      creditDays: "30",
      paymentDay: "15",
      siteName: "Trụ sở chính",
      siteType: "Văn phòng chính",
      country: "VN",
      contactName: "Nguyễn Văn A",
      department: "Phòng Kinh doanh",
      position: "Trưởng phòng kinh doanh",
      phone: "0987654321",
      email: "lienhe{'@'}congty.com",
    },
    unknownSpeaker: "Không rõ người gửi",
  },
  products: {
    panel: {
      tabs: {
        info: "Thông tin",
        components: "Thành phần",
        revisions: "Phiên bản",
      },
      components: "Thành phần",
      master: "Thông tin gốc",
      activeRevision: "Phiên bản đang hiệu lực",
      allRevisions: "Xem {count} phiên bản",
      manageComponents: "Quản lý thành phần",
      moreComponents: "Xem thêm {count} thành phần",
      pendingRevision: "Phiên bản {code} đang chờ kích hoạt.",
      draftPending: "Có phiên bản nháp chờ kích hoạt",
      pricing: "Giá & chi phí",
      editMaster: "Sửa thông tin",
      editDraft: "Sửa phiên bản nháp {code}",
      newRevision: "Phiên bản mới {code}",
    },
    listPrice: {
      button: "Nhập List price",
      title: "Nhập sheet List price vào danh mục sản phẩm",
      dryRun: "Chạy thử",
      commit: "Ghi vào danh mục",
      summary: "{inserts} sản phẩm mới · {updates} sản phẩm cập nhật · {components} thành phần mới · {componentUpdates} thành phần cập nhật",
      committed: "Đã ghi {inserts} sản phẩm mới, {updates} sản phẩm cập nhật, {components} thành phần.",
      mappingNote: "Không thêm cột mới: giá thành phần = A&A cost + Mr Sang's cost (VND); A&A, Mr Sang, Tiêu chuẩn/Option và NMI Price = ROUND(Đơn giá/0,6; −5) ghi trong Mô tả tính năng.",
      kindStandard: "Tiêu chuẩn",
      kindOption: "Tùy chọn",
      columns: {
        code: "Mã",
        name: "Tên",
        kind: "Loại",
        aaCost: "Chi phí A&A",
        sangCost: "Chi phí Mr Sang",
        unitPrice: "Đơn giá",
        nmiPrice: "Giá NMI",
        action: "Thao tác",
      },
      actions: {
        Insert: "Thêm mới",
        Update: "Cập nhật",
        Error: "Lỗi",
      },
      issues: {
        list_price_not_numeric: "Giá không phải số",
        list_price_mismatch: "Lệch giá Excel",
        list_price_kind_ambiguous: "Vừa Tiêu chuẩn vừa Tùy chọn",
        list_price_orphan_component: "Mã nằm trên module đầu tiên",
        list_price_name_missing: "Module thiếu tên",
        duplicate_code_in_payload: "Trùng mã module",
        duplicate_product_component: "Trùng mã thành phần",
        validation_failed: "Dữ liệu không hợp lệ",
        record_in_trash: "Sản phẩm đang trong thùng rác",
        list_price_empty: "Không có module",
        list_price_sheet_missing: "Thiếu sheet List price",
        list_price_header_missing: "Thiếu dòng tiêu đề",
        invalid_workbook: "File không đọc được",
      },
    },
    exportCsv: "Xuất CSV",
    bom: {
      unknownCurrency: "Chưa xác định tiền tệ",
      partName: "Sản phẩm",
      module: "Module",
      code: "Mã",
      title: "Thành phần của {code}",
      featureDescription: "Mô tả tính năng",
      unitPrice: "Đơn giá",
      totalPrice: "Thành tiền",
      currency: "Tiền tệ",
      componentCode: "Code đầu vào (mã NCC)",
      outputCode: "Code đầu ra",
      outputCodePlaceholder: "Theo Code đầu vào",
      price: "Giá",
      addComponent: "Thêm thành phần",
      updateComponent: "Cập nhật thành phần",
      catalogAmbiguous:
        "Danh mục có nhiều thông tin cho lựa chọn này. Kiểm tra và nhập mã, mô tả, giá và tiền tệ phù hợp.",
      empty: "Chưa khai thành phần con nào.",
      invalid: "Mỗi thành phần cần một mã riêng và giá không âm.",
      saved: "Đã lưu danh mục thành phần.",
      dragToReorder: "Kéo thả dòng để thay đổi thứ tự",
      moveUp: "Di chuyển lên",
      moveDown: "Di chuyển xuống",
    },
    placeholders: {
      code: "PN-00123",
      outputCode: "Để trống thì dùng Mã",
      partName: "Cụm giá đỡ",
      model: "M-2024A",
      category: "Linh kiện cơ khí",
      unit: "PCS",
      revision: "Rev. A",
      description: "Mô tả ngắn về sản phẩm",
      specification: "Thép, dày 2mm",
      makerName: "Công ty TNHH Sản xuất ABC",
      currency: "USD",
      module: "MD-101",
    },
    title: "Danh mục sản phẩm",
    subtitle: "Quản lý model, revision và WBS template mặc định",
    code: "Mã",
    outputCode: "Code đầu ra",
    outputCodeTooLong: "Code đầu ra không được vượt quá 50 ký tự.",
    model: "Model",
    module: "Module",
    category: "Nhóm",
    partName: "Sản phẩm",
    revision: "Revision",
    revisions: "Các revision",
    customers: "Khách hàng sử dụng",
    unit: "Đơn vị",
    new: "Tạo sản phẩm",
    specification: "Thông số kỹ thuật",
    effective: "Hiệu lực từ",
    import: "Nhập dữ liệu",
    importHelp:
      "CSV có header chuẩn và các cột mua hàng: makerName,importQuantity,currency,inputPrice,fobPrice,importTax,cifCost,swiftFee,landedCost. Cột outputCode là tùy chọn: không có cột thì giữ mã đầu ra hiện tại; ô trống thì dùng mã đầu vào.",
    importInvalid: "Dòng thiếu trường bắt buộc hoặc sai ngày",
    importReady: "dòng hợp lệ",
    addRevision: "Thêm revision",
    activateRevision: "Kích hoạt",
    defaultTemplate: "WBS template mặc định",
    deactivate: "Ngưng hoạt động",
    description: "Mô tả",
    makerName: "Nhà sản xuất",
    importQuantity: "Số lượng nhập",
    currency: "Đơn vị tiền tệ",
    inputPrice: "Giá đầu vào",
    fobPrice: "Giá FOB",
    importTax: "Thuế nhập khẩu (%)",
    cifCost: "Chi phí CIF",
    swiftFee: "Phí SWIFT",
    landedCost: "Giá về kho",
    selectCustomer: "Chọn khách hàng",
    customerModel: "Model phía khách hàng",
    linkCustomer: "Liên kết",
    endLink: "Kết thúc liên kết",
    customerReadRequired: "Cần quyền đọc khách hàng để tạo liên kết.",
  },
  organizations: {
    panel: {
      tabs: {
        info: "Thông tin",
        contacts: "Liên hệ",
      },
    },
    deleteConfirm: "Chuyển đối tác/nhà cung cấp {code} vào thùng rác?",
    cooperationHistory: "Lịch sử hợp tác",
    relatedProjects: "Dự án liên quan",
    cooperationProject: "Dự án hợp tác",
    purchaseOrders: "PO",
    supplierMaterials: "Danh sách linh kiện",
    partner: "Đối tác",
    supplier: "Nhà cung cấp",
    partnerTitle: "Danh sách đối tác",
    supplierTitle: "Danh sách nhà cung cấp",
    shortName: "Tên viết tắt",
    country: "Quốc gia",
    category: "Loại công ty",
    region: "Khu vực",
    taxCode: "Mã số thuế ",
    legalRepresentative: "Người đại diện pháp luật",
    address: "Địa chỉ trụ sở / giao hàng",
    industry: "Ngành nghề kinh doanh",
    factoryCount: "Số lượng nhà máy",
    salesOwner: "Đảm trách kinh doanh",
    purchasingOwner: "Đảm trách mua hàng",
    currency: "Tiền tệ giao dịch",
    vatRate: "VAT (%)",
    bank: "Ngân hàng giao dịch",
    account: "Số tài khoản",
    creditDays: "Số ngày công nợ",
    paymentDay: "Ngày thanh toán định kỳ",
    contacts: "Người liên lạc",
    addContact: "Thêm người liên lạc",
    contactName: "Họ tên",
    department: "Phòng ban",
    title: "Chức vụ",
    phone: "Số điện thoại",
    email: "Email",
    activate: "Kích hoạt",
    deactivate: "Ngưng hoạt động",
    sections: {
      profile: "Hồ sơ \n doanh nghiệp",
      commercial: "Thương mại \n tài chính",
      contacts: "Người \n liên lạc",
    },
    placeholders: {
      region: "TP. Hồ Chí Minh",
      taxCode: "0123456789",
      category: "Nhà sản xuất",
      factoryCount: "1",
      owner: "Chọn người phụ trách",
      currency: "USD",
      vatRate: "10",
      bank: "Vietcombank",
      account: "0123456789012",
      creditDays: "30",
      paymentDay: "15",
      contactName: "Nguyễn Văn A",
      department: "Phòng Kinh doanh",
      title: "Trưởng phòng kinh doanh",
      phone: "0987654321",
      email: "lienhe{'@'}congty.com",
    },
  },
  materials: {
    stockTabs: "Danh mục và giao dịch kho hàng kinh doanh",
    directoryTab: "Danh sách vật tư",
    title: "Danh sách hàng hóa, vật tư linh kiện kinh doanh",
    deleteConfirm: "Chuyển vật tư {code} vào thùng rác?",
    new: "Tạo vật tư / linh kiện",
    selectRow: "Chọn",
    selectMaterial: "Chọn vật tư {code}",
    partName: "Sản phẩm",
    model: "Model",
    version: "Số Rev",
    category: "Phân loại",
    description: "Mô tả linh kiện",
    maker: "Nhà sản xuất",
    unit: "Đơn vị",
    moq: "MOQ",
    leadTime: "Thời gian giao hàng (ngày)",
    unitPrice: "Đơn giá",
    currency: "Đơn vị tiền tệ",
    packageBag: "Số lượng đóng gói / Bịch",
    packageBox: "Số lượng đóng gói / hộp",
    supplier: "Nhà cung cấp",
    purchasingOwner: "Đảm trách mua hàng",
    activate: "Kích hoạt",
    submitApproval: "Gửi duyệt",
    deactivate: "Ngưng hoạt động",
    sections: {
      identity: "Nhận diện quy cách",
      procurement: "Mua hàng giá",
      packaging: "Đóng gói",
    },
    placeholders: {
      partName: "Bu lông thép M6",
      model: "SB-M6-2024",
      category: "Nguyên vật liệu",
      maker: "Công ty TNHH Sản xuất ABC",
      unit: "PCS",
      description: "Mô tả ngắn về vật tư",
      version: "Rev. A",
      currency: "USD",
      supplier: "Chọn nhà cung cấp",
      purchasingOwner: "Chọn người phụ trách mua hàng",
      code: "MAT-00123",
    },
  },
  materialEnrollment: {
    configDraftTitle: 'Bản nháp đăng ký vật tư',
    sourceUnavailable: 'Chưa đọc được nguồn {source}. Danh sách chưa đầy đủ; tải lại để đọc nguồn này.',
    configFieldsHint: 'Lưu thông tin đăng ký trước, sau đó gửi bản nháp để xét duyệt.',
    note: 'Ghi chú đề nghị', lockedHint: 'Phiên bản này chưa được sửa. Dùng thao tác đang được hệ thống cho phép và tải lại trạng thái hiện tại.',
    discardChanges: 'Bỏ các thay đổi đăng ký chưa lưu?',
    recoverWorkflow: 'Đối soát luồng duyệt', revise: 'Tạo phiên bản nháp',
    reviseConfirm: 'Tạo phiên bản nháp sau khi luồng duyệt trước được xác minh đã kết thúc?',
    withdrawConfirm: 'Yêu cầu rút hồ sơ? Hồ sơ vẫn ở trạng thái đã gửi đến khi quy trình duyệt xác nhận rút.',
    deleteDraftConfirm: 'Xóa bản nháp này? Không thể xóa lịch sử hồ sơ đã gửi duyệt.',
    bindingStates: { StartPending: 'Đang chờ khởi tạo luồng duyệt', StartInFlight: 'Đang khởi tạo luồng duyệt', StartUnknown: 'Chưa biết kết quả khởi tạo; cần đối soát trước thao tác tiếp',
      AwaitingRequester: 'Người đề nghị cần đối soát bằng quyền hiện tại', Bound: 'Đã xác minh liên kết luồng duyệt', WithdrawPending: 'Yêu cầu rút đang chờ xác nhận',
      WithdrawInFlight: 'Đang xác nhận yêu cầu rút', WithdrawUnknown: 'Chưa biết kết quả rút; chưa xác nhận hồ sơ đã rút',
      Withdrawn: 'Đã xác nhận rút', Blocked: 'Đối soát luồng duyệt đang bị chặn', unavailable: 'Chưa có trạng thái liên kết luồng duyệt' },
    project: "Dự án",
    tabsLabel: "Nhóm đăng ký vật tư",
    pendingSection: "Đơn chưa duyệt",
    approvedSection: "Đơn đã duyệt đủ",
    pageTitle: "Theo dõi & phê duyệt vật tư, linh kiện",
    assetPageTitle: "Theo dõi & phê duyệt tài sản",
    pageSubtitle:
      "Đăng ký mua và nhập kho hàng hóa, vật tư linh kiện kinh doanh",
    scopeHint:
      "Màn hình riêng cho hồ sơ vật tư, tài sản và phiếu kho liên quan; các quy trình duyệt khác xem tại Hộp phê duyệt.",
    myRequests: "Phiếu của tôi",
    kind: "Loại",
    updatedAt: "Cập nhật",
    tabs: {
      material: "Vật tư, linh kiện kinh doanh",
      procurement: "Tài sản",
      mine: "Hồ sơ của tôi",
    },
    returnConfirm: "Bạn có chắc chắn muốn báo trả lại vật tư này?",
    returnAction: "Trả lại",
    quickPick: "Chọn nhanh từ danh mục vật tư:",
    quickPickPlaceholder: "-- Chọn mẫu vật tư có sẵn --",
    columns: {
      code: "Mã đơn",
      borrower: "Người mượn",
      borrowDate: "Ngày mượn",
      expectedReturnDate: "Ngày dự kiến trả",
      quantity: "Số lượng mượn",
      returnedDate: "Ngày trả",
    },
    history: {
      returnRejected: "Từ chối trả",
      returnWorkflowStarted: "Chờ duyệt trả",
      returnFailed: "Lỗi luồng trả lại",
      ReturnRequested: "Yêu cầu trả vật tư",
      ReturnWorkflowStarted: "Chờ duyệt trả",
      ReturnSubmitted: "Đã nộp yêu cầu trả",
      ReturnRejected: "Từ chối trả",
      Returned: "Đã trả vật tư",
    },
    assetSubtitle: "Đăng ký mượn, trả tài sản nội bộ và theo dõi phê duyệt.",
  },
  crmTrash: {
    title: "Thùng rác dữ liệu CRM",
    help: "Dữ liệu trong thùng rác không xuất hiện ở danh sách hoạt động và vẫn giữ nguyên lịch sử liên quan.",
    moveTitle: "Chuyển {code} vào thùng rác",
    move: "Chuyển vào thùng rác",
    moveHelp: "Có thể khôi phục dữ liệu tại màn hình Thùng rác CRM.",
    reason: "Lý do xoá",
    reasonPlaceholder: "Nhập lý do để phục vụ kiểm tra và truy vết",
    previousStatus: "Trạng thái trước khi xoá",
    deletedAt: "Thời điểm xoá",
    restore: "Khôi phục",
    empty: "Thùng rác không có dữ liệu.",
    open: "Mở thùng rác",
    types: {
      customers: "Khách hàng",
      partners: "Đối tác",
      suppliers: "Nhà cung cấp",
      materials: "Vật tư",
      products: "Sản phẩm",
    },
  },
  documentTemplates: {
    categories: { quotation: "Báo giá", contract: "Hợp đồng", rfq: "Yêu cầu báo giá nhà cung cấp", "purchase-order": "Đơn đặt hàng nhà cung cấp" },
    name: "Tên mẫu",
    code: "Mã mẫu",
    codeHint: "VD: HD-NMI (cùng mã = phiên bản mới)",
    version: "Phiên bản",
    layout: "Bố cục",
    affiliation: "Pháp nhân",
    allAffiliations: "Mọi pháp nhân",
    default: "Mặc định",
    activatedAt: "Ngày áp dụng",
    format: "Định dạng",
    notes: "Ghi chú",
    system: "Mẫu hệ thống",
    systemHint: "Mẫu hệ thống chỉ đọc. Tải về, sửa rồi tải lên thành mẫu riêng của công ty.",
    statuses: { Draft: "Nháp", Active: "Đang dùng", Retired: "Ngừng dùng" },
    upload: "Tải mẫu lên",
    uploadFromSystem: "Tải bản sửa của mẫu này",
    newVersion: "Tải phiên bản mới",
    file: "Tệp mẫu (.{extension}, tối đa 5 MB)",
    saveDraft: "Lưu thành bản nháp",
    uploaded: "Đã tải lên phiên bản v{version} (nháp). Kiểm tra bằng Xem trước rồi Kích hoạt.",
    saved: "Đã lưu thông tin mẫu.",
    download: "Tải mẫu",
    preview: "Xem trước",
    previewPdf: "Xem trước PDF",
    activate: "Kích hoạt",
    activated: "Đã kích hoạt. Phiên bản cũ cùng mã chuyển sang Ngừng dùng.",
    makeDefault: "Đặt làm mặc định",
    defaultSet: "Đã đặt làm mẫu mặc định.",
    retire: "Ngừng dùng",
    retireConfirm: "Ngừng dùng mẫu này? Chứng từ xuất sau đó sẽ dùng mẫu mặc định khác.",
    retired: "Đã ngừng dùng mẫu.",
    info: "Thông tin",
    versions: "Phiên bản",
    fields: "Trường dữ liệu",
    fieldsHint: "Bấm vào trường để chép, rồi dán vào ô Excel hoặc đoạn Word. Trường bắt đầu bằng lines. đặt ở dòng mẫu của bảng hàng.",
    field: "Trường",
    meaning: "Ý nghĩa",
    sample: "Ví dụ",
    copy: "Chép trường",
    copied: "Đã chép {key}",
    lineField: "dòng hàng",
    guide: "Hướng dẫn",
    guideSteps: {
      download: "Tải mẫu đang dùng về máy (nút Tải mẫu).",
      edit: "Sửa bố cục, logo, chữ, điều khoản trong tệp .{extension}. Chèn trường dữ liệu dạng {example} vào chỗ cần điền.",
      linesExcel: "Bảng hàng: đặt các trường lines. trên một dòng mẫu, ví dụ {example}. Hệ thống nhân dòng theo số dòng hàng; công thức trong dòng và tổng phía dưới tự giãn.",
      linesWord: "Bảng hàng: đặt các trường lines. trên một hàng của bảng Word, ví dụ {example}. Hệ thống lặp hàng đó cho từng dòng hàng.",
      upload: "Tải tệp lên: hệ thống kiểm tra trường sai/thiếu trước khi lưu thành bản nháp.",
      activate: "Xem trước bằng dữ liệu mẫu, Kích hoạt, rồi Đặt làm mặc định cho pháp nhân.",
    },
    validationOk: "Mẫu hợp lệ · {count} trường dữ liệu.",
    validationFailed: "Mẫu chưa hợp lệ, sửa các lỗi sau rồi tải lại:",
    quotationRows: "Mẫu báo giá: dòng chứa {leaf} là dòng mẫu thường, {group} là dòng nhóm (1), {child} là dòng con (1.1); dòng chứa {footer} là đầu phần tổng. Công thức tính giá do hệ thống ghi theo cột của trường, sửa bố cục, chữ, logo, vị trí trường tuỳ ý.",
  },
  quotations: {
    new: "Tạo báo giá",
    issue: "Phát hành báo giá",
    notFoundInList: "Không tìm thấy báo giá trong danh sách; hãy lọc theo dự án của báo giá.",
    pickProjectToImport: "Chọn dự án ở bộ lọc để nhập báo giá từ file Form.",
    unsaved: "Có thay đổi chưa lưu",
    discard: "Hoàn tác thay đổi",
    importForm: {
      button: "Nhập từ file Form",
      title: "Nhập báo giá từ file Form1/Form2/Form3",
      chooseFile: "Chọn file .xlsx (tối đa 5 MB)",
      preview: "Xem trước",
      commit: "Tạo revision nháp",
      detected: "Nhận dạng: {form} · pháp nhân {affiliation}",
      targetNew: "Sẽ tạo báo giá mới {number} rev {revision}",
      targetRevision: "Sẽ tạo revision nháp {number} rev {revision}; các bản đã có giữ nguyên",
      number: "Số báo giá / Rev",
      date: "Ngày",
      customer: "Khách hàng",
      pic: "Người liên hệ",
      endUser: "End User",
      rate: "Tỷ giá VND/USD",
      discount: "Chiết khấu",
      validity: "Hiệu lực (ngày)",
      total: "Tổng (A)",
      grandTotal: "Tổng thanh toán",
      rowRef: "Dòng {row}",
      errors: "Lỗi chặn ({count})",
      warnings: "Cảnh báo ({count})",
      noIssues: "Không có cảnh báo; số Excel khớp hệ thống.",
      columns: {
        row: "Dòng Excel",
        no: "STT",
        description: "Mô tả",
        quantity: "SL",
        unit: "ĐVT",
        excelPrice: "Đơn giá Excel",
        systemPrice: "Đơn giá hệ thống",
        subtotal: "Thành tiền",
        difference: "Chênh lệch",
      },
      file: {
        required: "Chọn file .xlsx.",
        type: "Chỉ nhận file .xlsx.",
        size: "File vượt quá 5 MB.",
      },
      issues: {
        ref_error: "Ô lỗi #REF!",
        excel_engine_mismatch: "Lệch số Excel và hệ thống > 1 đ",
        excel_total_mismatch: "Tổng thanh toán khác biểu mẫu gốc (Q10)",
        missing_exchange_rate: "Thiếu tỷ giá",
        missing_quantity: "Dòng thiếu số lượng",
        quote_number_differs: "Số báo giá trong file khác hệ thống",
        import_without_cost: "Không có quyền xem giá vốn",
        affiliation_unknown: "Không nhận ra pháp nhân",
        line_description_missing: "Dòng thiếu mô tả",
        line_number_missing: "Dòng thiếu STT",
        orphan_child_line: "Dòng con không có dòng cha",
        line_invalid: "Dòng không hợp lệ",
        line_price_missing: "Dòng thiếu đơn giá",
        unknown_quotation_form: "Không nhận dạng được Form",
        quote_sheet_missing: "Thiếu sheet QUOTE",
        quote_footer_missing: "Thiếu dòng Subtotal (A)",
        invalid_workbook: "File không đọc được",
        quotation_import_empty: "Không có dòng báo giá",
        quotation_import_too_many_lines: "Quá 200 dòng",
        quotation_import_invalid: "Dữ liệu báo giá không hợp lệ",
      },
    },
    quantity: "Số lượng",
    unitOfMeasure: "Đơn vị",
    unitSellingPrice: "Đơn giá bán",
    calculatedPrice: "Theo chi phí và lợi nhuận",
    saveForPrice: "Lưu để cập nhật giá",
    discountPercent: "Chiết khấu (%)",
    vatPercent: "VAT (%)",
    addProduct: "Lấy sản phẩm từ danh mục",
    sourceRevision: "Phiên bản nguồn",
    sourceCurrencyMismatch:
      "Phiên bản phải có giá nhập và cùng loại tiền với báo giá.",
    commercialOutcome: "Kết quả thương mại",
    outcomes: {
      None: "Chưa gửi khách",
      Sent: "Đã gửi khách",
      Accepted: "Khách chấp nhận",
      Rejected: "Khách từ chối",
      Expired: "Hết hiệu lực",
    },

    title: "Báo giá dự án",
    project: "Dự án",
    number: "Mã dự án",
    revision: "Số Rev",
    currency: "Đơn vị tiền tệ",
    installationMandays: "Số Manday lắp đặt",
    travelMode: "Hình thức công tác",
    travelerCount: "Số lượng người công tác",
    content: "Nội dung báo giá",
    addLine: "Thêm dòng",
    history: "Lịch sử báo giá",
    classification: "Phân loại",
    costBreakdown: "Chi tiết cấu thành giá",
    totalCost: "Tổng giá vốn",
    totalPrice: "Giá bán đầu ra",
    inputPrice: "Giá đầu vào",
    customsCost: "Chi phí khai báo hải quan",
    transportCost: "Chi phí vận tải",
    packagingCost: "Chi phí đóng gói",
    managementCost: "Chi phí quản lý",
    surveyCost: "Chi phí khảo sát",
    solutionReportCost: "Chi phí báo cáo giải pháp",
    demoCost: "Chi phí demo",
    travelCost: "Chi phí công tác",
    hotelCost: "Chi phí khách sạn",
    mealCost: "Chi phí ăn uống",
    movementCost: "Chi phí di chuyển",
    overtimeCost: "Chi phí tăng ca",
    personnelCost: "Chi phí nhân sự",
    installationCost: "Chi phí cài đặt & hướng dẫn",
    maintenanceCost: "Chi phí bảo trì",
    commissionCost: "Chi phí COM",
    commissionTax: "TAX của COM",
    profitPercent: "Phần trăm lợi nhuận",
    exportTemplate: "Mẫu xuất",
    exportAudience: "Đối tượng nhận",
    audienceCustomer: "Khách hàng",
    audienceInternal: "Nội bộ",
    exportExcel: "Xuất Excel",
    exportPdf: "Xuất PDF",
    exportCsv: "Xuất CSV",
    exportFailed: "Không xuất được file báo giá.",
    deliveryTerms: "Điều khoản giao hàng",
    paymentTerms: "Điều khoản thanh toán",
    warrantyTerms: "Điều khoản bảo hành",
    validUntil: "Hiệu lực đến",
    cloneRevision: "Nhân bản Revision",
    pricingModel: "Cách tính giá",
    pricingModels: {
      Legacy: "Cũ: cộng lãi trên giá vốn (OP1–OP3)",
      NmiSheet: "Biểu mẫu NMI: biên lãi trên giá bán",
    },
    template: "Biểu mẫu",
    forms: {
      Form1: "OP1 · Dự án/dịch vụ",
      Form2: "OP3 · Hàng hoá",
      Form3: "NMIT · Giải pháp",
      OP1: "Mẫu giá vốn 1 (cũ)",
      OP2: "Mẫu giá vốn 2 (cũ)",
      OP3: "Mẫu giá vốn 3 (cũ)",
    },
    formLayouts: {
      Form1: "Pháp nhân NMI · nhóm 1 → 1.1",
      Form2: "Pháp nhân NMI · danh sách phẳng",
      Form3: "Pháp nhân NMIT · nhóm 1 → 1.1",
    },
    formDescriptions: {
      Form1: "Dự án/dịch vụ: nhóm 1, 1.1…; dòng nhóm cộng dồn dòng con; có khối \"Phạm vi không bao gồm\".",
      Form2: "Bán hàng hoá: danh sách phẳng 1, 2, 3…; dòng nhóm (nếu có) vẫn giữ và in thành dòng cộng dồn.",
      Form3: "Giải pháp (phần mềm + thiết bị): nhóm 1, 1.1…; header pháp nhân NMIT.",
      OP1: "Mẫu xuất cũ cho báo giá tính theo giá vốn.",
      OP2: "Mẫu xuất cũ có cột mã hàng.",
      OP3: "Mẫu xuất cũ có cột phân loại.",
    },
    sheet: {
      internalColumns: "Cột tính giá",
      addGroup: "Thêm nhóm",
      addChild: "Thêm dòng con",
      indent: "Đưa vào nhóm trên",
      outdent: "Đưa ra khỏi nhóm",
      moveUp: "Lên trên",
      moveDown: "Xuống dưới",
      applyToGroup: "Áp tham số giá cho cả nhóm",
      applyToAll: "Áp tham số giá cho các dòng cấp 1",
      pricingApplied: "Đã chép tham số giá sang {count} dòng.",
      removeGroup: "Xóa nhóm và dòng con",
      flatWithGroups: "OP3 là danh sách phẳng: các nhóm đang có vẫn được giữ và in thành dòng cộng dồn.",
      bandQuote: "I. Báo giá",
      bandInput: "Đầu vào (Input)",
      bandOutput: "Giá bán (Output Price)",
      no: "STT",
      description: "Mô tả hạng mục",
      unitPrice: "Đơn giá ({currency})",
      subtotal: "Thành tiền ({currency})",
      fromManday: "= manday × số ngày",
      usdTimesRate: "= USD × tỷ giá của báo giá",
      subtotalA: "Cộng (A)",
      addProductGroup: "Thêm nhóm theo thành phần",
      productComponents: "Tạo 1 dòng nhóm và {count} dòng con theo thành phần sản phẩm.",
      productSingle: "Sản phẩm không có thành phần: tạo một dòng với giá vào của phiên bản.",
    },
    nmi: {
      header: "Thông tin biểu mẫu",
      pricing: "Tính giá nội bộ",
      summary: "Tổng hợp theo nhóm",
      affiliation: "Trực thuộc",
      exchangeRate: "Tỷ giá VND/USD",
      corporateTaxPercent: "Thuế TNDN (%)",
      validityDays: "Hiệu lực (ngày)",
      discountPercent: "Chiết khấu đầu phiếu (%)",
      customerPic: "Người liên hệ (PIC)",
      customerEmail: "Email liên hệ",
      customerPhone: "Điện thoại liên hệ",
      endUser: "Khách hàng cuối (EU)",
      endUserPlaceholder: "Chọn khách hàng từ danh mục (gõ mã hoặc tên)",
      scopeExclusions: "Phạm vi không bao gồm",
      detailText: "II. Nội dung chi tiết (không xuất hoá đơn)",
      signPlace: "Nơi ký",
      signDate: "Ngày ký",
      parentLine: "Thuộc nhóm",
      topLevel: "— Hạng mục cấp 1 —",
      groupLine: "Dòng nhóm: đơn giá bằng tổng thành tiền các dòng con.",
      maker: "Hãng",
      leadtime: "Thời gian giao",
      mandayUnitPrice: "Đơn giá manday (VND)",
      mandayUnitPriceUsd: "Đơn giá manday (USD)",
      mandayQuantity: "Số manday",
      inputNetPriceVnd: "Giá NET nhập (VND)",
      inputNetHint: "Bỏ trống thì lấy đơn giá manday × số manday.",
      fobPercent: "FOB (%)",
      importTaxPercent: "Thuế nhập khẩu (%)",
      cifPercent: "CIF (%)",
      swiftFeeUsd: "Phí SWIFT (USD)",
      marginPercent: "Biên lãi trên giá bán (%)",
      endUserCommissionPercent: "HH End User (%)",
      endUserTaxPercent: "Thuế EU trên HH (%)",
      inPriceVatPercent: "VAT trong giá (%)",
      contingencyPercent: "Phí phát sinh (%)",
      acquisitionVnd: "Chi phí mua (VND)",
      unitPrice: "Đơn giá (6)",
      salesPrice: "Giá bán (11)",
      customerUnitPrice: "Đơn giá báo khách",
      subtotal: "Thành tiền",
      vatAmount: "VAT",
      grossProfit: "Lãi gộp",
      corporateTax: "Thuế TNDN",
      netProfit: "Lãi ròng",
      total: "Tổng",
      discount: "Chiết khấu",
      amount: "Sau chiết khấu",
      vat: "VAT (sau chiết khấu)",
      grandTotal: "Tổng thanh toán",
      acquisitionTotal: "Tổng chi phí mua",
      group: "Nhóm",
      description: "Nội dung",
      share: "Tỷ trọng",
    },
    sections: {
      overview: "Tổng quan báo giá",
      materials: "Vật tư & logistics",
      services: "Dịch vụ & nhân sự",
      delivery: "Công tác & thương mại",
    },
  },
  account: {
    profileSection: "Thông tin tài khoản",
    passwordSection: "Đổi mật khẩu",
    profileHint:
      "Họ tên, tên đăng nhập và email do bạn tự quản lý. Mã nhân viên, phòng ban, chức danh và vai trò được đồng bộ từ hồ sơ nhân sự.",
    fullName: "Họ và tên",
    userName: "Tên đăng nhập",
    email: "Email",
    accountState: "Trạng thái tài khoản",
    employeeCode: "Mã nhân viên",
    department: "Phòng ban",
    position: "Chức danh",
    employmentStatus: "Tình trạng lao động",
    roles: "Vai trò",
    currentPassword: "Mật khẩu hiện tại",
    newPassword: "Mật khẩu mới",
    confirmPassword: "Nhập lại mật khẩu mới",
    changePassword: "Đổi mật khẩu",
    passwordHint:
      "Mật khẩu mới cần tối thiểu {min} ký tự. Sau khi đổi, mọi phiên đăng nhập bị thu hồi và bạn phải đăng nhập lại.",
    passwordTooShort: "Mật khẩu mới cần tối thiểu {min} ký tự.",
    passwordMismatch: "Hai lần nhập mật khẩu mới không khớp.",
    passwordReused: "Mật khẩu mới phải khác mật khẩu hiện tại.",
    currentPasswordWrong: "Mật khẩu hiện tại không đúng.",
    duplicate: "Tên đăng nhập hoặc email đã có người dùng.",
    validationFailed: "Dữ liệu nhập chưa hợp lệ.",
    profileSaved: "Đã cập nhật thông tin tài khoản.",
    passwordChanged: "Đã đổi mật khẩu. Vui lòng đăng nhập lại.",
    loadFailed: "Không tải được thông tin tài khoản.",
    saveFailed: "Không lưu được thông tin tài khoản.",
    passwordFailed: "Không đổi được mật khẩu.",
    profileInvalidBeforePassword:
      "Hãy điền đủ họ tên, tên đăng nhập và email trước khi đổi mật khẩu.",
    pendingProfileNotice:
      "Thông tin tài khoản đang sửa sẽ được lưu trước khi đổi mật khẩu.",
    profileAndPasswordChanged:
      "Đã lưu thông tin tài khoản và đổi mật khẩu. Vui lòng đăng nhập lại.",
    unsavedConfirm:
      "Thông tin tài khoản chưa lưu sẽ bị mất. Vẫn rời khỏi trang?",
    changeAvatar: "Đổi ảnh đại diện",
    chooseImage: "Chọn ảnh",
    chooseAnotherImage: "Chọn ảnh khác",
    notificationSection: "Cài đặt thông báo",
    channelWebTitle: "Thông báo trên trình duyệt & máy tính",
    channelWebDesc: "Nhận thông báo chuông tức thì trên hệ thống và hiển thị thông báo đẩy trên màn hình máy tính.",
    channelEmailTitle: "Thông báo qua Email",
    channelEmailDesc: "Gửi thông báo cập nhật công việc và phê duyệt đến",
    emailSyncActive: "Đã liên kết email",
    testNotification: "Gửi thử",
    testNotificationBody: "Đây là thông báo thử nghiệm từ hệ thống Q ONE CRM PM.",
    testNotificationSent: "Đã gửi thông báo thử nghiệm lên màn hình.",
    tabProfile: "Hồ sơ",
    tabSecurity: "Bảo mật",
    tabNotifications: "Thông báo",
    tabConnections: "Ứng dụng kết nối",
    personalInfo: "Thông tin cá nhân",
    employmentInfo: "Thông tin nhân sự",
    employmentHint: "Đồng bộ từ hồ sơ nhân sự; liên hệ HCNS nếu cần thay đổi.",
    readOnly: "Chỉ xem",
    uploadAvatar: "Tải ảnh lên",
    avatarHint: "Ảnh vuông, tối thiểu 256×256 px. Ảnh được lưu khi bấm Lưu.",
    unsavedBar: "Bạn có thay đổi chưa lưu.",
    discard: "Hủy thay đổi",
    notificationHint: "Chọn kênh nhận thông báo về công việc, phê duyệt và cập nhật dự án.",
    showPassword: "Hiện mật khẩu",
    hidePassword: "Ẩn mật khẩu",
    passwordRequirements: "Yêu cầu mật khẩu",
    reqLength: "Tối thiểu {min} ký tự",
    reqMixedCase: "Có chữ hoa và chữ thường",
    reqDigit: "Có chữ số",
    reqSymbol: "Có ký tự đặc biệt",
    reqDifferent: "Khác mật khẩu hiện tại",
    reqMatch: "Hai lần nhập khớp nhau",
    strengthLabel: "Độ mạnh",
    strength: {
      weak: "Yếu",
      fair: "Trung bình",
      good: "Khá",
      strong: "Mạnh",
    },
    sessionNotice: "Sau khi đổi mật khẩu, mọi thiết bị sẽ bị đăng xuất.",
    connectionsTitle: "Lịch liên kết",
    connectionsHint: "Kết nối Google Calendar hoặc Microsoft 365 để đồng bộ hai chiều sự kiện và tạo link họp Meet/Teams.",
    openCalendar: "Mở Lịch",
    providers: {
      google: "Google Calendar",
      microsoft: "Microsoft 365 / Outlook",
    },
    providerUnavailable: "Quản trị viên chưa cấu hình ứng dụng",
    notConnected: "Chưa kết nối tài khoản nào.",
    lastSync: "Đồng bộ lần cuối: {at}",
    connect: "Kết nối",
    connectAnother: "Thêm tài khoản",
    disconnect: "Ngắt kết nối",
    disconnectConfirm: "Ngắt kết nối {account}? Sự kiện đã đồng bộ trên lịch ngoài vẫn được giữ.",
  },
  notificationEmail: {
    title: "Thông báo qua email",
    hint: "Mọi thông báo của bạn đều được gửi kèm email (có nút mở thẳng tới hồ sơ). Bạn có thể tắt chung hoặc theo từng loại.",
    all: "Gửi email cho thông báo",
    type: "Loại thông báo",
    inApp: "Nhận thông báo",
    email: "Gửi email",
    received: "Đã nhận (180 ngày)",
    empty: "Bạn chưa nhận thông báo nào; các loại sẽ hiện ở đây khi có.",
    cadence: "Nhịp gửi email",
    cadenceHint: "Gửi ngay từng thư, hoặc gộp thành thư tổng hợp mỗi giờ/hằng ngày. Lời mời lịch luôn gửi ngay.",
    cadenceDefault: "Theo mặc định hệ thống ({value})",
    cadenceImmediate: "Gửi ngay",
    cadenceHourly: "Thư tổng hợp mỗi giờ",
    cadenceDaily: "Thư tổng hợp hằng ngày",
    types: {
      CalendarInvitation: "Lời mời sự kiện",
      CalendarEventUpdated: "Sự kiện thay đổi",
      CalendarEventCancelled: "Sự kiện bị huỷ",
      CalendarResponse: "Khách trả lời lời mời",
      CalendarReminder: "Nhắc lịch",
      CalendarTaskDue: "Việc đến hạn",
      CalendarShared: "Lịch được chia sẻ",
      BusinessDeadline: "Hạn nghiệp vụ",
      CustomerFollowUpDue: "Hẹn chăm sóc khách hàng đến hạn",
      CustomerFollowUpOverdue: "Hẹn chăm sóc khách hàng quá hạn",
      WorkflowStepAssigned: "Việc chờ duyệt mới",
      WorkflowTaskOverdue: "Việc chờ duyệt quá hạn",
      WorkflowTaskEscalated: "Việc chờ duyệt được chuyển cấp",
    },
  },
  calendar: {
    mine: "{name} (tôi)",
    someone: "Người khác",
    eventsError: "Không tải được sự kiện của lịch. Thử tải lại trang; nếu vẫn lỗi hãy báo quản trị viên.",
    ownedBy: "{name} (của {owner})",
    primaryOf: "Lịch của {name}",
    changeColor: "Đổi màu",
    title: "Lịch",
    tabs: {
      calendar: "Lịch",
      yearSettings: "Cài đặt lịch năm",
    },
    today: "Hôm nay",
    prev: "Trước",
    next: "Sau",
    create: "Tạo",
    createEvent: "Sự kiện",
    createTask: "Việc cần làm",
    views: {
      day: "Ngày",
      week: "Tuần",
      month: "Tháng",
      year: "Năm",
      schedule: "Lịch biểu",
      "4days": "4 ngày",
    },
    searchPlaceholder: "Tìm sự kiện",
    searchEmpty: "Không tìm thấy sự kiện",
    toggleSidebar: "Ẩn/hiện menu lịch",
    options: "Tuỳ chọn",
    myCalendars: "Lịch của tôi",
    otherCalendars: "Lịch khác",
    otherHint: "Gõ tên đồng nghiệp ở ô “Gặp gỡ với...” để xem lịch rảnh/bận của họ.",
    systemLayers: "Dữ liệu hệ thống",
    meetWith: "Gặp gỡ với...",
    newCalendar: "Tạo lịch mới",
    calendarSettings: "Cài đặt và chia sẻ",
    calendarName: "Tên lịch",
    calendarDescription: "Mô tả",
    color: "Màu",
    share: "Chia sẻ",
    shareWith: "Chia sẻ với người cụ thể",
    chooseUser: "Chọn người",
    exportIcs: "Xuất tệp .ics",
    deleteCalendar: "Xoá lịch",
    deleteCalendarConfirm: "Xoá lịch “{name}”? Các sự kiện trong lịch sẽ không còn hiển thị.",
    removeOther: "Bỏ khỏi danh sách",
    onlyThis: "Chỉ hiển thị lịch này",
    openSource: "Mở trang gốc",
    access: {
      None: "Bỏ chia sẻ",
      FreeBusy: "Chỉ xem rảnh/bận",
      ReadDetails: "Xem mọi chi tiết sự kiện",
      Edit: "Thay đổi sự kiện",
      Manage: "Thay đổi và quản lý chia sẻ",
      Owner: "Chủ sở hữu",
    },
    layers: {
      holidays: "Ngày lễ / nghỉ công ty",
      leave: "Nghỉ phép",
      trip: "Công tác",
      onsite: "Onsite",
      overtime: "Tăng ca",
      vehicle: "Xe công ty",
      wbs: "Đầu việc WBS",
      warranty: "Phiếu bảo hành",
      followUp: "Hẹn chăm sóc khách hàng",
      approvals: "Việc chờ tôi duyệt",
      deadlines: "Hạn nghiệp vụ",
      tasks: "Việc cá nhân",
    },
    dayTypes: {
      HOLIDAY: "Ngày lễ",
      OFF: "Ngày nghỉ công ty",
    },
    busyKind: {
      event: "Có sự kiện",
      leave: "Nghỉ phép",
      trip: "Công tác",
      onsite: "Onsite",
    },
    pending: "chờ duyệt",
    busy: "Bận",
    noTitle: "(Không có tiêu đề)",
    allDay: "Cả ngày",
    noEvents: "Không có sự kiện nào",
    layerError: "Một số dữ liệu hệ thống tạm thời không tải được; lịch vẫn hiển thị phần còn lại.",
    event: {
      addMeet: "Thêm Google Meet",
      addTeams: "Thêm Microsoft Teams",
      meetPending: "Liên kết Google Meet sẽ được tạo khi lưu.",
      teamsPending: "Liên kết Microsoft Teams sẽ được tạo khi lưu.",
      new: "Sự kiện mới",
      edit: "Sửa sự kiện",
      titlePlaceholder: "Thêm tiêu đề",
      save: "Lưu",
      moreOptions: "Tuỳ chọn khác",
      details: "Chi tiết sự kiện",
      findTime: "Tìm thời gian",
      findTimeHint: "Khung xám là thời gian bận; bấm vào giờ để chọn.",
      location: "Thêm vị trí",
      meetingUrl: "Dán liên kết họp (Teams, Zoom, Meet...)",
      description: "Thêm mô tả",
      busy: "Bận",
      free: "Rảnh",
      visibilityDefault: "Chế độ hiển thị mặc định",
      visibilityPublic: "Công khai",
      visibilityPrivate: "Riêng tư",
      calendarColor: "Màu của lịch",
      reminderNotification: "Thông báo",
      reminderEmail: "Email",
      minutes: "phút",
      hours: "giờ",
      days: "ngày",
      weeks: "tuần",
      before: "trước",
      addReminder: "Thêm thông báo",
      removeReminder: "Xoá thông báo",
      reminderShort: "Trước {n} phút",
      guests: "Khách",
      addGuests: "Thêm khách (tên hoặc email)",
      inviteEmail: "Mời {email}",
      organizer: "Người tổ chức",
      optional: "Không bắt buộc",
      markOptional: "Đánh dấu không bắt buộc",
      removeGuest: "Xoá khách",
      autoDeclined: "Tự từ chối do nghỉ phép",
      guestPermissions: "Quyền của khách",
      canModify: "Sửa sự kiện",
      canInvite: "Mời người khác",
      canSeeGuests: "Xem danh sách khách",
      me: "Tôi",
      invalidRange: "Thời điểm kết thúc phải sau thời điểm bắt đầu.",
      delete: "Xoá sự kiện",
      duplicate: "Nhân bản",
      joinMeeting: "Tham gia cuộc họp",
      copyLink: "Sao chép liên kết",
      copied: "Đã sao chép",
      guestSummary: "{n} khách · {yes} có, {no} không, {pending} chờ phản hồi",
      going: "Tham gia?",
      saved: "Đã lưu sự kiện",
      moved: "Đã cập nhật sự kiện",
      deleted: "Đã xoá sự kiện",
      undo: "Hoàn tác",
    },
    rsvp: {
      Accepted: "Có",
      Declined: "Không",
      Tentative: "Có thể",
    },
    response: {
      NeedsAction: "Chờ phản hồi",
      Accepted: "Đồng ý",
      Declined: "Từ chối",
      Tentative: "Có thể",
    },
    recurrence: {
      none: "Không lặp lại",
      daily: "Hằng ngày",
      weekly: "Hằng tuần vào {day}",
      monthlyNth: "Hằng tháng vào {day} tuần thứ {n}",
      monthlyLast: "Hằng tháng vào {day} cuối cùng",
      yearly: "Hằng năm vào ngày {date}",
      weekdays: "Mọi ngày trong tuần (thứ Hai đến thứ Sáu)",
      custom: "Tuỳ chỉnh...",
      repeatEvery: "Lặp lại mỗi",
      ends: "Kết thúc",
      never: "Không bao giờ",
      onDate: "Vào ngày",
      after: "Sau",
      occurrences: "lần xuất hiện",
      monthlyOnDay: "Hằng tháng vào ngày {day}",
      every: "Mỗi {n} {unit}",
      on: "vào {days}",
      onDay: "vào ngày {day}",
      times: "{n} lần",
      until: "đến {date}",
      nthWeekday: "{day} tuần thứ {n}",
      lastWeekday: "{day} cuối cùng",
      base: {
        DAILY: "Hằng ngày",
        WEEKLY: "Hằng tuần",
        MONTHLY: "Hằng tháng",
        YEARLY: "Hằng năm",
      },
      unit: {
        DAILY: "ngày",
        WEEKLY: "tuần",
        MONTHLY: "tháng",
        YEARLY: "năm",
      },
      unitName: {
        DAILY: "ngày",
        WEEKLY: "tuần",
        MONTHLY: "tháng",
        YEARLY: "năm",
      },
    },
    scope: {
      title: {
        edit: "Sửa sự kiện định kỳ",
        move: "Đổi giờ sự kiện định kỳ",
        delete: "Xoá sự kiện định kỳ",
        create: "Sự kiện định kỳ",
      },
      This: "Sự kiện này",
      Following: "Sự kiện này và các sự kiện tiếp theo",
      All: "Tất cả sự kiện",
      notifyTitle: "Gửi thông báo cho khách?",
      notifyGuests: "Gửi thông báo cập nhật cho khách",
      ok: "OK",
    },
    days: {
      SU: "Chủ Nhật",
      MO: "Thứ Hai",
      TU: "Thứ Ba",
      WE: "Thứ Tư",
      TH: "Thứ Năm",
      FR: "Thứ Sáu",
      SA: "Thứ Bảy",
    },
    daysShort: {
      SU: "CN",
      MO: "T2",
      TU: "T3",
      WE: "T4",
      TH: "T5",
      FR: "T6",
      SA: "T7",
    },
    todo: {
      title: "Việc cần làm",
      addPlaceholder: "Thêm việc cần làm (Enter)",
      empty: "Không có việc nào",
      filter: "Lọc theo nguồn",
      filterAll: "Tất cả nguồn",
      showCompleted: "Hiện việc đã xong",
      noDue: "Không có hạn",
      today: "Hôm nay",
      tomorrow: "Ngày mai",
      notes: "Ghi chú",
      deleteTask: "Xoá việc",
      deleted: "Đã xoá việc",
      completed: "Đánh dấu đã xong",
      markDone: "Đánh dấu đã xong",
      reopen: "Đánh dấu chưa xong",
      overdueCount: "{n} quá hạn",
      sources: {
        task: "Việc cá nhân",
        wbs: "WBS",
        warranty: "Bảo hành",
        approval: "Chờ duyệt",
        followUp: "Chăm sóc KH",
        deadline: "Hạn nghiệp vụ",
      },
    },
    settings: {
      title: "Cài đặt lịch",
      general: "Chung",
      defaultView: "Chế độ xem mặc định",
      weekStartsOn: "Tuần bắt đầu vào",
      defaultDuration: "Thời lượng sự kiện mặc định (phút)",
      defaultReminders: "Thông báo mặc định (số phút trước, cách nhau dấu phẩy)",
      hideWeekends: "Ẩn cuối tuần",
      showWeekNumbers: "Hiện số tuần",
      showLunarDates: "Hiện ngày âm lịch",
      showDeclinedEvents: "Hiện sự kiện đã từ chối",
      showPendingRequests: "Hiện phiếu đang chờ duyệt",
      autoDeclineDuringLeave: "Tự từ chối lời mời trong thời gian nghỉ phép đã duyệt",
      shortcuts: "Phím tắt",
      shortcutList: "C tạo sự kiện · T hôm nay · D ngày · W tuần · M tháng · Y năm · A lịch biểu · X 4 ngày · J/N sau · K/P trước · / tìm kiếm · Esc đóng",
    },
    external: {
      title: "Lịch Google / Outlook",
      hint: "Kết nối tài khoản Google để xem mọi lịch của bạn (kể cả lịch được chia sẻ) ngay trên CRM.",
      filter: "Nguồn lịch",
      source: { all: "Tất cả", crm: "CRM", external: "Lịch ngoài" },
      syncedIntoCrm: "Lịch chính của tài khoản ghi đã đồng bộ hai chiều vào lịch CRM.",
      readOnly: "Chỉ xem: sửa sự kiện này trên Google.",
      openInGoogle: "Mở trên Google",
    },
    connections: {
      addAccount: "Thêm tài khoản",
      writeTarget: "Ghi CRM",
      writeTargetHint: "Sự kiện CRM đồng bộ hai chiều với lịch chính của tài khoản này.",
      setWriteTarget: "Đặt làm tài khoản ghi",
      calendarsCount: "{n} lịch",
      title: "Kết nối",
      hint: "Kết nối tài khoản Google hoặc Outlook để đồng bộ hai chiều với lịch chính QOne (5 phút một lần) và tạo liên kết Google Meet / Microsoft Teams. Nghỉ phép, công tác, WBS… không đẩy ra ngoài.",
      Google: "Google Calendar",
      Microsoft: "Outlook / Microsoft 365",
      notConfigured: "Quản trị viên chưa cấu hình kết nối này.",
      notConnected: "Chưa kết nối",
      lastSync: "đồng bộ lần cuối",
      syncNow: "Đồng bộ ngay",
      connect: "Kết nối",
      reconnect: "Kết nối lại",
      disconnect: "Ngắt kết nối",
      status: {
        Active: "Đang hoạt động",
        Error: "Lỗi đồng bộ",
        Revoked: "Cần kết nối lại",
      },
      result: {
        connected: "Đã kết nối tài khoản lịch.",
        cancelled: "Bạn đã huỷ kết nối.",
        failed: "Kết nối không thành công, vui lòng thử lại.",
      },
    },
    trash: {
      title: "Thùng rác",
      hint: "Sự kiện đã xoá được giữ 30 ngày.",
      empty: "Thùng rác trống",
      restore: "Khôi phục",
      purge: "Xoá vĩnh viễn",
      deletedAt: "xoá lúc",
    },
  },
  workCalendar: {
    title: "Lịch làm việc & năng lực",
    employee: "Nhân viên",
    minutes: "phút khả dụng",
    saved: "Đã lưu lịch làm việc.",
    year: "Năm",
    calendar: "Lịch",
    selectionHelp:
      "Chọn một hoặc nhiều ngày, sau đó đặt dung lượng khả dụng (phút):",
    selectedCount: "Đã chọn {count} ngày",
    applySelected: "Áp dụng",
    companyMode: "Lịch chung công ty",
    individualMode: "Lịch cá nhân",
    companyBadge: "Lịch Công ty",
    readOnlyNotice: "Bạn đang xem ở chế độ chỉ đọc.",
    nextYearPlanning:
      "Kèm {count} tháng đầu năm {year} để lập kế hoạch vắt qua năm.",
    nextYearLocked:
      "Lịch năm {year} đã chốt duyệt nên các tháng năm sau chỉ để xem.",
    batchSaveSuccess: "Đã lưu lịch công ty thành công",
    working: "Ngày làm việc",
    weekend: "Cuối tuần",
    holiday: "Nghỉ lễ",
    off: "Nghỉ không lương",
    clearSelection: "Bỏ chọn",
    setWeekendOff: "Đặt T7/CN = 0",
    resetDefault: "Đặt lại 480 phút (8 giờ)",
    unsavedChanges: "Bạn có thay đổi chưa lưu. Bạn có chắc muốn rời trang?",
    unsaved: "Chưa lưu",
    loadFailed: "Không tải được lịch làm việc.",
    saveFailed: "Không lưu được lịch làm việc.",
    totalDays: "Tổng số ngày",
    totalWorkingDays: "Ngày làm việc",
    totalHours: "Tổng giờ",
    capacityFull: "Đầy đủ (480 phút / 8 giờ)",
    capacityOff: "Nghỉ (0 phút)",
    capacityCustom: "Tùy chỉnh",
    bulkMinutes: "Số phút",
    documentNumber: "Số tài liệu",
    revision: "Số Rev",
    headerSaved: "Đã lưu thông tin kiểm soát lịch năm.",
    headerAudit: "Dấu vết phê duyệt lịch năm",
    revisionHistory: "Lịch sử revision ({count})",
    reviewOnly:
      "Bạn đang ở chế độ duyệt thông tin kiểm soát lịch năm; dữ liệu ngày cần quyền Capacity.Read.",
    audit: {
      submitted: "Gửi duyệt",
      confirmed: "Xác nhận",
      approved: "Phê duyệt",
    },
    weekdays: {
      mon: "T2",
      tue: "T3",
      wed: "T4",
      thu: "T5",
      fri: "T6",
      sat: "T7",
      sun: "CN",
    },
    customized: "Tùy chỉnh",
    minutesLabel: "Số phút:",
    syncCompanyCalendar: "Đồng bộ lịch công ty",
  },
  costing: {
    newProfile: "Lập cấu hình mới",
    title: "Chi phí gốc & giá 1 Manday",
    effectiveFrom: "Hiệu lực từ",
    staffCount: "Số nhân sự cả công ty",
    workingDays: "Ngày công / tháng",
    costPerManday: "Giá 1 Manday",
    formulaHelp:
      "Tính từ chi phí nhân sự, phúc lợi, chi phí chung và công tác theo từng ngày.",
    history: "Lịch sử cấu hình",
    saved: "Đã lưu. Giá 1 Manday: {value}",
    averageMonthlySalary: "Lương bình quân / tháng",
    driverAllowanceMonthly: "Phụ cấp lái xe / tháng",
    socialInsuranceMonthly: "BHXH / tháng",
    mealCostPerDay: "Ăn ca / ngày",
    annualTravelCost: "Du lịch / năm",
    annualUniformCost: "Đồng phục / năm",
    monthlyOfficeSupplies: "VPP / tháng",
    annualThirteenthMonthBonus: "Thưởng tháng 13 / năm",
    annualCondolenceAllowance: "Trợ cấp khánh điếu / năm",
    annualQuarterlyPartyCost: "Tiệc hàng quý / năm",
    monthlyUtilities: "Điện nước / tháng",
    annualEquipmentCost: "Trang thiết bị / năm",
    annualPerformanceBonus: "Thưởng thái độ & thành tích / năm",
    annualHealthCheckCost: "Khám sức khỏe nhân sự / năm",
    dailyTravelAllowance: "Chi phí công tác / ngày",
    dailyHotelCost: "Chi phí khách sạn / ngày",
    dailyMealAllowance: "Chi phí ăn uống / ngày",
    dailyMovementCost: "Chi phí di chuyển / ngày",
    sections: {
      basis: "Cơ sở tính",
      people: "Chi phí nhân sự",
      annual: "Chi phí năm & vận hành",
      travel: "Chi phí công tác ngày",
    },
  },
  projectRegistration: {
    projectGroup: "Dự án",
    technicalGroup: "Thông tin kỹ thuật",
    technicalInformation: "Thông tin kỹ thuật dự án",
    setupProject: "Thiết lập dự án",
    setupChoiceLabel: "Chọn nội dung thiết lập dự án",
    sales: "Kinh doanh",
    pi: "PI",
    salesDetail: "Chi tiết dự án theo Kinh doanh",
    piDetail: "Chi tiết dự án theo PI",
    projectId: "Mã dự án",
    projectContent: "Nội dung dự án",
    endUser: "Khách hàng (End User)",
    summaryChoiceLabel: "Chọn trạng thái tóm tắt dự án",
    all: "Tất cả",
    cancelled: "Đã hủy",
    registration: "Mới tạo",
    executing: "Đang thực hiện",
    finished: "Đã hoàn thành",
    lifecycleStatus: "Trạng thái vòng đời",
    pendingApproval: "Đang chờ phê duyệt",
    finishedPendingClose: "Hoàn thành · Chờ đóng",
    finishedWithCancelled: "Hoàn thành có hạng mục hủy · Chờ đóng",
    closed: "Đã đóng",
    closedWithCancelled: "Đã đóng · Có hạng mục hủy",
    progressCompleteWithPendingWbs: "100% giai đoạn · Còn công việc chưa hoàn tất",
    pendingList: "Danh sách tóm tắt dự án chờ phê duyệt",
    approvedList: "Danh sách tóm tắt dự án đã phê duyệt",
    addProject: "Thêm dự án",
    selectRow: "Chọn",
    selectProject: "Chọn dự án {code}",
    tabRegistration: "Thông tin chung",
    overviewProject: "Dự án",
    overviewCustomer: "Khách hàng & liên hệ",
    overviewBusiness: "Nội dung & kinh doanh",
    overviewAudit: "Theo dõi",
    tabDocuments: "Tài liệu",
  },
  piRegistration: {
    unassigned: "Chưa có trưởng dự án",
    related: "Dự án liên quan",
    claimProject: "Nhận dự án",
    claimSaved: "Đã nhận dự án.",
    saveLeader: "Lưu trưởng dự án",
    salesInformation: "Thông tin kinh doanh (chỉ đọc)",
    selectProject: "Chọn một dự án trong danh sách đăng ký.",
    dynamicPicCount: "{count} PIC từ WBS & Gantt",
    noWbsPic: "Chưa có PIC nào được phân công từ WBS & Gantt.",
    leaderAssignedBy: "Người gán trưởng dự án",
    leaderAssignedAt: "Thời điểm gán trưởng dự án",
    leaderSaved: "Đã lưu trưởng dự án.",
    concurrency:
      "Phân công trưởng dự án đã được thay đổi bởi yêu cầu khác. Hãy tải lại và thử lại.",
    loadFailed: "Không tải được danh sách đăng ký dự án.",
    salesAssignmentInvalid:
      "Cần ít nhất một nhân viên kinh doanh; trưởng dự án sẽ được gán tại màn PI.",
  },
  projectWorkbook: {
    number: "No.",
    projectId: "Mã dự án",
    projectRevision: "Mã dự án (Rev)",
    receiptDate: "Ngày tiếp nhận",
    projectModel: "Mô hình dự án",
    endUser: "Khách hàng (End User)",
    customerShortName: "Tên viết tắt khách hàng",
    partnerName: "Tên đối tác",
    projectContent: "Nội dung dự án",
    shortProjectContent: "Tên viết tắt nội dung dự án",
    projectName: "Tên dự án",
    similarProject: "Dự án tương tự",
    attachedDocument: "Tài liệu đính kèm",
    contactPerson: "Người liên hệ",
    phoneNo: "Số điện thoại",
    email: "Email",
    attachedSurvey: "Tài liệu khảo sát đính kèm",
    feasibility: "Tính khả thi dự án",
    potential: "Tính tiềm năng",
    competition: "Tính cạnh tranh",
    competitor: "Đối thủ cạnh tranh (nếu có)",
    salesSubmittedAt: "Ngày kinh doanh gửi",
    salesCreatedBy: "Người tạo (kinh doanh)",
    createdDate: "Ngày tạo",
    surveyDate: "Ngày khảo sát (※1)",
    solutionTarget: "Mục tiêu có giải pháp từ (※1)",
    demoTarget: "Mục tiêu có Demo từ (※1)",
    quotationTarget: "Mục tiêu có báo giá từ (※1)",
    solutionProposalDate: "Ngày đề xuất giải pháp",
    demoDate: "Ngày Demo",
    quotationDate: "Ngày báo giá",
    purchaseOrderDate: "Ngày nhận P/O",
    goLiveDate: "Ngày đưa vào sử dụng",
    projectLeader: "Trưởng dự án",
    pic: "PIC",
    piSubmittedAt: "Ngày PI gửi",
    piCreatedBy: "Người tạo (PI)",
    confirmBy: "Người xác nhận",
    confirmDate: "Ngày xác nhận",
    approvedBy: "Người phê duyệt",
    approvedDate: "Ngày phê duyệt",
  },
  projectDocumentNaming: {
    typesLoadFailed:
      "Không tải được loại tài liệu. Vui lòng thử lại để chọn loại và tải file lên.",
    documentsLoadFailed: "Không tải được tài liệu dự án. Vui lòng thử lại.",
    documentType: "Loại tài liệu",
    maxFileSize: "Dung lượng tối đa cho mỗi file: 1 GiB.",
    uploadProgress: "Đang tải lên: {percent}%",
    processingProgress: "Đang xử lý tài liệu: {percent}%",
    uploadCancel: "Hủy tải lên",
    uploadCancelled: "Đã hủy tải lên; dự án vẫn được giữ nguyên.",
    uploadFailed: "Không tải được tài liệu. Vui lòng thử lại.",
    noType: "Vui lòng chọn loại tài liệu.",
    noFile: "Vui lòng chọn file.",
    invalidPrefix: "Tên file chưa đúng. Prefix kỳ vọng: {prefix}",
    duplicateConfirm:
      "File cùng basename đã tồn tại. Bạn có muốn thay thế file hiện tại không?",
    replacementSaved: "Đã thay thế tài liệu hiện tại.",
    filesystemNote:
      "Tên file hợp lệ được giữ nguyên; hệ thống từ chối path separator và không tự đổi tên.",
    standardGroupFolder: "Nhóm Rev01 (vd 02_KHAO_SAT_DE_XUAT)",
    standardTypeFolder: "Loại Rev01 (vd 01_BAO_CAO_KHAO_SAT)",
    standardCode: "Mã Rev01 (vd BCKS)",
    remoteSync: {
      Pending: "Chờ đồng bộ Q One Document",
      Synced: "Đã có trên Q One Document",
      Failed: "Đồng bộ Q One Document lỗi",
      Skipped: "Không đồng bộ Q One Document",
      PendingDelete: "Chờ gỡ khỏi Q One Document",
      Deleted: "Đã gỡ khỏi Q One Document",
      DeleteFailed: "Gỡ khỏi Q One Document lỗi",
    },
    openInQOneDocument: "Mở trên Q One Document",
    typePlaceholder: "Chọn loại tài liệu…",
    fileNamePreview: "Tên tệp",
    copyPrefix: "Sao chép tiền tố",
    prefixCopied: "Đã sao chép tiền tố {prefix}",
    uploadFile: "Tải tệp lên",
    dropHint: "Thả tệp để tải lên",
    catalog: "Danh mục loại",
    catalogTitle: "Danh mục loại tài liệu",
    catalogSearch: "Tìm theo mã, tên, thư mục…",
    catalogCount: "{count} loại",
    catalogEmpty: "Không có loại tài liệu phù hợp.",
    addType: "Thêm loại tài liệu",
    unmappedGroup: "Chưa ánh xạ Rev01 (mẫu cũ)",
    rev01Group00: "Quản lý dự án",
    rev01Group01: "Khách hàng & hợp đồng",
    rev01Group02: "Khảo sát & đề xuất",
    rev01Group03: "Thiết kế kỹ thuật",
    rev01Group04: "Mua hàng - NCC - NTP",
    rev01Group05: "Triển khai & hậu cần",
    rev01Group06: "QA/QC & kiểm thử",
    rev01Group07: "Thay đổi & xử lý vấn đề",
    rev01Group08: "Bàn giao & nghiệm thu",
    rev01Group09: "Thương mại & tài chính",
    rev01Badge: "Chuẩn Rev01",
    legacyBadge: "Mẫu cũ",
    exemptBadge: "Không bắt buộc",
    ruleRev01: "Bắt đầu bằng {prefix}_ rồi đến nội dung viết in hoa không dấu, nối bằng _. Revision và trạng thái do Q One Document quản lý nên không bắt buộc.",
    ruleLegacy: "Loại này chưa ánh xạ chuẩn Rev01 nên dùng mẫu cũ: tên tệp bắt đầu bằng {prefix}-.",
    ruleExempt: "Loại tài liệu này không bắt buộc đặt tên theo mẫu; tên tệp gốc được giữ nguyên.",
    ruleNone: "Chọn loại tài liệu để xem tên tệp cần đặt theo chuẩn NMI Rev01: <MÃ DỰ ÁN>_<MÃ LOẠI>_<NỘI DUNG>_<REV>_<TRẠNG THÁI>.",
    saveTo: "Lưu vào",
    segmentFixed: "Bắt buộc, đúng như hiển thị",
    segmentFree: "Tự đặt: chữ in hoa không dấu, nối các từ bằng _",
    segmentOptional: "Không bắt buộc, do Q One Document quản lý",
    placeholderProject: "MA_DU_AN",
    placeholderType: "MA_LOAI",
    placeholderSubject: "NOI_DUNG",
    placeholderRevision: "R00",
    placeholderStatus: "TRANG_THAI",
    placeholderExtension: "pdf",
    keepOriginalName: "Giữ nguyên tên tệp gốc",
    errors: {
      ...businessErrorsVi,
      unexpected_action_error:
        "Thao tác gặp lỗi. Vui lòng kiểm tra bản nhập rồi thử lại.",
      cash_advance_limit_exceeded:
        "Tạm ứng tiền mặt vượt 10.000.000 đ/lần; cần ghi chú của Giám đốc.",
      open_advance_exists:
        "Còn tạm ứng chưa hoàn ứng; phải thanh toán hết mới được ứng tiếp.",
      employee_profile_missing:
        "Bạn chưa có hồ sơ nhân viên được duyệt nên chưa lập được phiếu.",
      expense_category_invalid: "Mã chi phí không tồn tại hoặc đã tắt.",
      expense_category_exists: "Mã chi phí này đã tồn tại.",
      payment_request_not_editable:
        "Chỉ sửa được phiếu nháp hoặc phiếu bị trả về.",
      payment_request_not_deletable:
        "Chỉ xoá được bản nháp chưa từng gửi duyệt.",
      payment_request_lines_required: "Phiếu cần ít nhất một dòng chi.",
      document_number_required:
        "Dòng có hoá đơn/tờ khai phải nhập số chứng từ.",
      invalid_submitter: "Chỉ người lập mới được gửi duyệt phiếu này.",
      self_approval_forbidden:
        "Người lập không được duyệt phiếu của chính mình.",
      advance_not_paid: "Phiếu tạm ứng tham chiếu chưa được chi tiền.",
      advance_not_owned: "Phiếu tạm ứng thuộc nhân viên khác.",
      advance_already_settled: "Phiếu tạm ứng này đã được hoàn ứng.",
      advance_reference_required:
        "Giấy thanh toán tạm ứng phải chọn phiếu tạm ứng đã chi.",
      settlement_refund_expected:
        'Phiếu hoàn ứng này nộp tiền lại quỹ; dùng thao tác "Đã nhận nộp lại".',
      settlement_payment_expected:
        "Phiếu hoàn ứng này công ty phải chi thêm; chọn hình thức chi trước.",
      payment_reference_required: "Chuyển khoản cần số UNC/tham chiếu.",
      cash_entry_already_reversed: "Bút toán này đã được đảo.",
      cash_entry_is_reversal: "Không đảo lại một bút toán đảo.",
      invalid_delegation:
        "Ủy quyền phải cho người khác, có thời gian hợp lệ và chưa hết hạn.",
      circular_delegation: "Không thể tạo vòng ủy quyền.",
      workflow_amount_missing:
        "Hồ sơ chưa có giá trị số cần thiết để chọn bước duyệt.",
      workflow_amount_invalid: "Giá trị dùng xét ngưỡng duyệt không hợp lệ.",
      responsibility_not_owned:
        "Trách nhiệm đã đổi người phụ trách. Tải lại danh sách trước khi chuyển giao.",
      duplicate_document_name:
        "Tên tài liệu đã tồn tại; hãy xác nhận thay thế.",
      project_storage_party_mapping_missing:
        "Chưa cấu hình mapping thư mục đối tác cho khách hàng.",
      project_storage_party_mapping_invalid:
        "Mã, tên khách hàng hoặc Tỉnh/Thành phố đang thiếu hay không hợp lệ.",
      project_storage_party_folder_missing:
        "Không tìm thấy thư mục khách hàng đã được provision.",
      project_storage_project_folder_missing:
        "Không tìm thấy duy nhất thư mục dự án đã provision.",
      project_storage_project_folder_ambiguous:
        "Có nhiều thư mục khớp mã dự án; cần vận hành xử lý.",
      project_storage_document_type_folder_missing:
        "Không tìm thấy thư mục loại tài liệu đã provision.",
      project_storage_counterparty_unsupported:
        "Loại đối tác này chưa được hỗ trợ cho tài liệu dự án.",
      project_storage_not_writable:
        "Kho tài liệu dự án chưa sẵn sàng ghi file.",
      project_storage_target_conflict:
        "File đích đã tồn tại hoặc không khớp metadata hiện hành.",
      project_storage_path_too_long:
        "Đường dẫn tài liệu vượt giới hạn cho phép.",
      unsafe_file: "File không an toàn hoặc bị từ chối khi quét bảo mật.",
      invalid_document_name: "Tên file không khớp quy tắc mã tài liệu dự án.",
      project_code_ambiguous: "Mã dự án chưa duy nhất; cần vận hành xử lý.",
      project_storage_unavailable:
        "Kho tài liệu dự án tạm thời không khả dụng.",
      request_entity_too_large: "File vượt quá dung lượng tối đa 1 GiB.",
      file_too_large: "File vượt quá dung lượng tối đa 1 GiB.",
      upload_timeout: "Tải file quá thời gian chờ. Vui lòng thử lại.",
      upload_cancelled:
        "Đã hủy tải file; chưa có thông báo thành công nào được ghi nhận.",
      network_error: "Không thể kết nối để tải file. Vui lòng thử lại.",
      unauthorized: "Bạn không có quyền tải tài liệu lên dự án này.",
    },
    managerOnly: "Chỉ quản lý được sửa danh mục; các vai trò khác chỉ xem.",
    inactive: "Ngưng sử dụng",
    active: "Đang sử dụng",
    activate: "Kích hoạt",
    deactivate: "Ngưng sử dụng",
  },
  progressUpdate: {
    openProject: "Mở chi tiết dự án",
    pickProject: "Chọn dự án để cập nhật tiến độ các việc.",
    scope: "Phạm vi việc",
    empty: "Không có việc phù hợp bộ lọc.",
    panel: "Cập nhật tiến độ việc",
    assignees: "Người làm",
    percent: "Tiến độ",
    asOf: "Tính đến ngày",
    actualStart: "Bắt đầu thực tế",
    actualEnd: "Kết thúc thực tế",
    reason: "Ghi chú / lý do",
    reasonHint: "Bắt buộc khi trễ, tạm dừng hoặc không áp dụng",
    confirm: "Lưu tiến độ {percent}% cho việc {code}?",
    saved: "Đã lưu tiến độ việc {code}.",
    naCascadeHint: "Sẽ đánh dấu N/A cả {count} việc con: {codes}",
    naUnassigned: "Bạn chưa được giao các việc con: {codes}. Chỉ Leader mới N/A được mục này.",
    confirmNa: "Đánh dấu N/A việc {code} và {count} việc con?",
    parentBadge: "Mục cha · {count} việc con",
    scopes: {
      mine: "Việc của tôi",
      all: "Cả dự án",
      late: "Trễ",
      open: "Chưa xong",
    },
    blocked: {
      permission: "Bạn chưa có quyền cập nhật tiến độ.",
      locked: "Dự án đang khóa hoặc đã hủy.",
      phase: "Dự án chưa vào pha thực thi.",
      assignee: "Chỉ Leader hoặc người được giao việc mới cập nhật được.",
    },
    statuses: {
      NotStarted: "Chưa bắt đầu",
      InProgress: "Đang làm",
      Blocked: "Tạm dừng",
      Completed: "Hoàn thành",
      Cancelled: "Hủy",
      NotApplicable: "Không áp dụng",
    },
    history: {
      title: "Lịch sử cập nhật",
      changedAt: "Thời điểm",
      changedBy: "Người cập nhật",
      wbs: "Hạng mục",
      percent: "% cũ → mới",
      status: "Trạng thái cũ → mới",
      empty: "Dự án chưa có lần cập nhật tiến độ nào",
    },
  },
  progressBoard: {
    viewAs: "Xem theo tài khoản",
    viewAsSelf: "Tài khoản của tôi",
    period: "Thời gian",
    actual: "Thực tế",
    planned: "Kế hoạch",
    lateTasks: "Việc trễ",
    nextMilestone: "Mốc kế tiếp",
    filter: "Lọc việc",
    pickProject: "Chọn dự án để xem bảng tiến độ.",
    noProjects: "Tài khoản này chưa tham gia dự án nào.",
    financialTitle: "Tài chính nội bộ (theo báo giá mới nhất)",
    filters: {
      all: "Tất cả",
      late: "Trễ",
      inProgress: "Đang làm",
      notStarted: "Chưa bắt đầu",
      completed: "Đã xong",
    },
    internalTitle: "Giám sát tiến độ dự án",
    customerTitle: "Tiến độ dành cho khách hàng",
    subcontractorTitle: "Tiến độ dành cho nhà thầu phụ",
    internalHelp:
      "Theo dõi WBS đầy đủ và tổng hợp tài chính nội bộ từ báo giá mới nhất.",
    customerHelp:
      "Chỉ hiển thị dự án được phân công; dữ liệu trả về không chứa thông tin tài chính.",
    subcontractorHelp:
      "Chỉ hiển thị công việc được phân công và các công đoạn cha; dữ liệu trả về không chứa thông tin tài chính.",
    project: "Dự án",
    timeline: "Bảng tiến độ",
    backToday: "Về hôm nay",
    assign: "Giao việc",
    assignHint: "Chọn một việc trên bảng tiến độ để giao",
    inputPrice: "Giá đầu vào",
    additionalCost: "Chi phí phát sinh",
    salesPrice: "Giá bán",
    profit: "Lời / lỗ",
    paymentProgress: "Tiến độ thanh toán",
    documents: "Tài liệu dự án",
    fileName: "Tên file",
    category: "Nhóm",
    version: "Phiên bản",
    size: "Dung lượng",
  },
  approvedRegistration: {
    codeHistory: "Lịch sử mã dự án (cũ → mới)",
    requiredFields:
      "Vui lòng kiểm tra các trường bắt buộc và lý do thay đổi (tối đa 2.000 ký tự).",
    uncertain:
      "Chưa xác nhận được kết quả. Thử lại cùng yêu cầu trước khi sửa hoặc tải lại dữ liệu.",
    requestedBy: "Người yêu cầu",
    decidedBy: "Người quyết định",
    title: "Sửa đăng ký đã phê duyệt",
    reason: "Lý do thay đổi",
    reasonRequired: "Nhập lý do thay đổi.",
    save: "Lưu thông tin",
    requestApproval: "Gửi yêu cầu phê duyệt",
    planChangeNotice:
      "Thay đổi kế hoạch cần được phê duyệt. Kế hoạch thực thi hiện tại giữ nguyên cho đến khi được duyệt.",
    saved: "Đã cập nhật thông tin dự án.",
    requested: "Đã gửi yêu cầu thay đổi để phê duyệt.",
    history: "Lịch sử thay đổi đăng ký",
    before: "Trước",
    after: "Sau",
    field: "Trường thông tin",
    noChanges: "Chưa có thay đổi đăng ký.",
    decisionReason: "Lý do quyết định",
    approve: "Phê duyệt",
    reject: "Từ chối",
    applied: "Đã áp dụng",
    pending: "Chờ phê duyệt",
    approved: "Đã phê duyệt",
    rejected: "Đã từ chối",
    decided: "Đã lưu quyết định.",
    invalidMembers:
      "Cần thành viên kinh doanh và các cặp thành viên–vai trò hợp lệ, không trùng nhau.",
    refresh: "Tải lại",
    lookupUnavailable:
      "Không tải được dữ liệu tham chiếu. Hãy tải lại để thử lại.",
  },
  projects: {
    projectModelVision: "Vision",
    projectModelIt: "IT",
    projectModelCommercial: "Thương mại",
    wbsModelDateHelp: "Ngày kế hoạch của mô hình Vision chỉ BOD được sửa.",
    wbsModelDatesOnly: "Bạn được sửa ngày kế hoạch; các nội dung khác theo quyền của từng dòng.",

    registrationOperationCompleted:
      "Yêu cầu đã hoàn tất. Dự án đã chuyển sang trạng thái {status}; thông tin hiện tại được tải lại.",
    registrationEditReady:
      "Có thể sửa thông tin đăng ký. Lưu thay đổi và gửi lại để xét duyệt.",
    registrationDeleted: "Đã xóa đăng ký dự án.",
    withdrawRegistrationTitle: "Thu hồi đăng ký để sửa",
    deleteRegistrationTitle: "Xóa đăng ký dự án",
    withdrawRegistrationHelp:
      "Thu hồi đăng ký {code} về bước nhập thông tin. Các tác vụ duyệt đang chờ sẽ dừng; sau khi sửa, cần gửi lại để xét duyệt.",
    deleteRegistrationHelp:
      "Xóa đăng ký {code} và dừng các tác vụ duyệt đang chờ. Lịch sử thao tác vẫn được lưu. Xác nhận khi bạn muốn loại bỏ đăng ký này.",
    registrationReason: "Lý do",
    registrationRetry: "Kiểm tra và thử lại",
    registrationChangePending:
      "Chưa xác nhận được kết quả hoặc quy trình đang đồng bộ. Dùng Kiểm tra và thử lại để tiếp tục cùng yêu cầu; chưa thể sửa hoặc xóa tiếp.",
    registrationConflict:
      "Dự án đã thay đổi. Dữ liệu bạn nhập được giữ lại; hãy làm mới thông tin dự án trước khi thử lại.",
    saved: "Đã lưu dự án thành công.",
    savedWithAttachmentErrors:
      "Dự án đã được lưu, nhưng chưa lưu được các tệp vào thư mục: {files}. Bấm Lưu lại để chỉ thử lại các tệp này.",
    documentTypeUnavailable:
      "thiếu hoặc sai cấu hình loại tài liệu đang hoạt động {code}; hệ thống không chuyển sang kho lưu trữ khác",
    replaceAttachmentConfirm:
      "Tệp {target} đã tồn tại trong thư mục dự án và có nội dung khác. Thay thế bằng tệp {file}? Hệ thống sẽ tạo phiên bản mới cho đúng ô tài liệu này.",
    attachmentReplacementCancelled:
      "Tệp {file} chưa được thay thế; tệp đã chọn vẫn được giữ để bạn thử lại.",
    projectIdMissing: "Chưa đủ dữ kiện để cấp mã dự án — còn thiếu {fields}.",
    projectIdPreview:
      "Mã dự kiến theo dữ liệu hiện có — chữ cái thứ tự (A, B, C…) do hệ thống cấp chính thức khi lưu; dấu ? nghĩa là chưa lấy được thứ tự từ máy chủ.",
    customerAbbreviationMissing:
      "Khách hàng chưa có tên viết tắt — vào Dữ liệu CRM › Khách hàng để điền trước khi tạo mã dự án.",
    title: "Danh sách dự án",
    subtitle: "Đăng ký, phê duyệt và kiểm soát toàn bộ vòng đời",
    status: "Trạng thái",
    customer: "Khách hàng",
    customerShortName: "Tên khách hàng viết tắt",
    type: "Loại dự án",
    model: "Model dự án",
    shortContent: "Nội dung ngắn gọn",
    content: "Nội dung dự án đầy đủ",
    partner: "Đối tác",
    contactName: "Người liên hệ",
    contactPhone: "Điện thoại liên hệ",
    contactEmail: "Email liên hệ",
    similarProject: "Dự án tương tự",
    restartDate: "Ngày bắt đầu lại",
    restartRequiresSimilar:
      "Ngày bắt đầu lại chỉ dùng khi đã chọn dự án tương tự.",
    feasibility: "Tính khả thi",
    potential: "Tiềm năng",
    competition: "Tình hình cạnh tranh",
    competitor: "Đối thủ cạnh tranh",
    subcontractor: "Nhà thầu phụ",
    documentCategory: "Nhóm tài liệu",
    registrationDetails: "Thông tin đăng ký theo biểu mẫu Q ONE",
    registrationDetailsHelp:
      "Thông tin thương mại, liên hệ, đánh giá và truy vết nguồn của dự án.",
    priority: "Ưu tiên",
    leader: "Trưởng dự án",
    start: "Bắt đầu",
    end: "Kết thúc",
    health: "Tiến độ lịch",
    new: "Đăng ký dự án",
    objective: "Mục tiêu",
    scope: "Phạm vi",
    requirements: "Yêu cầu",
    workflow: "Luồng phê duyệt",
    overview: "Tổng quan",
    information: "Thông tin dự án",
    execution: "WBS & Gantt",
    messages: "Tin nhắn",
    files: "Tệp",
    chatSaveToDocuments: "Đưa {file} vào Tài liệu dự án",
    chatCopyingDocuments: "Đang đưa tệp đã gửi vào Tài liệu dự án…",
    chatDocumentCopyFailed: "Tin nhắn đã gửi, nhưng chưa đưa được các tệp sau vào Tài liệu dự án:",
    projectGroup: "Nhóm dự án",
    directMessages: "Tin nhắn trực tiếp",
    customGroups: "Nhóm tùy chỉnh",
    projectTopics: "Chủ đề dự án",
    selectMember: "Chọn thành viên",
    newDirect: "Chat trực tiếp",
    newGroup: "Nhóm mới",
    selectWbsTopic: "Chọn chủ đề WBS",
    newTopic: "Chủ đề mới",
    groupName: "Tên nhóm",
    topicName: "Tên chủ đề",
    reply: "Trả lời",
    replyingTo: "Đang trả lời",
    originalUnavailable: "Không xem được tin nhắn gốc",
    deleteMessageConfirm: "Xóa tin nhắn này?",
    sendMessage: "Gửi",
    wbs: "WBS",
    documents: "Tài liệu",
    issues: "Theo dõi yêu cầu",
    lessons: "Bài học",
    reports: "Báo cáo",
    timesheet: "Chấm công",
    member: "Thành viên",
    role: "Vai trò",
    addMember: "Thêm thành viên",
    assignmentInvalid: "Phải có đúng 1 trưởng dự án và đủ Kinh doanh, PI/PIC, Người duyệt.",
    milestones: "Milestone dự kiến",
    addMilestone: "Thêm milestone",
    sortByDate: "Xếp theo ngày",
    milestonesInvalid:
      "Milestone phải không trùng loại và nằm trong thời gian dự án.",
    lateOnly: "Chỉ dự án trễ",
    from: "Từ ngày",
    to: "Đến ngày",
    filters: "Bộ lọc",
    editDependency: "Sửa cạnh phụ thuộc",
    deleteDependency: "Xóa cạnh phụ thuộc",
    deleteDependencyConfirm: "Xóa cạnh {from} → {to}?",
    quickStart: "Bắt đầu",
    quickBlock: "Chặn",
    quickUnblock: "Bỏ chặn",
    quickComplete: "Xong",
    quickReopen: "Mở lại",
    quickCancel: "Hủy việc",
    quickUnstart: "Hủy bắt đầu",
    cancelProject: "Hủy thẳng dự án",
    cancelTask: "Hủy từ công việc này",
    cancelProjectConfirm: "Hủy toàn bộ {count} công việc? {completed} công việc đã hoàn thành cũng sẽ chuyển sang Hủy.",
    cancelTaskConfirm: "Hủy công việc này và toàn bộ {count} công việc phía sau? {completed} công việc đã hoàn thành cũng sẽ chuyển sang Hủy.",
    cancelPreviewTitle: "Kiểm tra trước khi hủy dự án",
    cancelAffectedNodes: "Danh sách WBS bị ảnh hưởng",
    cancelOperationId: "Mã thao tác",
    cancelOperationIdOnConfirm: "sẽ được tạo khi xác nhận",
    confirmCancellation: "Xác nhận hủy",
    cancelRecoveryPending: "Thao tác hủy cần được kiểm tra lại kết quả.",
    cancelRefreshRequired: "Thao tác hủy đã kết thúc. Tải lại dự án trước khi chỉnh sửa tiếp.",
    reconcileCancellation: "Kiểm tra kết quả hủy",
    retryCancellation: "Thử lại cùng mã thao tác",
    cancelOutcomeUnknown: "Chưa xác định được kết quả hủy. Hãy kiểm tra thao tác trước khi thử lại.",
    quickReasonPrompt: "Nhập lý do (bắt buộc):",
    pendingRequests: "Yêu cầu chờ duyệt",
    decision: "Quyết định",
    approvedAt: "Phê duyệt lúc",
    approveKeepsWbs: "Duyệt sẽ giữ nguyên WBS đã lập",
    approvalOutcomeUnknown:
      "Chưa xác nhận được kết quả phê duyệt. Tải lại dự án để kiểm tra trạng thái hiện tại trước khi thử lại.",
    updateProgress: "Cập nhật tiến độ",
    percent: "Phần trăm",
    asOfDate: "Ngày ghi nhận",
    actualStart: "Bắt đầu thực tế",
    actualEnd: "Kết thúc thực tế",
    closeOutcomeUnknown:
      "Chưa xác định được kết quả đóng dự án. Hãy đồng bộ lại trạng thái trước khi thử lại.",
    closeRowVersionRequired:
      "Không có phiên bản dữ liệu hiện tại để đóng dự án. Hãy tải lại trang.",
    reconcileClose: "Đối soát thao tác đóng dự án",
    newCloseAttempt: "Bắt đầu lần đóng dự án mới",
    abortPendingClose: "Hủy lần đóng đang chờ",

    actualDates: "Ngày thực tế",
    plannedMd: "MD kế hoạch",
    weight: "Trọng số",
    rejectReason: "Lý do từ chối",
    statusReason: "Lý do trạng thái",
    progressHistory: "Lịch sử tiến độ",
    ganttScale: "Tỷ lệ Gantt",
    day: "Ngày",
    week: "Tuần",
    month: "Tháng",
    year: "Năm",
    dependencies: "Phụ thuộc",
    predecessor: "Công việc trước",
    successor: "Công việc sau",
    addDependency: "Thêm phụ thuộc",
    plan: "Kế hoạch",
    actual: "Thực tế",
    unassigned: "Chưa gán",
    picHistory: "Lịch sử gán PIC",
    picFilter: "Lọc PIC",
    allPics: "Tất cả PIC",
    bulkNa: "N/A nhiều mục",
    bulkNaTitle: "Đánh dấu N/A nhiều mục WBS",
    bulkNaHint: "Chọn các mục không thực hiện. Chọn mục cha thì mọi mục con chuyển N/A theo mục cha, không cần chọn riêng.",
    bulkNaCovered: "theo mục cha",
    bulkNaReason: "Lý do (không bắt buộc)",
    bulkNaApply: "Đánh dấu N/A ({count} mục)",
    bulkNaDone: "Đã N/A",
    bulkNaFailed: "Lỗi — dừng tại đây",
    bulkNaSkipped: "Chưa thực hiện",
    naCascadeHint: "Sẽ đánh dấu N/A cả {count} việc con: {codes}",
    naUnassigned: "Bạn chưa được giao các việc con: {codes}. Chỉ Leader mới N/A được mục này.",
    nodeDocuments: "Tài liệu của công việc",
    nodeDocumentUpload: "Tải lên tệp cho công việc này",
    addWbs: "Thêm WBS",
    editWbs: "Sửa WBS",
    deleteWbsConfirm: "Xóa WBS {code}?",
    deleteNodeImpact:
      "Công việc này đang có {days} ngày phân bổ nguồn lực. Xóa sẽ mất toàn bộ phân bổ, tiếp tục?",
    concurrencyConflict:
      "Đầu việc vừa được người khác sửa. Đã tải lại bản mới, vui lòng nhập lại thay đổi.",
    parent: "WBS cha",
    summaryNodeProgressLockedNotice:
      "Tiến độ công việc cha được tính tự động từ các công việc con.",
    wbsCloneNotice:
      "Hạng mục [{parentCode}] đã phát sinh tiến độ thực tế ({percent}%). Tiến độ hiện có sẽ được tự động tách thành công việc con [{cloneCode}], công việc mới sẽ mang mã [{newCode}].",
    reparentingNotAllowed:
      "Không thể thay đổi công việc cha. Vui lòng xóa và tạo lại dưới công việc cha mới.",
    wbsChildDatesOutOfParentRange:
      "Thời gian công việc con ({start} - {end}) phải nằm trong khoảng thời gian của công việc cha ({pStart} - {pEnd}).",
    wbsParentDatesMustEncloseChildren:
      "Thời gian công việc cha ({start} - {end}) phải bao trùm toàn bộ các công việc con ({cStart} - {cEnd}).",
    sortOrder: "Thứ tự",
    milestoneSchedule: "Lịch mốc dự kiến / thực tế",
    stageTracker: "Trạng thái 16 giai đoạn",
    stageTrackerHelp:
      "Tổng hợp trạng thái dùng chung cho dự án khởi tạo từ mẫu chuẩn.",
    stage: "Giai đoạn",
    stageHasActivity: "Đã",
    stageNoActivity: "Chưa",
    projectProgress: "Tiến độ dự án",
    totalProjectDays: "Tổng số ngày thực hiện",
    remainingProjectDays: "Tổng số ngày còn lại",
    projectDocuments: "Tài liệu dự án",
    scheduleEntry: "Nhập lịch WBS",
    scheduleEntryHelp:
      "Sửa kế hoạch phía trên, ngày và manday thực tế phía dưới rồi lưu một lần.",
    actualMandaysEntry:
      "Nhập tổng manday thực tế hiện tại; bảng chấm công được duyệt sau đó vẫn tiếp tục cộng dồn.",
    resourceSchedule: "Lịch nguồn lực theo ngày",
    resourceScheduleHelpCurrent:
      "MD kế hoạch tự chia theo ngày khi lưu WBS. Chấm công đã duyệt được cộng thêm vào giá trị thực tế nhập tay của cùng ô.",
    resourceScheduleHelp:
      "Phân bổ số người theo WBS và ngày. Chấm công đã duyệt được cộng thêm vào giá trị thực tế nhập tay của cùng ô.",
    chartResourceEdit: "Nhập nguồn lực trên biểu đồ",
    chartResourceHelp: "Nhập số người trực tiếp tại ô KH / TT theo ngày.",
    chartResourceDayOnly: "Chuyển sang chế độ Ngày để nhập nguồn lực.",
    unsavedAllocations: "{count} ô chưa lưu",
    scale: "Tỷ lệ",
    previousPeriod: "Kỳ trước",
    nextPeriod: "Kỳ sau",
    today: "Hôm nay",
    people: "Người",
    totalPeople: "Tổng nguồn lực",
    variance: "Chênh lệch",
    timesheetLocked: "Chấm công đã duyệt được cộng vào thực tế",
    approvedTimesheetIncluded:
      "Số thực tế đã bao gồm chấm công đã duyệt; phần nhập tay vẫn được cộng thêm.",
    progressDetailsTitle: "Chi tiết hạng mục",
    itemLogTitle: "Nhật ký hạng mục",
    itemLogDate: "Ngày",
    itemLogHint: "Cập nhật %/trạng thái và giờ công đã duyệt của hạng mục và mọi hạng mục con, trên mọi ngày. Giờ trong ngày gắn vào lần cập nhật cuối cùng ngày của cùng người.",
    progressTimesheetRestricted: "Bạn không có quyền xem chi tiết chấm công của hạng mục này.",
    timesheetDetailsTitle: "Chi tiết chấm công đã duyệt",
    timesheetDetailsCurrentUser:
      "Hiển thị các dòng chấm công đã duyệt cho ô này.",
    timesheetDetailsAssignee: "Nhân sự",
    timesheetDetailsOpenHint: "Nhấn để xem chi tiết chấm công.",
    timesheetDetailsEmpty:
      "Không tìm thấy chi tiết chấm công đã duyệt cho ô này.",
    planChangeReason: "Lý do đổi kế hoạch",
    planChangeReasonHelp: "Dự án đang thực hiện: đổi ngày, manday hoặc trọng số kế hoạch phải ghi lý do; lý do được lưu vào lịch sử cập nhật của việc.",
    parentRollupHint: "Mục này có mục con: % hoàn thành, trạng thái và ngày thực tế được tính từ các mục con (trừ N/A, Hủy); chỉ có thể đặt N/A cho cả nhánh.",
    saveAllocations: "Lưu phân bổ",
    noAllocationChanges: "Không có thay đổi phân bổ cần lưu.",
    allocationSaved: "Đã lưu phân bổ nguồn lực.",
    loadOlderMessages: "Tải tin nhắn cũ hơn",
    noMessages: "Chưa có tin nhắn.",
    you: "Bạn",
    messageDeleted: "Tin nhắn đã bị xóa.",
    edited: "Đã sửa",
    writeMessage: "Viết tin nhắn…",
    search: "Tìm tin nhắn",
    searchResults: "Kết quả tìm kiếm",
    export: "Xuất lịch sử",
    createIssue: "Tạo vấn đề từ tin nhắn",
    linkedIssue: "Đã tạo vấn đề",
    quoteWbs: "Trích dẫn WBS",
    rateLimited: "Bạn gửi quá nhanh, chờ vài giây rồi thử lại.",
    addChild: "Thêm công việc con",
    deleteChildrenFirst: "Cần xóa hoặc chuyển công việc con trước",
    childName: "Tên công việc con",
    gantt: {
      nonWorkdayPlanned: "Ngày nghỉ theo lịch làm việc Việt Nam, không được xếp kế hoạch.",
      overtimeRequired: "Cần phiếu tăng ca đã duyệt cho dự án và ngày này.",
      approvedOvertimePeople: "Nhân sự tăng ca đã duyệt: {count}",
    },
    documentTypeNameVi: "Tên tiếng Việt",
    documentTypeNameEn: "Tên tiếng Anh",
    documentTypeAbbreviation: "Viết tắt",
    documentTypeNumber: "Số",
  },
  projectMilestone: {
    addColumn: "Thêm cột mốc",
    savePlan: "Lưu kế hoạch",
    name: "Tên mốc",
    namePlaceholder: "Nhập tên cột",
    invalidPlan:
      "Tên mốc không được để trống hoặc trùng nhau; ngày phải nằm trong thời gian dự án và tăng dần từ trái sang phải.",
  },
  notifications: {
    actionState: { actionable: "Cần bạn xử lý", informational: "Thông tin", unknown: "Chưa xác minh được việc cần xử lý" },
    openUnavailable: "Không mở được thông báo này: đã bị xóa, không thuộc tài khoản này hoặc bạn không còn quyền.",
    noTarget: "Thông báo đã được đánh dấu đã đọc; không có hồ sơ để mở.",
    whyReceived: "Vì sao tôi nhận thông báo này?",
    receiptReasonUnknown: "Thông báo này chưa có lý do nhận được ghi lại.",
    receiptReasons: {
      direct_user: "Bạn được chọn đích danh.",
      system_role: "Theo vai trò hệ thống của bạn lúc gửi.",
      record_participant: "Theo vai trò của bạn trong hồ sơ lúc xảy ra sự kiện.",
      record_assignee: "Theo phân công trong hồ sơ lúc xảy ra sự kiện.",
      record_reviewer: "Bạn thuộc nhóm xem xét hồ sơ lúc xảy ra sự kiện.",
    },
    groupedView: "Nhóm theo hồ sơ và loại sự việc",
    groupedPageHint: "Nhóm trong trang hiện tại theo từng khoảng 5 phút. Mỗi thông báo vẫn giữ trạng thái đọc riêng.",
    groupCount: "{count} thông báo · {unread} chưa đọc",
    previewEmpty:
      "Không có thông báo phù hợp trong bản xem nhanh. Mở lịch sử để xem thêm.",
    ReportSubmitted: {
      title: "Có báo cáo chờ duyệt",
      message: "Báo cáo đã được gửi. Mở báo cáo để xem và quyết định.",
    },
    ReportDistributionSkipped: {
      title: "Kỳ phát hành báo cáo bị bỏ qua",
      message:
        "Chưa có báo cáo được duyệt cho kỳ phát hành. Mở lịch sử để kiểm tra.",
    },
    IssueOverdue: {
      title: "Yêu cầu đã quá hạn",
      message:
        "Yêu cầu đang mở đã quá hạn. Mở dự án để cập nhật tiến độ xử lý.",
    },
    WorkflowTaskOverdue: {
      title: "Hồ sơ duyệt đã quá hạn",
      message: "Một hồ sơ đang chờ bạn xử lý đã quá hạn.",
    },
    WorkflowTaskEscalated: {
      title: "Hồ sơ duyệt được chuyển cấp",
      message: "Hồ sơ quá hạn đã được chuyển tới vai trò xử lý tiếp theo.",
    },
    WbsAssigned: {
      title: "Bạn được gán phụ trách một công việc",
      message:
        "Bạn vừa được gán làm người phụ trách. Mở dự án để xem kế hoạch và cập nhật tiến độ.",
    },
    WbsUnassigned: {
      title: "Bạn không còn phụ trách một công việc",
      message:
        "Bạn đã được gỡ khỏi công việc này; các cập nhật tiến độ tiếp theo thuộc người phụ trách mới.",
    },
    ProjectRegistrationInformationChanged: {
      title: "Thông tin đăng ký dự án đã thay đổi",
      message:
        "Thông tin đăng ký đã được cập nhật. Mở dự án để xem lý do và lịch sử trước/sau.",
    },
    ProjectRegistrationChangeRequested: {
      title: "Đăng ký dự án có yêu cầu thay đổi",
      message:
        "Có yêu cầu thay đổi kế hoạch cần phê duyệt. Kế hoạch hiện tại được giữ nguyên cho đến khi duyệt.",
    },
    ProjectRegistrationChangeApproved: {
      title: "Thay đổi đăng ký đã được phê duyệt",
      message: "Yêu cầu thay đổi đăng ký đã được phê duyệt và áp dụng.",
    },
    ProjectRegistrationChangeRejected: {
      title: "Thay đổi đăng ký đã bị từ chối",
      message: "Yêu cầu thay đổi đăng ký đã bị từ chối. Mở dự án để xem lý do.",
    },
    title: "Thông báo",
    empty: "Chưa có thông báo nào.",
    emptyForFilter: "Không có thông báo phù hợp.",
    filterLabel: "Lọc thông báo",
    all: "Tất cả",
    unread: "Chưa đọc",
    read: "Đã đọc",
    markAllRead: "Đọc tất cả",
    viewAll: "Xem tất cả thông báo",
    pageDescription: "Xem lại, lọc và quản lý các thông báo của bạn.",
    back: "Quay lại",
    showLess: "Thu gọn",
    flagged: "Đặc biệt",
    flag: "Đánh dấu đặc biệt",
    unflag: "Bỏ đánh dấu đặc biệt",
    delete: "Xóa thông báo",
    deleteConfirm: "Xóa thông báo này?",
    targetMissing:
      "Nội dung liên kết không còn tồn tại hoặc bạn không có quyền truy cập.",
    projectTarget: "Dự án: {project}",
    fallbackTitle: "Thông báo mới",
    projectFallbackTitle: "Thông báo dự án",
    fallbackMessage: "Có cập nhật liên quan đến bạn.",
    targetTypes: {
      OperationsOutbox: "chẩn đoán vận hành",
      AssetMaterialReturnedEnrollment: "phiếu trả tài sản",
      Project: "dự án",
      ProjectRegistration: "đăng ký dự án",
      ProjectIssue: "yêu cầu dự án",
      WbsNode: "công việc WBS",
      Report: "báo cáo",
      Timesheet: "bảng chấm công",
      MaterialEnrollment: "phiếu đăng ký vật tư",
      AssetMaterialEnrollment: "phiếu đăng ký tài sản",
      ProcurementMaterialEnrollment: "phiếu đăng ký vật tư",
      ProcurementMaterialReturnedEnrollment: "phiếu trả vật tư",
      ProcurementPaymentRequest: "đề nghị thanh toán",
      ProcurementStockReceipt: "phiếu nhập kho",
      Default: "hồ sơ liên quan",
    },
    pagination: "Phân trang thông báo",
    previousPage: "Trang trước",
    nextPage: "Trang tiếp theo",
    workflow: "Quy trình",
    windowsPush: {
      enable: "Bật thông báo trên máy",
      disable: "Tắt thông báo trên máy",
      states: {
        checking: "Đang kiểm tra thông báo trên máy…",
        unsupported: "Trình duyệt không hỗ trợ thông báo trên máy.",
        unavailable: "Máy chủ chưa cấu hình thông báo trên máy.",
        denied:
          "Trình duyệt đã chặn thông báo. Hãy cho phép trong cài đặt trình duyệt.",
        disabled: "Thông báo trên máy đang tắt.",
        enabled: "Thông báo trên máy đang bật.",
        error: "Không thiết lập được thông báo trên máy.",
      },
    },
    WorkflowStarted: {
      title: "Quy trình đã khởi tạo",
      message: "Hồ sơ đã được tạo và bắt đầu quy trình phê duyệt.",
    },
    WorkflowStepAssigned: {
      title: "Bạn có bước quy trình mới",
      message: "Bạn được giao xử lý {target}.",
    },
  },
  chat: {
    title: "Tin nhắn",
    minimize: "Thu nhỏ",
    mute: "Tắt thông báo",
    unmute: "Bật thông báo",
    searchConversations: "Tìm hội thoại",
    searchMessages: "Tìm tin nhắn",
    search: "Tìm",
    searchResults: "Kết quả tìm kiếm",
    newChat: "Cuộc trò chuyện mới",
    newDirect: "Chat riêng",
    newGroup: "Tạo nhóm",
    selectPeople: "Chọn người tham gia",
    groupName: "Tên nhóm",
    directFallback: "Chat riêng",
    you: "Bạn",
    noConversations: "Chưa có cuộc trò chuyện nào.",
    pickConversation: "Chọn một cuộc trò chuyện để bắt đầu.",
    noMessages: "Chưa có tin nhắn nào.",
    writeMessage: "Nhập tin nhắn…",
    send: "Gửi",
    attach: "Đính kèm tệp",
    react: "Thả cảm xúc",
    reply: "Trả lời",
    replyingTo: "Đang trả lời",
    originalUnavailable: "Không xem được tin gốc",
    edited: "Đã sửa",
    messageDeleted: "Tin nhắn đã bị xoá.",
    deleteConfirm: "Xoá tin nhắn này?",
    loadOlder: "Tải tin cũ hơn",
    typing: "Đang soạn tin…",
    typingOne: "{first} đang soạn tin…",
    typingTwo: "{first} và {second} đang soạn tin…",
    typingMany: "{first} và {count} người khác đang soạn tin…",
    mentionPeople: "Nhắc đến thành viên",
    mentionAllHelp: "Thông báo cho mọi người",
    emojiPicker: "Bảng chọn emoji",
    searchEmoji: "Tìm emoji",
    recentEmoji: "Gần đây",
    moreEmoji: "Thêm emoji",
    createPoll: "Tạo bình chọn",
    pollQuestion: "Câu hỏi bình chọn",
    pollOption: "Lựa chọn",
    addOption: "Thêm lựa chọn",
    allowMultiple: "Cho phép chọn nhiều",
    anonymousPoll: "Bình chọn ẩn danh",
    allowAddOptions: "Thành viên được thêm lựa chọn",
    pollClosesAt: "Đóng lúc",
    vote: "Bỏ phiếu",
    totalVoters: "{count} người đã chọn",
    pollClosed: "Đã đóng bình chọn",
    closePoll: "Đóng bình chọn",
    poll: "Bình chọn",
    pin: "Ghim",
    unpin: "Bỏ ghim",
    pinned: "Tin đã ghim",
    forwarded: "Tin nhắn được chuyển tiếp",
    forward: "Chuyển tiếp",
    hideForMe: "Ẩn với tôi",
    forwardTarget: "Chọn hội thoại",
    forwardWithoutFiles: "Phiên bản này không chuyển tiếp tệp đính kèm.",
    members: "Thành viên",
    owner: "Chủ nhóm",
    member: "Thành viên",
    removeMemberAction: "Xóa",
    removeMember: "Xóa {name} khỏi nhóm chat",
    removeMemberConfirm: "Xóa {name} khỏi nhóm chat dự án? Vai trò dự án của người này vẫn được giữ.",
    openProject: "Mở dự án",
    eligibleUsersLoadFailed: "Không tải được danh sách người dùng có quyền Chat.",
    online: "Trực tuyến",
    offline: "Ngoại tuyến",
    jumpToLatest: "Xem tin mới nhất",
    moreActions: "Thêm hành động",
    retryConnection: "Thử lại",
    searchScopeHint:
      "Tìm kiếm phủ tin nhắn gần đây; phần lịch sử đã lưu trữ không được đánh chỉ mục.",
    seenBy: "Đã xem bởi",
    membershipChanged:
      "Quyền tham gia hội thoại đã thay đổi. Danh sách đã được làm mới.",
    unknownUser: "Người dùng đã rời",
    createIssue: "Tạo vấn đề",
    linkedIssue: "Vấn đề liên kết",
    kindProjectGroup: "Nhóm dự án",
    kindDirect: "Chat riêng",
    kindCustomGroup: "Nhóm tự tạo",
    kindProjectTopic: "Chủ đề WBS",
    connection: {
      connected: "Trực tuyến",
      degraded: "Kết nối yếu",
      off: "Ngắt kết nối",
    },
  },
  roles: {
    Sales: "Kinh doanh",
    PiPic: "PI/PIC",
    Leader: "Trưởng dự án",
    Member: "Thành viên",
    Approver: "Người phê duyệt",
  },
  milestone: {
    Receipt: "Tiếp nhận",
    Survey: "Khảo sát",
    SolutionProposal: "Đề xuất giải pháp",
    Demo: "Demo",
    Quotation: "Báo giá",
    PurchaseOrder: "Nhận P/O",
    Implementation: "Triển khai",
    GoLive: "Đưa vào sử dụng",
  },
  timesheets: {
    afterProjectActualEnd: "Ngày công sau ngày kết thúc thực tế của dự án.",
    unsavedChanges:
      "Có thay đổi công chưa lưu. Bạn có muốn bỏ các thay đổi này không?",
    weekView: {
      label: "Tuần {week} · {from}–{to}",
      previous: "Tuần trước",
      next: "Tuần sau",
      today: "Hôm nay",
      goTo: "Đi tới ngày",
      total: "Tổng tuần",
      openDay: "Ghi công ngày",
      submit: "Gửi tuần",
      submitted: "Đã gửi duyệt {count} ngày.",
      submitFailed: "Ngày {date}: {message}",
      grid: "Bảng công tuần",
      rowLabel: "Dự án / Công việc",
      dayTotal: "Tổng ngày",
      empty: "Tuần này chưa có dòng công. Chọn một ngày rồi bấm \"Ghi công ngày\".",
      overCapacity: "Vượt giờ chuẩn",
      underCapacity: "Thiếu giờ chuẩn",
      offDay: "Ngày nghỉ",
      reminder: "Nhắc chấm công",
      openCell: "Mở ngày {date} để ghi chi tiết",
    },
    weekCopy: {
      button: "Chép sang tuần",
      title: "Chép công ngày {date} sang các ngày trong tuần",
      hint: "Mỗi ngày được lưu thành nháp riêng và chưa gửi duyệt. Ngày đã có dòng công sẽ được bỏ qua, không ghi đè.",
      run: "Chép thành nháp",
      saved: "Đã lưu nháp",
      hasEntries: "Đã có công — bỏ qua",
    },
    copyPrevious: "Sao chép ngày trước",
    noPreviousEntries: "Ngày trước không có dòng công để sao chép.",
    approvalPart: "Phần duyệt",
    openApprovalInbox: "Mở hộp duyệt chấm công",
    title: "Bảng công ngày",
    myAttendance: "Máy chấm công của tôi",
    myAttendanceHint: "Giờ vào/ra, công ghi nhận và công chờ duyệt của chính bạn trong tháng đang chọn.",
    subtitle: "Ghi nhận manday thực tế theo dự án và WBS",
    calendar: "Lịch chấm công tháng",
    workDate: "Ngày làm việc",
    project: "Dự án",
    task: "WBS / Công việc",
    hours: "Số giờ",
    hourType: "Loại giờ",
    normal: "Bình thường",
    overtime: "Tăng ca",
    workType: "Loại công việc",
    content: "Nội dung",
    result: "Kết quả",
    ineligibleReference:
      "Dự án hoặc WBS/công việc không còn hợp lệ hoặc chưa được gán cho bạn; hãy chọn lại.",
    add: "Thêm dòng",
    total: "Tổng giờ",
    capacity: "Năng lực",
    attendanceCheck: "Chấm công",
    attendanceEffort: "Công ghi nhận",
    pendingEffort: "Chờ duyệt",
    policy:
      "Dữ liệu theo bước 15 phút; giờ thường không vượt năng lực và tổng tối đa 16 giờ/ngày.",
    approvals: "Bảng chấm công chờ duyệt",
    history: "Lịch sử phiên bản",
    currentVersion: "Phiên bản hiện tại",
    user: "Nhân viên",
    overload: "Vượt năng lực trong ngày",
    missing: "Thiếu chấm công",
    periodLock: "Khóa kỳ chấm công",
    lock: "Khóa",
    unlock: "Mở khóa",
    unlockPeriod: "Mở khóa kỳ",
    unlockReason: "Lý do mở khóa",
    periodEvents: "Lịch sử khóa / mở kỳ",
    confirmForceLock:
      "Kỳ này vẫn còn bảng chấm công chờ duyệt. Bạn có muốn bắt buộc khóa không?",
    from: "Từ ngày",
    to: "Đến ngày",
    withdraw: "Rút bảng công",
    deleteDraft: "Xóa nháp",
    withdrawn: "Đã rút bảng chấm công.",
    deleted: "Đã xóa bảng chấm công nháp.",
    resubmit: "Nộp lại",
    rejectedBanner: "Bảng chấm công bị từ chối: {reason}",
    rejectReason: "Lý do từ chối",
    reminderEnabled: "Nhắc chấm công",
    timeZone: "Múi giờ",
    cutoff: "Giờ nhắc",
    saveReminder: "Lưu nhắc việc",
    importCapacity: "Nhập năng lực",
    capacityImportHelp: "CSV có header: userId,date,availableMinutes.",
    weekday1: "T2",
    weekday2: "T3",
    weekday3: "T4",
    weekday4: "T5",
    weekday5: "T6",
    weekday6: "T7",
    weekday7: "CN",
    companyCalendar: "Lịch công ty",
    defaultCapacity: "Công suất chuẩn",
    batchSaveSuccess: "Đã lưu lịch công ty thành công",
    working: "Ngày làm việc",
    weekend: "Cuối tuần",
    holiday: "Nghỉ lễ",
    off: "Nghỉ không lương",
    missingWbsTitle: "Công việc chưa chấm",
    missingWbsSubtitle:
      "Nhập lý do nếu hôm đó chưa chấm công việc; lý do không miễn cảnh báo quản lý.",
    missingWbsReasonPlaceholder: "Lý do chưa chấm (tối đa 1.000 ký tự)",
    saveReason: "Lưu lý do",
    noMissingWbs: "Không còn công việc chưa chấm trong ngày này.",
    explainedWbs: "Đã giải trình ({count})",
    obligationsLoadFailed: "Không tải được danh sách công việc cần chấm.",
  },
  masterImport: {
    customersTitle: "Nhập khách hàng",
    productsTitle: "Nhập sản phẩm",
    mode: "Chế độ",
    insertOnly: "Chỉ thêm mới",
    upsert: "Thêm mới hoặc cập nhật",
    csv: "Dữ liệu CSV",
    customerHelp:
      "CSV có header: code,legalName,shortName,countryCode,taxCode,industry,sector,legalRepresentative,corporateEmail,fax,salesOwnerId.",
    preview: "Kiểm tra trước",
    commit: "Ghi dữ liệu",
    insert: "thêm mới",
    update: "cập nhật",
    errors: "lỗi",
    invalidFile: "Dữ liệu CSV không hợp lệ hoặc trống.",
    committed: "Đã ghi: {inserted} thêm mới, {updated} cập nhật.",
  },
  reports: {
    projectReports: "Báo cáo dự án",
    exportAll: "Xuất tất cả",
    exportAllHint: "Xuất mọi báo cáo theo bộ lọc đang chọn thành một tệp Excel: gom theo dự án, kèm mục lục từng báo cáo.",
    author: "Người lập",
    general: "Thông tin chung",
    periodFrom: "Từ ngày",
    periodTo: "Đến ngày",
    content: "Nội dung",
    issueTitle: "Vấn đề",
    countermeasures: "Đối sách",
    openIssues: "Đang mở",
    closedIssues: "Đã đóng",
    issueDetails: "Mô tả vấn đề",
    handling: "Phụ trách & hạn",
    allProjects: "Mọi dự án",
    schedulesHelp: "Theo lịch của từng dự án, hệ thống lấy báo cáo đã duyệt mới nhất (ngày hoặc tuần) và gửi thông báo cho người nhận. Chưa có báo cáo đã duyệt thì lượt gửi được ghi là bỏ qua và người nhận được báo.",
    whatToSend: "Gửi báo cáo nào",
    whenToSend: "Gửi lúc nào",
    everyDay: "Hằng ngày",
    everyWeek: "Hằng tuần",
    scheduleSettings: "Cấu hình",
    lastRun: "Lần gửi gần nhất",
    statuses: {
      Draft: "Nháp",
      Submitted: "Đã nộp",
      Reviewed: "Đã rà soát",
      Approved: "Đã duyệt",
      Returned: "Trả lại",
      Rejected: "Từ chối",
    },
    severities: {
      Low: "Thấp",
      Medium: "Trung bình",
      High: "Cao",
      Critical: "Nghiêm trọng",
    },
    weekdays: {
      Monday: "Thứ Hai",
      Tuesday: "Thứ Ba",
      Wednesday: "Thứ Tư",
      Thursday: "Thứ Năm",
      Friday: "Thứ Sáu",
      Saturday: "Thứ Bảy",
      Sunday: "Chủ nhật",
    },
    title: "Báo cáo dự án",
    subtitle: "Báo cáo ngày/tuần, bằng chứng và bài học kinh nghiệm",
    type: "Loại",
    period: "Kỳ báo cáo",
    workPerformed: "Công việc đã thực hiện",
    result: "Kết quả công việc",
    nextPlan: "Kế hoạch tiếp theo",
    lessons: "Bài học kinh nghiệm",
    new: "Tạo báo cáo",
    edit: "Sửa báo cáo",
    daily: "Hàng ngày",
    weekly: "Hàng tuần",
    description: "Mô tả",
    cause: "Nguyên nhân",
    receivedDate: "Ngày tiếp nhận",
    requestSource: "Nguồn yêu cầu",
    requester: "Người yêu cầu",
    issueContent: "Nội dung yêu cầu / vấn đề",
    handlingApproach: "Phương án xử lý",
    actualCompletedDate: "Ngày hoàn thành thực tế",
    sourceCustomer: "Khách hàng",
    sourceInternal: "Nội bộ",
    deadline: "Hạn xử lý",
    internalDeadline: "Hạn nội bộ",
    customerDeadline: "Hạn khách hàng",
    deliveryState: "Tình trạng giao",
    severity: "Mức độ",
    impact: "Ảnh hưởng",
    action: "Nội dung đối sách",
    completeAction: "Hoàn tất",
    evidenceId: "ID tài liệu bằng chứng",
    history: "Lịch sử phiên bản",
    review: "Rà soát",
    return: "Trả lại",
    decisionReason: "Lý do quyết định",
    lessonsLibrary: "Bài học kinh nghiệm",
    newLesson: "Ghi nhận bài học",
    lessonContent: "Nội dung bài học",
    schedules: "Gửi báo cáo định kỳ",
    newSchedule: "Tạo lịch gửi",
    editSchedule: "Sửa lịch gửi",
    frequency: "Tần suất",
    deliveryTime: "Thời điểm gửi",
    weekday: "Thứ",
    recipients: "Người nhận",
    nextRun: "Lần chạy tiếp theo",
    enable: "Bật",
    disable: "Tắt",
    project: "Dự án",
  },
  issueTracking: {
    workspace: "Không gian theo dõi yêu cầu",
    availableAfterApproval:
      "Theo dõi yêu cầu khả dụng sau khi dự án được duyệt.",
    summary: "Tổng hợp",
    requests: "Yêu cầu & xử lý",
    closure: "Đánh giá kết thúc",
    surveyTitle: "Khảo sát hài lòng khách hàng",
    surveyWarning:
      "Dự án chưa có khảo sát hài lòng (cảnh báo, không chặn kết luận đóng dự án).",
    surveyEmpty: "Chưa có khảo sát nào cho dự án này.",
    surveyDate: "Ngày khảo sát",
    surveyRespondent: "Người trả lời",
    surveyRole: "Vai trò người trả lời",
    surveySchedule: "Tiến độ",
    surveyQuality: "Chất lượng",
    surveyCommunication: "Trao đổi",
    surveySupport: "Hỗ trợ",
    surveyOverall: "Tổng thể",
    surveyRecommend: "Khả năng giới thiệu (0–10)",
    surveyComment: "Nhận xét",
    total: "Tổng yêu cầu",
    open: "Đang xử lý",
    closed: "Đã hoàn tất",
    late: "Trễ hạn",
    awaitingDecision: "Chờ quyết định",
    plannedMandays: "Tổng MD kế hoạch",
    completionRate: "Tỷ lệ hoàn tất",
    onTimeRate: "Tỷ lệ đúng / sớm hạn",
    closeOutProgress: "Đánh giá đóng dự án",
    statusDistribution: "Trạng thái yêu cầu",
    scheduleDistribution: "Tiến độ theo hạn chót",
    severityDistribution: "Mức độ nghiêm trọng",
    decisionDistribution: "Các bước quyết định",
    early: "Sớm hạn",
    onTrack: "Đúng tiến độ",
    severityLow: "Thấp",
    severityMedium: "Trung bình",
    severityHigh: "Cao",
    severityCritical: "Nghiêm trọng",
    decisionPending: "Chờ xử lý",
    decisionApproved: "Đồng ý",
    decisionRejected: "Từ chối",
    reviewsCompleted: "Đã hoàn tất {completed}/{total} đánh giá",
    newRequest: "Tạo yêu cầu",
    workflowDefinitionUnavailable:
      "Chưa có quy trình duyệt đang hoạt động cho yêu cầu xử lý.",
    workflowCreatePending: "Đã lưu yêu cầu; đang chờ khởi tạo quy trình duyệt.",
    workflowCreateStarting:
      "Quy trình duyệt đang được khởi tạo; yêu cầu vẫn có thể khôi phục.",
    workflowCreateFailed:
      "Khởi tạo quy trình duyệt thất bại; hãy thử lại với cùng mã yêu cầu.",
    workflowCreateRecoverable:
      "Lần gửi này có thể khôi phục; khi thử lại hệ thống dùng đúng payload đã lưu.",
    workflowCreateDraftChanged:
      "Bản nháp đã thay đổi sau lần gửi lỗi. Hãy tạo Lần thử mới để dùng payload đã chỉnh sửa.",
    workflowCreateNewAttemptRequired:
      "Lần thử này không có snapshot payload bất biến. Hãy tạo Lần thử mới trước khi gửi.",
    newAttempt: "Lần thử mới",
    workflowTaskState: "Việc duyệt: {state}",
    openWorkflowTask: "Mở việc duyệt",
    resumeWorkflow: "Tiếp tục gửi duyệt",
    lastUpdated: "Cập nhật",
    lastUpdatedAt: "Cập nhật lần cuối",
    createOpen: "Tạo yêu cầu",
    copyLink: "Sao chép liên kết",
    linkCopied: "Đã sao chép",
    checkpointDetails: "Chi tiết",
    summaryMetrics: "Chỉ số",
    dueOverdue: "Trễ {days} ngày",
    dueToday: "Đến hạn hôm nay",
    dueIn: "Còn {days} ngày",
    mineOnly: "Của tôi",
    mineOnlyHint: "Chỉ hiện yêu cầu bạn phụ trách, có nội dung xử lý chưa xong giao cho bạn hoặc đang chờ bạn duyệt",
    awaitingMe: "Chờ bạn duyệt",
    nextStep: "Việc tiếp theo",
    nextDecideMine: "Bạn cần quyết định mốc «{stage}»",
    nextWaitingDecision: "Đang chờ quyết định mốc «{stage}»",
    nextAddAction: "Chưa có nội dung xử lý, hãy thêm nội dung đầu tiên",
    nextOpenActions: "Còn {count} nội dung xử lý chưa hoàn tất",
    nextRecordNmi: "Các nội dung xử lý đã xong, hãy ghi «Ngày NMI hoàn thành»",
    nextRecordDelivery: "Ghi «Ngày giao khách hàng» để hoàn tất yêu cầu",
    addLogLine: "Thêm dòng nhật ký",
    addLogLineHint: "Chèn dòng mới có ngày giờ và tên bạn lên đầu ghi chú",
    unsaved: "Chưa lưu",
    saveShortcut: "Ctrl+Enter để lưu",
    unsavedCloseWarning: "«Kết quả thực tế» có thay đổi chưa lưu.",
    keepEditing: "Tiếp tục sửa",
    discardChanges: "Bỏ thay đổi",
    saveAndClose: "Lưu và đóng",
    deadlineOrder: "Hạn nội bộ phải trước hoặc bằng hạn khách hàng",
    emptyNoRequests: "Chưa có yêu cầu nào.",
    emptyCreateHint: "Chưa có yêu cầu nào. Bấm «Tạo yêu cầu» để ghi yêu cầu đầu tiên.",
    emptyFiltered: "Không có yêu cầu phù hợp bộ lọc.",

    nmiCompletedDate: "Ngày NMI hoàn thành",
    customerDeliveredDate: "Ngày giao khách hàng",
    picCheckpoint: "PIC xác nhận",
    confirmCheckpoint: "Xác nhận",
    approvalCheckpoint: "Đã duyệt",
    decisionComment: "Nhập ghi chú quyết định (bắt buộc khi từ chối)",
    actualTracking: "Kết quả thực tế",
    notes: "Ghi chú",
    addAction: "Thêm nội dung xử lý",
    actions: "Danh sách xử lý",
    completedAt: "Hoàn tất lúc",
    evidence: "Bằng chứng",
    documents: "Tài liệu yêu cầu",
    issuesAndObservations: "Vấn đề / nhận xét",
    lessonsLearned: "Bài học kinh nghiệm",
    finalConclusion: "Kết luận cuối cùng",
    outcome: "Kết quả",
    canClose: "Có thể kết thúc dự án",
    cannotClose: "Chưa thể kết thúc dự án",
    conclusionComment: "Nội dung kết luận",
    roleLeader: "Trưởng dự án",
    roleImplementation: "Triển khai",
    roleProduction: "Sản xuất",
    roleSales: "Kinh doanh",
    roleDirector: "Ban giám đốc",
  },
  documentCategory: {
    Survey: "Khảo sát",
    Drawing: "Bản vẽ",
    Contract: "Hợp đồng",
    Report: "Báo cáo",
    Other: "Khác",
  },
  ganttStage: { notStarted: "Chưa", inProgress: "Đang", completed: "Đã", cancelled: "Hủy" },
  wbsAssignees: {
    label: "Người được gán",
    help: "Giữ Ctrl hoặc Cmd để chọn nhiều người.",
  },
  status: {
    draft: "Nháp",
    stockissue: "Xuất kho (FIFO)",
    active: "Hoạt động",
    inactive: "Ngưng hoạt động",
    discontinued: "Ngừng kinh doanh",
    submitted: "Đã gửi",
    reviewed: "Đã rà soát",
    confirmed: "Đã xác nhận",
    approved: "Đã duyệt",
    rejected: "Từ chối",
    returned: "Trả lại",
    pending: "Chờ duyệt",
    pendingconfirmation: "Chờ xác nhận",
    adminreceived: "HCNS đã nhận",
    accountingreceived: "Kế toán đã nhận",
    received: "Đã tiếp nhận",
    missing: "Thiếu",
    nonworkday: "Ngày nghỉ",
    planned: "Kế hoạch",
    due: "Đến hạn",
    overdue: "Quá hạn",
    delivered: "Đã giao",
    closed: "Đã đóng",
    cancelled: "Đã hủy",
    notapplicable: "N/A – Không thực hiện",
    notstarted: "Chưa bắt đầu",
    inprogress: "Đang thực hiện",
    blocked: "Bị chặn",
    withdrawn: "Đã rút",
    completed: "Hoàn thành",
    early: "Sớm",
    ontrack: "Đúng hạn",
    atrisk: "Nguy cơ trễ",
    late: "Trễ",
    low: "Thấp",
    normal: "Bình thường",
    high: "Cao",
    critical: "Khẩn cấp",
    disbursing: "Chờ chi tiền",
    paid: "Đã chi",
    notsubmitted: "Chưa gửi",
    pendingapproval: "Chờ duyệt",
    quoted: "Đã báo giá",
    reversed: "Đã đảo",
    available: "Sẵn có",
    open: "Đang mở",
    resolved: "Đã xử lý",
    medium: "Trung bình",
  },
  documentRevisions: {
    title: "Lịch sử sửa",
    history: "Lịch sử",
    edit: "Sửa",
    empty: "Chưa có lần sửa nào.",
    version: "Phiên bản",
    changedAt: "Thời điểm",
    changedBy: "Người sửa",
    reason: "Lý do",
    changes: "Trước → sau",
    reasonLabel: "Lý do sửa",
    reasonRequired: "Nhập lý do sửa.",
    line: "Dòng {n}",
    lineAdded: "thêm dòng",
    lineRemoved: "xoá dòng",
    you: "Bạn",
    invoiceTitle: "Sửa hoá đơn",
    cashTitle: "Sửa bút toán",
    bankTitle: "Sửa dòng sao kê",
    paidLocked: "Hoá đơn đã có thu tiền: chỉ sửa được người đảm trách, số tờ khai và hạn thanh toán. Muốn sửa tiền/dòng hàng phải gỡ lần thu trước.",
    cashMoneyHint: "Đổi quỹ, ngày, loại thu/chi hoặc số tiền sẽ đảo bút toán cũ và ghi bút toán mới liên kết; các trường khác sửa tại chỗ.",
    sourceManaged: "Bút toán sinh từ phiếu chi: chỉ sửa trường mô tả; số tiền phải sửa ở phiếu nguồn.",
    bankImmutable: "Số tiền và ngày ngân hàng không sửa được; chỉ sửa phân loại, ghi chú, trực thuộc.",
    periodHint: "Tháng đã chốt thì phải mở lại kỳ trước khi sửa.",
    fields: {
      issueDate: "Ngày hoá đơn",
      invoiceNumber: "Số hoá đơn",
      responsibleName: "Người đảm trách",
      affiliationCode: "Trực thuộc",
      customsDeclarationNumber: "Số tờ khai",
      dueDate: "Hạn thanh toán",
      currency: "Tiền tệ",
      amount: "Số tiền",
      itemCode: "Mã hàng",
      model: "Model",
      serial: "Serial",
      description: "Nội dung",
      itemGroup: "Nhóm hàng",
      classification: "Phân loại",
      quantity: "Số lượng",
      unit: "ĐVT",
      unitPrice: "Đơn giá",
      taxRatePercent: "Thuế suất",
      projectCode: "Dự án",
      commercialPoCode: "PO thương mại",
      materialId: "Vật tư",
      invoiceDate: "Ngày hoá đơn",
      supplierName: "Nhà cung cấp",
      endUser: "Người dùng cuối",
      purchaseOrderNumber: "Số P/O",
      expenseCategoryCode: "Mã chi phí",
      exchangeRate: "Tỉ giá",
      totalAmount: "Tổng tiền",
      note: "Ghi chú",
      fund: "Quỹ",
      entryDate: "Ngày",
      receiptAmount: "Thu",
      disbursementAmount: "Chi",
      documentRef: "Chứng từ",
      payeeName: "Người nhận/nộp",
      payeeUnit: "Trực thuộc",
      flowCode: "Phân loại dòng tiền",
      matchedPaymentRequestId: "Khớp phiếu chi",
      matchedInvoicePaymentId: "Khớp thu hoá đơn",
      matchedSupplierInvoicePaymentId: "Khớp trả NCC",
      replacedByEntryId: "Bút toán thay thế",
      reversalEntryId: "Bút toán đảo",
    },
  },
  systemSettings: {
    title: "Cài đặt hệ thống",
    subtitle: "Cấu hình tổ chức, bảo mật, email, lịch và tích hợp. Mỗi nhóm lưu riêng, có hiệu lực ngay và được ghi lịch sử.",
    general: "Thông tin tổ chức",
    security: "Bảo mật & phiên đăng nhập",
    auditGroup: "Lưu trữ nhật ký",
    organizationName: "Tên tổ chức",
    organizationNameHint: "Hiển thị ở màn đăng nhập, email và tiêu đề hệ thống.",
    supportEmail: "Email hỗ trợ",
    supportPhone: "Điện thoại hỗ trợ",
    defaultLanguage: "Ngôn ngữ mặc định",
    defaultLanguageHint: "Áp dụng khi người dùng chưa tự chọn ngôn ngữ trên thanh trên cùng.",
    languages: {
      vi: "Tiếng Việt",
      en: "English",
    },
    fields: {
      failureLimit: "Số lần đăng nhập sai trước khi tạm khóa",
      windowMinutes: "Thời gian tạm khóa (phút)",
      minLength: "Độ dài mật khẩu tối thiểu",
      accessTokenMinutes: "Thời hạn phiên truy cập (phút)",
      retentionDays: "Thời gian lưu nhật ký hệ thống (ngày, 0 = giữ mãi)",
    },
    default: "mặc định {value}",
    reason: "Lý do thay đổi",
    reasonHint: "Lý do thay đổi (ghi vào lịch sử phân quyền)",
    discard: "Bỏ thay đổi",
    saved: "Đã lưu, có hiệu lực ngay.",
    readOnly: "Bạn chỉ có quyền xem cài đặt.",
    updatedAt: "Cập nhật lần cuối {at}",
    unsaved: "Có thay đổi chưa lưu",
    copy: "Sao chép",
    copied: "Đã chép",
    navGroup: {
      organization: "Tổ chức",
      security: "Bảo mật",
      integrations: "Tích hợp",
      platform: "Nền tảng",
    },
    nav: {
      overview: "Tổng quan",
      general: "Thông tin chung",
      security: "Đăng nhập & mật khẩu",
      audit: "Nhật ký",
      email: "Email & thông báo",
      calendar: "Lịch Google & Microsoft",
      webpush: "Thông báo đẩy",
      platform: "Hệ thống & tính năng",
      ecosystem: "Hệ sinh thái Q One",
    },
    intro: {
      general: "Tên tổ chức, thông tin hỗ trợ và ngôn ngữ mặc định của giao diện.",
      security: "Chính sách khóa đăng nhập, độ dài mật khẩu và thời hạn phiên truy cập.",
      audit: "Thời gian giữ nhật ký thao tác hệ thống trước khi tự xóa.",
    },
    overview: {
      intro: "Trạng thái cấu hình hiện hành. Chọn một mục để chỉnh sửa.",
      on: "Đang bật",
      off: "Đang tắt",
      password: "Mật khẩu tối thiểu {n} ký tự",
      session: "Phiên truy cập {n} phút",
      deploymentTitle: "Tham số còn ở cấu hình triển khai",
      deploymentHint: "Chuỗi kết nối CSDL, RabbitMQ, khóa ký JWT, khóa nội bộ giữa các service, thư mục lưu trữ, cổng/tên miền và Cloudflare Tunnel vẫn đặt trong .env vì cần có trước khi hệ thống khởi động hoặc là bí mật gốc.",
    },
    source: {
      locked: "Khóa bởi môi trường",
      lockedHint: "Môi trường triển khai (vd DEV ép email về Mailpit) khóa nhóm này; giá trị trong CSDL không được áp dụng.",
      database: "Lưu trong CSDL",
      deployment: "Cấu hình triển khai",
      deploymentHint: "Chưa lưu trên giao diện: đang dùng appsettings/biến môi trường. Lưu lần đầu sẽ chuyển nhóm này vào CSDL.",
      reset: "Khôi phục cấu hình triển khai",
      resetTitle: "Khôi phục cấu hình triển khai",
      resetContext: "Xóa bản lưu trong CSDL; nhóm này quay lại dùng appsettings/biến môi trường.",
    },
    secret: {
      keep: "Đã đặt — để trống để giữ nguyên",
      empty: "Chưa đặt",
      unreadable: "Không giải mã được — nhập lại",
      unreadableHint: "Giá trị đã lưu được mã hóa bằng khóa của môi trường khác (vd DB chép từ Production). Hãy nhập lại.",
      willClear: "Sẽ xóa khi lưu",
      clear: "Xóa giá trị",
      undoClear: "Không xóa nữa",
    },
    emailNotifications: {
      intro: "Một tài khoản SMTP cho email thông báo, quên mật khẩu và phiếu lương (bên trái); nhịp gửi email thông báo, giờ yên lặng, thời gian hiển thị và lưu giữ thông báo (bên phải). Hai phần lưu cùng một lần.",
    },
    email: {
      intro: "Tài khoản SMTP gửi email thông báo, đặt lại mật khẩu và phiếu lương.",
      enabled: "Bật gửi email",
      enabledHint: "Tắt thì hệ thống không gửi email nào (thông báo vẫn hiện trong ứng dụng).",
      account: "Tài khoản gửi",
      presets: "Điền nhanh:",
      preset: {
        microsoft365: "Microsoft 365",
        google: "Google Workspace",
      },
      host: "Máy chủ SMTP",
      port: "Cổng",
      security: "Bảo mật",
      tls: "STARTTLS/TLS",
      noTls: "Không mã hóa",
      userName: "Tên đăng nhập",
      password: "Mật khẩu / App password",
      fromAddress: "Địa chỉ gửi",
      fromName: "Tên hiển thị",
      usage: "Sử dụng cho",
      notifications: "Email thông báo",
      notificationsHint: "Phê duyệt, công việc, nhắc hạn… theo cài đặt nhận email của từng người.",
      passwordReset: "Quên mật khẩu",
      passwordResetHint: "Gửi liên kết đặt lại mật khẩu; cần TLS và địa chỉ hệ thống https.",
      payroll: "Phiếu lương",
      payrollHint: "Gửi phiếu lương (PDF có mật khẩu) cho nhân viên.",
      payrollSeparate: "Dùng tài khoản riêng cho phiếu lương",
      payrollSeparateHint: "Vd hộp thư kế toán/nhân sự riêng.",
      test: "Gửi email thử",
      testHint: "Gửi bằng cấu hình đang hiệu lực để kiểm tra kết nối SMTP.",
      testTo: "Email người nhận",
      testPayroll: "Dùng tài khoản phiếu lương",
      testSend: "Gửi thử",
      testSent: "Đã gửi email thử tới {to}.",
      saveBeforeTest: "Lưu thay đổi trước khi gửi thử.",
    },
    calendar: {
      intro: "Ứng dụng OAuth để người dùng kết nối Google Calendar và Microsoft 365/Outlook: đồng bộ hai chiều sự kiện, tạo link Meet/Teams.",
      enable: "Cho phép kết nối",
      googleClientId: "Client ID",
      microsoftClientId: "Application (client) ID",
      clientSecret: "Client secret",
      tenant: "Tenant",
      tenantHint: "common = mọi tài khoản Microsoft; organizations = chỉ tài khoản công ty; hoặc Tenant ID/tên miền của bạn.",
      redirectUri: "Redirect URI (đăng ký vào ứng dụng OAuth)",
      howTo: "Hướng dẫn tạo ứng dụng",
      googleStep1: "Google Cloud Console › APIs & Services › Credentials › Create OAuth client ID (Web application); bật Google Calendar API.",
      microsoftStep1: "Microsoft Entra admin center › App registrations › New registration (Web); tạo Client secret ở Certificates & secrets.",
      openConsole: "Mở console",
      stepRedirect: "Thêm Redirect URI:",
      stepScopes: "Quyền (scope) cần cấp:",
      stepPaste: "Dán Client ID và Client secret vào đây rồi lưu; người dùng kết nối ở Tài khoản › Ứng dụng kết nối hoặc Lịch › Cài đặt.",
      redirectFollowsUrl: "Redirect URI lấy theo Địa chỉ truy cập hệ thống (Hệ thống & tính năng).",
    },
    webpush: {
      intro: "Thông báo đẩy ra màn hình máy tính/điện thoại qua trình duyệt (chuẩn Web Push, khóa VAPID).",
      enabled: "Bật thông báo đẩy",
      enabledHint: "Người dùng vẫn phải tự cho phép trên trình duyệt (Tài khoản › Thông báo).",
      keys: "Khóa VAPID",
      subject: "Subject",
      subjectHint: "mailto: hoặc https:// liên hệ của quản trị viên, gửi kèm cho dịch vụ push.",
      publicKey: "Public key",
      privateKey: "Private key",
      generateHint: "Tạo cặp khóa một lần, không đổi về sau (đổi khóa làm mất đăng ký push hiện có):",
    },
    notifications: {
      intro: "Thời gian hiển thị và lưu giữ thông báo, nhịp gửi email, trần thư mỗi ngày và giờ yên lặng (ADR-089). Lưu xong áp dụng trong khoảng một phút.",
      display: "Hiển thị và lưu giữ",
      legacyAudienceDays: "Hiển thị thông báo cũ theo vai trò/phòng ban (ngày)",
      legacyAudienceDaysHint: "Thông báo gửi chung theo vai trò hoặc phòng ban (cách cũ) chỉ hiện trong chuông và được đếm chưa đọc trong số ngày này.",
      readRetentionDays: "Giữ thông báo đã đọc (ngày)",
      readRetentionDaysHint: "Thông báo đã đọc cũ hơn số ngày này được tự xóa. 0 = không tự xóa; tối thiểu 30 ngày.",
      deliveryLogRetentionDays: "Giữ nhật ký giao tin (ngày)",
      deliveryLogRetentionDaysHint: "Bản ghi xử lý, giao tin, email và chống trùng đã kết thúc được dọn sau số ngày này.",
      email: "Email thông báo",
      emailDefaultCadence: "Nhịp gửi email mặc định",
      emailDefaultCadenceHint: "Áp dụng cho người dùng chưa tự chọn ở Tài khoản › Thông báo.",
      cadenceImmediate: "Gửi ngay",
      cadenceHourly: "Thư tổng hợp mỗi giờ",
      cadenceDaily: "Thư tổng hợp hằng ngày",
      dailyDigestHour: "Giờ gửi thư tổng hợp hằng ngày",
      emailDailyLimit: "Tối đa email mỗi người mỗi ngày",
      emailDailyLimitHint: "0 = không giới hạn. Thông báo vượt trần được gộp vào thư tổng hợp kế tiếp.",
      quietHours: "Giờ yên lặng",
      quietHoursEnabled: "Không gửi email trong giờ yên lặng",
      quietHoursEnabledHint: "Thông báo phát sinh trong khung giờ này được gộp vào một thư khi hết giờ yên lặng.",
      quietHoursStart: "Từ",
      quietHoursEnd: "Đến",
      timeZone: "Múi giờ",
      timeZoneHint: "Tên IANA, ví dụ Asia/Ho_Chi_Minh.",
      overviewLine: "Hiển thị {days} ngày · email {cadence}",
    },
    platform: {
      intro: "Địa chỉ truy cập hệ thống và các cờ tính năng trước đây đặt bằng biến Docker.",
      address: "Địa chỉ truy cập",
      publicBaseUrl: "Địa chỉ truy cập hệ thống",
      publicBaseUrlHint: "Dùng cho liên kết trong email, OAuth redirect của lịch và trang đặt lại mật khẩu (vd https://crm.nmi.vn).",
      features: "Tính năng",
      projectIssueWorkflow: "Phê duyệt vấn đề dự án qua quy trình",
      projectIssueWorkflowHint: "Vấn đề dự án đi qua Workflow (người duyệt theo trưởng dự án).",
      projectCancellation: "Hủy dự án",
      projectCancellationHint: "Cho phép yêu cầu hủy dự án theo quy trình phê duyệt.",
      documentStorage: "Lưu trữ hồ sơ dự án",
      documentStorageHint: "Hồ sơ dự án luôn được ghi vào kho trên máy chủ. Chế độ Q One Document đẩy thêm một bản lên doc.nmi.vn theo cây thư mục chuẩn NMI Rev01, bằng tài khoản của người tải lên.",
      documentStorageLocal: "Chỉ lưu trên máy chủ (thư mục data)",
      documentStorageQOneDocument: "Đồng bộ lên Q One Document",
      documentStorageQOneDocumentHint: "Hồ sơ đẩy lên QOD dưới tài khoản QOD của người tải (lần đầu tự liên kết theo email hoặc tạo mới); QOD phải bật «Đăng nhập bằng Q One». Khi QOD mất kết nối, tệp vẫn được lưu và tự đồng bộ lại sau.",
      overviewStorageLocal: "Hồ sơ dự án: chỉ trên máy chủ",
      overviewStorageQOneDocument: "Hồ sơ dự án: đồng bộ Q One Document",
      qodApiBaseUrl: "Địa chỉ gateway Q One Document",
      qodApiBaseUrlHint: "CRM gọi API tích hợp của QOD qua địa chỉ này. Cùng máy chủ Docker: http://host.docker.internal:5188; khác máy: địa chỉ công khai, ví dụ https://doc.nmi.vn.",
      qodApiKey: "Khóa tích hợp Q One Document",
      qodApiKeyHint: "Phải trùng QOD_CRM_INTEGRATION_API_KEY trong cấu hình triển khai của Q One Document. Không hiển thị lại sau khi lưu.",
      qodWebBaseUrl: "Địa chỉ web Q One Document",
      qodWebBaseUrlHint: "Dùng cho liên kết «Mở trên Q One Document» (ví dụ https://doc.nmi.vn).",
      qodTestHint: "Lưu xong, kiểm tra kết nối ở Hệ sinh thái Q One › Kiểm tra kết nối. Token người tải lên xin qua Q One Platform khi bật «Đăng nhập bằng Q One».",
      restartNotice: "Bật/tắt Hủy dự án và bộ chọn trưởng dự án của Workflow cần khởi động lại service tương ứng để đổi đăng ký; các mục khác có hiệu lực trong khoảng 1 phút.",
    },
    ecosystem: {
      intro: "Đăng nhập CRM bằng tài khoản Q One Platform (IdP chung của hệ sinh thái, như Q One Document và Q One EDU). CRM chỉ cho vào khi có tài khoản CRM cùng email; vai trò và quyền vẫn quản lý ở CRM. Lưu xong có hiệu lực ngay.",
      login: "Đăng nhập bằng Q One",
      enabled: "Cho phép đăng nhập bằng Q One",
      enabledHint: "Hiện nút «Đăng nhập bằng Q One» ở màn đăng nhập CRM.",
      authority: "Địa chỉ Q One Platform (issuer)",
      authorityHint: "Ví dụ https://qone.nmi.vn/ — phải trùng issuer của Platform. Ứng dụng CRM phải được cho phép ở Q One Platform › Hệ thống › Cấu hình › Đăng nhập hệ sinh thái Q One.",
      clientId: "Client ID của web CRM",
      clientIdHint: "Client công khai đăng ký ở Platform (mặc định qone-crm-web), redirect về https://<địa chỉ CRM>/auth/callback.",
      service: "Client dịch vụ (token ủy quyền)",
      delegate: "Xin token ủy quyền gửi Q One Document qua Q One Platform",
      delegateHint: "Khi đồng bộ hồ sơ lên Q One Document, CRM xin token thay mặt người tải ở Platform bằng client dịch vụ này.",
      serviceClientId: "Client ID dịch vụ",
      serviceClientSecret: "Client secret dịch vụ",
      serviceClientSecretHint: "Secret của client qone-crm-service ở Platform (tệp oidc.env trên máy chủ Platform). Không hiển thị lại sau khi lưu.",
      test: "Kiểm tra kết nối",
      testHint: "Dùng cấu hình đã lưu: đọc discovery của Platform, lấy token của client dịch vụ và thử khóa tích hợp Q One Document (khi bật đồng bộ).",
      testRun: "Kiểm tra",
      check: {
        platformDisabled: "Đăng nhập bằng Q One đang tắt",
        platformDiscovery: "Q One Platform phản hồi, issuer khớp",
        platformService: "Client dịch vụ lấy được token ủy quyền",
        document: "Q One Document nhận khóa tích hợp",
      },
      detail: {
        secret: "chưa nhập client secret",
        missing: "chưa nhập địa chỉ hoặc khóa tích hợp",
        key: "khóa tích hợp sai",
        qone_login_disabled: "Q One Document chưa bật «Đăng nhập bằng Q One»",
      },
    },
  },
  usage: {
    tabs: { overview: "Tổng quan sử dụng", accounts: "Tài khoản" },
    period: "Kỳ thống kê",
    lastDays: "{n} ngày",
    searchAccount: "Tìm tài khoản, tên, mã NV",
    includeInactive: "Gồm tài khoản đã khoá",
    note: "Ngày có dùng = ngày làm việc (thứ 2–6) có ít nhất một thao tác hoặc lần đăng nhập. Tỉ lệ tính từ ngày tạo tài khoản. Không tính các lần gọi nền (thông báo, làm mới phiên).",
    kpi: {
      accounts: "Tài khoản hoạt động", activeInPeriod: "{n} tài khoản có dùng trong kỳ", today: "Dùng hôm nay", week: "Dùng trong 7 ngày", month: "Dùng trong 30 ngày",
      rate: "Tỉ lệ ngày có dùng (TB)", dormant: "Không dùng > 30 ngày", actions: "Lượt thao tác", writes: "{n} lượt ghi", logins: "Lần đăng nhập",
    },
    activeUsers: "Người dùng hoạt động",
    activeTrend: "Người dùng hoạt động theo thời gian",
    byArea: "Lượt dùng theo phân hệ",
    otherAreas: "Phân hệ khác",
    mostActive: "Dùng nhiều nhất",
    dormant: "Lâu không dùng",
    noDormant: "Mọi tài khoản đều có dùng trong 30 ngày qua.",
    accountsTitle: "Tần suất sử dụng theo tài khoản",
    account: "Tài khoản",
    roles: "Vai trò",
    department: "Phòng ban",
    rate: "Tỉ lệ ngày có dùng",
    activeDays: "Ngày có dùng",
    trend: "Xu hướng",
    requests: "Lượt thao tác",
    writes: "Lượt ghi",
    logins: "Đăng nhập",
    topArea: "Dùng nhiều nhất",
    lastActive: "Lần cuối",
    never: "Chưa dùng",
    today: "Hôm nay",
    daysAgo: "{n} ngày trước",
    statusActive: "Đang hoạt động",
    statusLocked: "Đã khoá",
    openPermissions: "Mở phân quyền",
    panel: { overview: "Hồ sơ tài khoản", activity: "Lịch hoạt động", areas: "Theo phân hệ", actions: "Thao tác gần đây" },
    fields: {
      employeeCode: "Mã nhân viên", position: "Chức danh", employment: "Tình trạng làm việc", createdAt: "Ngày tạo tài khoản", sessions: "Phiên đăng nhập còn hiệu lực",
      groups: "Nhóm tài khoản", directGrants: "{n} quyền gán trực tiếp", password: "Mật khẩu", mustChangePassword: "Phải đổi mật khẩu ở lần đăng nhập tới",
    },
    dayTitle: "{requests} thao tác, {writes} ghi, {logins} đăng nhập",
    legend: "Ít",
    day: "Ngày",
    firstLast: "Đầu – cuối",
    time: "Thời điểm",
    action: "Thao tác",
    area: "Phân hệ",
    noData: "Chưa có dữ liệu trong kỳ.",
    areas: {
      "projects": "Dự án",
      "customers": "Khách hàng",
      "organizations": "Đối tác & NCC",
      "products": "Sản phẩm",
      "quotations": "Báo giá",
      "customer-orders": "PO khách hàng",
      "project-contracts": "Hợp đồng",
      "document-templates": "Mẫu chứng từ",
      "timesheets": "Chấm công & đơn từ",
      "calendar": "Lịch làm việc",
      "reports": "Báo cáo",
      "dashboards": "Trung tâm điều hành",
      "workflow": "Quy trình duyệt",
      "documents": "Tài liệu",
      "chat": "Trao đổi",
      "procurement": "Mua hàng",
      "purchase-requests": "Đề nghị mua",
      "purchase-orders": "Đơn đặt hàng NCC",
      "materials": "Vật tư",
      "payment-requests": "Phiếu chi",
      "finance": "Kế toán",
      "users": "Tài khoản",
      "roles": "Vai trò",
      "audit-trail": "Nhật ký",
      "exchange-rates": "Tỷ giá",
      "login": "Đăng nhập",
      "work": "Hộp công việc",
    },
  },
  auditLog: {
    title: "Nhật ký & chẩn đoán",
    sections: { trail: "Nhật ký thao tác", outbox: "Chẩn đoán đồng bộ dữ liệu" },
    hints: { trail: "Ai làm gì, lúc nào, kết quả ra sao (không chứa nội dung dữ liệu).", outbox: "Sự kiện chờ gửi giữa các service (Outbox): tồn đọng, lỗi, lần thử lại." },
  },
  auditTrail: {
    title: "Nhật ký hệ thống",
    note: "Mọi thao tác thêm/sửa/xóa qua API: ai, lúc nào, gọi gì và kết quả. Không lưu nội dung dữ liệu.",
    occurredAt: "Thời điểm",
    actor: "Người thao tác",
    anonymous: "Chưa đăng nhập",
    method: "Thao tác",
    path: "Đường dẫn",
    area: "Khu vực",
    status: "Kết quả",
    duration: "ms",
    success: "Thành công",
    failure: "Lỗi / bị từ chối",
    from: "Từ ngày",
    to: "Đến ngày",
    searchHint: "Đường dẫn, người thao tác hoặc mã tham chiếu",
    invalidRange: "Từ ngày phải trước hoặc bằng Đến ngày.",
    export: "Xuất CSV",
    correlationId: "Mã tham chiếu",
    clientAddress: "Địa chỉ IP",
  },
  reauth: {
    title: "Xác nhận mật khẩu",
    message: "Thay đổi phân quyền cần nhập lại mật khẩu của bạn.",
    password: "Mật khẩu hiện tại",
    confirm: "Xác nhận",
  },
  errors: {
    settings_locked: "Nhóm cài đặt này bị khóa bởi môi trường triển khai.",
    email_not_configured: "Chưa cấu hình máy chủ SMTP và địa chỉ gửi.",
    email_test_failed: "Gửi email thử thất bại.",
    reauth_required: "Nhập mật khẩu hiện tại để xác nhận thay đổi phân quyền.",
    reauth_failed: "Mật khẩu không đúng.",
    ...businessErrorsVi,
    ...errorUiVi,
    payment_bank_account_required: "Chọn hoặc nhập số tài khoản ngân hàng của công ty dùng cho giao dịch này.",
    payment_bank_account_locked: "Tài khoản ngân hàng phải khớp tài khoản kế toán đã chỉ định.",
    document_revision_no_changes: "Không có thay đổi nào để lưu.",
    document_revision_reason_required: "Nhập lý do sửa chứng từ.",
    invoice_has_payments: "Hoá đơn đã có thu tiền: gỡ lần thu trước khi sửa tiền, ngày hoặc dòng hàng.",
    cash_entry_source_managed: "Bút toán sinh từ phiếu chi: sửa số tiền ở phiếu nguồn.",
    invoice_number_occupied: "Số hoá đơn đã được dùng cho cùng đích.",
    cash_entry_already_reversed: "Bút toán đã bị đảo, không sửa được.",
    cash_entry_is_reversal: "Bút toán đảo không sửa được.",
    payment_expense_category_required: "Kế toán cần gắn mã chi phí cho mọi dòng trước khi chi.",
    expense_category_scope_mismatch: "Mã chi phí không đúng phạm vi: dự án không dùng mã chi phí văn phòng, chi phí văn phòng không dùng mã phát sinh dự án.",
    supplier_invoice_allocation_conflict: "Không được chọn dự án ở đầu hóa đơn khi đã phân bổ theo từng dòng.",
    supplier_invoice_line_allocation_required: "Mỗi dòng hóa đơn NCC phải chọn đúng một dự án hoặc mã PO thương mại ngoài.",
    invoice_line_allocation_required: "Mỗi dòng hóa đơn bán phải chọn đúng một dự án hoặc mã PO thương mại ngoài.",
    invoice_line_allocation_conflict: "Không được trộn P/O hoặc dự án đầu hóa đơn với phân bổ theo từng dòng.",
    invoice_customer_mismatch: "Các dự án trên hóa đơn phải thuộc cùng một khách hàng.",
    invalid_customer: "Chọn khách hàng đang hoạt động cho các dòng PO thương mại ngoài.",
    supplier_invoice_service_not_stock:
      "Dòng dịch vụ không thể nhập kho vật tư.",
    stock_backdate_blocked: "Không nhập/xuất kho lùi ngày trước phiếu xuất đã duyệt gần nhất của vật tư. Đảo các phiếu xuất phía sau trước.",
    stock_receipt_consumed: "Phiếu nhập này đã bị xuất (giá vốn FIFO). Đảo các phiếu xuất đã lấy từ phiếu nhập trước.",
    invoice_service_not_stock: "Dòng dịch vụ không xuất kho.",
    invoice_material_unit_mismatch: "ĐVT của dòng khác ĐVT vật tư.",
    supplier_invoice_material_mismatch:
      "Chọn vật tư đang hoạt động có cùng đơn vị tính với dòng hóa đơn.",
    supplier_invoice_material_required:
      "Chọn vật tư kho cho dòng hóa đơn trước khi tạo phiếu nhập.",
    supplier_invoice_stock_locked:
      "Không thể thay đổi nguồn hóa đơn/phiếu nhập khi đang liên kết kho.",
    amortization_affiliation_locked:
      "Không thể thay đổi trực thuộc sau khi đã phân bổ.",
    amortization_opening_locked:
      "Không thể thay đổi số dư phân bổ ban đầu sau khi đã phân bổ.",
    invoice_lines_immutable:
      "Dòng hàng đã phát hành không sửa trực tiếp; hãy lập hóa đơn thay thế.",
    login_rate_limited:
      "Đăng nhập sai quá nhiều lần. Vui lòng chờ vài phút rồi thử lại.",
    bank_match_no_candidate:
      "Không có chứng từ nào khớp đúng số tiền và loại tiền trong ±15 ngày.",
    bank_match_ambiguous:
      "Có nhiều chứng từ cùng khớp; hãy mở “Đối soát” để chọn tay.",
    bank_line_already_matched: "Dòng sao kê này đã được khớp.",
    bank_batch_too_large: "Một lượt chỉ xử lý tối đa 200 dòng sao kê.",
    finance_period_blocked:
      "Kỳ còn hạng mục chặn chốt. Xử lý xong rồi chốt lại.",
    finance_period_already_closed:
      "Kỳ này đã được chốt. Mở lại trước khi chốt lần nữa.",
    finance_period_not_closed: "Chỉ mở lại được kỳ đang ở trạng thái đã chốt.",
    finance_period_not_ended: "Chỉ chốt được kỳ đã kết thúc.",
    finance_reopen_reason_too_short: "Lý do mở lại cần ít nhất 10 ký tự.",
    supplier_allocation_exceeds_payment:
      "Tổng phân bổ vượt số tiền thực chi của phiếu.",
    supplier_allocation_mixed_suppliers:
      "Một phiếu chi chỉ phân bổ cho hoá đơn của một nhà cung cấp.",
    supplier_allocation_duplicate:
      "Phiếu chi đã có dòng phân bổ cho hoá đơn này. Gỡ dòng cũ trước khi phân bổ lại.",
    contract_signed_date_required:
      "Cần nhập ngày PO trước khi kích hoạt hợp đồng.",
    contract_invalid_transition:
      "Trạng thái hợp đồng không cho phép thao tác này.",
    contract_not_editable:
      "Hợp đồng đã hoàn tất hoặc chấm dứt nên không sửa được.",
    contract_number_taken: "Số hợp đồng đã được dùng.",
    acceptance_remarks_required:
      "Cần ghi chú tồn tại khi kết quả không phải “Đạt”.",
    acceptance_warranty_not_allowed:
      "Biên bản không đạt thì không bắt đầu bảo hành.",
    acceptance_number_taken: "Số biên bản đã được dùng trong dự án này.",
    acceptance_already_void: "Biên bản này đã bị huỷ.",
    warranty_invalid_transition:
      "Trạng thái phiếu bảo hành không cho phép thao tác này.",
    warranty_assignee_required: "Cần có người nhận xử lý trước khi bắt đầu.",
    project_not_writable: "Dự án bị từ chối nên không ghi được hợp đồng hay phiếu bảo hành.",
    project_cancelled: "Dự án đã hủy nên không thể ghi dữ liệu nghiệp vụ.",
    cancellation_active: "Dự án đang được hủy; hãy kiểm tra trạng thái trước khi thao tác tiếp.",
    project_cancellation_preparing: "Dự án đang chuẩn bị hủy nên chưa thể ghi dữ liệu nghiệp vụ.",
    payroll_password_notice_unknown: "Chưa xác định email mật khẩu đã được gửi hay chưa. Cần đối soát trước khi tiếp tục gửi phiếu lương.",
    payroll_password_notice_failed: "Thông báo mật khẩu gửi thất bại. Chọn gửi lại các lần thất bại sau khi xử lý nguyên nhân.",
    payroll_password_mismatch: "Phiếu lương cũ dùng mật khẩu khác với mật khẩu đã cấp. Cần kiểm tra hoặc phát hành bản điều chỉnh trước khi gửi.",
    payroll_password_credential_missing: "Yêu cầu gửi cũ chưa có thông tin mật khẩu. Tải lại bảng lương và yêu cầu gửi lại lần thất bại.",
    email_authentication_failed: "Máy chủ email từ chối đăng nhập. Kiểm tra tài khoản gửi và mật khẩu ứng dụng SMTP.",
    email_configuration_invalid: "Cấu hình SMTP chưa hợp lệ. Kiểm tra máy chủ, cổng, TLS và địa chỉ gửi.",
    payroll_recipient_rejected: "Máy chủ email từ chối người nhận. Kiểm tra địa chỉ email trước khi gửi lại.",
    amortization_source_locked: "Không đổi nguồn mua hoặc nguyên giá, loại và ngày ghi nhận của khoản phân bổ đã liên kết.",
    amortization_source_in_use: "Khoản mua này đã có lịch phân bổ; không thể lập trùng hoặc đảo bút toán nguồn.",
    amortization_source_invalid: "Nguồn mua không còn hợp lệ, đã đảo hoặc đã được chọn phân bổ.",
    amortization_source_mismatch: "Nguyên giá, loại, tiền tệ và ngày ghi nhận phải khớp nguồn mua; tháng phân bổ không được trước tháng mua.",
    bank_invoice_required: "Chọn hóa đơn hợp lệ để ghi nhận thanh toán công nợ.",
    bank_manual_link_locked: "Giao dịch ngân hàng đã liên kết công nợ; không thể gỡ liên kết hoặc xóa thanh toán riêng lẻ.",
    payroll_employee_linked: "Nhân viên có khoản chi đã liên kết vào kỳ lương. Hãy xử lý liên kết trước khi xóa khỏi bảng lương.",
    finance_period_closed: "Kỳ tài chính đã chốt. Cần mở lại kỳ trước khi thay đổi số liệu.",
    amortization_code_exists: "Mã khoản phân bổ đã tồn tại.",
    amortization_effective_month:
      "Tháng hiệu lực phải từ tháng hiện tại trở đi.",
    amortization_revision_order:
      "Tháng hiệu lực không được trước một lần điều chỉnh đã có.",
    amortization_currency_locked:
      "Không đổi được loại tiền của khoản phân bổ đã tạo.",
    amortization_below_allocated:
      "Tổng tiền không được nhỏ hơn phần đã phân bổ trước tháng hiệu lực.",
    amortization_no_remaining_period:
      "Cần kéo dài số kỳ để phân bổ hết phần còn lại sau tháng hiệu lực.",
    expense_category_unknown: "Mã chi phí không tồn tại.",
    bank_csv_empty: "Tệp sao kê rỗng.",
    bank_csv_header_not_found:
      "Không tìm thấy dòng tiêu đề có cột ngày và cột ghi có/ghi nợ.",
    bank_csv_too_large: "Tệp sao kê vượt số dòng tối đa cho một lần nhập.",
    bank_csv_no_rows: "Tệp có tiêu đề nhưng không có dòng sao kê nào đọc được.",
    bank_csv_invalid_quotes: "Tệp CSV kết thúc giữa một ô đang mở dấu nháy.",
    bank_match_not_paid: "Chỉ đối soát được với phiếu chi đã thực chi.",
    bank_match_taken: "Chứng từ này đã được khớp với dòng sao kê khác.",
    bank_line_is_credit: "Dòng ghi có không khớp được với phiếu chi.",
    bank_line_is_debit: "Dòng ghi nợ không khớp được với khoản thu hoá đơn.",
    cash_opening_future:
      "Không xác nhận số dư đầu kỳ cho ngày trong tương lai.",
    cash_opening_exists:
      "Đã có số dư đầu kỳ cho loại tiền và ngày này; hãy ghi một lần xác nhận mới theo ngày khác.",
    cash_negative_confirmation_required:
      "Khoản chi này làm quỹ tiền mặt âm. Cần xác nhận kèm lý do để tiếp tục.",
    payroll_payment_ineligible:
      "Chỉ gắn được khoản chi VND cho nhân viên, chưa chi và chọn hình thức qua lương.",
    advance_not_found: "Không tìm thấy phiếu tạm ứng được tham chiếu.",
    currency_mismatch:
      "Phiếu hoàn ứng phải dùng đúng loại tiền của phiếu tạm ứng.",
    workflow_definition_mismatch:
      "Quy trình duyệt đang bật không khớp chính sách duyệt đã chốt của phiếu.",
    workflow_submit_not_ready:
      "Bước đầu của quy trình duyệt chưa sẵn sàng. Thử lại sau ít phút.",
    supplier_invoice_void: "Hoá đơn đã huỷ thì không ghi thanh toán được.",
    supplier_invoice_overpayment:
      "Số tiền trả vượt phần còn phải trả của hoá đơn.",
    supplier_invoice_overpaid: "Tổng các lần trả vượt tổng hoá đơn.",
    supplier_invoice_payment_held:
      "Hoá đơn lệch P/O hoặc chưa nhận đủ hàng nên đang giữ thanh toán. Cần người có quyền giải trình để mở.",
    supplier_invoice_exists: "Hoá đơn này của nhà cung cấp đã tồn tại.",
    supplier_invoice_source_locked:
      "Không đổi được nhà cung cấp, dự án, loại tiền khi đã có phiếu chi gắn với hoá đơn.",
    supplier_invoice_has_payments:
      "Gỡ các lần thanh toán trước khi sửa hoặc huỷ hoá đơn.",
    supplier_invoice_lines_required: "Hoá đơn cần ít nhất một dòng.",
    supplier_payment_request_not_paid:
      "Chỉ phiếu chi đã thực chi mới dùng để trả hoá đơn.",
    supplier_payment_request_taken:
      "Phiếu chi này đã dùng để trả một hoá đơn khác.",
    supplier_payment_source_locked:
      "Khoản trả sinh từ phiếu chi nguồn không gỡ được; dùng quy trình đảo thanh toán có thẩm quyền.",
    exchange_rate_snapshot_required:
      "Hoá đơn ngoại tệ cần tỷ giá có nguồn và ngày hiệu lực không sau ngày hoá đơn.",
    invoice_slot_occupied: "Lần xuất hoá đơn này đã được dùng.",
    invoice_slot_out_of_order:
      "Phải xuất hoá đơn theo đúng thứ tự lần kế tiếp.",
    invoice_slot_invalid: "Lần xuất hoá đơn phải lớn hơn 0.",
    payment_payer_required: "Chọn người chi / thu tiền trong danh sách đã cấu hình.",
    payment_payer_invalid: "Chỉ chọn tài khoản còn hoạt động.",
    payment_payer_unavailable: "Chưa tải được danh sách người chi tiền. Vui lòng thử lại.",
    payment_payer_directory_unavailable: "Chưa tải được danh sách tài khoản từ hệ thống. Vui lòng thử lại.",
    invoice_slots_exhausted: "P/O đã dùng hết bốn lần xuất hoá đơn.",
    invoice_referenced_by_stock:
      "Không huỷ được hoá đơn đang được phiếu kho đã duyệt tham chiếu.",
    replacement_invoice_not_found: "Không tìm thấy hoá đơn thay thế.",
    invalid_replacement_invoice: "Hoá đơn thay thế phải thuộc cùng P/O.",
    invoice_voided: "Hoá đơn đã huỷ thì không đổi được số tiền.",
    invoice_already_voided: "Hoá đơn này đã bị huỷ.",
    invoice_amount_incomplete:
      "Số tiền, loại tiền và hạn thanh toán phải nhập cùng nhau.",
    invoice_amount_missing: "Nhập số tiền hoá đơn trước khi ghi thu.",
    payment_exceeds_invoice: "Khoản thu vượt phần còn phải thu của hoá đơn.",
    purchase_request_not_found: "Không tìm thấy yêu cầu mua hàng.",
    purchase_request_not_approved: "P/O cần một yêu cầu mua hàng đã duyệt.",
    purchase_request_immutable: "Yêu cầu mua hàng không còn sửa được.",
    purchase_request_not_editable:
      "Chỉ sửa được yêu cầu mua hàng ở trạng thái nháp.",
    purchase_request_not_deletable:
      "Chỉ xoá được bản nháp chưa vào quy trình và chưa có P/O.",
    purchase_request_lines_required: "Yêu cầu mua hàng cần ít nhất một dòng.",
    quote_not_found: "Không tìm thấy báo giá của lần sửa hiện tại.",
    invalid_editor: "Chỉ người lập mới được sửa hồ sơ này.",
    invalid_supplier: "Cần chọn nhà cung cấp đang hoạt động.",
    invalid_party: "Cần chọn đối tác đang hoạt động đúng loại.",
    invalid_material: "Vật tư trong yêu cầu mua phải đang hoạt động.",
    purchase_order_not_found: "Không tìm thấy P/O.",
    purchase_order_not_editable: "Chỉ sửa được P/O ở trạng thái nháp.",
    purchase_order_not_deletable:
      "Chỉ xoá được P/O nháp chưa có giao dịch phụ thuộc.",
    purchase_order_not_issued: "Hoá đơn cần P/O đã gửi, đã duyệt hoặc đã giao.",
    purchase_order_exceeds_request:
      "Tổng P/O vượt tổng yêu cầu mua hàng quá mức cho phép.",
    purchase_order_lines_required: "P/O cần ít nhất một dòng.",
    purchase_order_not_receivable:
      "Chỉ P/O mua từ nhà cung cấp đã duyệt mới nhận hàng được.",
    purchase_order_overreceipt: "Số lượng nhận vượt số còn lại của P/O.",
    purchase_receipt_material_mismatch:
      "Chọn vật tư đang hoạt động đúng mã hàng và đơn vị của dòng P/O.",
    project_revision_stale:
      "Thông tin dự án vừa thay đổi. Tải lại rồi thử lại.",
    insufficient_stock: "Tồn kho không đủ.",
    invalid_stock_count:
      "Số kiểm kê phải không âm và tối đa bốn chữ số thập phân.",
    stock_count_no_difference:
      "Số kiểm kê bằng số sổ sách nên không cần điều chỉnh.",
    stock_count_stale:
      "Tồn kho đã thay đổi sau lần kiểm kê này. Hãy kiểm kê lại trước khi duyệt.",
    stock_count_immutable:
      "Không sửa ảnh chụp kiểm kê; hãy tạo lần kiểm kê mới.",
    stock_transaction_not_editable: "Chỉ sửa được phiếu kho ở trạng thái nháp.",
    stock_transaction_not_deletable:
      "Chỉ xoá được phiếu kho nháp chưa vào quy trình.",
    material_approval_rejected:
      "Tiếp tục hoặc xử lý quy trình đã bị từ chối trước khi gửi duyệt lại.",
    material_immutable: "Không đổi được vật tư của phiếu này.",
    material_unit_mismatch:
      "Đơn vị của phiếu phải khớp đơn vị đang dùng của vật tư.",
    invalid_transaction_type: "Loại phiếu kho không được hỗ trợ.",
    review_separation_required:
      "Người xác nhận và người duyệt phải là hai người khác nhau.",
    duplicate_code: "Mã này đã tồn tại.",
    idempotency_conflict:
      "Thao tác này đã được gửi trước đó với nội dung khác. Tải lại rồi thử lại.",
    invalid_date_range: "Ngày kết thúc không được trước ngày bắt đầu.",
    unauthenticated: "Vui lòng đăng nhập lại.",
    employee_not_found: "Có nhân viên được chọn chưa có hồ sơ nhân viên.",
    workflow_managed_request:
      "Phần dự án này phải được duyệt qua quy trình của nó.",
    group_details_required:
      "Đơn nhóm cần có người tham gia và phân bổ theo dự án.",
    group_fields_required: "Cần nhập người tham gia và phân bổ của đơn nhóm.",
    participant_not_found:
      "Mọi người tham gia phải có hồ sơ nhân viên đã duyệt.",
    participant_allocation_required:
      "Mỗi người tham gia cần ít nhất một phân bổ dự án.",
    duplicate_participant: "Mỗi người chỉ đăng ký một lần trong một đơn.",
    approved_part_locked:
      "Không đổi được người tham gia đã gắn với phần đã duyệt.",
    travel_interval_required:
      "Cần nhập ngày giờ đi và về thực tế của từng người.",
    travel_outside_request:
      "Khoảng thời gian đi lại phải nằm trong ngày của đơn.",
    invalid_travel_form: "Công tác trong ngày phải về trong ngày đi.",
    allocation_outside_travel:
      "Phân bổ dự án phải nằm trong khoảng đi lại của người đó.",
    allocation_outside_request: "Phân bổ phải nằm trong khoảng ngày của đơn.",
    allocation_overlap:
      "Một người không thể có hai phân bổ dự án trùng giờ trong cùng ngày.",
    overtime_minimum_not_met:
      "Tổng tăng ca mỗi ngày của từng người phải trên 60 phút.",
    active_request_overlap:
      "Có người tham gia đã có đơn hiệu lực trùng thời gian này.",
    part_revision_required:
      "Phần bị từ chối phải được sửa trước khi gửi lại đơn.",
    part_not_editable: "Phần đã gửi hoặc đã xác nhận thì không sửa được.",
    request_parts_incomplete:
      "Mọi phần của đơn phải được duyệt trước khi duyệt cả đơn.",
    project_part_required: "Hãy duyệt riêng từng phần theo dự án.",
    request_type_immutable: "Không đổi được loại đơn.",
    invalid_request_group:
      "Chỉ đơn tăng ca và onsite hỗ trợ phân bổ theo nhóm.",
    leave_classification_required:
      "Chọn nghỉ có lương hay không lương trước khi gửi đơn.",
    monthly_late_limit_reached: "Mỗi tháng chỉ được hai lần điều chỉnh đi trễ.",
    invalid_late_arrival_time: "Giờ đi trễ phải từ 08:01 đến 08:59.",
    receipt_not_supported: "Chỉ đơn công tác và đơn xe có bước nhận phiếu.",
    receipt_separation_required:
      "Người nhận hành chính và người nhận kế toán phải khác nhau.",
    vehicle_in_use: "Xe đã có đơn sử dụng; hãy ngừng sử dụng xe thay vì xoá.",
    duplicate_vehicle_code: "Biển số này đã có xe khác dùng.",
    invalid_time_zone: "Múi giờ nhắc việc không được hỗ trợ.",
    profile_not_editable:
      "Chỉ sửa được hồ sơ ở trạng thái nháp hoặc bị từ chối.",
    assessment_not_editable:
      "Chỉ sửa được đánh giá ở trạng thái nháp hoặc bị từ chối.",
    assessment_header_immutable:
      "Không đổi được thông tin chung của đánh giá; hãy tạo đánh giá khác.",
    calendar_not_editable:
      "Chỉ lịch ở trạng thái nháp, bị từ chối hoặc đã duyệt mới mở được lần sửa.",
    new_calendar_revision_required:
      "Lịch đã duyệt chỉ mở lại được với số văn bản hoặc lần sửa mới.",
    invalid_author: "Chỉ người lập lịch mới sửa được thông tin chung.",
    payroll_locked: "Khoản bổ sung qua lương chỉ thêm được vào kỳ lương nháp.",
    payroll_not_calculated: "Hãy tính và rà bảng lương trước khi duyệt.",
    payroll_not_approved: "Hãy duyệt bảng lương trước khi phát hành.",
    payroll_incomplete: "Bảng lương chưa có kết quả tính đã duyệt.",
    payroll_not_published:
      "Hãy phát hành bảng lương trước khi gửi phiếu lương.",
    payroll_delivery_unknown:
      "Lần gửi trước chưa rõ kết quả. Hãy đối chiếu trước khi gửi lại.",
    payroll_already_sent:
      "Phiếu lương này đã vào hàng gửi hoặc đã được máy chủ thư nhận. Chỉ gửi lại lần đã biết là lỗi.",
    payroll_period_duplicate: "Tháng này đã có một lần lập bảng lương khác.",
    payroll_employee_duplicate:
      "Nhân viên đã có trong bảng lương. Tải lại trước khi chọn thêm.",
    payroll_recipient_invalid: "Cần một email nhận phiếu lương hợp lệ.",
    bank_match_mismatch:
      "Giao dịch ngân hàng không khớp số tiền, loại tiền hoặc hình thức thanh toán của chứng từ.",
    supplier_payment_request_mismatch:
      "Khoản trả nhà cung cấp không khớp phiếu chi đã thanh toán.",
    bank_csv_invalid_amount:
      "Sao kê có giá trị tiền không hợp lệ. Kiểm tra dòng và cột được báo.",
    project_closing:
      "Dự án đang trong thao tác đóng; không thể thay đổi lúc này.",
    invalid_rebaseline:
      "Đề nghị rebaseline phải có đúng một dòng cho mỗi công việc.",
    dependency_cycle: "Cạnh phụ thuộc này tạo ra chu trình.",
    duplicate_dependency: "Cạnh phụ thuộc đã tồn tại.",
    assignee_unknown: "Người được gán không phải tài khoản có thật.",
    progress_regression:
      "Không thể hạ % tiến độ, trừ khi mở lại việc đã hoàn thành kèm lý do.",
    forbidden_scope:
      "Bạn không nằm trong phạm vi được thao tác trên dự án này.",
    validation_failed:
      "Dữ liệu chưa hợp lệ. Vui lòng kiểm tra thông tin đã nhập.",
    wbs_has_allocations:
      "Công việc đang có phân bổ nguồn lực. Xác nhận xóa để tiếp tục.",
    wbs_child_dates_out_of_parent_range:
      "Thời gian công việc con phải nằm trong khoảng thời gian của công việc cha.",
    wbs_parent_dates_must_enclose_children:
      "Thời gian công việc cha phải bao trùm toàn bộ các công việc con.",
    summary_node_progress_locked:
      "Tiến độ công việc cha được tính tự động từ các công việc con.",
    wbs_reparenting_not_allowed:
      "Không thể thay đổi công việc cha. Vui lòng xóa và tạo lại dưới công việc cha mới.",
    company_calendar_year_locked: "Lịch làm việc năm này đã bị khóa.",
    date_range_too_large: "Khoảng ngày yêu cầu vượt giới hạn cho phép.",
    duplicate_capacity:
      "Trùng ngày và nhân viên trong dữ liệu năng lực làm việc.",
    invalid_wbs_obligation:
      "Công việc này không thuộc nghĩa vụ khai công của bạn trong ngày đã chọn.",
    invalid_wbs_reference: "Công việc WBS không thuộc dự án đã chọn.",
    timesheet_project_not_active: "Dự án chưa ở trạng thái cho phép khai công.",
    timesheet_after_project_actual_end: "Ngày công không được sau ngày kết thúc thực tế của dự án.",
    timesheet_progress_work_pending: "Bảng công ngày này đang chờ đối soát cập nhật tiến độ.",
    progress_work_operation_conflict: "Mã thao tác đã được dùng cho người thực hiện hoặc nội dung khác.",
    progress_work_coordination_unavailable: "Luồng đối soát tiến độ và chấm công chưa được bật.",
    progress_work_operation_cancelled: "Thao tác cập nhật tiến độ và chấm công đã bị hủy.",
    progress_work_operation_invalid: "Nội dung cập nhật tiến độ và chấm công đã lưu không hợp lệ.",
    progress_actual_mandays_read_only: "Cập nhật tiến độ không được thay đổi trực tiếp manday từ chấm công đã duyệt.",
    progress_work_unavailable: "Luồng đối soát tiến độ và chấm công chưa được bật.",
    progress_work_operation_id_required: "Cần mã thao tác khi ghi giờ công cùng tiến độ.",
    progress_work_payload_conflict: "Mã thao tác đã được dùng cho nội dung cập nhật tiến độ khác.",
    progress_work_pending: "Dự án đang có thao tác tiến độ và chấm công chờ đối soát.",
    progress_work_cancelled: "Thao tác đã bị hủy trước khi áp dụng tiến độ.",
    progress_work_intake_paused: "Đang tạm dừng tiếp nhận thao tác cập nhật tiến độ kèm chấm công mới.",
    timesheet_wbs_not_assigned: "Bạn chưa được giao công việc WBS này.",
    timesheet_wbs_not_eligible:
      "Công việc WBS đã hủy, N/A – Không thực hiện hoặc chưa ở trạng thái cho phép khai công.",
    meal_date_passed: "Không thể thay đổi suất ăn của ngày đã qua.",
    request_inactive: "Đơn đã rút hoặc hủy nên không thể tiếp tục xử lý.",
    request_source_mismatch: "Phiếu phát sinh không thuộc đơn nguồn này.",
    workflow_cancel_failed: "Chưa hoàn tất hủy quy trình. Vui lòng thử lại.",
    workflow_cancel_unavailable:
      "Hiện chưa thể kết nối để hủy quy trình. Vui lòng thử lại.",
    mixed_timesheet_approvers: "Bảng chấm công có nhiều người duyệt khác nhau.",
    project_leader_required: "Dự án chưa có trưởng dự án phụ trách phê duyệt.",
    timesheet_period_locked: "Kỳ chấm công đã bị khóa.",
    timesheet_not_withdrawable:
      "Không thể rút bảng chấm công ở trạng thái hiện tại.",
    timesheet_not_deletable: "Chỉ có thể xóa bảng chấm công ở trạng thái nháp.",
    timesheet_has_multiple_parts:
      "Bảng chấm công có nhiều phần duyệt riêng biệt.",
    not_part_approver: "Bạn không phải người phê duyệt phần này.",
    unauthorized_part_approver:
      "Bạn không có quyền duyệt phần bảng chấm công này.",
    timesheet_part_already_decided: "Phần bảng chấm công này đã được xử lý.",
    timesheet_part_not_found: "Không tìm thấy phần bảng chấm công.",
    part_concurrency_conflict:
      "Phần bảng chấm công đã được người khác cập nhật.",
    concurrency_conflict:
      "Dữ liệu đã được người khác cập nhật. Vui lòng tải lại.",
    row_version_required:
      "Thiếu phiên bản bản ghi (rowVersion). Vui lòng tải lại rồi thao tác lại.",
    invalid_audience:
      "Đối tượng xuất không hợp lệ (chỉ khách hàng hoặc nội bộ).",
    duplicate_quotation: "Số báo giá và revision này đã tồn tại trong dự án.",
    vehicle_code_locked:
      "Biển số đã có phiếu tham chiếu nên không đổi được. Hãy ngừng khai thác xe này và đăng ký xe mới.",
    vehicle_has_future_bookings:
      "Xe còn phiếu đã duyệt chưa chạy xong, chưa thể ngừng khai thác.",
    vehicle_status_change_requires_reason:
      "Ngừng khai thác hoặc kích hoạt lại xe phải dùng nút riêng kèm lý do.",
    vehicle_log_entry_locked:
      "Dòng nhật ký hệ thống của xe không sửa hay xóa được.",
    document_number_busy: "Bộ đếm số tài liệu đang bận, vui lòng lưu lại.",
    password_change_required:
      "Bạn phải đổi mật khẩu tạm trước khi dùng chức năng này.",
    user_has_open_responsibilities:
      "Tài khoản còn trách nhiệm đang mở. Chuyển giao trước hoặc buộc vô hiệu hóa.",
    responsibility_check_unavailable:
      "Chưa kiểm được trách nhiệm đang mở ở một số dịch vụ. Thử lại sau.",
    target_user_inactive: "Chỉ chuyển giao được cho tài khoản đang hoạt động.",
    responsibility_transfer_failed: "Dịch vụ đích từ chối chuyển giao.",
    no_step_roles:
      "Bước duyệt không có vai trò dự phòng; hãy chọn người nhận cụ thể.",
    scope_not_supported:
      "Cấp quyền theo phạm vi chưa được áp dụng (ADR-022 Q23); chỉ dùng phạm vi toàn hệ thống.",
    stale_row_version:
      "Dữ liệu đã thay đổi, vui lòng tải lại trước khi tiếp tục.",
    period_has_pending_timesheets:
      "Kỳ chấm công vẫn còn bảng chấm công chờ duyệt.",
    period_locked: "Kỳ chấm công đã bị khóa.",
    period_not_locked: "Kỳ chấm công chưa được khóa.",
    timesheet_already_approved: "Bảng chấm công đã được phê duyệt.",
    self_approval_forbidden:
      "Không thể tự phê duyệt bảng chấm công của chính mình.",
    invalid_daily_minutes:
      "Tổng số phút trong ngày không hợp lệ (tối đa 16 giờ/ngày).",
    normal_minutes_exceed_capacity:
      "Số phút làm việc bình thường vượt quá năng lực trong ngày.",
    duplicate_time_entry:
      "Trùng lặp dòng chấm công cho cùng dự án và công việc.",
    timesheet_not_editable:
      "Bảng chấm công không ở trạng thái cho phép chỉnh sửa.",
    invalid_transition: "Chuyển đổi trạng thái không hợp lệ.",
    not_found: "Không tìm thấy dữ liệu yêu cầu.",
    forbidden: "Bạn không có quyền thực hiện thao tác này.",
    request_not_editable: "Đơn yêu cầu không ở trạng thái cho phép chỉnh sửa.",
    request_not_withdrawable: "Chỉ có thể rút đơn khi đang chờ duyệt.",
    request_not_deletable: "Chỉ có thể xóa đơn ở trạng thái nháp.",
    request_not_cancellable: "Chỉ có thể hủy đơn đã được phê duyệt.",
    meal_cutoff_passed: "Đã qua mốc chốt đăng ký suất ăn cho ngày này.",
    not_a_meal_day: "Ngày lễ hoặc ngày nghỉ không đăng ký suất ăn được.",
    approved_request_cannot_be_deleted: "Không thể xóa đơn đã được phê duyệt.",
    insufficient_annual_leave_balance: "Số ngày phép năm còn lại không đủ.",
    meal_registration_cutoff_passed: "Đã quá giờ chốt đăng ký / hủy suất ăn.",
    meal_registration_locked: "Đăng ký suất ăn đã bị khóa.",
    unknown: "Có lỗi xảy ra, vui lòng thử lại.",
    unexpected_action_error: "Đã xảy ra lỗi không mong muốn. Vui lòng thử lại.",
  },
  historyReader: {
    searchChat: "Tìm trong đoạn chat (Ctrl + F)",
    previousResult: "Kết quả trước",
    nextResult: "Kết quả sau",
    removeFile: "Bỏ tệp",
    sendMedia: "Gửi ảnh hoặc video",
    sendFile: "Gửi tệp",
    messagePlaceholder: "Nhập tin nhắn...",
    pickEmoji: "Chọn biểu cảm",
    popularEmoji: "Biểu cảm phổ biến",
    send: "Gửi",
  },
  multiSelect: {
    placeholder: "— Chọn hoặc để trống (Tất cả) —",
    clearAll: "Bỏ chọn tất cả",
    search: "Tìm kiếm...",
    selectAll: "Chọn tất cả",
    clear: "Bỏ chọn",
    noResults: "Không tìm thấy kết quả",
  },
  identity: {
    toast_invalidImageFile: "Tệp ảnh không hợp lệ.",
    toast_imageTooLarge: "Ảnh vượt quá dung lượng cho phép.",
    toast_failedUploadImage: "Không tải lên được ảnh.",
    removePhoto: "Xóa ảnh",
  },
  bug112: {
    deleteWbsSubtreeConfirm: "Xóa mục WBS {code} và toàn bộ {count} mục con?",
    deleteWbsStarted: "Không thể xóa {code}: mục này hoặc mục con đã có tiến độ/chấm công hoặc đã đổi trạng thái.",
    deleteWbsHistory: "Không thể xóa {code}: mục này hoặc mục con có lịch sử tiến độ, chấm công hoặc phân công PIC đã kết thúc.",
  },
  progressWarnings: {
    title: "Cảnh báo tiến độ",
    from: "Từ ngày",
    to: "Đến ngày",
    asOf: "Đánh giá tại {date}",
    generated: "Đọc dữ liệu lúc {time}",
    allProjects: "Tất cả dự án được xem",
    allLeaders: "Tất cả trưởng dự án",
    apply: "Lọc cảnh báo",
    groupsLabel: "Ba nhóm cảnh báo tiến độ",
    allGroups: "Xem cả ba nhóm",
    group: "Nhóm cảnh báo",
    taskCode: "Mã WBS",
    task: "Công việc",
    actual: "% thực tế",
    expected: "% kỳ vọng",
    evidence: "Lý do / hoạt động trong kỳ",
    planRule: "Ưu tiên kế hoạch phân bổ ngày; khi chưa phân bổ, dùng thời gian và manday kế hoạch hiện tại. Chỉ xét phần kỳ đã trôi. Một việc có thể xuất hiện ở nhiều nhóm.",
    invalidRange: "Chọn kỳ hợp lệ: ngày bắt đầu không được sau ngày kết thúc.",
    noUpdateEvidence: "Có kế hoạch trong kỳ nhưng chưa ghi nhận cập nhật tiến độ có ngày hiệu lực trong kỳ.",
    overdueEvidence: "Quá hạn {days} ngày, công việc chưa hoàn thành.",
    behindEvidence: "Thực tế thấp hơn kỳ vọng {gap} điểm %.",
    progressEvidence: "{updates} cập nhật tiến độ ngoài kế hoạch",
    timeEvidence: "{minutes} phút ngoài kế hoạch (nháp {draft}, chờ duyệt {pending}, đã duyệt {approved}, từ chối {rejected})",
    timeUnknown: "Chấm công: chưa đủ dữ liệu để kết luận",
    incompleteHistory: "{count} công việc chưa đủ lịch sử để xác định %/trạng thái tại kỳ đã chọn. Giá trị chưa biết hiển thị —; nhóm nguy cơ trễ có thể chưa đầy đủ.",
    empty: "Không có cảnh báo phù hợp trong kỳ đã chọn.",
    partialEmpty: "Chưa có cảnh báo từ dữ liệu đã đọc; còn nguồn chưa đầy đủ.",
    unavailable: "Chưa đọc được cảnh báo. Hãy thử lại.",
    wbsMissing: {
      title: "Việc chưa ghi giờ",
      subtitle: "Việc có hoạt động nhưng người được gán chưa ghi giờ (máy chủ phát hiện). Thông tin để quản lý theo dõi; không phải bước phê duyệt.",
      employee: "Nhân viên",
      project: "Dự án / WBS",
      workDate: "Ngày làm việc",
      reason: "Lý do",
      detected: "Phát hiện",
      late: "Đã chấm bù lúc {time}",
      noReason: "Không có lý do",
      dismiss: "Bỏ qua / Đã xem",
      loadFailed: "Không tải được danh sách việc chưa ghi giờ.",
    },
    groups: {
      NoUpdate: "Có kế hoạch, chưa cập nhật",
      UnplannedActivity: "Có hoạt động ngoài kế hoạch",
      AtRisk: "Có nguy cơ trễ",
    },
    sources: {
      Forbidden: "Chưa có quyền xem toàn bộ chấm công. Nhóm hoạt động ngoài kế hoạch hiện chỉ gồm cập nhật tiến độ; số lượng có thể chưa đầy đủ.",
      Unavailable: "Nguồn chấm công tạm thời chưa khả dụng. Nhóm hoạt động ngoài kế hoạch hiện chỉ gồm cập nhật tiến độ; hãy tải lại để đối soát đủ.",
    },
  },
  progressOverview: {
    demoMappingNote: "Mẫu WBS hiện có 16 công đoạn, chưa có Demo triển khai riêng. Không dùng Demo báo giá hoặc Test vận hành để thay thế. Cần quyết định riêng về template và trọng số trước khi bổ sung dữ liệu.",
    quoteSources: {
      Quotation: "Báo giá phát hành",
      QuotationMilestone: "Mốc báo giá thực tế",
      WbsQuotation: "WBS Báo giá đã hoàn thành",
    },
    noData: "Chưa có dữ liệu",
    target: "Mục tiêu 100%",
    stageCatalog: "Đối chiếu {count} công đoạn",
    ordinalHint: "STT là thứ tự nghiệp vụ, không phải mã WBS. Mục thiếu ánh xạ không được tính thành 0% hoặc hoàn thành.",
    openWbsCode: "Mở WBS {code}",
    unmappedStage: "Chưa có ánh xạ WBS",
    missingStage: "Chưa có công đoạn WBS tương ứng",
    openWbs: "Mở WBS chi tiết",
    noPhaseMapping: "Chưa đủ ánh xạ cho hai Step",
    zeroDuration: "Kế hoạch không có ngày làm việc trong khoảng (bắt đầu, kết thúc]; đạt mục tiêu tại mốc kết thúc, không chia cho 0.",
    noCurveData: "Chưa đủ dữ liệu để vẽ biểu đồ giai đoạn.",
    chartData: "Xem dữ liệu biểu đồ bằng bảng",
    projectionMissing: "Máy chủ chưa cung cấp dữ liệu cho hai Step mới. Không dùng nhóm 01–06/07–16 cũ để thay thế.",
    pendingHint: "Số liệu đang chờ tổng hợp; chưa kết luận vượt hoặc chậm kế hoạch.",
    preparation: "Chuẩn bị trước khi xuống nhà máy",
    preparationRequirement: "Cần hoàn thành HDCV và kế hoạch làm việc chi tiết cho giao hàng, lắp đặt/vận hành, đào tạo và nghiệm thu.",
    preparationUnknown: "Chưa có dữ liệu xác nhận hoàn thành HDCV và kế hoạch chuẩn bị. Trạng thái WBS hoặc tệp đính kèm riêng lẻ chưa đủ xác nhận yêu cầu này.",
    preparationWork: "Công việc nguồn",
    relatedTasks: "Công việc chi tiết liên quan",
    preparationDocuments: "Tài liệu dự án để đối chiếu",
    openDocuments: "Mở tài liệu dự án",
    documentsUnavailable: "Không tải được tài liệu; chưa thể kết luận thiếu hay đã hoàn thành.",
    noPreparationDocuments: "Chưa có tài liệu đính kèm ở cấp dự án. Tài liệu gắn riêng với WBS cần xem tại công việc nguồn.",
    documentsForbidden: "Chưa có quyền xem tài liệu.",
    abnormalHint: "Công đoạn WBS 16 được trình bày trong Step 2. Danh sách yêu cầu của dự án là nguồn theo dõi riêng; chưa có liên kết để cộng mọi yêu cầu vào tiến độ công đoạn này.",
    followUpTitle: "Đã báo giá · chưa nhận P/O khách hàng",
    followUpScope: "Theo dõi riêng các dự án được phép xem, kể cả trước vận hành; không chịu bộ lọc PO, tiến độ và phân trang của Gantt. P/O ở đây là của khách hàng, không phải P/O phát hành cho NCC hoặc nhà thầu phụ.",
    followUpSnapshot: "Trạng thái tại {date}, gom theo tháng phát hành báo giá gần nhất. Đây không phải số dư cuối tháng trong quá khứ; chưa có đủ lịch sử để suy ngược.",
    followUpMonths: "Dự án hiện chưa nhận P/O theo tháng báo giá",
    projectCount: "{count} dự án",
    quoteIssued: "Báo giá đã phát hành",
    responsible: "Trưởng dự án",
    unresolvedPerson: "Chưa phân giải được tên",
    quoteOutcome: "Kết quả báo giá",
    recordedOutcomeReason: "Lý do kết quả đã ghi nhận",
    noPoReason: "Nguyên nhân chưa nhận P/O",
    noPoReasonMissing: "Chưa ghi nhận nguyên nhân chưa nhận P/O.",
    followUpForbidden: "Cần quyền xem WBS, báo giá và P/O khách hàng để đối chiếu.",
    followUpUnavailable: "Không tải được danh sách báo giá chưa nhận P/O.",
    followUpEmpty: "Không có dự án đã phát hành báo giá chưa nhận P/O trong phạm vi đọc.",
    retry: "Thử lại",
    stages: {
      receipt: "Tiếp nhận yêu cầu",
      survey: "Khảo sát",
      solution: "Đề xuất giải pháp",
      quotationDemo: "Demo báo giá",
      quotation: "Báo giá",
      customerPo: "Tiếp nhận P/O khách hàng",
      execution: "Triển khai dự án",
      executionDemo: "Demo triển khai",
      supplierPo: "Phát hành P/O cho nhà cung cấp",
      subcontractorPo: "Phát hành P/O cho nhà thầu phụ",
      assembly: "Lắp ráp hoàn thành sản phẩm",
      delivery: "Giao hàng",
      installation: "Lắp đặt, set up, vận hành",
      training: "Đào tạo, chuyển giao công nghệ",
      acceptance: "Nghiệm thu",
      payment: "Thanh toán",
      abnormal: "Xử lý bất thường",
    },
    dataStates: {
      Available: "Đủ dữ liệu",
      Partial: "Số liệu chỉ thuộc WBS đã ánh xạ. Còn công đoạn thiếu nguồn; chưa đủ dữ liệu kết luận toàn Step.",
      NoData: "Chưa có WBS phù hợp.",
      NoWeight: "Chưa có trọng số WBS hữu hiệu; không suy tiến độ bằng chia đều công đoạn.",
      NotApplicable: "Các mục của giai đoạn đều N/A; không tính thành hoàn thành.",
      Cancelled: "Các mục hữu hiệu đã hủy; không kết luận tiến độ.",
      NotStarted: "Chưa bắt đầu hoặc chưa có lần cập nhật thực tế; không vẽ đường 0% giả.",
    },
    conclusions: {
      ahead: "Đang vượt kế hoạch",
      behind: "Đang chậm kế hoạch",
      onPlan: "Đúng kế hoạch",
      insufficient: "Chưa đủ dữ liệu kết luận toàn giai đoạn",
      pending: "Đang chờ tổng hợp",
    },
    quoteOutcomes: {
      None: "Chưa ghi nhận kết quả",
      Sent: "Đã gửi",
      Accepted: "Đã chấp nhận",
      Rejected: "Đã từ chối",
      Expired: "Đã hết hạn",
    },
    title: "Theo dõi tiến độ",
    planned: "Kế hoạch",
    actual: "Thực tế",
    today: "Hôm nay",
    colSeq: "STT",
    colProject: "Dự án",
    detail: "Chi tiết",
    done: "Đã đạt 100%",
    remaining: "còn {days} ngày",
    empty: "Không có dự án đang vận hành nào trong 3 năm đang xem.",
    unavailable: "Không tải được tiến độ dự án.",
    pageInfo: "Trang {page}/{pages} · {total} dự án",
    previousPage: "Trang trước",
    nextPage: "Trang sau",
    summary: "Tóm tắt",
    overall: "Tiến độ tổng thể",
    ahead: "vượt",
    behind: "chậm",
    onPlan: "đúng kế hoạch",
    poDate: "Ngày nhận PO",
    poFromPlannedStart: "(theo ngày bắt đầu kế hoạch)",
    plannedEnd: "Ngày kết thúc",
    durationValue: "{days} ngày làm việc = 100% ⇒ 1 ngày = {daily}%",
    daysValue: "{days} ngày",
    overdue: "Quá hạn {days} ngày",
    chart: "Biểu đồ tiến độ",
    aheadZone: "Vượt",
    behindZone: "Chậm",
    curveUnavailable: "Không tải được biểu đồ tiến độ.",
    scale: "Thang thời gian",
    colPo: "PO",
    lateButton: "Việc trễ ({count})",
    weekdaysCalendar: "(lịch Thứ Hai–Sáu)",
    chartPreOrder: "Step 1 · Tiến độ báo giá",
    chartQuoted: "Đã báo giá",
    chartCompleted: "Hoàn thành",
    completedTitle: "Dự án đã hoàn thành 100%",
    completedEmpty: "Không có dự án đạt 100% trong 3 năm đang xem.",
    colPlannedEnd: "Kết thúc kế hoạch",
    colActualStart: "Bắt đầu thực tế",
    colActualEnd: "Kết thúc thực tế",
    chartExecution: "Step 2 · Tiến độ triển khai dự án",
    stepTabs: "Giai đoạn theo dõi tiến độ",
    sharedProjectScope: "Bộ lọc, % và cảnh báo trễ áp dụng cho toàn dự án. Chi tiết hiển thị số liệu riêng của Step đang chọn.",
    projectPercent: "% dự án",
    projectRemaining: "Dự án còn {days} ngày",
    phasePreOrder: "Step 1",
    phaseExecution: "Step 2",
    phaseDone: "{done}/{total} hạng mục xong",
    phaseLegend: "Step 1: báo giá (WBS 01–05) · Step 2: triển khai (WBS 06–16)",
    chartNoItems: "Dự án không có hạng mục gốc nào thuộc nhóm này.",
    unmappedRoots: "{count} hạng mục gốc ngoài mã 01–16 không thuộc biểu đồ nào.",
    planDoneAtStartPreOrder: "Ngày nhận PO ({po}) không sau ngày bắt đầu kế hoạch sớm nhất của nhóm ({start}) nên kế hoạch là 100% ngay từ đầu.",
    planDoneAtStartExecution: "Ngày kết thúc ({end}) không sau Ngày nhận PO ({po}) nên kế hoạch là 100% ngay từ đầu.",
    lateTitle: "Việc trễ · {project}",
    lateHint: "Hạng mục WBS mọi cấp chưa hoàn thành đã qua ngày kết thúc kế hoạch tính đến {date}; bấm một dòng để xem nội dung theo dõi tiến độ.",
    colCode: "Mã",
    colName: "Hạng mục",
    colLateDays: "Số ngày trễ",
    historyTitle: "Nội dung theo dõi tiến độ · {node}",
    historyForbidden: "Không có quyền xem lịch sử cập nhật.",
    historyUnavailable: "Không tải được lịch sử cập nhật.",
    historyEmpty: "Hạng mục chưa có lần cập nhật tiến độ nào.",
    historyDate: "Ngày",
    historyStatus: "Trạng thái",
    historyContent: "Nội dung",
    historyBy: "Người cập nhật",
    colIssues: "Yêu cầu",
    issueOpen: "{count} đang xử lý",
    issueLate: "{count} trễ",
    issueForbidden: "Không có quyền xem yêu cầu",
    issuesTitle: "Yêu cầu · {project}",
    issuesEmpty: "Dự án chưa có yêu cầu nào.",
    issuesUnavailable: "Không tải được danh sách yêu cầu.",
    issueColTitle: "Tiêu đề",
    issueColSchedule: "Tiến độ hạn",
    openIssueTracking: "Mở theo dõi yêu cầu",
    filters: "Bộ lọc tiến độ dự án",
    searchPlaceholder: "Tìm mã hoặc tên dự án",
    filterAll: "Tất cả",
    filterProgress: "Tiến độ",
    filterLate: "Trễ",
    clearFilters: "Xóa lọc",
    progressActive: "Đang thực hiện (dưới 100%)",
    progressCompleted: "Đã đạt 100%",
    progressBehind: "Chậm so với kế hoạch",
    progressOverdue: "Quá ngày kết thúc",
    lateWbs: "Có việc trễ",
    lateIssue: "Có yêu cầu trễ",
    lateAny: "Có việc hoặc yêu cầu trễ",
    emptyFiltered: "Không có dự án khớp bộ lọc.",
    chartTitleQuotation: "Chart quản lý tiến độ báo giá",
    chartTitleExecution: "Chart quản lý tiến độ thi công dự án",
    chartLegend: "Chú thích biểu đồ",
    targetLegend: "Target",
    axisProgress: "Tiến độ (%)",
    infoBox: "Thông tin tiến độ của Step",
    infoReceipt: "Ngày tiếp nhận yêu cầu:",
    infoQuotation: "Ngày có báo giá:",
    infoDuration: "Tổng ngày thực hiện dự án:",
    infoRemaining: "Tổng số ngày còn lại:",
    infoOverdue: "(quá hạn {days} ngày)",
    infoPlanned: "Tiến độ theo kế hoạch:",
    infoActual: "Tiến độ theo thực tế:",
    infoAhead: "Tiến độ dự án đang vượt tiến độ {value}% so với kế hoạch",
    infoBehind: "Tiến độ dự án đang trễ tiến độ {value}% so với kế hoạch",
    rangeLine: "Kế hoạch {plannedStart} → {plannedEnd} · Thực tế {actualStart} → {actualEnd}",
    rangePo: "Ngày PO {date}",
    notesTitle: "Ghi chú",
    noteWeekdays: "Số ngày tính theo lịch Thứ Hai–Sáu (chưa đọc được lịch công ty).",
  },
};
